//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class VovClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    auth(body: AuthRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth(_response);
        });
    }

    protected processAuth(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authInvestor(body: AuthInvestorRequest | undefined, cancelToken?: CancelToken): Promise<AuthInvestorResponse> {
        let url_ = this.baseUrl + "/Auth/authInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthInvestor(_response);
        });
    }

    protected processAuthInvestor(response: AxiosResponse): Promise<AuthInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthInvestorResponse.fromJS(resultData200);
            return Promise.resolve<AuthInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthInvestorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authSubcontractor(body: AuthSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<AuthSubcontractorResponse> {
        let url_ = this.baseUrl + "/Auth/authSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthSubcontractor(_response);
        });
    }

    protected processAuthSubcontractor(response: AxiosResponse): Promise<AuthSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<AuthSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authKrosSuperAdmin(body: AuthKrosSuperAdminRequest | undefined, cancelToken?: CancelToken): Promise<AuthKrosSuperAdminResponse> {
        let url_ = this.baseUrl + "/Auth/authKrosSuperAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthKrosSuperAdmin(_response);
        });
    }

    protected processAuthKrosSuperAdmin(response: AxiosResponse): Promise<AuthKrosSuperAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthKrosSuperAdminResponse.fromJS(resultData200);
            return Promise.resolve<AuthKrosSuperAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthKrosSuperAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest | undefined, cancelToken?: CancelToken): Promise<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/Auth/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<RefreshTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshInvestorToken(body: RefreshInvestorTokenRequest | undefined, cancelToken?: CancelToken): Promise<RefreshInvestorTokenResponse> {
        let url_ = this.baseUrl + "/Auth/refreshInvestorToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshInvestorToken(_response);
        });
    }

    protected processRefreshInvestorToken(response: AxiosResponse): Promise<RefreshInvestorTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshInvestorTokenResponse.fromJS(resultData200);
            return Promise.resolve<RefreshInvestorTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshInvestorTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshSubcontractorToken(body: RefreshTokenSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<RefreshTokenSubcontractorResponse> {
        let url_ = this.baseUrl + "/Auth/refreshSubcontractorToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshSubcontractorToken(_response);
        });
    }

    protected processRefreshSubcontractorToken(response: AxiosResponse): Promise<RefreshTokenSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reauth(body: ReauthRequest | undefined, cancelToken?: CancelToken): Promise<ReauthResponse> {
        let url_ = this.baseUrl + "/Auth/reauth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReauth(_response);
        });
    }

    protected processReauth(response: AxiosResponse): Promise<ReauthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReauthResponse.fromJS(resultData200);
            return Promise.resolve<ReauthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReauthResponse>(null as any);
    }

    /**
     * @return Success
     */
    me( cancelToken?: CancelToken): Promise<GetMeDetailResponse> {
        let url_ = this.baseUrl + "/Auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<GetMeDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMeDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetMeDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMeDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loginOldErp(body: AuthOldErpAdminUsersRequest | undefined, cancelToken?: CancelToken): Promise<AuthOldErpAdminUsersResponse> {
        let url_ = this.baseUrl + "/Auth/loginOldErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginOldErp(_response);
        });
    }

    protected processLoginOldErp(response: AxiosResponse): Promise<AuthOldErpAdminUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthOldErpAdminUsersResponse.fromJS(resultData200);
            return Promise.resolve<AuthOldErpAdminUsersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthOldErpAdminUsersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loginEmpAsAdminMobile(body: AuthEmpToAdminUserRequest | undefined, cancelToken?: CancelToken): Promise<AuthEmpToAdminUserResponse> {
        let url_ = this.baseUrl + "/Auth/loginEmpAsAdminMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginEmpAsAdminMobile(_response);
        });
    }

    protected processLoginEmpAsAdminMobile(response: AxiosResponse): Promise<AuthEmpToAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthEmpToAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<AuthEmpToAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthEmpToAdminUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loginOldSubcontractorErp(body: AuthOldErpSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<AuthOldErpSubcontractorResponse> {
        let url_ = this.baseUrl + "/Auth/loginOldSubcontractorErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginOldSubcontractorErp(_response);
        });
    }

    protected processLoginOldSubcontractorErp(response: AxiosResponse): Promise<AuthOldErpSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthOldErpSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<AuthOldErpSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthOldErpSubcontractorResponse>(null as any);
    }

    /**
     * @return Success
     */
    healthCheck(password: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Auth/healthCheck/{Password}";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{Password}", encodeURIComponent("" + password));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAppLogoUrl( cancelToken?: CancelToken): Promise<GetAppLogoResponse> {
        let url_ = this.baseUrl + "/Auth/get-app-logo-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppLogoUrl(_response);
        });
    }

    protected processGetAppLogoUrl(response: AxiosResponse): Promise<GetAppLogoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppLogoResponse.fromJS(resultData200);
            return Promise.resolve<GetAppLogoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppLogoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    testPrint(body: TestPrintRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Auth/test-print";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestPrint(_response);
        });
    }

    protected processTestPrint(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    projects(deleted: boolean, cancelToken?: CancelToken): Promise<GetBuildingsForProjectsListPageResponse> {
        let url_ = this.baseUrl + "/Building/projects/{Deleted}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjects(_response);
        });
    }

    protected processProjects(response: AxiosResponse): Promise<GetBuildingsForProjectsListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingsForProjectsListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingsForProjectsListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingsForProjectsListPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    buildingImages(buildingId: number, cancelToken?: CancelToken): Promise<GetBuildingPhotosResponse> {
        let url_ = this.baseUrl + "/Building/buildingImages/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildingImages(_response);
        });
    }

    protected processBuildingImages(response: AxiosResponse): Promise<GetBuildingPhotosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingPhotosResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingPhotosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingPhotosResponse>(null as any);
    }

    /**
     * @return Success
     */
    buildings( cancelToken?: CancelToken): Promise<GetBuildingForAdminUserResponse> {
        let url_ = this.baseUrl + "/Building/buildings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildings(_response);
        });
    }

    protected processBuildings(response: AxiosResponse): Promise<GetBuildingForAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingForAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingForAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingForAdminUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    projectDetail(buildingId: number, cancelToken?: CancelToken): Promise<GetBuildingDataDetailResponse> {
        let url_ = this.baseUrl + "/Building/projectDetail/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectDetail(_response);
        });
    }

    protected processProjectDetail(response: AxiosResponse): Promise<GetBuildingDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingDataDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProjects(body: DeleteBuildingsRequest | undefined, cancelToken?: CancelToken): Promise<DeleteBuildingsResponse> {
        let url_ = this.baseUrl + "/Building/deleteProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProjects(_response);
        });
    }

    protected processDeleteProjects(response: AxiosResponse): Promise<DeleteBuildingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteBuildingsResponse.fromJS(resultData200);
            return Promise.resolve<DeleteBuildingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteBuildingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveProjectsFromTrash(body: MoveBuildingsFromTrashRequest | undefined, cancelToken?: CancelToken): Promise<MoveBuildingsFromTrashResponse> {
        let url_ = this.baseUrl + "/Building/MoveProjectsFromTrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveProjectsFromTrash(_response);
        });
    }

    protected processMoveProjectsFromTrash(response: AxiosResponse): Promise<MoveBuildingsFromTrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveBuildingsFromTrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveBuildingsFromTrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveBuildingsFromTrashResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBuilding(body: SaveBuildingRequest | undefined, cancelToken?: CancelToken): Promise<SaveBuildingResponse> {
        let url_ = this.baseUrl + "/Building/SaveBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBuilding(_response);
        });
    }

    protected processSaveBuilding(response: AxiosResponse): Promise<SaveBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveBuildingResponse.fromJS(resultData200);
            return Promise.resolve<SaveBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveBuildingResponse>(null as any);
    }

    /**
     * @return Success
     */
    filesForBuilding(buildingId: number, cancelToken?: CancelToken): Promise<GetFilesFoldersForBuildingResponse> {
        let url_ = this.baseUrl + "/Building/filesForBuilding/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilesForBuilding(_response);
        });
    }

    protected processFilesForBuilding(response: AxiosResponse): Promise<GetFilesFoldersForBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilesFoldersForBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetFilesFoldersForBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilesFoldersForBuildingResponse>(null as any);
    }

    /**
     * @return Success
     */
    filesForBuildingApplication(buildingId: number, cancelToken?: CancelToken): Promise<GetFilesFoldersForBuildingApplicationResponse> {
        let url_ = this.baseUrl + "/Building/filesForBuildingApplication/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilesForBuildingApplication(_response);
        });
    }

    protected processFilesForBuildingApplication(response: AxiosResponse): Promise<GetFilesFoldersForBuildingApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilesFoldersForBuildingApplicationResponse.fromJS(resultData200);
            return Promise.resolve<GetFilesFoldersForBuildingApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilesFoldersForBuildingApplicationResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectFilesTree(projectId: number, cancelToken?: CancelToken): Promise<GetProjectFilesTreeResponse> {
        let url_ = this.baseUrl + "/Building/GetProjectFilesTree/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectFilesTree(_response);
        });
    }

    protected processGetProjectFilesTree(response: AxiosResponse): Promise<GetProjectFilesTreeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectFilesTreeResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectFilesTreeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectFilesTreeResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectFileDetail(documentId: number, cancelToken?: CancelToken): Promise<GetProjectFileDetailResponse> {
        let url_ = this.baseUrl + "/Building/GetProjectFileDetail/{DocumentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{DocumentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectFileDetail(_response);
        });
    }

    protected processGetProjectFileDetail(response: AxiosResponse): Promise<GetProjectFileDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectFileDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectFileDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectFileDetailResponse>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationInvestors( cancelToken?: CancelToken): Promise<GetApplicationInvestorsResponse> {
        let url_ = this.baseUrl + "/Building/GetApplicationInvestors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationInvestors(_response);
        });
    }

    protected processGetApplicationInvestors(response: AxiosResponse): Promise<GetApplicationInvestorsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationInvestorsResponse.fromJS(resultData200);
            return Promise.resolve<GetApplicationInvestorsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationInvestorsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmailTemplates( cancelToken?: CancelToken): Promise<GetEmailTemplatesResponse> {
        let url_ = this.baseUrl + "/Building/GetEmailTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailTemplates(_response);
        });
    }

    protected processGetEmailTemplates(response: AxiosResponse): Promise<GetEmailTemplatesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmailTemplatesResponse.fromJS(resultData200);
            return Promise.resolve<GetEmailTemplatesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmailTemplatesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProjectFileDetail(body: SaveProjectFileDetailRequest | undefined, cancelToken?: CancelToken): Promise<SaveProjectFileDetailResponse> {
        let url_ = this.baseUrl + "/Building/SaveProjectFileDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProjectFileDetail(_response);
        });
    }

    protected processSaveProjectFileDetail(response: AxiosResponse): Promise<SaveProjectFileDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveProjectFileDetailResponse.fromJS(resultData200);
            return Promise.resolve<SaveProjectFileDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveProjectFileDetailResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectFileDocuments(documentId: number, cancelToken?: CancelToken): Promise<GetProjectFileDocumentsResponse> {
        let url_ = this.baseUrl + "/Building/GetProjectFileDocuments/{DocumentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{DocumentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectFileDocuments(_response);
        });
    }

    protected processGetProjectFileDocuments(response: AxiosResponse): Promise<GetProjectFileDocumentsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectFileDocumentsResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectFileDocumentsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectFileDocumentsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProjectFile(body: DeleteProjectFileRequest | undefined, cancelToken?: CancelToken): Promise<DeleteProjectFileResponse> {
        let url_ = this.baseUrl + "/Building/DeleteProjectFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProjectFile(_response);
        });
    }

    protected processDeleteProjectFile(response: AxiosResponse): Promise<DeleteProjectFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteProjectFileResponse.fromJS(resultData200);
            return Promise.resolve<DeleteProjectFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteProjectFileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProjectFileDocument(body: DeleteProjectFileDocumentRequest | undefined, cancelToken?: CancelToken): Promise<DeleteProjectFileDocumentResponse> {
        let url_ = this.baseUrl + "/Building/DeleteProjectFileDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProjectFileDocument(_response);
        });
    }

    protected processDeleteProjectFileDocument(response: AxiosResponse): Promise<DeleteProjectFileDocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteProjectFileDocumentResponse.fromJS(resultData200);
            return Promise.resolve<DeleteProjectFileDocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteProjectFileDocumentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectFile(body: CreateProjectFileRequest | undefined, cancelToken?: CancelToken): Promise<CreateProjectFileResponse> {
        let url_ = this.baseUrl + "/Building/CreateProjectFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProjectFile(_response);
        });
    }

    protected processCreateProjectFile(response: AxiosResponse): Promise<CreateProjectFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProjectFileResponse.fromJS(resultData200);
            return Promise.resolve<CreateProjectFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProjectFileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectFilesFromPaths(body: CreateProjectFilesFromPathsRequest | undefined, cancelToken?: CancelToken): Promise<CreateProjectFilesFromPathsResponse> {
        let url_ = this.baseUrl + "/Building/CreateProjectFilesFromPaths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProjectFilesFromPaths(_response);
        });
    }

    protected processCreateProjectFilesFromPaths(response: AxiosResponse): Promise<CreateProjectFilesFromPathsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProjectFilesFromPathsResponse.fromJS(resultData200);
            return Promise.resolve<CreateProjectFilesFromPathsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProjectFilesFromPathsResponse>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param chunk (optional) 
     * @param chunkNumber (optional) 
     * @param totalChunks (optional) 
     * @param key (optional) 
     * @param buildingDocumentsId (optional) 
     * @param path (optional) 
     * @return Success
     */
    uploadProjectDocumentChunk(fileName: string | undefined, chunk: FileParameter | undefined, chunkNumber: number | undefined, totalChunks: number | undefined, key: string | undefined, buildingDocumentsId: number | undefined, path: string | undefined, cancelToken?: CancelToken): Promise<UploadProjectDocumentChunkResponse> {
        let url_ = this.baseUrl + "/Building/UploadProjectDocumentChunk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (chunk === null || chunk === undefined)
            throw new Error("The parameter 'chunk' cannot be null.");
        else
            content_.append("Chunk", chunk.data, chunk.fileName ? chunk.fileName : "Chunk");
        if (chunkNumber === null || chunkNumber === undefined)
            throw new Error("The parameter 'chunkNumber' cannot be null.");
        else
            content_.append("ChunkNumber", chunkNumber.toString());
        if (totalChunks === null || totalChunks === undefined)
            throw new Error("The parameter 'totalChunks' cannot be null.");
        else
            content_.append("TotalChunks", totalChunks.toString());
        if (key === null || key === undefined)
            throw new Error("The parameter 'key' cannot be null.");
        else
            content_.append("Key", key.toString());
        if (buildingDocumentsId === null || buildingDocumentsId === undefined)
            throw new Error("The parameter 'buildingDocumentsId' cannot be null.");
        else
            content_.append("BuildingDocumentsId", buildingDocumentsId.toString());
        if (path === null || path === undefined)
            throw new Error("The parameter 'path' cannot be null.");
        else
            content_.append("Path", path.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProjectDocumentChunk(_response);
        });
    }

    protected processUploadProjectDocumentChunk(response: AxiosResponse): Promise<UploadProjectDocumentChunkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadProjectDocumentChunkResponse.fromJS(resultData200);
            return Promise.resolve<UploadProjectDocumentChunkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadProjectDocumentChunkResponse>(null as any);
    }

    /**
     * @return Success
     */
    getImagesBuilding(buildingId: number, cancelToken?: CancelToken): Promise<GetImagesBuildingResponse> {
        let url_ = this.baseUrl + "/Building/GetImagesBuilding/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImagesBuilding(_response);
        });
    }

    protected processGetImagesBuilding(response: AxiosResponse): Promise<GetImagesBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetImagesBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetImagesBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetImagesBuildingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersBuilding(buildingId: number, cancelToken?: CancelToken): Promise<GetUsersBuildingResponse> {
        let url_ = this.baseUrl + "/Building/GetUsersBuilding/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersBuilding(_response);
        });
    }

    protected processGetUsersBuilding(response: AxiosResponse): Promise<GetUsersBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyCutPasteProjectFile(body: CopyCutPasteProjectFileRequest | undefined, cancelToken?: CancelToken): Promise<CopyCutPasteProjectFileResponse> {
        let url_ = this.baseUrl + "/Building/CopyCutPasteProjectFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyCutPasteProjectFile(_response);
        });
    }

    protected processCopyCutPasteProjectFile(response: AxiosResponse): Promise<CopyCutPasteProjectFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyCutPasteProjectFileResponse.fromJS(resultData200);
            return Promise.resolve<CopyCutPasteProjectFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyCutPasteProjectFileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchDocumentFiles(body: SearchDocumentFilesRequest | undefined, cancelToken?: CancelToken): Promise<SearchDocumentFilesResponse> {
        let url_ = this.baseUrl + "/Building/SearchDocumentFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchDocumentFiles(_response);
        });
    }

    protected processSearchDocumentFiles(response: AxiosResponse): Promise<SearchDocumentFilesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchDocumentFilesResponse.fromJS(resultData200);
            return Promise.resolve<SearchDocumentFilesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchDocumentFilesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestEyetower(body: RequestEyetowerRequest | undefined, cancelToken?: CancelToken): Promise<RequestEyetowerResponse> {
        let url_ = this.baseUrl + "/Building/RequestEyetower";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestEyetower(_response);
        });
    }

    protected processRequestEyetower(response: AxiosResponse): Promise<RequestEyetowerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestEyetowerResponse.fromJS(resultData200);
            return Promise.resolve<RequestEyetowerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestEyetowerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRequestEyetowerData(buildingId: number, cancelToken?: CancelToken): Promise<GetRequestEyetowerDataResponse> {
        let url_ = this.baseUrl + "/Building/GetRequestEyetowerData/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestEyetowerData(_response);
        });
    }

    protected processGetRequestEyetowerData(response: AxiosResponse): Promise<GetRequestEyetowerDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestEyetowerDataResponse.fromJS(resultData200);
            return Promise.resolve<GetRequestEyetowerDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestEyetowerDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateEyetowerPrice(body: CalculateEyetowerPriceRequest | undefined, cancelToken?: CancelToken): Promise<CalculateEyetowerPriceResponse> {
        let url_ = this.baseUrl + "/Building/CalculateEyetowerPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateEyetowerPrice(_response);
        });
    }

    protected processCalculateEyetowerPrice(response: AxiosResponse): Promise<CalculateEyetowerPriceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculateEyetowerPriceResponse.fromJS(resultData200);
            return Promise.resolve<CalculateEyetowerPriceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateEyetowerPriceResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBuildingsPermissions( cancelToken?: CancelToken): Promise<GetBuildingsPermissionsResponse> {
        let url_ = this.baseUrl + "/Building/GetBuildingsPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildingsPermissions(_response);
        });
    }

    protected processGetBuildingsPermissions(response: AxiosResponse): Promise<GetBuildingsPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingsPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingsPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingsPermissionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteImagesBuilding(body: DeleteImagesBuildingRequest | undefined, cancelToken?: CancelToken): Promise<DeleteImagesBuildingResponse> {
        let url_ = this.baseUrl + "/Building/DeleteImagesBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteImagesBuilding(_response);
        });
    }

    protected processDeleteImagesBuilding(response: AxiosResponse): Promise<DeleteImagesBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteImagesBuildingResponse.fromJS(resultData200);
            return Promise.resolve<DeleteImagesBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteImagesBuildingResponse>(null as any);
    }

    /**
     * @param buildingId (optional) 
     * @param categoryId (optional) 
     * @param file (optional) 
     * @return Success
     */
    addImageToProject(buildingId: number | undefined, categoryId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<AddImageToProjectResponse> {
        let url_ = this.baseUrl + "/Building/AddImageToProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (buildingId === null || buildingId === undefined)
            throw new Error("The parameter 'buildingId' cannot be null.");
        else
            content_.append("BuildingId", buildingId.toString());
        if (categoryId === null || categoryId === undefined)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else
            content_.append("CategoryId", categoryId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImageToProject(_response);
        });
    }

    protected processAddImageToProject(response: AxiosResponse): Promise<AddImageToProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddImageToProjectResponse.fromJS(resultData200);
            return Promise.resolve<AddImageToProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImageToProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addImageCategory(body: AddImageCategoryRequest | undefined, cancelToken?: CancelToken): Promise<AddImageCategoryResponse> {
        let url_ = this.baseUrl + "/Building/AddImageCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImageCategory(_response);
        });
    }

    protected processAddImageCategory(response: AxiosResponse): Promise<AddImageCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddImageCategoryResponse.fromJS(resultData200);
            return Promise.resolve<AddImageCategoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImageCategoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteImageCategoryBuilding(body: DeleteImageCategoryBuildingRequest | undefined, cancelToken?: CancelToken): Promise<DeleteImageCategoryBuildingResponse> {
        let url_ = this.baseUrl + "/Building/DeleteImageCategoryBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteImageCategoryBuilding(_response);
        });
    }

    protected processDeleteImageCategoryBuilding(response: AxiosResponse): Promise<DeleteImageCategoryBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteImageCategoryBuildingResponse.fromJS(resultData200);
            return Promise.resolve<DeleteImageCategoryBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteImageCategoryBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameImagesBuilding(body: RenameImagesBuildingRequest | undefined, cancelToken?: CancelToken): Promise<RenameImagesBuildingResponse> {
        let url_ = this.baseUrl + "/Building/RenameImagesBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameImagesBuilding(_response);
        });
    }

    protected processRenameImagesBuilding(response: AxiosResponse): Promise<RenameImagesBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RenameImagesBuildingResponse.fromJS(resultData200);
            return Promise.resolve<RenameImagesBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RenameImagesBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRequestImageBuilding(body: CreateRequestImageBuildingRequest | undefined, cancelToken?: CancelToken): Promise<CreateRequestImageBuildingResponse> {
        let url_ = this.baseUrl + "/Building/CreateRequestImageBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRequestImageBuilding(_response);
        });
    }

    protected processCreateRequestImageBuilding(response: AxiosResponse): Promise<CreateRequestImageBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRequestImageBuildingResponse.fromJS(resultData200);
            return Promise.resolve<CreateRequestImageBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRequestImageBuildingResponse>(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param text (optional) 
     * @param file (optional) 
     * @return Success
     */
    createRequestImageBuildingComment(requestId: number | undefined, text: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<CreateRequestImageBuildingCommentResponse> {
        let url_ = this.baseUrl + "/Building/CreateRequestImageBuildingComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requestId === null || requestId === undefined)
            throw new Error("The parameter 'requestId' cannot be null.");
        else
            content_.append("RequestId", requestId.toString());
        if (text === null || text === undefined)
            throw new Error("The parameter 'text' cannot be null.");
        else
            content_.append("Text", text.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRequestImageBuildingComment(_response);
        });
    }

    protected processCreateRequestImageBuildingComment(response: AxiosResponse): Promise<CreateRequestImageBuildingCommentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRequestImageBuildingCommentResponse.fromJS(resultData200);
            return Promise.resolve<CreateRequestImageBuildingCommentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRequestImageBuildingCommentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setImagesShowToInvestor(body: SetImagesShowToInvestorRequest | undefined, cancelToken?: CancelToken): Promise<SetImagesShowToInvestorResponse> {
        let url_ = this.baseUrl + "/Building/SetImagesShowToInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetImagesShowToInvestor(_response);
        });
    }

    protected processSetImagesShowToInvestor(response: AxiosResponse): Promise<SetImagesShowToInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetImagesShowToInvestorResponse.fromJS(resultData200);
            return Promise.resolve<SetImagesShowToInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetImagesShowToInvestorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setAllImagesShowToInvestor(body: SetAllImagesShowToInvestorRequest | undefined, cancelToken?: CancelToken): Promise<SetAllImagesShowToInvestorResponse> {
        let url_ = this.baseUrl + "/Building/SetAllImagesShowToInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAllImagesShowToInvestor(_response);
        });
    }

    protected processSetAllImagesShowToInvestor(response: AxiosResponse): Promise<SetAllImagesShowToInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetAllImagesShowToInvestorResponse.fromJS(resultData200);
            return Promise.resolve<SetAllImagesShowToInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetAllImagesShowToInvestorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setBuildingIsActive(body: SetBuildingIsActiveRequest | undefined, cancelToken?: CancelToken): Promise<SetBuildingIsActiveResponse> {
        let url_ = this.baseUrl + "/Building/SetBuildingIsActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBuildingIsActive(_response);
        });
    }

    protected processSetBuildingIsActive(response: AxiosResponse): Promise<SetBuildingIsActiveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetBuildingIsActiveResponse.fromJS(resultData200);
            return Promise.resolve<SetBuildingIsActiveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetBuildingIsActiveResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setBuildingShowToEmployees(body: SetBuildingShowToEmployeesRequest | undefined, cancelToken?: CancelToken): Promise<SetBuildingShowToEmployeesResponse> {
        let url_ = this.baseUrl + "/Building/SetBuildingShowToEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBuildingShowToEmployees(_response);
        });
    }

    protected processSetBuildingShowToEmployees(response: AxiosResponse): Promise<SetBuildingShowToEmployeesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetBuildingShowToEmployeesResponse.fromJS(resultData200);
            return Promise.resolve<SetBuildingShowToEmployeesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetBuildingShowToEmployeesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameCategoryBuilding(body: RenameCategoryBuildingRequest | undefined, cancelToken?: CancelToken): Promise<RenameCategoryBuildingResponse> {
        let url_ = this.baseUrl + "/Building/RenameCategoryBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameCategoryBuilding(_response);
        });
    }

    protected processRenameCategoryBuilding(response: AxiosResponse): Promise<RenameCategoryBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RenameCategoryBuildingResponse.fromJS(resultData200);
            return Promise.resolve<RenameCategoryBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RenameCategoryBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImagesByIdForBuildingZip(body: GetImagesByIdForBuildingZipRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Building/GetImagesByIdForBuildingZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImagesByIdForBuildingZip(_response);
        });
    }

    protected processGetImagesByIdForBuildingZip(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setImagesCategory(body: SetImagesCategoryRequest | undefined, cancelToken?: CancelToken): Promise<SetImagesCategoryResponse> {
        let url_ = this.baseUrl + "/Building/SetImagesCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetImagesCategory(_response);
        });
    }

    protected processSetImagesCategory(response: AxiosResponse): Promise<SetImagesCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetImagesCategoryResponse.fromJS(resultData200);
            return Promise.resolve<SetImagesCategoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetImagesCategoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBuildingNote(body: DeleteBuildingNoteRequest | undefined, cancelToken?: CancelToken): Promise<DeleteBuildingNoteResponse> {
        let url_ = this.baseUrl + "/Building/DeleteBuildingNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBuildingNote(_response);
        });
    }

    protected processDeleteBuildingNote(response: AxiosResponse): Promise<DeleteBuildingNoteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteBuildingNoteResponse.fromJS(resultData200);
            return Promise.resolve<DeleteBuildingNoteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteBuildingNoteResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDeletedProjectFilesToRestore(buildingId: number, cancelToken?: CancelToken): Promise<GetDeletedProjectFilesToRestoreResponse> {
        let url_ = this.baseUrl + "/Building/GetDeletedProjectFilesToRestore/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeletedProjectFilesToRestore(_response);
        });
    }

    protected processGetDeletedProjectFilesToRestore(response: AxiosResponse): Promise<GetDeletedProjectFilesToRestoreResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeletedProjectFilesToRestoreResponse.fromJS(resultData200);
            return Promise.resolve<GetDeletedProjectFilesToRestoreResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeletedProjectFilesToRestoreResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restoreDeletedProjectFiles(body: RestoreDeletedProjectFilesRequest | undefined, cancelToken?: CancelToken): Promise<RestoreDeletedProjectFilesResponse> {
        let url_ = this.baseUrl + "/Building/RestoreDeletedProjectFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreDeletedProjectFiles(_response);
        });
    }

    protected processRestoreDeletedProjectFiles(response: AxiosResponse): Promise<RestoreDeletedProjectFilesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RestoreDeletedProjectFilesResponse.fromJS(resultData200);
            return Promise.resolve<RestoreDeletedProjectFilesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RestoreDeletedProjectFilesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDeletedProjectDocumentFilesToRestore(documentId: number, cancelToken?: CancelToken): Promise<GetDeletedProjectDocumentFilesToRestoreResponse> {
        let url_ = this.baseUrl + "/Building/GetDeletedProjectDocumentFilesToRestore/{DocumentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{DocumentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeletedProjectDocumentFilesToRestore(_response);
        });
    }

    protected processGetDeletedProjectDocumentFilesToRestore(response: AxiosResponse): Promise<GetDeletedProjectDocumentFilesToRestoreResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeletedProjectDocumentFilesToRestoreResponse.fromJS(resultData200);
            return Promise.resolve<GetDeletedProjectDocumentFilesToRestoreResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeletedProjectDocumentFilesToRestoreResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restoreDeletedProjectDocumentFiles(body: RestoreDeletedProjectDocumentFilesRequest | undefined, cancelToken?: CancelToken): Promise<RestoreDeletedProjectDocumentFilesResponse> {
        let url_ = this.baseUrl + "/Building/RestoreDeletedProjectDocumentFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreDeletedProjectDocumentFiles(_response);
        });
    }

    protected processRestoreDeletedProjectDocumentFiles(response: AxiosResponse): Promise<RestoreDeletedProjectDocumentFilesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RestoreDeletedProjectDocumentFilesResponse.fromJS(resultData200);
            return Promise.resolve<RestoreDeletedProjectDocumentFilesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RestoreDeletedProjectDocumentFilesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBuildingWeather(buildingId: number, cancelToken?: CancelToken): Promise<GetBuildingWeatherResponse> {
        let url_ = this.baseUrl + "/Building/GetBuildingWeather/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildingWeather(_response);
        });
    }

    protected processGetBuildingWeather(response: AxiosResponse): Promise<GetBuildingWeatherResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingWeatherResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingWeatherResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingWeatherResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeBuildingImageDate(body: ChangeBuildingImageCreationDateRequest | undefined, cancelToken?: CancelToken): Promise<ChangeBuildingImageCreationDateResponse> {
        let url_ = this.baseUrl + "/Building/change-building-image-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeBuildingImageDate(_response);
        });
    }

    protected processChangeBuildingImageDate(response: AxiosResponse): Promise<ChangeBuildingImageCreationDateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeBuildingImageCreationDateResponse.fromJS(resultData200);
            return Promise.resolve<ChangeBuildingImageCreationDateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeBuildingImageCreationDateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameDocumentOrFile(body: RenameDocumentOrFileRequest | undefined, cancelToken?: CancelToken): Promise<RenameDocumentOrFileResponse> {
        let url_ = this.baseUrl + "/Building/RenameDocumentOrFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameDocumentOrFile(_response);
        });
    }

    protected processRenameDocumentOrFile(response: AxiosResponse): Promise<RenameDocumentOrFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RenameDocumentOrFileResponse.fromJS(resultData200);
            return Promise.resolve<RenameDocumentOrFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RenameDocumentOrFileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyCategoryTemplate(body: ApplyCategoryTemplateRequest | undefined, cancelToken?: CancelToken): Promise<ApplyCategoryTemplateResponse> {
        let url_ = this.baseUrl + "/Building/ApplyCategoryTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyCategoryTemplate(_response);
        });
    }

    protected processApplyCategoryTemplate(response: AxiosResponse): Promise<ApplyCategoryTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplyCategoryTemplateResponse.fromJS(resultData200);
            return Promise.resolve<ApplyCategoryTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplyCategoryTemplateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadImage(body: DownloadImageRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Common/DownloadImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadImage(_response);
        });
    }

    protected processDownloadImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCustomFieldsForApplication( cancelToken?: CancelToken): Promise<GetAllCustomFieldsForApplicationResponse> {
        let url_ = this.baseUrl + "/CustomFields/GetCustomFieldsForApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomFieldsForApplication(_response);
        });
    }

    protected processGetCustomFieldsForApplication(response: AxiosResponse): Promise<GetAllCustomFieldsForApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllCustomFieldsForApplicationResponse.fromJS(resultData200);
            return Promise.resolve<GetAllCustomFieldsForApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllCustomFieldsForApplicationResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteCustomField(customFieldId: number, cancelToken?: CancelToken): Promise<DeleteCustomFieldForApplicationResponse> {
        let url_ = this.baseUrl + "/CustomFields/DeleteCustomField/{CustomFieldId}";
        if (customFieldId === undefined || customFieldId === null)
            throw new Error("The parameter 'customFieldId' must be defined.");
        url_ = url_.replace("{CustomFieldId}", encodeURIComponent("" + customFieldId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomField(_response);
        });
    }

    protected processDeleteCustomField(response: AxiosResponse): Promise<DeleteCustomFieldForApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteCustomFieldForApplicationResponse.fromJS(resultData200);
            return Promise.resolve<DeleteCustomFieldForApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteCustomFieldForApplicationResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCustomFieldsForBuilding(buildingId: number, cancelToken?: CancelToken): Promise<GetCustomFieldsForBuildingResponse> {
        let url_ = this.baseUrl + "/CustomFields/GetCustomFieldsForBuilding/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomFieldsForBuilding(_response);
        });
    }

    protected processGetCustomFieldsForBuilding(response: AxiosResponse): Promise<GetCustomFieldsForBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomFieldsForBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetCustomFieldsForBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomFieldsForBuildingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCustomFieldOptionsForEnum(customFieldId: number, cancelToken?: CancelToken): Promise<GetOptionsForCustomFieldEnumTypeResponse> {
        let url_ = this.baseUrl + "/CustomFields/GetCustomFieldOptionsForEnum/{CustomFieldId}";
        if (customFieldId === undefined || customFieldId === null)
            throw new Error("The parameter 'customFieldId' must be defined.");
        url_ = url_.replace("{CustomFieldId}", encodeURIComponent("" + customFieldId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomFieldOptionsForEnum(_response);
        });
    }

    protected processGetCustomFieldOptionsForEnum(response: AxiosResponse): Promise<GetOptionsForCustomFieldEnumTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOptionsForCustomFieldEnumTypeResponse.fromJS(resultData200);
            return Promise.resolve<GetOptionsForCustomFieldEnumTypeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOptionsForCustomFieldEnumTypeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCustomFieldForApplication(body: CreateCustomFieldForApplicationRequest | undefined, cancelToken?: CancelToken): Promise<CreateCustomFieldForApplicationResponse> {
        let url_ = this.baseUrl + "/CustomFields/CreateCustomFieldForApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCustomFieldForApplication(_response);
        });
    }

    protected processCreateCustomFieldForApplication(response: AxiosResponse): Promise<CreateCustomFieldForApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateCustomFieldForApplicationResponse.fromJS(resultData200);
            return Promise.resolve<CreateCustomFieldForApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateCustomFieldForApplicationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomFieldForApplication(body: UpdateCustomFieldForApplicationRequest | undefined, cancelToken?: CancelToken): Promise<UpdateCustomFieldForApplicationResponse> {
        let url_ = this.baseUrl + "/CustomFields/UpdateCustomFieldForApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomFieldForApplication(_response);
        });
    }

    protected processUpdateCustomFieldForApplication(response: AxiosResponse): Promise<UpdateCustomFieldForApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateCustomFieldForApplicationResponse.fromJS(resultData200);
            return Promise.resolve<UpdateCustomFieldForApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateCustomFieldForApplicationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBuildingCustomFieldValues(body: SaveBuildingCustomFieldValuesRequest | undefined, cancelToken?: CancelToken): Promise<SaveBuildingCustomFieldValuesResponse> {
        let url_ = this.baseUrl + "/CustomFields/SaveBuildingCustomFieldValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBuildingCustomFieldValues(_response);
        });
    }

    protected processSaveBuildingCustomFieldValues(response: AxiosResponse): Promise<SaveBuildingCustomFieldValuesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveBuildingCustomFieldValuesResponse.fromJS(resultData200);
            return Promise.resolve<SaveBuildingCustomFieldValuesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveBuildingCustomFieldValuesResponse>(null as any);
    }

    /**
     * @return Success
     */
    changeBuildingCustomFieldVisibility(customFieldId: number, buildingVisible: boolean, cancelToken?: CancelToken): Promise<ChangeBuildingCustomFieldVisibilityResponse> {
        let url_ = this.baseUrl + "/CustomFields/ChangeBuildingCustomFieldVisibility/{CustomFieldId}/{BuildingVisible}";
        if (customFieldId === undefined || customFieldId === null)
            throw new Error("The parameter 'customFieldId' must be defined.");
        url_ = url_.replace("{CustomFieldId}", encodeURIComponent("" + customFieldId));
        if (buildingVisible === undefined || buildingVisible === null)
            throw new Error("The parameter 'buildingVisible' must be defined.");
        url_ = url_.replace("{BuildingVisible}", encodeURIComponent("" + buildingVisible));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeBuildingCustomFieldVisibility(_response);
        });
    }

    protected processChangeBuildingCustomFieldVisibility(response: AxiosResponse): Promise<ChangeBuildingCustomFieldVisibilityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeBuildingCustomFieldVisibilityResponse.fromJS(resultData200);
            return Promise.resolve<ChangeBuildingCustomFieldVisibilityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeBuildingCustomFieldVisibilityResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryPermissions( cancelToken?: CancelToken): Promise<GetDiaryPermissionsResponse> {
        let url_ = this.baseUrl + "/Diary/GetDiaryPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryPermissions(_response);
        });
    }

    protected processGetDiaryPermissions(response: AxiosResponse): Promise<GetDiaryPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryPermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyNameForDiary( cancelToken?: CancelToken): Promise<GetCompanyNameForDiaryResponse> {
        let url_ = this.baseUrl + "/Diary/GetCompanyNameForDiary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyNameForDiary(_response);
        });
    }

    protected processGetCompanyNameForDiary(response: AxiosResponse): Promise<GetCompanyNameForDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompanyNameForDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetCompanyNameForDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompanyNameForDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiariesForUser(deleted: boolean, onlyMain: boolean, buildingId: number, cancelToken?: CancelToken): Promise<GetDiariesForUserResponse> {
        let url_ = this.baseUrl + "/Diary/GetDiariesForUser/{Deleted}/{OnlyMain}/{BuildingId}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        if (onlyMain === undefined || onlyMain === null)
            throw new Error("The parameter 'onlyMain' must be defined.");
        url_ = url_.replace("{OnlyMain}", encodeURIComponent("" + onlyMain));
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiariesForUser(_response);
        });
    }

    protected processGetDiariesForUser(response: AxiosResponse): Promise<GetDiariesForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiariesForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetDiariesForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiariesForUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDailyRecordsForUser(deleted: boolean, cancelToken?: CancelToken): Promise<GetDailyRecordsForUserResponse> {
        let url_ = this.baseUrl + "/Diary/GetDailyRecordsForUser/{Deleted}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyRecordsForUser(_response);
        });
    }

    protected processGetDailyRecordsForUser(response: AxiosResponse): Promise<GetDailyRecordsForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyRecordsForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyRecordsForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyRecordsForUserResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param language (optional) 
     * @param token (optional) 
     * @param adminUsersId (optional) 
     * @param domain (optional) 
     * @param file (optional) 
     * @return Success
     */
    getOneDayPDF(diaryRecordId: number | undefined, language: string | undefined, token: string | undefined, adminUsersId: number | undefined, domain: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Diary/GetOneDayPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("Language", language.toString());
        if (token === null || token === undefined)
            throw new Error("The parameter 'token' cannot be null.");
        else
            content_.append("Token", token.toString());
        if (adminUsersId === null || adminUsersId === undefined)
            throw new Error("The parameter 'adminUsersId' cannot be null.");
        else
            content_.append("AdminUsersId", adminUsersId.toString());
        if (domain === null || domain === undefined)
            throw new Error("The parameter 'domain' cannot be null.");
        else
            content_.append("Domain", domain.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOneDayPDF(_response);
        });
    }

    protected processGetOneDayPDF(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    getOneDayPDFLogged(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Diary/GetOneDayPDFLogged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOneDayPDFLogged(_response);
        });
    }

    protected processGetOneDayPDFLogged(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiaryRecord(diaryRecordId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, otherUserId: number, hasPhotos: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Diary/PrintDiaryRecord/{DiaryRecordId}/{OnlyMyNotes}/{HasDigitalSignatureField}/{OtherUserId}/{HasPhotos}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        if (otherUserId === undefined || otherUserId === null)
            throw new Error("The parameter 'otherUserId' must be defined.");
        url_ = url_.replace("{OtherUserId}", encodeURIComponent("" + otherUserId));
        if (hasPhotos === undefined || hasPhotos === null)
            throw new Error("The parameter 'hasPhotos' must be defined.");
        url_ = url_.replace("{HasPhotos}", encodeURIComponent("" + hasPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryRecord(_response);
        });
    }

    protected processPrintDiaryRecord(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiaryTitlePage(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, otherUserId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Diary/PrintDiaryTitlePage/{DiaryId}/{OnlyMyNotes}/{HasDigitalSignatureField}/{HasAttachments}/{OtherUserId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        if (hasAttachments === undefined || hasAttachments === null)
            throw new Error("The parameter 'hasAttachments' must be defined.");
        url_ = url_.replace("{HasAttachments}", encodeURIComponent("" + hasAttachments));
        if (otherUserId === undefined || otherUserId === null)
            throw new Error("The parameter 'otherUserId' must be defined.");
        url_ = url_.replace("{OtherUserId}", encodeURIComponent("" + otherUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryTitlePage(_response);
        });
    }

    protected processPrintDiaryTitlePage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiary(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasAttachments: boolean, otherUserId: number, hasPhotos: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Diary/PrintDiary/{DiaryId}/{OnlyMyNotes}/{HasDigitalSignatureField}/{HasAttachments}/{OtherUserId}/{HasPhotos}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        if (hasAttachments === undefined || hasAttachments === null)
            throw new Error("The parameter 'hasAttachments' must be defined.");
        url_ = url_.replace("{HasAttachments}", encodeURIComponent("" + hasAttachments));
        if (otherUserId === undefined || otherUserId === null)
            throw new Error("The parameter 'otherUserId' must be defined.");
        url_ = url_.replace("{OtherUserId}", encodeURIComponent("" + otherUserId));
        if (hasPhotos === undefined || hasPhotos === null)
            throw new Error("The parameter 'hasPhotos' must be defined.");
        url_ = url_.replace("{HasPhotos}", encodeURIComponent("" + hasPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiary(_response);
        });
    }

    protected processPrintDiary(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printDiaryInDateRange(body: GetPrintDiaryInDateRangeRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Diary/PrintDiaryInDateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryInDateRange(_response);
        });
    }

    protected processPrintDiaryInDateRange(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printWholeDiary(diaryId: number, onlyMyNotes: boolean, cancelToken?: CancelToken): Promise<GetPrintWholeDiaryOldErpResponse> {
        let url_ = this.baseUrl + "/Diary/PrintWholeDiary/{DiaryId}/{OnlyMyNotes}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintWholeDiary(_response);
        });
    }

    protected processPrintWholeDiary(response: AxiosResponse): Promise<GetPrintWholeDiaryOldErpResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPrintWholeDiaryOldErpResponse.fromJS(resultData200);
            return Promise.resolve<GetPrintWholeDiaryOldErpResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPrintWholeDiaryOldErpResponse>(null as any);
    }

    /**
     * @return Success
     */
    printWholeDiaryInDateRange(diaryId: number, onlyMyNotes: boolean, dateFrom: string, dateTo: string, cancelToken?: CancelToken): Promise<GetPrintWholeDiaryInDateRangeOldErpResponse> {
        let url_ = this.baseUrl + "/Diary/PrintWholeDiaryInDateRange/{DiaryId}/{OnlyMyNotes}/{DateFrom}/{DateTo}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        if (dateFrom === undefined || dateFrom === null)
            throw new Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{DateFrom}", encodeURIComponent("" + dateFrom));
        if (dateTo === undefined || dateTo === null)
            throw new Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{DateTo}", encodeURIComponent("" + dateTo));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintWholeDiaryInDateRange(_response);
        });
    }

    protected processPrintWholeDiaryInDateRange(response: AxiosResponse): Promise<GetPrintWholeDiaryInDateRangeOldErpResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPrintWholeDiaryInDateRangeOldErpResponse.fromJS(resultData200);
            return Promise.resolve<GetPrintWholeDiaryInDateRangeOldErpResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPrintWholeDiaryInDateRangeOldErpResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDownloadLinkOldErp(body: GetDownloadForSignedDiaryRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Diary/GetDownloadLinkOldErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadLinkOldErp(_response);
        });
    }

    protected processGetDownloadLinkOldErp(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWorkers(body: SaveWorkersRequest | undefined, cancelToken?: CancelToken): Promise<SaveWorkersResponse> {
        let url_ = this.baseUrl + "/Diary/SaveWorkers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWorkers(_response);
        });
    }

    protected processSaveWorkers(response: AxiosResponse): Promise<SaveWorkersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWorkersResponse.fromJS(resultData200);
            return Promise.resolve<SaveWorkersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWorkersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDiaryContents(body: SaveDiaryContentsRequest | undefined, cancelToken?: CancelToken): Promise<SaveDiaryContentsResponse> {
        let url_ = this.baseUrl + "/Diary/SaveDiaryContents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDiaryContents(_response);
        });
    }

    protected processSaveDiaryContents(response: AxiosResponse): Promise<SaveDiaryContentsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveDiaryContentsResponse.fromJS(resultData200);
            return Promise.resolve<SaveDiaryContentsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveDiaryContentsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWeathers(body: SaveWeathersRequest | undefined, cancelToken?: CancelToken): Promise<SaveWeathersResponse> {
        let url_ = this.baseUrl + "/Diary/SaveWeathers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWeathers(_response);
        });
    }

    protected processSaveWeathers(response: AxiosResponse): Promise<SaveWeathersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWeathersResponse.fromJS(resultData200);
            return Promise.resolve<SaveWeathersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWeathersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMaterialsTable(body: SaveMaterialsTableRequest | undefined, cancelToken?: CancelToken): Promise<SaveMaterialsTableResponse> {
        let url_ = this.baseUrl + "/Diary/SaveMaterialsTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMaterialsTable(_response);
        });
    }

    protected processSaveMaterialsTable(response: AxiosResponse): Promise<SaveMaterialsTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMaterialsTableResponse.fromJS(resultData200);
            return Promise.resolve<SaveMaterialsTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMaterialsTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMachinesTable(body: SaveMachinesTableRequest | undefined, cancelToken?: CancelToken): Promise<SaveMachinesTableResponse> {
        let url_ = this.baseUrl + "/Diary/SaveMachinesTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMachinesTable(_response);
        });
    }

    protected processSaveMachinesTable(response: AxiosResponse): Promise<SaveMachinesTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMachinesTableResponse.fromJS(resultData200);
            return Promise.resolve<SaveMachinesTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMachinesTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDiaryRecord(body: CreateDailyRecordRequest | undefined, cancelToken?: CancelToken): Promise<CreateDailyRecordResponse> {
        let url_ = this.baseUrl + "/Diary/CreateDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDiaryRecord(_response);
        });
    }

    protected processCreateDiaryRecord(response: AxiosResponse): Promise<CreateDailyRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDailyRecordResponse.fromJS(resultData200);
            return Promise.resolve<CreateDailyRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDailyRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyDiaryRecord(body: CopyDiaryRecordRequest | undefined, cancelToken?: CancelToken): Promise<CopyDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Diary/CopyDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyDiaryRecord(_response);
        });
    }

    protected processCopyDiaryRecord(response: AxiosResponse): Promise<CopyDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<CopyDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyDiaryRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDiary(body: CreateDiaryRequest | undefined, cancelToken?: CancelToken): Promise<CreateDiaryResponse> {
        let url_ = this.baseUrl + "/Diary/CreateDiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDiary(_response);
        });
    }

    protected processCreateDiary(response: AxiosResponse): Promise<CreateDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDiaryResponse.fromJS(resultData200);
            return Promise.resolve<CreateDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDiaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDiary(body: SaveDiaryRequest | undefined, cancelToken?: CancelToken): Promise<SaveDiaryResponse> {
        let url_ = this.baseUrl + "/Diary/SaveDiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDiary(_response);
        });
    }

    protected processSaveDiary(response: AxiosResponse): Promise<SaveDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveDiaryResponse.fromJS(resultData200);
            return Promise.resolve<SaveDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteImageRelation(diaryRecordId: number, fileName: string, cancelToken?: CancelToken): Promise<DeleteImageRelationFromDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Diary/DeleteImageRelation/{DiaryRecordId}/{FileName}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{FileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteImageRelation(_response);
        });
    }

    protected processDeleteImageRelation(response: AxiosResponse): Promise<DeleteImageRelationFromDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteImageRelationFromDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<DeleteImageRelationFromDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteImageRelationFromDiaryRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDiaryRecords(body: DeleteDailyRecordRequest | undefined, cancelToken?: CancelToken): Promise<DeleteDailyRecordResponse> {
        let url_ = this.baseUrl + "/Diary/DeleteDiaryRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDiaryRecords(_response);
        });
    }

    protected processDeleteDiaryRecords(response: AxiosResponse): Promise<DeleteDailyRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteDailyRecordResponse.fromJS(resultData200);
            return Promise.resolve<DeleteDailyRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteDailyRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDiaries(body: DeleteDiariesRequest | undefined, cancelToken?: CancelToken): Promise<DeleteDiariesResponse> {
        let url_ = this.baseUrl + "/Diary/DeleteDiaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDiaries(_response);
        });
    }

    protected processDeleteDiaries(response: AxiosResponse): Promise<DeleteDiariesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteDiariesResponse.fromJS(resultData200);
            return Promise.resolve<DeleteDiariesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteDiariesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFileRel(body: DeleteFileRelationDiaryRequest | undefined, cancelToken?: CancelToken): Promise<DeleteFileRelationDiaryResponse> {
        let url_ = this.baseUrl + "/Diary/DeleteFileRel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFileRel(_response);
        });
    }

    protected processDeleteFileRel(response: AxiosResponse): Promise<DeleteFileRelationDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteFileRelationDiaryResponse.fromJS(resultData200);
            return Promise.resolve<DeleteFileRelationDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteFileRelationDiaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lockUnlockDiaryRecord(body: LockDiaryRecordRequest | undefined, cancelToken?: CancelToken): Promise<LockDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Diary/LockUnlockDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLockUnlockDiaryRecord(_response);
        });
    }

    protected processLockUnlockDiaryRecord(response: AxiosResponse): Promise<LockDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LockDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<LockDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LockDiaryRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRemoveFilesDiaryRecord(body: AddRemoveFilesDiaryRecordRequest | undefined, cancelToken?: CancelToken): Promise<AddRemoveFilesDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Diary/AddRemoveFilesDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRemoveFilesDiaryRecord(_response);
        });
    }

    protected processAddRemoveFilesDiaryRecord(response: AxiosResponse): Promise<AddRemoveFilesDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddRemoveFilesDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<AddRemoveFilesDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddRemoveFilesDiaryRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveDiariesFromTrash(body: MoveDiariesFromTrashRequest | undefined, cancelToken?: CancelToken): Promise<MoveDiariesFromTrashResponse> {
        let url_ = this.baseUrl + "/Diary/MoveDiariesFromTrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveDiariesFromTrash(_response);
        });
    }

    protected processMoveDiariesFromTrash(response: AxiosResponse): Promise<MoveDiariesFromTrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveDiariesFromTrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveDiariesFromTrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveDiariesFromTrashResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveDailyRecordsFromTrash(body: MoveDialyRecordsFromTrashRequest | undefined, cancelToken?: CancelToken): Promise<MoveDialyRecordsFromTrashResponse> {
        let url_ = this.baseUrl + "/Diary/MoveDailyRecordsFromTrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveDailyRecordsFromTrash(_response);
        });
    }

    protected processMoveDailyRecordsFromTrash(response: AxiosResponse): Promise<MoveDialyRecordsFromTrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveDialyRecordsFromTrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveDialyRecordsFromTrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveDialyRecordsFromTrashResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRotatedImage(body: SaveRotatedImageRequest | undefined, cancelToken?: CancelToken): Promise<SaveRotatedImageResponse> {
        let url_ = this.baseUrl + "/Diary/SaveRotatedImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRotatedImage(_response);
        });
    }

    protected processSaveRotatedImage(response: AxiosResponse): Promise<SaveRotatedImageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveRotatedImageResponse.fromJS(resultData200);
            return Promise.resolve<SaveRotatedImageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveRotatedImageResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addEmployeesToWorkers(body: AddEmployeesToWorkersRequest | undefined, cancelToken?: CancelToken): Promise<AddEmployeesToWorkersResponse> {
        let url_ = this.baseUrl + "/Diary/AddEmployeesToWorkers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddEmployeesToWorkers(_response);
        });
    }

    protected processAddEmployeesToWorkers(response: AxiosResponse): Promise<AddEmployeesToWorkersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddEmployeesToWorkersResponse.fromJS(resultData200);
            return Promise.resolve<AddEmployeesToWorkersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddEmployeesToWorkersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthsForDiaryDialog(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetWealthsForDiaryDialogResponse> {
        let url_ = this.baseUrl + "/Diary/GetWealthsForDiaryDialog/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthsForDiaryDialog(_response);
        });
    }

    protected processGetWealthsForDiaryDialog(response: AxiosResponse): Promise<GetWealthsForDiaryDialogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthsForDiaryDialogResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthsForDiaryDialogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthsForDiaryDialogResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addWealthsToMechanisms(body: AddWealthsToMechanismsRequest | undefined, cancelToken?: CancelToken): Promise<AddWealthsToMechanismsResponse> {
        let url_ = this.baseUrl + "/Diary/AddWealthsToMechanisms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddWealthsToMechanisms(_response);
        });
    }

    protected processAddWealthsToMechanisms(response: AxiosResponse): Promise<AddWealthsToMechanismsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddWealthsToMechanismsResponse.fromJS(resultData200);
            return Promise.resolve<AddWealthsToMechanismsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddWealthsToMechanismsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWeatherForDiaryRecord(body: GetBuildingWeatherByDiaryIdRequest | undefined, cancelToken?: CancelToken): Promise<GetBuildingWeatherByDiaryIdResponse> {
        let url_ = this.baseUrl + "/Diary/GetWeatherForDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeatherForDiaryRecord(_response);
        });
    }

    protected processGetWeatherForDiaryRecord(response: AxiosResponse): Promise<GetBuildingWeatherByDiaryIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingWeatherByDiaryIdResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingWeatherByDiaryIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingWeatherByDiaryIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWeatherToDiaryRecord(body: SaveBuildingWeatherToDiaryDiaryByIdRequest | undefined, cancelToken?: CancelToken): Promise<SaveBuildingWeatherToDiaryDiaryByIdResponse> {
        let url_ = this.baseUrl + "/Diary/SaveWeatherToDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWeatherToDiaryRecord(_response);
        });
    }

    protected processSaveWeatherToDiaryRecord(response: AxiosResponse): Promise<SaveBuildingWeatherToDiaryDiaryByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveBuildingWeatherToDiaryDiaryByIdResponse.fromJS(resultData200);
            return Promise.resolve<SaveBuildingWeatherToDiaryDiaryByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveBuildingWeatherToDiaryDiaryByIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    saveShownChat(diaryRecordId: number, cancelToken?: CancelToken): Promise<SaveShownChatResponse> {
        let url_ = this.baseUrl + "/Diary/SaveShownChat/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveShownChat(_response);
        });
    }

    protected processSaveShownChat(response: AxiosResponse): Promise<SaveShownChatResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveShownChatResponse.fromJS(resultData200);
            return Promise.resolve<SaveShownChatResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveShownChatResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiariesForBuilding(buildingId: number, cancelToken?: CancelToken): Promise<GetDiariesForBuildingResponse> {
        let url_ = this.baseUrl + "/Diary/GetDiariesForBuilding/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiariesForBuilding(_response);
        });
    }

    protected processGetDiariesForBuilding(response: AxiosResponse): Promise<GetDiariesForBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiariesForBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetDiariesForBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiariesForBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImagesByIdForDiaryRecordZip(body: GetImagesByIdForDiaryRecordZipRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Diary/GetImagesByIdForDiaryRecordZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImagesByIdForDiaryRecordZip(_response);
        });
    }

    protected processGetImagesByIdForDiaryRecordZip(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWorkersIsShared(body: SaveWorkersIsSharedRequest | undefined, cancelToken?: CancelToken): Promise<SaveWorkersIsSharedResponse> {
        let url_ = this.baseUrl + "/Diary/SaveWorkersIsShared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWorkersIsShared(_response);
        });
    }

    protected processSaveWorkersIsShared(response: AxiosResponse): Promise<SaveWorkersIsSharedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWorkersIsSharedResponse.fromJS(resultData200);
            return Promise.resolve<SaveWorkersIsSharedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWorkersIsSharedResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWeathersIsShared(body: SaveWeathersIsSharedRequest | undefined, cancelToken?: CancelToken): Promise<SaveWeathersIsSharedResponse> {
        let url_ = this.baseUrl + "/Diary/SaveWeathersIsShared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWeathersIsShared(_response);
        });
    }

    protected processSaveWeathersIsShared(response: AxiosResponse): Promise<SaveWeathersIsSharedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWeathersIsSharedResponse.fromJS(resultData200);
            return Promise.resolve<SaveWeathersIsSharedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWeathersIsSharedResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMaterialsTableIsShared(body: SaveMaterialsIsSharedTableRequest | undefined, cancelToken?: CancelToken): Promise<SaveMaterialsIsSharedTableResponse> {
        let url_ = this.baseUrl + "/Diary/SaveMaterialsTableIsShared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMaterialsTableIsShared(_response);
        });
    }

    protected processSaveMaterialsTableIsShared(response: AxiosResponse): Promise<SaveMaterialsIsSharedTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMaterialsIsSharedTableResponse.fromJS(resultData200);
            return Promise.resolve<SaveMaterialsIsSharedTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMaterialsIsSharedTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMachinesTableIsShared(body: SaveMachinesIsSharedTableRequest | undefined, cancelToken?: CancelToken): Promise<SaveMachinesIsSharedTableResponse> {
        let url_ = this.baseUrl + "/Diary/SaveMachinesTableIsShared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMachinesTableIsShared(_response);
        });
    }

    protected processSaveMachinesTableIsShared(response: AxiosResponse): Promise<SaveMachinesIsSharedTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMachinesIsSharedTableResponse.fromJS(resultData200);
            return Promise.resolve<SaveMachinesIsSharedTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMachinesIsSharedTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setIsActiveDiary(body: SetIsActiveDiaryRequest | undefined, cancelToken?: CancelToken): Promise<SetIsActiveDiaryResponse> {
        let url_ = this.baseUrl + "/Diary/SetIsActiveDiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsActiveDiary(_response);
        });
    }

    protected processSetIsActiveDiary(response: AxiosResponse): Promise<SetIsActiveDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetIsActiveDiaryResponse.fromJS(resultData200);
            return Promise.resolve<SetIsActiveDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetIsActiveDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBase64FromUri(uri: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetBase64FromUri/{Uri}";
        if (uri === undefined || uri === null)
            throw new Error("The parameter 'uri' must be defined.");
        url_ = url_.replace("{Uri}", encodeURIComponent("" + uri));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBase64FromUri(_response);
        });
    }

    protected processGetBase64FromUri(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiaryRecordInvestor(diaryRecordId: number, hasDigitalSignatureField: boolean, hasPhotos: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/PrintDiaryRecordInvestor/{DiaryRecordId}/{HasDigitalSignatureField}/{HasPhotos}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        if (hasPhotos === undefined || hasPhotos === null)
            throw new Error("The parameter 'hasPhotos' must be defined.");
        url_ = url_.replace("{HasPhotos}", encodeURIComponent("" + hasPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryRecordInvestor(_response);
        });
    }

    protected processPrintDiaryRecordInvestor(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiaryInvestorTitlePage(diaryId: number, hasDigitalSignatureField: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/PrintDiaryInvestorTitlePage/{DiaryId}/{HasDigitalSignatureField}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryInvestorTitlePage(_response);
        });
    }

    protected processPrintDiaryInvestorTitlePage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiaryInvestor(diaryId: number, hasDigitalSignatureField: boolean, hasPhotos: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/PrintDiaryInvestor/{DiaryId}/{HasDigitalSignatureField}/{HasPhotos}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        if (hasPhotos === undefined || hasPhotos === null)
            throw new Error("The parameter 'hasPhotos' must be defined.");
        url_ = url_.replace("{HasPhotos}", encodeURIComponent("" + hasPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryInvestor(_response);
        });
    }

    protected processPrintDiaryInvestor(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDailyRecordsForUserAndDiary(diaryId: number, cancelToken?: CancelToken): Promise<GetDailyRecordsForUserAndDiaryResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetDailyRecordsForUserAndDiary/{DiaryId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyRecordsForUserAndDiary(_response);
        });
    }

    protected processGetDailyRecordsForUserAndDiary(response: AxiosResponse): Promise<GetDailyRecordsForUserAndDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyRecordsForUserAndDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyRecordsForUserAndDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyRecordsForUserAndDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDailyRecordsForUserAndDiaryByRecordId(recordId: number, cancelToken?: CancelToken): Promise<GetDailyRecordsForUserAndDiaryByRecordIdResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetDailyRecordsForUserAndDiaryByRecordId/{RecordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{RecordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyRecordsForUserAndDiaryByRecordId(_response);
        });
    }

    protected processGetDailyRecordsForUserAndDiaryByRecordId(response: AxiosResponse): Promise<GetDailyRecordsForUserAndDiaryByRecordIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyRecordsForUserAndDiaryByRecordIdResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyRecordsForUserAndDiaryByRecordIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyRecordsForUserAndDiaryByRecordIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryDataDetail(diaryId: number, cancelToken?: CancelToken): Promise<GetDiaryDataDetailResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetDiaryDataDetail/{DiaryId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryDataDetail(_response);
        });
    }

    protected processGetDiaryDataDetail(response: AxiosResponse): Promise<GetDiaryDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryDataDetailResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryUsersForGroup(groupId: number, buildingId: number, cancelToken?: CancelToken): Promise<GetDiaryUsersForGroupResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetDiaryUsersForGroup/{GroupId}/{BuildingId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryUsersForGroup(_response);
        });
    }

    protected processGetDiaryUsersForGroup(response: AxiosResponse): Promise<GetDiaryUsersForGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryUsersForGroupResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryUsersForGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryUsersForGroupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWeatherForRecord(body: GetWeatherForRecordRequest | undefined, cancelToken?: CancelToken): Promise<GetWeatherForRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetWeatherForRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeatherForRecord(_response);
        });
    }

    protected processGetWeatherForRecord(response: AxiosResponse): Promise<GetWeatherForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWeatherForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetWeatherForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWeatherForRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWorkersForRecord(body: GetWorkersForRecordRequest | undefined, cancelToken?: CancelToken): Promise<GetWorkersForRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetWorkersForRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkersForRecord(_response);
        });
    }

    protected processGetWorkersForRecord(response: AxiosResponse): Promise<GetWorkersForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWorkersForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetWorkersForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWorkersForRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCompletedWorks(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetCompletedWorksResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetCompletedWorks/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompletedWorks(_response);
        });
    }

    protected processGetCompletedWorks(response: AxiosResponse): Promise<GetCompletedWorksResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompletedWorksResponse.fromJS(resultData200);
            return Promise.resolve<GetCompletedWorksResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompletedWorksResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMachinesForRecordTable(body: GetMachinesForRecordTableRequest | undefined, cancelToken?: CancelToken): Promise<GetMachinesForRecordTableResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetMachinesForRecordTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMachinesForRecordTable(_response);
        });
    }

    protected processGetMachinesForRecordTable(response: AxiosResponse): Promise<GetMachinesForRecordTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMachinesForRecordTableResponse.fromJS(resultData200);
            return Promise.resolve<GetMachinesForRecordTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMachinesForRecordTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMaterialsForRecordTable(body: GetMaterialsForRecordTableRequest | undefined, cancelToken?: CancelToken): Promise<GetMaterialsForRecordTableResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetMaterialsForRecordTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialsForRecordTable(_response);
        });
    }

    protected processGetMaterialsForRecordTable(response: AxiosResponse): Promise<GetMaterialsForRecordTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMaterialsForRecordTableResponse.fromJS(resultData200);
            return Promise.resolve<GetMaterialsForRecordTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMaterialsForRecordTableResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAdditionalNotes(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetAdditionalNotesResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetAdditionalNotes/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdditionalNotes(_response);
        });
    }

    protected processGetAdditionalNotes(response: AxiosResponse): Promise<GetAdditionalNotesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdditionalNotesResponse.fromJS(resultData200);
            return Promise.resolve<GetAdditionalNotesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdditionalNotesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryImages(diaryRecordId: number, getBase64: boolean, cancelToken?: CancelToken): Promise<GetImagesUrlsForRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetDiaryImages/{DiaryRecordId}/{GetBase64}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (getBase64 === undefined || getBase64 === null)
            throw new Error("The parameter 'getBase64' must be defined.");
        url_ = url_.replace("{GetBase64}", encodeURIComponent("" + getBase64));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryImages(_response);
        });
    }

    protected processGetDiaryImages(response: AxiosResponse): Promise<GetImagesUrlsForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetImagesUrlsForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetImagesUrlsForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetImagesUrlsForRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getImageUrlsForDiary(diaryId: number, getBase64: boolean, cancelToken?: CancelToken): Promise<GetImageUrlsForDiaryResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetImageUrlsForDiary/{DiaryId}/{GetBase64}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (getBase64 === undefined || getBase64 === null)
            throw new Error("The parameter 'getBase64' must be defined.");
        url_ = url_.replace("{GetBase64}", encodeURIComponent("" + getBase64));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImageUrlsForDiary(_response);
        });
    }

    protected processGetImageUrlsForDiary(response: AxiosResponse): Promise<GetImageUrlsForDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetImageUrlsForDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetImageUrlsForDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetImageUrlsForDiaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fullDayRecord(body: GetDailyFullRecordRequest | undefined, cancelToken?: CancelToken): Promise<GetDailyFullRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/FullDayRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFullDayRecord(_response);
        });
    }

    protected processFullDayRecord(response: AxiosResponse): Promise<GetDailyFullRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyFullRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyFullRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyFullRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    diaryRecordDataNotTables(diaryRecordId: number, onlyShared: boolean, cancelToken?: CancelToken): Promise<GetDiaryRecordDataNotTablesResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/DiaryRecordDataNotTables/{DiaryRecordId}/{OnlyShared}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (onlyShared === undefined || onlyShared === null)
            throw new Error("The parameter 'onlyShared' must be defined.");
        url_ = url_.replace("{OnlyShared}", encodeURIComponent("" + onlyShared));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiaryRecordDataNotTables(_response);
        });
    }

    protected processDiaryRecordDataNotTables(response: AxiosResponse): Promise<GetDiaryRecordDataNotTablesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryRecordDataNotTablesResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryRecordDataNotTablesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryRecordDataNotTablesResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @param isInvestor (optional) 
     * @return Success
     */
    uploadSignature(diaryRecordId: number | undefined, file: FileParameter | undefined, isInvestor: boolean | undefined, cancelToken?: CancelToken): Promise<SaveDiarySignatureAdminUserResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/UploadSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (isInvestor === null || isInvestor === undefined)
            throw new Error("The parameter 'isInvestor' cannot be null.");
        else
            content_.append("IsInvestor", isInvestor.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSignature(_response);
        });
    }

    protected processUploadSignature(response: AxiosResponse): Promise<SaveDiarySignatureAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveDiarySignatureAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<SaveDiarySignatureAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveDiarySignatureAdminUserResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadDigitallySignedPDF(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadDigitalSignedPDFResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/UploadDigitallySignedPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDigitallySignedPDF(_response);
        });
    }

    protected processUploadDigitallySignedPDF(response: AxiosResponse): Promise<UploadDigitalSignedPDFResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadDigitalSignedPDFResponse.fromJS(resultData200);
            return Promise.resolve<UploadDigitalSignedPDFResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadDigitalSignedPDFResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSignaturesForRecord(diaryRecordId: number, getBase64: boolean, cancelToken?: CancelToken): Promise<GetSignaturesForRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetSignaturesForRecord/{DiaryRecordId}/{GetBase64}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (getBase64 === undefined || getBase64 === null)
            throw new Error("The parameter 'getBase64' must be defined.");
        url_ = url_.replace("{GetBase64}", encodeURIComponent("" + getBase64));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignaturesForRecord(_response);
        });
    }

    protected processGetSignaturesForRecord(response: AxiosResponse): Promise<GetSignaturesForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignaturesForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetSignaturesForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignaturesForRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodosForDiary(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetTodosForDiaryResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetTodosForDiary/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodosForDiary(_response);
        });
    }

    protected processGetTodosForDiary(response: AxiosResponse): Promise<GetTodosForDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosForDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosForDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosForDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFilesForDiary(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetFilesForBuildingRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetFilesForDiary/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilesForDiary(_response);
        });
    }

    protected processGetFilesForDiary(response: AxiosResponse): Promise<GetFilesForBuildingRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilesForBuildingRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetFilesForBuildingRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilesForBuildingRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFilesFromBuildingForDiary(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetFilesFromBuildingForDiaryResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetFilesFromBuildingForDiary/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilesFromBuildingForDiary(_response);
        });
    }

    protected processGetFilesFromBuildingForDiary(response: AxiosResponse): Promise<GetFilesFromBuildingForDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilesFromBuildingForDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetFilesFromBuildingForDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilesFromBuildingForDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorsChatMessages(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetDiaryInvestorsChatResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetInvestorsChatMessages/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestorsChatMessages(_response);
        });
    }

    protected processGetInvestorsChatMessages(response: AxiosResponse): Promise<GetDiaryInvestorsChatResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryInvestorsChatResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryInvestorsChatResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryInvestorsChatResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSubcontractorsChatMessages(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetDiarySubcontractorsChatResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetSubcontractorsChatMessages/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubcontractorsChatMessages(_response);
        });
    }

    protected processGetSubcontractorsChatMessages(response: AxiosResponse): Promise<GetDiarySubcontractorsChatResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiarySubcontractorsChatResponse.fromJS(resultData200);
            return Promise.resolve<GetDiarySubcontractorsChatResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiarySubcontractorsChatResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInvestorsChatMessage(body: PostDiaryChatMessageInvestorsRequest | undefined, cancelToken?: CancelToken): Promise<PostDiaryChatMessageInvestorsResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/SendInvestorsChatMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInvestorsChatMessage(_response);
        });
    }

    protected processSendInvestorsChatMessage(response: AxiosResponse): Promise<PostDiaryChatMessageInvestorsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostDiaryChatMessageInvestorsResponse.fromJS(resultData200);
            return Promise.resolve<PostDiaryChatMessageInvestorsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDiaryChatMessageInvestorsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSubcontractorsChatMessage(body: PostDiaryChatMessageSubcontractorsRequest | undefined, cancelToken?: CancelToken): Promise<PostDiaryChatMessageSubcontractorsResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/SendSubcontractorsChatMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSubcontractorsChatMessage(_response);
        });
    }

    protected processSendSubcontractorsChatMessage(response: AxiosResponse): Promise<PostDiaryChatMessageSubcontractorsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostDiaryChatMessageSubcontractorsResponse.fromJS(resultData200);
            return Promise.resolve<PostDiaryChatMessageSubcontractorsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDiaryChatMessageSubcontractorsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDiarySearchResult(body: GetDiarySearchResultRequest | undefined, cancelToken?: CancelToken): Promise<GetDiarySearchResultResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetDiarySearchResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiarySearchResult(_response);
        });
    }

    protected processGetDiarySearchResult(response: AxiosResponse): Promise<GetDiarySearchResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiarySearchResultResponse.fromJS(resultData200);
            return Promise.resolve<GetDiarySearchResultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiarySearchResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendMessageDiary(body: SendMessageDiaryRequest | undefined, cancelToken?: CancelToken): Promise<SendMessageDiaryResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/SendMessageDiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMessageDiary(_response);
        });
    }

    protected processSendMessageDiary(response: AxiosResponse): Promise<SendMessageDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendMessageDiaryResponse.fromJS(resultData200);
            return Promise.resolve<SendMessageDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendMessageDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPhotosBuildingToChoose(diaryRecordId: number, onlyTodaysPhotos: boolean, cancelToken?: CancelToken): Promise<GetPhotosFromBuildingToDiaryChooseResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetPhotosBuildingToChoose/{DiaryRecordId}/{OnlyTodaysPhotos}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (onlyTodaysPhotos === undefined || onlyTodaysPhotos === null)
            throw new Error("The parameter 'onlyTodaysPhotos' must be defined.");
        url_ = url_.replace("{OnlyTodaysPhotos}", encodeURIComponent("" + onlyTodaysPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhotosBuildingToChoose(_response);
        });
    }

    protected processGetPhotosBuildingToChoose(response: AxiosResponse): Promise<GetPhotosFromBuildingToDiaryChooseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPhotosFromBuildingToDiaryChooseResponse.fromJS(resultData200);
            return Promise.resolve<GetPhotosFromBuildingToDiaryChooseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPhotosFromBuildingToDiaryChooseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transferPhotoFromProject(body: TransferPhotosFromProjectRequest | undefined, cancelToken?: CancelToken): Promise<TransferPhotosFromProjectResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/TransferPhotoFromProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferPhotoFromProject(_response);
        });
    }

    protected processTransferPhotoFromProject(response: AxiosResponse): Promise<TransferPhotosFromProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransferPhotosFromProjectResponse.fromJS(resultData200);
            return Promise.resolve<TransferPhotosFromProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransferPhotosFromProjectResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadImage(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<AddImageToProjectAndDiaryRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/UploadImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: AxiosResponse): Promise<AddImageToProjectAndDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddImageToProjectAndDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<AddImageToProjectAndDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImageToProjectAndDiaryRecordResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    addFileToRecordDirect(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadFileToDiaryDirectResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/AddFileToRecordDirect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFileToRecordDirect(_response);
        });
    }

    protected processAddFileToRecordDirect(response: AxiosResponse): Promise<UploadFileToDiaryDirectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadFileToDiaryDirectResponse.fromJS(resultData200);
            return Promise.resolve<UploadFileToDiaryDirectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFileToDiaryDirectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryRecordLog(recordId: number, cancelToken?: CancelToken): Promise<GetDiaryRecordLogResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetDiaryRecordLog/{RecordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{RecordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryRecordLog(_response);
        });
    }

    protected processGetDiaryRecordLog(response: AxiosResponse): Promise<GetDiaryRecordLogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryRecordLogResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryRecordLogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryRecordLogResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMaterialsForRecordsExcel(body: GetMaterialsForRecordsExcelRequest | undefined, cancelToken?: CancelToken): Promise<GetMaterialsForRecordsExcelResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetMaterialsForRecordsExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialsForRecordsExcel(_response);
        });
    }

    protected processGetMaterialsForRecordsExcel(response: AxiosResponse): Promise<GetMaterialsForRecordsExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMaterialsForRecordsExcelResponse.fromJS(resultData200);
            return Promise.resolve<GetMaterialsForRecordsExcelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMaterialsForRecordsExcelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPrintStatus(body: GetPrintStatusRequest | undefined, cancelToken?: CancelToken): Promise<GetPrintStatusResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetPrintStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrintStatus(_response);
        });
    }

    protected processGetPrintStatus(response: AxiosResponse): Promise<GetPrintStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPrintStatusResponse.fromJS(resultData200);
            return Promise.resolve<GetPrintStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPrintStatusResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserRoleForSubcontractor( cancelToken?: CancelToken): Promise<GetUserRoleForSubcontractorResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetUserRoleForSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoleForSubcontractor(_response);
        });
    }

    protected processGetUserRoleForSubcontractor(response: AxiosResponse): Promise<GetUserRoleForSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserRoleForSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<GetUserRoleForSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserRoleForSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printDiaryBackground(body: PrintDiaryBackgroundRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/DiaryCommon/PrintDiaryBackground";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryBackground(_response);
        });
    }

    protected processPrintDiaryBackground(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printSignedDiaryRecordsZIP(body: PrintSignedDiaryRecordsZIPRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/DiaryCommon/PrintSignedDiaryRecordsZIP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintSignedDiaryRecordsZIP(_response);
        });
    }

    protected processPrintSignedDiaryRecordsZIP(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMobileDiaryRecord(diaryRecordId: number, date: Date, cancelToken?: CancelToken): Promise<GetMobileDiaryRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/GetMobileDiaryRecord/{DiaryRecordId}/{Date}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{Date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMobileDiaryRecord(_response);
        });
    }

    protected processGetMobileDiaryRecord(response: AxiosResponse): Promise<GetMobileDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMobileDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetMobileDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMobileDiaryRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMobileDiaryRecord(body: SaveMobileDiaryRecordRequest | undefined, cancelToken?: CancelToken): Promise<SaveMobileDiaryRecordResponse> {
        let url_ = this.baseUrl + "/DiaryCommon/SaveMobileDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMobileDiaryRecord(_response);
        });
    }

    protected processSaveMobileDiaryRecord(response: AxiosResponse): Promise<SaveMobileDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMobileDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<SaveMobileDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMobileDiaryRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    employeeMe( cancelToken?: CancelToken): Promise<MeEmployeeResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/employee-me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployeeMe(_response);
        });
    }

    protected processEmployeeMe(response: AxiosResponse): Promise<MeEmployeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeEmployeeResponse.fromJS(resultData200);
            return Promise.resolve<MeEmployeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeEmployeeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAttendanceForEmployeeMobile(body: GetAttendanceForEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<GetAttendanceForEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/GetAttendanceForEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttendanceForEmployeeMobile(_response);
        });
    }

    protected processGetAttendanceForEmployeeMobile(response: AxiosResponse): Promise<GetAttendanceForEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAttendanceForEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<GetAttendanceForEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAttendanceForEmployeeMobileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllDocumentsEmployeeMobile( cancelToken?: CancelToken): Promise<GetAllDocumentsEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/GetAllDocumentsEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDocumentsEmployeeMobile(_response);
        });
    }

    protected processGetAllDocumentsEmployeeMobile(response: AxiosResponse): Promise<GetAllDocumentsEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllDocumentsEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<GetAllDocumentsEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllDocumentsEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDocumentAsRejectedEmployeeMobile(body: SetDocumentAsRejectedEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<SetDocumentAsRejectedEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/SetDocumentAsRejectedEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDocumentAsRejectedEmployeeMobile(_response);
        });
    }

    protected processSetDocumentAsRejectedEmployeeMobile(response: AxiosResponse): Promise<SetDocumentAsRejectedEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetDocumentAsRejectedEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<SetDocumentAsRejectedEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetDocumentAsRejectedEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDocumentAsReadEmployeeMobile(body: SetDocumentAsReadEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<SetDocumentAsReadEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/SetDocumentAsReadEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDocumentAsReadEmployeeMobile(_response);
        });
    }

    protected processSetDocumentAsReadEmployeeMobile(response: AxiosResponse): Promise<SetDocumentAsReadEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetDocumentAsReadEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<SetDocumentAsReadEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetDocumentAsReadEmployeeMobileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllBozpDocumentNewsEmployeeMobile(documents: boolean, bozp: boolean, news: boolean, cancelToken?: CancelToken): Promise<GetAllBozpDocumentNewsEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/GetAllBozpDocumentNewsEmployeeMobile/{Documents}/{Bozp}/{News}";
        if (documents === undefined || documents === null)
            throw new Error("The parameter 'documents' must be defined.");
        url_ = url_.replace("{Documents}", encodeURIComponent("" + documents));
        if (bozp === undefined || bozp === null)
            throw new Error("The parameter 'bozp' must be defined.");
        url_ = url_.replace("{Bozp}", encodeURIComponent("" + bozp));
        if (news === undefined || news === null)
            throw new Error("The parameter 'news' must be defined.");
        url_ = url_.replace("{News}", encodeURIComponent("" + news));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBozpDocumentNewsEmployeeMobile(_response);
        });
    }

    protected processGetAllBozpDocumentNewsEmployeeMobile(response: AxiosResponse): Promise<GetAllBozpDocumentNewsEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllBozpDocumentNewsEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<GetAllBozpDocumentNewsEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllBozpDocumentNewsEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setBozpAsReadEmployeeMobile(body: SetBozpAsReadEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<SetBozpAsReadEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/SetBozpAsReadEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBozpAsReadEmployeeMobile(_response);
        });
    }

    protected processSetBozpAsReadEmployeeMobile(response: AxiosResponse): Promise<SetBozpAsReadEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetBozpAsReadEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<SetBozpAsReadEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetBozpAsReadEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNewsAsReadEmployeeMobile(body: SetNewsAsReadEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<SetNewsAsReadEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/SetNewsAsReadEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetNewsAsReadEmployeeMobile(_response);
        });
    }

    protected processSetNewsAsReadEmployeeMobile(response: AxiosResponse): Promise<SetNewsAsReadEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetNewsAsReadEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<SetNewsAsReadEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetNewsAsReadEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editWorkTimeNotify(body: EditWorkTimeNotifyRequest | undefined, cancelToken?: CancelToken): Promise<EditWorkTimeNotifyResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/edit-work-time-notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditWorkTimeNotify(_response);
        });
    }

    protected processEditWorkTimeNotify(response: AxiosResponse): Promise<EditWorkTimeNotifyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditWorkTimeNotifyResponse.fromJS(resultData200);
            return Promise.resolve<EditWorkTimeNotifyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditWorkTimeNotifyResponse>(null as any);
    }

    /**
     * @return Success
     */
    getHasUnreadDocumentsMobile( cancelToken?: CancelToken): Promise<GetHasUnreadDocumentsMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/GetHasUnreadDocumentsMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHasUnreadDocumentsMobile(_response);
        });
    }

    protected processGetHasUnreadDocumentsMobile(response: AxiosResponse): Promise<GetHasUnreadDocumentsMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHasUnreadDocumentsMobileResponse.fromJS(resultData200);
            return Promise.resolve<GetHasUnreadDocumentsMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHasUnreadDocumentsMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCurrentFcmToken(body: DeleteCurrentFcmTokenRequest | undefined, cancelToken?: CancelToken): Promise<DeleteCurrentFcmTokenResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/DeleteCurrentFcmToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCurrentFcmToken(_response);
        });
    }

    protected processDeleteCurrentFcmToken(response: AxiosResponse): Promise<DeleteCurrentFcmTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteCurrentFcmTokenResponse.fromJS(resultData200);
            return Promise.resolve<DeleteCurrentFcmTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteCurrentFcmTokenResponse>(null as any);
    }

    /**
     * @return Success
     */
    getHasUnreadBozpDocumentsNewsMobile( cancelToken?: CancelToken): Promise<GetHasUnreadBozpDocumentsNewsMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobile/GetHasUnreadBozpDocumentsNewsMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHasUnreadBozpDocumentsNewsMobile(_response);
        });
    }

    protected processGetHasUnreadBozpDocumentsNewsMobile(response: AxiosResponse): Promise<GetHasUnreadBozpDocumentsNewsMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHasUnreadBozpDocumentsNewsMobileResponse.fromJS(resultData200);
            return Promise.resolve<GetHasUnreadBozpDocumentsNewsMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHasUnreadBozpDocumentsNewsMobileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllRequestsEmployeeMobile(state: TodoState, pageSize: number, offset: number, cancelToken?: CancelToken): Promise<GetAllRequestsEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/GetAllRequestsEmployeeMobile/{State}/{PageSize}/{Offset}";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{State}", encodeURIComponent("" + state));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{PageSize}", encodeURIComponent("" + pageSize));
        if (offset === undefined || offset === null)
            throw new Error("The parameter 'offset' must be defined.");
        url_ = url_.replace("{Offset}", encodeURIComponent("" + offset));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllRequestsEmployeeMobile(_response);
        });
    }

    protected processGetAllRequestsEmployeeMobile(response: AxiosResponse): Promise<GetAllRequestsEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllRequestsEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<GetAllRequestsEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllRequestsEmployeeMobileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRequestDetail(id: number, cancelToken?: CancelToken): Promise<GetRequestDetailResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/GetRequestDetail/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestDetail(_response);
        });
    }

    protected processGetRequestDetail(response: AxiosResponse): Promise<GetRequestDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetRequestDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestDetailResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRequestMessagesEmployeeMobile(requestId: number, pageSize: number, offset: number, cancelToken?: CancelToken): Promise<GetRequestMessagesEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/GetRequestMessagesEmployeeMobile/{RequestId}/{PageSize}/{Offset}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{RequestId}", encodeURIComponent("" + requestId));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{PageSize}", encodeURIComponent("" + pageSize));
        if (offset === undefined || offset === null)
            throw new Error("The parameter 'offset' must be defined.");
        url_ = url_.replace("{Offset}", encodeURIComponent("" + offset));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestMessagesEmployeeMobile(_response);
        });
    }

    protected processGetRequestMessagesEmployeeMobile(response: AxiosResponse): Promise<GetRequestMessagesEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestMessagesEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<GetRequestMessagesEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestMessagesEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setRequestStateEmployeeMobile(body: SetRequestStateEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<SetRequestStateEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/SetRequestStateEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRequestStateEmployeeMobile(_response);
        });
    }

    protected processSetRequestStateEmployeeMobile(response: AxiosResponse): Promise<SetRequestStateEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetRequestStateEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<SetRequestStateEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetRequestStateEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRequestEmployeeMobile(body: AddRequestEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<AddRequestEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/AddRequestEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRequestEmployeeMobile(_response);
        });
    }

    protected processAddRequestEmployeeMobile(response: AxiosResponse): Promise<AddRequestEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddRequestEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<AddRequestEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddRequestEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMessageRequestEmployeeMobile(body: AddMessageRequestEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<AddMessageRequestEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/AddMessageRequestEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMessageRequestEmployeeMobile(_response);
        });
    }

    protected processAddMessageRequestEmployeeMobile(response: AxiosResponse): Promise<AddMessageRequestEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMessageRequestEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<AddMessageRequestEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMessageRequestEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRequestEmployeeMobile(body: UpdateRequestEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<UpdateRequestEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/UpdateRequestEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRequestEmployeeMobile(_response);
        });
    }

    protected processUpdateRequestEmployeeMobile(response: AxiosResponse): Promise<UpdateRequestEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRequestEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRequestEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRequestEmployeeMobileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setMessagesAsReadEmployeeMobile(body: SetMessagesAsReadEmployeeMobileRequest | undefined, cancelToken?: CancelToken): Promise<SetMessagesAsReadEmployeeMobileResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/SetMessagesAsReadEmployeeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMessagesAsReadEmployeeMobile(_response);
        });
    }

    protected processSetMessagesAsReadEmployeeMobile(response: AxiosResponse): Promise<SetMessagesAsReadEmployeeMobileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetMessagesAsReadEmployeeMobileResponse.fromJS(resultData200);
            return Promise.resolve<SetMessagesAsReadEmployeeMobileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetMessagesAsReadEmployeeMobileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUnreadMessagesCount( cancelToken?: CancelToken): Promise<GetUnreadMessagesCountResponse> {
        let url_ = this.baseUrl + "/EmployeeMobileRequests/GetUnreadMessagesCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnreadMessagesCount(_response);
        });
    }

    protected processGetUnreadMessagesCount(response: AxiosResponse): Promise<GetUnreadMessagesCountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUnreadMessagesCountResponse.fromJS(resultData200);
            return Promise.resolve<GetUnreadMessagesCountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUnreadMessagesCountResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesWithGroups(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetEmployeesWithGroupsResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeesWithGroups/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeesWithGroups(_response);
        });
    }

    protected processGetEmployeesWithGroups(response: AxiosResponse): Promise<GetEmployeesWithGroupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeesWithGroupsResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeesWithGroupsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeesWithGroupsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesForAdminUser( cancelToken?: CancelToken): Promise<GetEmployeesForAdminUserResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeesForAdminUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeesForAdminUser(_response);
        });
    }

    protected processGetEmployeesForAdminUser(response: AxiosResponse): Promise<GetEmployeesForAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeesForAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeesForAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeesForAdminUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeGroupsNames( cancelToken?: CancelToken): Promise<GetEmployeeGroupsNamesResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeGroupsNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeGroupsNames(_response);
        });
    }

    protected processGetEmployeeGroupsNames(response: AxiosResponse): Promise<GetEmployeeGroupsNamesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeGroupsNamesResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeGroupsNamesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeGroupsNamesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeForBuilding( cancelToken?: CancelToken): Promise<GetEmployeeForBuildingResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeForBuilding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeForBuilding(_response);
        });
    }

    protected processGetEmployeeForBuilding(response: AxiosResponse): Promise<GetEmployeeForBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeForBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeForBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeForBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmployeeAttendanceHelios(body: GetEmployeeAttendanceHeliosRequest | undefined, cancelToken?: CancelToken): Promise<GetEmployeeAttendanceHeliosResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeAttendanceHelios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeAttendanceHelios(_response);
        });
    }

    protected processGetEmployeeAttendanceHelios(response: AxiosResponse): Promise<GetEmployeeAttendanceHeliosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeAttendanceHeliosResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeAttendanceHeliosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeAttendanceHeliosResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesList( cancelToken?: CancelToken): Promise<GetEmployeesListResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeesList(_response);
        });
    }

    protected processGetEmployeesList(response: AxiosResponse): Promise<GetEmployeesListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeesListResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeesListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeesListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setIsEmployeeActive(body: SetIsEmployeeActiveRequest | undefined, cancelToken?: CancelToken): Promise<SetIsEmployeeActiveResponse> {
        let url_ = this.baseUrl + "/Employees/SetIsEmployeeActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsEmployeeActive(_response);
        });
    }

    protected processSetIsEmployeeActive(response: AxiosResponse): Promise<SetIsEmployeeActiveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetIsEmployeeActiveResponse.fromJS(resultData200);
            return Promise.resolve<SetIsEmployeeActiveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetIsEmployeeActiveResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDeletedEmployees( cancelToken?: CancelToken): Promise<GetDeletedEmployeesResponse> {
        let url_ = this.baseUrl + "/Employees/GetDeletedEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeletedEmployees(_response);
        });
    }

    protected processGetDeletedEmployees(response: AxiosResponse): Promise<GetDeletedEmployeesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeletedEmployeesResponse.fromJS(resultData200);
            return Promise.resolve<GetDeletedEmployeesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeletedEmployeesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveEmployeesFromTrash(body: MoveEmployeesFromTrashRequest | undefined, cancelToken?: CancelToken): Promise<MoveEmployeesFromTrashResponse> {
        let url_ = this.baseUrl + "/Employees/MoveEmployeesFromTrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveEmployeesFromTrash(_response);
        });
    }

    protected processMoveEmployeesFromTrash(response: AxiosResponse): Promise<MoveEmployeesFromTrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveEmployeesFromTrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveEmployeesFromTrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveEmployeesFromTrashResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployees(body: DeleteEmployeesRequest | undefined, cancelToken?: CancelToken): Promise<DeleteEmployeesResponse> {
        let url_ = this.baseUrl + "/Employees/DeleteEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmployees(_response);
        });
    }

    protected processDeleteEmployees(response: AxiosResponse): Promise<DeleteEmployeesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteEmployeesResponse.fromJS(resultData200);
            return Promise.resolve<DeleteEmployeesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteEmployeesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeDetail(id: number, cancelToken?: CancelToken): Promise<GetEmployeeDetailResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeDetail/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeDetail(_response);
        });
    }

    protected processGetEmployeeDetail(response: AxiosResponse): Promise<GetEmployeeDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeDetailResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSignatureForEmployee(employeeId: number, cancelToken?: CancelToken): Promise<GetSignatureForEmployeeResponse> {
        let url_ = this.baseUrl + "/Employees/GetSignatureForEmployee/{EmployeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{EmployeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignatureForEmployee(_response);
        });
    }

    protected processGetSignatureForEmployee(response: AxiosResponse): Promise<GetSignatureForEmployeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignatureForEmployeeResponse.fromJS(resultData200);
            return Promise.resolve<GetSignatureForEmployeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignatureForEmployeeResponse>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param file (optional) 
     * @return Success
     */
    saveEmployeeSignature(employeeId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<SaveEmployeeSignatureResponse> {
        let url_ = this.baseUrl + "/Employees/SaveEmployeeSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (employeeId === null || employeeId === undefined)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else
            content_.append("EmployeeId", employeeId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmployeeSignature(_response);
        });
    }

    protected processSaveEmployeeSignature(response: AxiosResponse): Promise<SaveEmployeeSignatureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveEmployeeSignatureResponse.fromJS(resultData200);
            return Promise.resolve<SaveEmployeeSignatureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveEmployeeSignatureResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployeeSignature(body: DeleteEmployeeSignatureRequest | undefined, cancelToken?: CancelToken): Promise<DeleteEmployeeSignatureResponse> {
        let url_ = this.baseUrl + "/Employees/DeleteEmployeeSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmployeeSignature(_response);
        });
    }

    protected processDeleteEmployeeSignature(response: AxiosResponse): Promise<DeleteEmployeeSignatureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteEmployeeSignatureResponse.fromJS(resultData200);
            return Promise.resolve<DeleteEmployeeSignatureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteEmployeeSignatureResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveEmployee(body: SaveEmployeeRequest | undefined, cancelToken?: CancelToken): Promise<SaveEmployeeResponse> {
        let url_ = this.baseUrl + "/Employees/SaveEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmployee(_response);
        });
    }

    protected processSaveEmployee(response: AxiosResponse): Promise<SaveEmployeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveEmployeeResponse.fromJS(resultData200);
            return Promise.resolve<SaveEmployeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveEmployeeResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeGroups( cancelToken?: CancelToken): Promise<GetEmployeeGroupsResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeGroups(_response);
        });
    }

    protected processGetEmployeeGroups(response: AxiosResponse): Promise<GetEmployeeGroupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeGroupsResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeGroupsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeGroupsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesPermissions( cancelToken?: CancelToken): Promise<GetEmployeesPermissionsResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeesPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeesPermissions(_response);
        });
    }

    protected processGetEmployeesPermissions(response: AxiosResponse): Promise<GetEmployeesPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeesPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeesPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeesPermissionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployeeNote(body: DeleteEmployeeNoteRequest | undefined, cancelToken?: CancelToken): Promise<DeleteEmployeeNoteResponse> {
        let url_ = this.baseUrl + "/Employees/DeleteEmployeeNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmployeeNote(_response);
        });
    }

    protected processDeleteEmployeeNote(response: AxiosResponse): Promise<DeleteEmployeeNoteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteEmployeeNoteResponse.fromJS(resultData200);
            return Promise.resolve<DeleteEmployeeNoteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteEmployeeNoteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployeeFile(body: DeleteEmployeeFileRequest | undefined, cancelToken?: CancelToken): Promise<DeleteEmployeeFileResponse> {
        let url_ = this.baseUrl + "/Employees/DeleteEmployeeFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmployeeFile(_response);
        });
    }

    protected processDeleteEmployeeFile(response: AxiosResponse): Promise<DeleteEmployeeFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteEmployeeFileResponse.fromJS(resultData200);
            return Promise.resolve<DeleteEmployeeFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteEmployeeFileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmployeeFile(body: CreateEmployeeFileRequest | undefined, cancelToken?: CancelToken): Promise<CreateEmployeeFileResponse> {
        let url_ = this.baseUrl + "/Employees/CreateEmployeeFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmployeeFile(_response);
        });
    }

    protected processCreateEmployeeFile(response: AxiosResponse): Promise<CreateEmployeeFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEmployeeFileResponse.fromJS(resultData200);
            return Promise.resolve<CreateEmployeeFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEmployeeFileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeFileDetail(documentId: number, cancelToken?: CancelToken): Promise<GetEmployeeFileDetailResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeFileDetail/{DocumentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{DocumentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeFileDetail(_response);
        });
    }

    protected processGetEmployeeFileDetail(response: AxiosResponse): Promise<GetEmployeeFileDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeFileDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeFileDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeFileDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveEmployeeFileData(body: SaveEmployeeFileDataRequest | undefined, cancelToken?: CancelToken): Promise<SaveEmployeeFileDataResponse> {
        let url_ = this.baseUrl + "/Employees/SaveEmployeeFileData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmployeeFileData(_response);
        });
    }

    protected processSaveEmployeeFileData(response: AxiosResponse): Promise<SaveEmployeeFileDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveEmployeeFileDataResponse.fromJS(resultData200);
            return Promise.resolve<SaveEmployeeFileDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveEmployeeFileDataResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeFileDocuments(documentId: number, cancelToken?: CancelToken): Promise<GetEmployeeFileDocumentsResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeFileDocuments/{DocumentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{DocumentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeFileDocuments(_response);
        });
    }

    protected processGetEmployeeFileDocuments(response: AxiosResponse): Promise<GetEmployeeFileDocumentsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeFileDocumentsResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeFileDocumentsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeFileDocumentsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmployeeFilesFromPaths(body: CreateEmployeeFilesFromPathsRequest | undefined, cancelToken?: CancelToken): Promise<CreateEmployeeFilesFromPathsResponse> {
        let url_ = this.baseUrl + "/Employees/CreateEmployeeFilesFromPaths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmployeeFilesFromPaths(_response);
        });
    }

    protected processCreateEmployeeFilesFromPaths(response: AxiosResponse): Promise<CreateEmployeeFilesFromPathsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEmployeeFilesFromPathsResponse.fromJS(resultData200);
            return Promise.resolve<CreateEmployeeFilesFromPathsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEmployeeFilesFromPathsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployeeFileDocument(body: DeleteEmployeeFileDocumentRequest | undefined, cancelToken?: CancelToken): Promise<DeleteEmployeeFileDocumentResponse> {
        let url_ = this.baseUrl + "/Employees/DeleteEmployeeFileDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmployeeFileDocument(_response);
        });
    }

    protected processDeleteEmployeeFileDocument(response: AxiosResponse): Promise<DeleteEmployeeFileDocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteEmployeeFileDocumentResponse.fromJS(resultData200);
            return Promise.resolve<DeleteEmployeeFileDocumentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteEmployeeFileDocumentResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDeletedEmployeeDocumentFilesToRestore(documentId: number, cancelToken?: CancelToken): Promise<GetDeletedEmployeeDocumentFilesToRestoreResponse> {
        let url_ = this.baseUrl + "/Employees/GetDeletedEmployeeDocumentFilesToRestore/{DocumentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{DocumentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeletedEmployeeDocumentFilesToRestore(_response);
        });
    }

    protected processGetDeletedEmployeeDocumentFilesToRestore(response: AxiosResponse): Promise<GetDeletedEmployeeDocumentFilesToRestoreResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeletedEmployeeDocumentFilesToRestoreResponse.fromJS(resultData200);
            return Promise.resolve<GetDeletedEmployeeDocumentFilesToRestoreResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeletedEmployeeDocumentFilesToRestoreResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restoreDeletedEmployeeDocumentFiles(body: RestoreDeletedEmployeeDocumentFilesRequest | undefined, cancelToken?: CancelToken): Promise<RestoreDeletedEmployeeDocumentFilesResponse> {
        let url_ = this.baseUrl + "/Employees/RestoreDeletedEmployeeDocumentFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreDeletedEmployeeDocumentFiles(_response);
        });
    }

    protected processRestoreDeletedEmployeeDocumentFiles(response: AxiosResponse): Promise<RestoreDeletedEmployeeDocumentFilesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RestoreDeletedEmployeeDocumentFilesResponse.fromJS(resultData200);
            return Promise.resolve<RestoreDeletedEmployeeDocumentFilesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RestoreDeletedEmployeeDocumentFilesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeFilesTree(employeeId: number, cancelToken?: CancelToken): Promise<GetEmployeeFilesTreeResponse> {
        let url_ = this.baseUrl + "/Employees/GetEmployeeFilesTree/{EmployeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{EmployeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeFilesTree(_response);
        });
    }

    protected processGetEmployeeFilesTree(response: AxiosResponse): Promise<GetEmployeeFilesTreeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeFilesTreeResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeFilesTreeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeFilesTreeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyCutPasteEmployeeFile(body: CopyCutPasteEmployeeFileRequest | undefined, cancelToken?: CancelToken): Promise<CopyCutPasteEmployeeFileResponse> {
        let url_ = this.baseUrl + "/Employees/CopyCutPasteEmployeeFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyCutPasteEmployeeFile(_response);
        });
    }

    protected processCopyCutPasteEmployeeFile(response: AxiosResponse): Promise<CopyCutPasteEmployeeFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyCutPasteEmployeeFileResponse.fromJS(resultData200);
            return Promise.resolve<CopyCutPasteEmployeeFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyCutPasteEmployeeFileResponse>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param chunk (optional) 
     * @param chunkNumber (optional) 
     * @param totalChunks (optional) 
     * @param key (optional) 
     * @param employeeDocumentsId (optional) 
     * @param path (optional) 
     * @return Success
     */
    uploadEmployeeDocumentChunk(fileName: string | undefined, chunk: FileParameter | undefined, chunkNumber: number | undefined, totalChunks: number | undefined, key: string | undefined, employeeDocumentsId: number | undefined, path: string | undefined, cancelToken?: CancelToken): Promise<UploadEmployeeDocumentChunkResponse> {
        let url_ = this.baseUrl + "/Employees/UploadEmployeeDocumentChunk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (chunk === null || chunk === undefined)
            throw new Error("The parameter 'chunk' cannot be null.");
        else
            content_.append("Chunk", chunk.data, chunk.fileName ? chunk.fileName : "Chunk");
        if (chunkNumber === null || chunkNumber === undefined)
            throw new Error("The parameter 'chunkNumber' cannot be null.");
        else
            content_.append("ChunkNumber", chunkNumber.toString());
        if (totalChunks === null || totalChunks === undefined)
            throw new Error("The parameter 'totalChunks' cannot be null.");
        else
            content_.append("TotalChunks", totalChunks.toString());
        if (key === null || key === undefined)
            throw new Error("The parameter 'key' cannot be null.");
        else
            content_.append("Key", key.toString());
        if (employeeDocumentsId === null || employeeDocumentsId === undefined)
            throw new Error("The parameter 'employeeDocumentsId' cannot be null.");
        else
            content_.append("EmployeeDocumentsId", employeeDocumentsId.toString());
        if (path === null || path === undefined)
            throw new Error("The parameter 'path' cannot be null.");
        else
            content_.append("Path", path.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadEmployeeDocumentChunk(_response);
        });
    }

    protected processUploadEmployeeDocumentChunk(response: AxiosResponse): Promise<UploadEmployeeDocumentChunkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadEmployeeDocumentChunkResponse.fromJS(resultData200);
            return Promise.resolve<UploadEmployeeDocumentChunkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadEmployeeDocumentChunkResponse>(null as any);
    }

    /**
     * @param email (optional) 
     * @param secretPassword (optional) 
     * @return Success
     */
    getKrossUserTenantList(email: string | undefined, secretPassword: string | undefined, cancelToken?: CancelToken): Promise<GetKrossUserTenantListResponse> {
        let url_ = this.baseUrl + "/ExternalIdentity/GetKrossUserTenantList?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (secretPassword === null)
            throw new Error("The parameter 'secretPassword' cannot be null.");
        else if (secretPassword !== undefined)
            url_ += "SecretPassword=" + encodeURIComponent("" + secretPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKrossUserTenantList(_response);
        });
    }

    protected processGetKrossUserTenantList(response: AxiosResponse): Promise<GetKrossUserTenantListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKrossUserTenantListResponse.fromJS(resultData200);
            return Promise.resolve<GetKrossUserTenantListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKrossUserTenantListResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    downloadDiaryPrint(token: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/File/DownloadDiaryPrint?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDiaryPrint(_response);
        });
    }

    protected processDownloadDiaryPrint(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    downloadDiaryPrintZIP(token: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/File/DownloadDiaryPrintZIP?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDiaryPrintZIP(_response);
        });
    }

    protected processDownloadDiaryPrintZIP(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    downloadProjectImagesZip(token: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/File/DownloadProjectImagesZip?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadProjectImagesZip(_response);
        });
    }

    protected processDownloadProjectImagesZip(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gptMessage(body: SendGptMessageRequest | undefined, cancelToken?: CancelToken): Promise<SendGptMessageResponse> {
        let url_ = this.baseUrl + "/Gpt/GptMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGptMessage(_response);
        });
    }

    protected processGptMessage(response: AxiosResponse): Promise<SendGptMessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendGptMessageResponse.fromJS(resultData200);
            return Promise.resolve<SendGptMessageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendGptMessageResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gptImage(body: SendGptImageMessageRequest | undefined, cancelToken?: CancelToken): Promise<SendGptImageMessageResponse> {
        let url_ = this.baseUrl + "/Gpt/GptImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGptImage(_response);
        });
    }

    protected processGptImage(response: AxiosResponse): Promise<SendGptImageMessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendGptImageMessageResponse.fromJS(resultData200);
            return Promise.resolve<SendGptImageMessageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendGptImageMessageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAiImagesDescriptions( cancelToken?: CancelToken): Promise<GetAiRecognizedImagesResponse> {
        let url_ = this.baseUrl + "/Gpt/GetAiImagesDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAiImagesDescriptions(_response);
        });
    }

    protected processGetAiImagesDescriptions(response: AxiosResponse): Promise<GetAiRecognizedImagesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAiRecognizedImagesResponse.fromJS(resultData200);
            return Promise.resolve<GetAiRecognizedImagesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAiRecognizedImagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    writeDiaryInRange(body: GetGptDiaryDescriptionsFromPhotosRequest | undefined, cancelToken?: CancelToken): Promise<GetGptDiaryDescriptionsFromPhotosResponse> {
        let url_ = this.baseUrl + "/Gpt/write-diary-in-range";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteDiaryInRange(_response);
        });
    }

    protected processWriteDiaryInRange(response: AxiosResponse): Promise<GetGptDiaryDescriptionsFromPhotosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGptDiaryDescriptionsFromPhotosResponse.fromJS(resultData200);
            return Promise.resolve<GetGptDiaryDescriptionsFromPhotosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGptDiaryDescriptionsFromPhotosResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    writeDiaryForRecord(body: GetGptDiaryDescriptionOneDayFromPhotosRequest | undefined, cancelToken?: CancelToken): Promise<GetGptDiaryDescriptionOneDayFromPhotosResponse> {
        let url_ = this.baseUrl + "/Gpt/write-diary-for-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteDiaryForRecord(_response);
        });
    }

    protected processWriteDiaryForRecord(response: AxiosResponse): Promise<GetGptDiaryDescriptionOneDayFromPhotosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGptDiaryDescriptionOneDayFromPhotosResponse.fromJS(resultData200);
            return Promise.resolve<GetGptDiaryDescriptionOneDayFromPhotosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGptDiaryDescriptionOneDayFromPhotosResponse>(null as any);
    }

    /**
     * @return Success
     */
    analyzePhotosFast( cancelToken?: CancelToken): Promise<AiImageRecognizeResponse> {
        let url_ = this.baseUrl + "/Gpt/AnalyzePhotosFast";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnalyzePhotosFast(_response);
        });
    }

    protected processAnalyzePhotosFast(response: AxiosResponse): Promise<AiImageRecognizeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AiImageRecognizeResponse.fromJS(resultData200);
            return Promise.resolve<AiImageRecognizeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiImageRecognizeResponse>(null as any);
    }

    /**
     * @return Success
     */
    analyzePhotos( cancelToken?: CancelToken): Promise<SendGptImageMessageResponse> {
        let url_ = this.baseUrl + "/Gpt/AnalyzePhotos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnalyzePhotos(_response);
        });
    }

    protected processAnalyzePhotos(response: AxiosResponse): Promise<SendGptImageMessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendGptImageMessageResponse.fromJS(resultData200);
            return Promise.resolve<SendGptImageMessageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendGptImageMessageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCategoryTemplates( cancelToken?: CancelToken): Promise<GetCategoryTemplatesResponse> {
        let url_ = this.baseUrl + "/ImageCategory/GetCategoryTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategoryTemplates(_response);
        });
    }

    protected processGetCategoryTemplates(response: AxiosResponse): Promise<GetCategoryTemplatesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCategoryTemplatesResponse.fromJS(resultData200);
            return Promise.resolve<GetCategoryTemplatesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCategoryTemplatesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCategoryTemplateDetail(id: number, cancelToken?: CancelToken): Promise<GetCategoryTemplateDetailResponse> {
        let url_ = this.baseUrl + "/ImageCategory/GetCategoryTemplateDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategoryTemplateDetail(_response);
        });
    }

    protected processGetCategoryTemplateDetail(response: AxiosResponse): Promise<GetCategoryTemplateDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCategoryTemplateDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetCategoryTemplateDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCategoryTemplateDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCategoryTemplate(body: CreateCategoryTemplateRequest | undefined, cancelToken?: CancelToken): Promise<CreateCategoryTemplateResponse> {
        let url_ = this.baseUrl + "/ImageCategory/CreateCategoryTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCategoryTemplate(_response);
        });
    }

    protected processCreateCategoryTemplate(response: AxiosResponse): Promise<CreateCategoryTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateCategoryTemplateResponse.fromJS(resultData200);
            return Promise.resolve<CreateCategoryTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateCategoryTemplateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCategoryTemplate(body: DeleteCategoryTemplateRequest | undefined, cancelToken?: CancelToken): Promise<DeleteCategoryTemplateResponse> {
        let url_ = this.baseUrl + "/ImageCategory/DeleteCategoryTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCategoryTemplate(_response);
        });
    }

    protected processDeleteCategoryTemplate(response: AxiosResponse): Promise<DeleteCategoryTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteCategoryTemplateResponse.fromJS(resultData200);
            return Promise.resolve<DeleteCategoryTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteCategoryTemplateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategoryTemplate(body: UpdateCategoryTemplateRequest | undefined, cancelToken?: CancelToken): Promise<UpdateCategoryTemplateResponse> {
        let url_ = this.baseUrl + "/ImageCategory/UpdateCategoryTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCategoryTemplate(_response);
        });
    }

    protected processUpdateCategoryTemplate(response: AxiosResponse): Promise<UpdateCategoryTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateCategoryTemplateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateCategoryTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateCategoryTemplateResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRequests(buildingId: number, cancelToken?: CancelToken): Promise<GetRequestsResponse> {
        let url_ = this.baseUrl + "/Investor/GetRequests/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequests(_response);
        });
    }

    protected processGetRequests(response: AxiosResponse): Promise<GetRequestsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestsResponse.fromJS(resultData200);
            return Promise.resolve<GetRequestsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRequest(requestId: number, cancelToken?: CancelToken): Promise<GetRequestResponse> {
        let url_ = this.baseUrl + "/Investor/GetRequest/{RequestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{RequestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequest(_response);
        });
    }

    protected processGetRequest(response: AxiosResponse): Promise<GetRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestResponse.fromJS(resultData200);
            return Promise.resolve<GetRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestResponse>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorBuildings(req: GetInvestorBuildingsRequest, cancelToken?: CancelToken): Promise<GetInvestorBuildingsResponse> {
        let url_ = this.baseUrl + "/Investor/GetInvestorBuildings";
        if (req === undefined || req === null)
            throw new Error("The parameter 'req' must be defined.");
        url_ = url_.replace("{req}", encodeURIComponent("" + req));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestorBuildings(_response);
        });
    }

    protected processGetInvestorBuildings(response: AxiosResponse): Promise<GetInvestorBuildingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvestorBuildingsResponse.fromJS(resultData200);
            return Promise.resolve<GetInvestorBuildingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvestorBuildingsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorDochazka(buildingId: number, cancelToken?: CancelToken): Promise<GetInvestorDochazkaResponse> {
        let url_ = this.baseUrl + "/Investor/GetInvestorDochazka/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestorDochazka(_response);
        });
    }

    protected processGetInvestorDochazka(response: AxiosResponse): Promise<GetInvestorDochazkaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvestorDochazkaResponse.fromJS(resultData200);
            return Promise.resolve<GetInvestorDochazkaResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvestorDochazkaResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRequestConversation(requestId: number, cancelToken?: CancelToken): Promise<GetRequestConversationResponse> {
        let url_ = this.baseUrl + "/Investor/GetRequestConversation/{RequestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{RequestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestConversation(_response);
        });
    }

    protected processGetRequestConversation(response: AxiosResponse): Promise<GetRequestConversationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestConversationResponse.fromJS(resultData200);
            return Promise.resolve<GetRequestConversationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestConversationResponse>(null as any);
    }

    /**
     * @return Success
     */
    getImagesInvestor(buildingId: number, getBase64: boolean, cancelToken?: CancelToken): Promise<GetImagesInvestorResponse> {
        let url_ = this.baseUrl + "/Investor/GetImagesInvestor/{GetBase64}/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        if (getBase64 === undefined || getBase64 === null)
            throw new Error("The parameter 'getBase64' must be defined.");
        url_ = url_.replace("{GetBase64}", encodeURIComponent("" + getBase64));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImagesInvestor(_response);
        });
    }

    protected processGetImagesInvestor(response: AxiosResponse): Promise<GetImagesInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetImagesInvestorResponse.fromJS(resultData200);
            return Promise.resolve<GetImagesInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetImagesInvestorResponse>(null as any);
    }

    /**
     * @param buildingId (optional) 
     * @return Success
     */
    getInvestorDiaryRecords(buildingId: number | undefined, cancelToken?: CancelToken): Promise<GetInvestorDiaryRecordsResponse> {
        let url_ = this.baseUrl + "/Investor/GetInvestorDiaryRecords?";
        if (buildingId === null)
            throw new Error("The parameter 'buildingId' cannot be null.");
        else if (buildingId !== undefined)
            url_ += "BuildingId=" + encodeURIComponent("" + buildingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestorDiaryRecords(_response);
        });
    }

    protected processGetInvestorDiaryRecords(response: AxiosResponse): Promise<GetInvestorDiaryRecordsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvestorDiaryRecordsResponse.fromJS(resultData200);
            return Promise.resolve<GetInvestorDiaryRecordsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvestorDiaryRecordsResponse>(null as any);
    }

    /**
     * @return Success
     */
    printWholeDiaryInvestor(diaryId: number, onlyMyNotes: boolean, cancelToken?: CancelToken): Promise<PrintWholeDiaryInvestorResponse> {
        let url_ = this.baseUrl + "/Investor/PrintWholeDiaryInvestor/{DiaryId}/{OnlyMyNotes}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintWholeDiaryInvestor(_response);
        });
    }

    protected processPrintWholeDiaryInvestor(response: AxiosResponse): Promise<PrintWholeDiaryInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrintWholeDiaryInvestorResponse.fromJS(resultData200);
            return Promise.resolve<PrintWholeDiaryInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrintWholeDiaryInvestorResponse>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorInfo( cancelToken?: CancelToken): Promise<GetInvestorInfoResponse> {
        let url_ = this.baseUrl + "/Investor/GetInvestorInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestorInfo(_response);
        });
    }

    protected processGetInvestorInfo(response: AxiosResponse): Promise<GetInvestorInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvestorInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetInvestorInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvestorInfoResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDocumentsForInvestorAndBuilding(buildingId: number, cancelToken?: CancelToken): Promise<GetDocumentsForInvestorAndBuildingResponse> {
        let url_ = this.baseUrl + "/Investor/GetDocumentsForInvestorAndBuilding/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentsForInvestorAndBuilding(_response);
        });
    }

    protected processGetDocumentsForInvestorAndBuilding(response: AxiosResponse): Promise<GetDocumentsForInvestorAndBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDocumentsForInvestorAndBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetDocumentsForInvestorAndBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDocumentsForInvestorAndBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRequests(body: DeleteRequestsRequest | undefined, cancelToken?: CancelToken): Promise<DeleteRequestsResponse> {
        let url_ = this.baseUrl + "/Investor/DeleteRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRequests(_response);
        });
    }

    protected processDeleteRequests(response: AxiosResponse): Promise<DeleteRequestsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRequestsResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRequestsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRequestsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRequest(body: SaveRequestRequest | undefined, cancelToken?: CancelToken): Promise<SaveRequestResponse> {
        let url_ = this.baseUrl + "/Investor/SaveRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequest(_response);
        });
    }

    protected processSaveRequest(response: AxiosResponse): Promise<SaveRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveRequestResponse.fromJS(resultData200);
            return Promise.resolve<SaveRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveRequestResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRequest(body: UpdateRequestRequest | undefined, cancelToken?: CancelToken): Promise<UpdateRequestResponse> {
        let url_ = this.baseUrl + "/Investor/UpdateRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRequest(_response);
        });
    }

    protected processUpdateRequest(response: AxiosResponse): Promise<UpdateRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRequestResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRequestResponse>(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param text (optional) 
     * @param file (optional) 
     * @return Success
     */
    saveRequestComment(requestId: number | undefined, text: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<SaveRequestCommentResponse> {
        let url_ = this.baseUrl + "/Investor/SaveRequestComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requestId === null || requestId === undefined)
            throw new Error("The parameter 'requestId' cannot be null.");
        else
            content_.append("RequestId", requestId.toString());
        if (text === null || text === undefined)
            throw new Error("The parameter 'text' cannot be null.");
        else
            content_.append("Text", text.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequestComment(_response);
        });
    }

    protected processSaveRequestComment(response: AxiosResponse): Promise<SaveRequestCommentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveRequestCommentResponse.fromJS(resultData200);
            return Promise.resolve<SaveRequestCommentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveRequestCommentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRequestCommentText(body: SaveRequestCommentTextRequest | undefined, cancelToken?: CancelToken): Promise<SaveRequestCommentTextResponse> {
        let url_ = this.baseUrl + "/Investor/SaveRequestCommentText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRequestCommentText(_response);
        });
    }

    protected processSaveRequestCommentText(response: AxiosResponse): Promise<SaveRequestCommentTextResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveRequestCommentTextResponse.fromJS(resultData200);
            return Promise.resolve<SaveRequestCommentTextResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveRequestCommentTextResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInvestorCredentials(body: UpdateInvestorCredentialsRequest | undefined, cancelToken?: CancelToken): Promise<UpdateInvestorCredentialsResponse> {
        let url_ = this.baseUrl + "/Investor/UpdateInvestorCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvestorCredentials(_response);
        });
    }

    protected processUpdateInvestorCredentials(response: AxiosResponse): Promise<UpdateInvestorCredentialsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInvestorCredentialsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInvestorCredentialsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInvestorCredentialsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInvestorPassword(body: UpdateInvestorPasswordRequest | undefined, cancelToken?: CancelToken): Promise<UpdateInvestorPasswordResponse> {
        let url_ = this.baseUrl + "/Investor/UpdateInvestorPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvestorPassword(_response);
        });
    }

    protected processUpdateInvestorPassword(response: AxiosResponse): Promise<UpdateInvestorPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInvestorPasswordResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInvestorPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInvestorPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markConversationAsRead(body: MarkConversationAsReadRequest | undefined, cancelToken?: CancelToken): Promise<MarkConversationAsReadResponse> {
        let url_ = this.baseUrl + "/Investor/MarkConversationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkConversationAsRead(_response);
        });
    }

    protected processMarkConversationAsRead(response: AxiosResponse): Promise<MarkConversationAsReadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkConversationAsReadResponse.fromJS(resultData200);
            return Promise.resolve<MarkConversationAsReadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkConversationAsReadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetInvestorPassword(body: ResetInvestorPasswordRequest | undefined, cancelToken?: CancelToken): Promise<ResetInvestorPasswordResponse> {
        let url_ = this.baseUrl + "/Investor/ResetInvestorPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetInvestorPassword(_response);
        });
    }

    protected processResetInvestorPassword(response: AxiosResponse): Promise<ResetInvestorPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetInvestorPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ResetInvestorPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetInvestorPasswordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiariesForInvestor(deleted: boolean, onlyMain: boolean, buildingId: number, cancelToken?: CancelToken): Promise<GetDiariesForInvestorResponse> {
        let url_ = this.baseUrl + "/Investor/GetDiariesForInvestor/{Deleted}/{OnlyMain}/{BuildingId}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        if (onlyMain === undefined || onlyMain === null)
            throw new Error("The parameter 'onlyMain' must be defined.");
        url_ = url_.replace("{OnlyMain}", encodeURIComponent("" + onlyMain));
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiariesForInvestor(_response);
        });
    }

    protected processGetDiariesForInvestor(response: AxiosResponse): Promise<GetDiariesForInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiariesForInvestorResponse.fromJS(resultData200);
            return Promise.resolve<GetDiariesForInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiariesForInvestorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDiaryRecordInvestor(body: CreateDailyRecordInvestorRequest | undefined, cancelToken?: CancelToken): Promise<CreateDailyRecordInvestorResponse> {
        let url_ = this.baseUrl + "/Investor/CreateDiaryRecordInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDiaryRecordInvestor(_response);
        });
    }

    protected processCreateDiaryRecordInvestor(response: AxiosResponse): Promise<CreateDailyRecordInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDailyRecordInvestorResponse.fromJS(resultData200);
            return Promise.resolve<CreateDailyRecordInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDailyRecordInvestorResponse>(null as any);
    }

    /**
     * @param buildingId (optional) 
     * @param categoryId (optional) 
     * @param file (optional) 
     * @return Success
     */
    addImageToProjectInvestor(buildingId: number | undefined, categoryId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<AddImageToProjectResponse> {
        let url_ = this.baseUrl + "/Investor/AddImageToProjectInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (buildingId === null || buildingId === undefined)
            throw new Error("The parameter 'buildingId' cannot be null.");
        else
            content_.append("BuildingId", buildingId.toString());
        if (categoryId === null || categoryId === undefined)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else
            content_.append("CategoryId", categoryId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImageToProjectInvestor(_response);
        });
    }

    protected processAddImageToProjectInvestor(response: AxiosResponse): Promise<AddImageToProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddImageToProjectResponse.fromJS(resultData200);
            return Promise.resolve<AddImageToProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImageToProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryPermissionsInvestor(r: GetDiaryPermissionsInvestorRequest, cancelToken?: CancelToken): Promise<GetDiaryPermissionsInvestorResponse> {
        let url_ = this.baseUrl + "/Investor/GetDiaryPermissionsInvestor";
        if (r === undefined || r === null)
            throw new Error("The parameter 'r' must be defined.");
        url_ = url_.replace("{r}", encodeURIComponent("" + r));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryPermissionsInvestor(_response);
        });
    }

    protected processGetDiaryPermissionsInvestor(response: AxiosResponse): Promise<GetDiaryPermissionsInvestorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryPermissionsInvestorResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryPermissionsInvestorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryPermissionsInvestorResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBuildingImageZip(buildingId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Investor/GetBuildingImageZip/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildingImageZip(_response);
        });
    }

    protected processGetBuildingImageZip(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImagesByIdForDiaryRecordZipInvestor(body: GetImagesByIdForDiaryRecordZipInvestorRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Investor/GetImagesByIdForDiaryRecordZipInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImagesByIdForDiaryRecordZipInvestor(_response);
        });
    }

    protected processGetImagesByIdForDiaryRecordZipInvestor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    invoices(deleted: boolean, cancelToken?: CancelToken): Promise<GetBuildingBillsForInvoicesPageResponse> {
        let url_ = this.baseUrl + "/Invoice/invoices/{Deleted}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoices(_response);
        });
    }

    protected processInvoices(response: AxiosResponse): Promise<GetBuildingBillsForInvoicesPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingBillsForInvoicesPageResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingBillsForInvoicesPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingBillsForInvoicesPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    invoiceDetail(invoiceId: number, cancelToken?: CancelToken): Promise<GetInvoiceDataDetailResponse> {
        let url_ = this.baseUrl + "/Invoice/invoiceDetail/{InvoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{InvoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceDetail(_response);
        });
    }

    protected processInvoiceDetail(response: AxiosResponse): Promise<GetInvoiceDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvoiceDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetInvoiceDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvoiceDataDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWholeInvoice(body: SaveWholeInvoiceRequest | undefined, cancelToken?: CancelToken): Promise<SaveWholeInvoiceResponse> {
        let url_ = this.baseUrl + "/Invoice/saveWholeInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWholeInvoice(_response);
        });
    }

    protected processSaveWholeInvoice(response: AxiosResponse): Promise<SaveWholeInvoiceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWholeInvoiceResponse.fromJS(resultData200);
            return Promise.resolve<SaveWholeInvoiceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWholeInvoiceResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteInvoices(body: DeleteInvoicesRequest | undefined, cancelToken?: CancelToken): Promise<DeleteInvoicesResponse> {
        let url_ = this.baseUrl + "/Invoice/deleteInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInvoices(_response);
        });
    }

    protected processDeleteInvoices(response: AxiosResponse): Promise<DeleteInvoicesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteInvoicesResponse.fromJS(resultData200);
            return Promise.resolve<DeleteInvoicesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteInvoicesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveInvoicesFromTrash(body: MoveInvoicesFromTrashRequest | undefined, cancelToken?: CancelToken): Promise<MoveInvoicesFromTrashResponse> {
        let url_ = this.baseUrl + "/Invoice/moveInvoicesFromTrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveInvoicesFromTrash(_response);
        });
    }

    protected processMoveInvoicesFromTrash(response: AxiosResponse): Promise<MoveInvoicesFromTrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveInvoicesFromTrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveInvoicesFromTrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveInvoicesFromTrashResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceRequest | undefined, cancelToken?: CancelToken): Promise<CreateInvoiceResponse> {
        let url_ = this.baseUrl + "/Invoice/createInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoice(_response);
        });
    }

    protected processCreateInvoice(response: AxiosResponse): Promise<CreateInvoiceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateInvoiceResponse.fromJS(resultData200);
            return Promise.resolve<CreateInvoiceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateInvoiceResponse>(null as any);
    }

    /**
     * @return Success
     */
    invoiceItems(invoiceId: number, cancelToken?: CancelToken): Promise<GetInvoiceItemsResponse> {
        let url_ = this.baseUrl + "/Invoice/invoiceItems/{InvoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{InvoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceItems(_response);
        });
    }

    protected processInvoiceItems(response: AxiosResponse): Promise<GetInvoiceItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvoiceItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetInvoiceItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvoiceItemsResponse>(null as any);
    }

    /**
     * @return Success
     */
    taxrates( cancelToken?: CancelToken): Promise<GetTaxratesForInvoiceItemsResponse> {
        let url_ = this.baseUrl + "/Invoice/taxrates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaxrates(_response);
        });
    }

    protected processTaxrates(response: AxiosResponse): Promise<GetTaxratesForInvoiceItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTaxratesForInvoiceItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetTaxratesForInvoiceItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTaxratesForInvoiceItemsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getInvoicesBuilding(buildingId: number, deleted: boolean, cancelToken?: CancelToken): Promise<GetBillsInvoicesForBuildingResponse> {
        let url_ = this.baseUrl + "/Invoice/getInvoicesBuilding/{BuildingId}/{Deleted}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesBuilding(_response);
        });
    }

    protected processGetInvoicesBuilding(response: AxiosResponse): Promise<GetBillsInvoicesForBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBillsInvoicesForBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetBillsInvoicesForBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBillsInvoicesForBuildingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBillsPermissions( cancelToken?: CancelToken): Promise<GetBillsPermissionsResponse> {
        let url_ = this.baseUrl + "/Invoice/getBillsPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillsPermissions(_response);
        });
    }

    protected processGetBillsPermissions(response: AxiosResponse): Promise<GetBillsPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBillsPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetBillsPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBillsPermissionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInvoiceFromList(body: UpdateInvoiceFromListRequest | undefined, cancelToken?: CancelToken): Promise<UpdateInvoiceFromListResponse> {
        let url_ = this.baseUrl + "/Invoice/updateInvoiceFromList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoiceFromList(_response);
        });
    }

    protected processUpdateInvoiceFromList(response: AxiosResponse): Promise<UpdateInvoiceFromListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInvoiceFromListResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInvoiceFromListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInvoiceFromListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadBillPayments(body: DownloadBillPaymentsRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Invoice/downloadBillPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadBillPayments(_response);
        });
    }

    protected processDownloadBillPayments(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadInvoiceFiles(body: DownloadInvoiceFilesRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Invoice/downloadInvoiceFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoiceFiles(_response);
        });
    }

    protected processDownloadInvoiceFiles(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationsCurrency( cancelToken?: CancelToken): Promise<GetApplicationsCurrencyResponse> {
        let url_ = this.baseUrl + "/Invoice/getApplicationsCurrency";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationsCurrency(_response);
        });
    }

    protected processGetApplicationsCurrency(response: AxiosResponse): Promise<GetApplicationsCurrencyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationsCurrencyResponse.fromJS(resultData200);
            return Promise.resolve<GetApplicationsCurrencyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationsCurrencyResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersKrosAdmin( cancelToken?: CancelToken): Promise<GetUsersKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetUsersKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersKrosAdmin(_response);
        });
    }

    protected processGetUsersKrosAdmin(response: AxiosResponse): Promise<GetUsersKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationsKrosAdmin( cancelToken?: CancelToken): Promise<GetApplicationsKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetApplicationsKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationsKrosAdmin(_response);
        });
    }

    protected processGetApplicationsKrosAdmin(response: AxiosResponse): Promise<GetApplicationsKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationsKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetApplicationsKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationsKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationListKrosAdmin( cancelToken?: CancelToken): Promise<GetApplicationListKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetApplicationListKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationListKrosAdmin(_response);
        });
    }

    protected processGetApplicationListKrosAdmin(response: AxiosResponse): Promise<GetApplicationListKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationListKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetApplicationListKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationListKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getKrosAdminUserInfo( cancelToken?: CancelToken): Promise<GetKrosAdminUserInfoResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetKrosAdminUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKrosAdminUserInfo(_response);
        });
    }

    protected processGetKrosAdminUserInfo(response: AxiosResponse): Promise<GetKrosAdminUserInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKrosAdminUserInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetKrosAdminUserInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKrosAdminUserInfoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteUserKrosAdmin(body: DeleteUserKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<DeleteUserKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/DeleteUserKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserKrosAdmin(_response);
        });
    }

    protected processDeleteUserKrosAdmin(response: AxiosResponse): Promise<DeleteUserKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteUserKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<DeleteUserKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteUserKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteApplicationKrosAdmin(body: DeleteApplicationKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<DeleteApplicationKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/DeleteApplicationKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteApplicationKrosAdmin(_response);
        });
    }

    protected processDeleteApplicationKrosAdmin(response: AxiosResponse): Promise<DeleteApplicationKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteApplicationKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<DeleteApplicationKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteApplicationKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserDataKrosAdmin(userId: number, cancelToken?: CancelToken): Promise<GetUserDataKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetUserDataKrosAdmin/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDataKrosAdmin(_response);
        });
    }

    protected processGetUserDataKrosAdmin(response: AxiosResponse): Promise<GetUserDataKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserDataKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetUserDataKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserDataKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationDataKrosAdmin(appId: number, cancelToken?: CancelToken): Promise<GetApplicationDataKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetApplicationDataKrosAdmin/{AppId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{AppId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationDataKrosAdmin(_response);
        });
    }

    protected processGetApplicationDataKrosAdmin(response: AxiosResponse): Promise<GetApplicationDataKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationDataKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetApplicationDataKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationDataKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveUserDataKrosAdmin(body: SaveUserDataKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<SaveUserDataKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/SaveUserDataKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUserDataKrosAdmin(_response);
        });
    }

    protected processSaveUserDataKrosAdmin(response: AxiosResponse): Promise<SaveUserDataKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveUserDataKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<SaveUserDataKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveUserDataKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveApplicationDataKrosAdmin(body: SaveApplicationDataKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<SaveApplicationDataKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/SaveApplicationDataKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveApplicationDataKrosAdmin(_response);
        });
    }

    protected processSaveApplicationDataKrosAdmin(response: AxiosResponse): Promise<SaveApplicationDataKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveApplicationDataKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<SaveApplicationDataKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveApplicationDataKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordKrosAdmin(body: ResetPasswordKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<ResetPasswordKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/ResetPasswordKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPasswordKrosAdmin(_response);
        });
    }

    protected processResetPasswordKrosAdmin(response: AxiosResponse): Promise<ResetPasswordKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<ResetPasswordKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setIsAppActiveKrosAdmin(body: SetIsAppActiveKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<SetIsAppActiveKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/SetIsAppActiveKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsAppActiveKrosAdmin(_response);
        });
    }

    protected processSetIsAppActiveKrosAdmin(response: AxiosResponse): Promise<SetIsAppActiveKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetIsAppActiveKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<SetIsAppActiveKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetIsAppActiveKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setIsAppPayingKrosAdmin(body: SetIsAppPayingKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<SetIsAppPayingKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/SetIsAppPayingKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsAppPayingKrosAdmin(_response);
        });
    }

    protected processSetIsAppPayingKrosAdmin(response: AxiosResponse): Promise<SetIsAppPayingKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetIsAppPayingKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<SetIsAppPayingKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetIsAppPayingKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setShowPayingKrosAdmin(body: SetShowPayingKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<SetShowPayingKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/SetShowPayingKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetShowPayingKrosAdmin(_response);
        });
    }

    protected processSetShowPayingKrosAdmin(response: AxiosResponse): Promise<SetShowPayingKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetShowPayingKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<SetShowPayingKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetShowPayingKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getStatisticsKrosAdmin( cancelToken?: CancelToken): Promise<GetStatisticsKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetStatisticsKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsKrosAdmin(_response);
        });
    }

    protected processGetStatisticsKrosAdmin(response: AxiosResponse): Promise<GetStatisticsKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStatisticsKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetStatisticsKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStatisticsKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationPermissionsKrosAdmin(applicationId: number, cancelToken?: CancelToken): Promise<GetApplicationPermissionsKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/GetApplicationPermissionsKrosAdmin/{ApplicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{ApplicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationPermissionsKrosAdmin(_response);
        });
    }

    protected processGetApplicationPermissionsKrosAdmin(response: AxiosResponse): Promise<GetApplicationPermissionsKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationPermissionsKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetApplicationPermissionsKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationPermissionsKrosAdminResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setApplicationPermissionsKrosAdmin(body: SetApplicationPermissionsKrosAdminRequest | undefined, cancelToken?: CancelToken): Promise<SetApplicationPermissionsKrosAdminResponse> {
        let url_ = this.baseUrl + "/KrosAdmin/SetApplicationPermissionsKrosAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetApplicationPermissionsKrosAdmin(_response);
        });
    }

    protected processSetApplicationPermissionsKrosAdmin(response: AxiosResponse): Promise<SetApplicationPermissionsKrosAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetApplicationPermissionsKrosAdminResponse.fromJS(resultData200);
            return Promise.resolve<SetApplicationPermissionsKrosAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetApplicationPermissionsKrosAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDisabledModules( cancelToken?: CancelToken): Promise<GetDisabledModulesResponse> {
        let url_ = this.baseUrl + "/MobileApplications/get-disabled-modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDisabledModules(_response);
        });
    }

    protected processGetDisabledModules(response: AxiosResponse): Promise<GetDisabledModulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDisabledModulesResponse.fromJS(resultData200);
            return Promise.resolve<GetDisabledModulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDisabledModulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mobileLogin(body: AuthMobileEmployeeRequest | undefined, cancelToken?: CancelToken): Promise<AuthMobileEmployeeResponse> {
        let url_ = this.baseUrl + "/MobileAuth/mobile-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMobileLogin(_response);
        });
    }

    protected processMobileLogin(response: AxiosResponse): Promise<AuthMobileEmployeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthMobileEmployeeResponse.fromJS(resultData200);
            return Promise.resolve<AuthMobileEmployeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthMobileEmployeeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshEmployeeToken(body: RefreshEmployeeTokenRequest | undefined, cancelToken?: CancelToken): Promise<RefreshEmployeeTokenResponse> {
        let url_ = this.baseUrl + "/MobileAuth/refreshEmployeeToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshEmployeeToken(_response);
        });
    }

    protected processRefreshEmployeeToken(response: AxiosResponse): Promise<RefreshEmployeeTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshEmployeeTokenResponse.fromJS(resultData200);
            return Promise.resolve<RefreshEmployeeTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshEmployeeTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partialRegistration(body: PartialRegistrationRequest | undefined, cancelToken?: CancelToken): Promise<PartialRegistrationResponse> {
        let url_ = this.baseUrl + "/MobileAuth/partial-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartialRegistration(_response);
        });
    }

    protected processPartialRegistration(response: AxiosResponse): Promise<PartialRegistrationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PartialRegistrationResponse.fromJS(resultData200);
            return Promise.resolve<PartialRegistrationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartialRegistrationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeRegistration(body: CompleteRegistrationRequest | undefined, cancelToken?: CancelToken): Promise<CompleteRegistrationResponse> {
        let url_ = this.baseUrl + "/MobileAuth/complete-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteRegistration(_response);
        });
    }

    protected processCompleteRegistration(response: AxiosResponse): Promise<CompleteRegistrationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompleteRegistrationResponse.fromJS(resultData200);
            return Promise.resolve<CompleteRegistrationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteRegistrationResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllBuildings( cancelToken?: CancelToken): Promise<GetAllBuildingsResponse> {
        let url_ = this.baseUrl + "/MobileBuildings/get-all-buildings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBuildings(_response);
        });
    }

    protected processGetAllBuildings(response: AxiosResponse): Promise<GetAllBuildingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllBuildingsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllBuildingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllBuildingsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployees(buildingId: number, cancelToken?: CancelToken): Promise<GetAllEmployeesBuildingResponse> {
        let url_ = this.baseUrl + "/MobileBuildings/get-all-employees/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEmployees(_response);
        });
    }

    protected processGetAllEmployees(response: AxiosResponse): Promise<GetAllEmployeesBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllEmployeesBuildingResponse.fromJS(resultData200);
            return Promise.resolve<GetAllEmployeesBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllEmployeesBuildingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addImagesToBuilding(body: AddImagesToBuildingRequest | undefined, cancelToken?: CancelToken): Promise<AddImagesToBuildingResponse> {
        let url_ = this.baseUrl + "/MobileBuildings/add-images-to-building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImagesToBuilding(_response);
        });
    }

    protected processAddImagesToBuilding(response: AxiosResponse): Promise<AddImagesToBuildingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddImagesToBuildingResponse.fromJS(resultData200);
            return Promise.resolve<AddImagesToBuildingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImagesToBuildingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getImageCategories(buildingId: number, cancelToken?: CancelToken): Promise<GetImageCategoriesResponse> {
        let url_ = this.baseUrl + "/MobileBuildings/get-image-categories/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImageCategories(_response);
        });
    }

    protected processGetImageCategories(response: AxiosResponse): Promise<GetImageCategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetImageCategoriesResponse.fromJS(resultData200);
            return Promise.resolve<GetImageCategoriesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetImageCategoriesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getLastRecordWithBreak( cancelToken?: CancelToken): Promise<GetLastRecordWithBreakResponse> {
        let url_ = this.baseUrl + "/MobileRecords/get-last-record-with-break";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastRecordWithBreak(_response);
        });
    }

    protected processGetLastRecordWithBreak(response: AxiosResponse): Promise<GetLastRecordWithBreakResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLastRecordWithBreakResponse.fromJS(resultData200);
            return Promise.resolve<GetLastRecordWithBreakResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLastRecordWithBreakResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertRecord(body: InsertRecordRequest | undefined, cancelToken?: CancelToken): Promise<InsertRecordResponse> {
        let url_ = this.baseUrl + "/MobileRecords/insert-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertRecord(_response);
        });
    }

    protected processInsertRecord(response: AxiosResponse): Promise<InsertRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertRecordResponse.fromJS(resultData200);
            return Promise.resolve<InsertRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertBreak(body: InsertBreakRequest | undefined, cancelToken?: CancelToken): Promise<InsertBreakResponse> {
        let url_ = this.baseUrl + "/MobileRecords/insert-break";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertBreak(_response);
        });
    }

    protected processInsertBreak(response: AxiosResponse): Promise<InsertBreakResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertBreakResponse.fromJS(resultData200);
            return Promise.resolve<InsertBreakResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertBreakResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertDoctor(body: InsertDoctorRequest | undefined, cancelToken?: CancelToken): Promise<InsertDoctorResponse> {
        let url_ = this.baseUrl + "/MobileRecords/insert-doctor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertDoctor(_response);
        });
    }

    protected processInsertDoctor(response: AxiosResponse): Promise<InsertDoctorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertDoctorResponse.fromJS(resultData200);
            return Promise.resolve<InsertDoctorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertDoctorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertHoliday(body: InsertHolidayRequest | undefined, cancelToken?: CancelToken): Promise<InsertHolidayResponse> {
        let url_ = this.baseUrl + "/MobileRecords/insert-holiday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertHoliday(_response);
        });
    }

    protected processInsertHoliday(response: AxiosResponse): Promise<InsertHolidayResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertHolidayResponse.fromJS(resultData200);
            return Promise.resolve<InsertHolidayResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertHolidayResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertSick(body: InsertSickRequest | undefined, cancelToken?: CancelToken): Promise<InsertSickResponse> {
        let url_ = this.baseUrl + "/MobileRecords/insert-sick";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertSick(_response);
        });
    }

    protected processInsertSick(response: AxiosResponse): Promise<InsertSickResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertSickResponse.fromJS(resultData200);
            return Promise.resolve<InsertSickResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertSickResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllActions( cancelToken?: CancelToken): Promise<GetAllActionsResponse> {
        let url_ = this.baseUrl + "/MobileRecords/get-all-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllActions(_response);
        });
    }

    protected processGetAllActions(response: AxiosResponse): Promise<GetAllActionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllActionsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllActionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllActionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertLog(body: InsertLogRecordRequest | undefined, cancelToken?: CancelToken): Promise<InsertLogRecordResponse> {
        let url_ = this.baseUrl + "/MobileRecords/insert-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertLog(_response);
        });
    }

    protected processInsertLog(response: AxiosResponse): Promise<InsertLogRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertLogRecordResponse.fromJS(resultData200);
            return Promise.resolve<InsertLogRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertLogRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    employeesWealth( cancelToken?: CancelToken): Promise<GetEmployeesWealthResponse> {
        let url_ = this.baseUrl + "/MobileWealth/employees-wealth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployeesWealth(_response);
        });
    }

    protected processEmployeesWealth(response: AxiosResponse): Promise<GetEmployeesWealthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeesWealthResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeesWealthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeesWealthResponse>(null as any);
    }

    /**
     * @return Success
     */
    wealthMobileDetail(code: string, cancelToken?: CancelToken): Promise<GetWealthMobileDetailResponse> {
        let url_ = this.baseUrl + "/MobileWealth/wealth-mobile-detail/{Code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{Code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWealthMobileDetail(_response);
        });
    }

    protected processWealthMobileDetail(response: AxiosResponse): Promise<GetWealthMobileDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthMobileDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthMobileDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthMobileDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setWealthToEmployee(body: SetWealthToEmployeeRequest | undefined, cancelToken?: CancelToken): Promise<SetWealthToEmployeeResponse> {
        let url_ = this.baseUrl + "/MobileWealth/set-wealth-to-employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetWealthToEmployee(_response);
        });
    }

    protected processSetWealthToEmployee(response: AxiosResponse): Promise<SetWealthToEmployeeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetWealthToEmployeeResponse.fromJS(resultData200);
            return Promise.resolve<SetWealthToEmployeeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetWealthToEmployeeResponse>(null as any);
    }

    /**
     * @return Success
     */
    wealthDetailById(wealthId: number, cancelToken?: CancelToken): Promise<GetWealthDetailByIdResponse> {
        let url_ = this.baseUrl + "/MobileWealth/wealth-detail-by-id/{WealthId}";
        if (wealthId === undefined || wealthId === null)
            throw new Error("The parameter 'wealthId' must be defined.");
        url_ = url_.replace("{WealthId}", encodeURIComponent("" + wealthId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWealthDetailById(_response);
        });
    }

    protected processWealthDetailById(response: AxiosResponse): Promise<GetWealthDetailByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthDetailByIdResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthDetailByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthDetailByIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthToBorrow( cancelToken?: CancelToken): Promise<GetWealthToBorrowResponse> {
        let url_ = this.baseUrl + "/MobileWealth/get-wealth-to-borrow";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthToBorrow(_response);
        });
    }

    protected processGetWealthToBorrow(response: AxiosResponse): Promise<GetWealthToBorrowResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthToBorrowResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthToBorrowResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthToBorrowResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    load(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/Load";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoad(_response);
        });
    }

    protected processLoad(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bookmarks(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmarks(_response);
        });
    }

    protected processBookmarks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderPdfPages(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/RenderPdfPages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderPdfPages(_response);
        });
    }

    protected processRenderPdfPages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderThumbnailImages(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/RenderThumbnailImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderThumbnailImages(_response);
        });
    }

    protected processRenderThumbnailImages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderPdfTexts(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/RenderPdfTexts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderPdfTexts(_response);
        });
    }

    protected processRenderPdfTexts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderAnnotationComments(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/RenderAnnotationComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderAnnotationComments(_response);
        });
    }

    protected processRenderAnnotationComments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unload(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/Unload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnload(_response);
        });
    }

    protected processUnload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    download(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/PdfHelper/Download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<HttpResponseMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HttpResponseMessage.fromJS(resultData200);
            return Promise.resolve<HttpResponseMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpResponseMessage>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printImages(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/PrintImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintImages(_response);
        });
    }

    protected processPrintImages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAnnotations(id: string, body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/PdfHelper/{id}/ExportAnnotations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAnnotations(_response);
        });
    }

    protected processExportAnnotations(response: AxiosResponse): Promise<HttpResponseMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HttpResponseMessage.fromJS(resultData200);
            return Promise.resolve<HttpResponseMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpResponseMessage>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importAnnotations(body: { [key: string]: any; } | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PdfHelper/ImportAnnotations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportAnnotations(_response);
        });
    }

    protected processImportAnnotations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePrompt(body: CreateOrUpdatePromptRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdatePromptResponse> {
        let url_ = this.baseUrl + "/Prompt/CreateOrUpdatePrompt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdatePrompt(_response);
        });
    }

    protected processCreateOrUpdatePrompt(response: AxiosResponse): Promise<CreateOrUpdatePromptResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdatePromptResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdatePromptResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdatePromptResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePrompt(body: DeletePromptRequest | undefined, cancelToken?: CancelToken): Promise<DeletePromptResponse> {
        let url_ = this.baseUrl + "/Prompt/DeletePrompt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePrompt(_response);
        });
    }

    protected processDeletePrompt(response: AxiosResponse): Promise<DeletePromptResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeletePromptResponse.fromJS(resultData200);
            return Promise.resolve<DeletePromptResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeletePromptResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSignPublicInformationsForSigniWorkflow(diaryRecordId: number, lang: string, cancelToken?: CancelToken): Promise<GetSignInformationsForSigniWorkflowResponse> {
        let url_ = this.baseUrl + "/Signi/GetSignPublicInformationsForSigniWorkflow/{DiaryRecordId}/{Lang}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{Lang}", encodeURIComponent("" + lang));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignPublicInformationsForSigniWorkflow(_response);
        });
    }

    protected processGetSignPublicInformationsForSigniWorkflow(response: AxiosResponse): Promise<GetSignInformationsForSigniWorkflowResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignInformationsForSigniWorkflowResponse.fromJS(resultData200);
            return Promise.resolve<GetSignInformationsForSigniWorkflowResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignInformationsForSigniWorkflowResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startSigniInteractive(body: StartSigniInteractiveRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Signi/StartSigniInteractive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartSigniInteractive(_response);
        });
    }

    protected processStartSigniInteractive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signiWebhook(body: any | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Signi/SigniWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSigniWebhook(_response);
        });
    }

    protected processSigniWebhook(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    signiAfter(contractId: number, diaryRecordId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Signi/signiAfter/{ContractId}/{DiaryRecordId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{ContractId}", encodeURIComponent("" + contractId));
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSigniAfter(_response);
        });
    }

    protected processSigniAfter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signiTestDown(body: TestSigniDownloadRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Signi/SigniTestDown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSigniTestDown(_response);
        });
    }

    protected processSigniTestDown(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMeDetail( cancelToken?: CancelToken): Promise<GetMeDetailResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetMeDetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeDetail(_response);
        });
    }

    protected processGetMeDetail(response: AxiosResponse): Promise<GetMeDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMeDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetMeDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMeDetailResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDailyRecordsForSubcontractorUser(deleted: boolean, cancelToken?: CancelToken): Promise<GetDailyRecordsForSubcontractorUserResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDailyRecordsForSubcontractorUser/{Deleted}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyRecordsForSubcontractorUser(_response);
        });
    }

    protected processGetDailyRecordsForSubcontractorUser(response: AxiosResponse): Promise<GetDailyRecordsForSubcontractorUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyRecordsForSubcontractorUserResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyRecordsForSubcontractorUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyRecordsForSubcontractorUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteImageRelationSubcontractor(diaryRecordId: number, fileName: string, cancelToken?: CancelToken): Promise<DeleteImageRelationFromSubcontractorDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/DeleteImageRelationSubcontractor/{DiaryRecordId}/{FileName}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{FileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteImageRelationSubcontractor(_response);
        });
    }

    protected processDeleteImageRelationSubcontractor(response: AxiosResponse): Promise<DeleteImageRelationFromSubcontractorDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteImageRelationFromSubcontractorDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<DeleteImageRelationFromSubcontractorDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteImageRelationFromSubcontractorDiaryRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSubcontractorDiaryRecords(body: DeleteSubcontractorDailyRecordRequest | undefined, cancelToken?: CancelToken): Promise<DeleteSubcontractorDailyRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/DeleteSubcontractorDiaryRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSubcontractorDiaryRecords(_response);
        });
    }

    protected processDeleteSubcontractorDiaryRecords(response: AxiosResponse): Promise<DeleteSubcontractorDailyRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteSubcontractorDailyRecordResponse.fromJS(resultData200);
            return Promise.resolve<DeleteSubcontractorDailyRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteSubcontractorDailyRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiariesForSubcontractorUser(deleted: boolean, onlyMain: boolean, buildingId: number, cancelToken?: CancelToken): Promise<GetDiariesForSubcontractorUserResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDiariesForSubcontractorUser/{Deleted}/{OnlyMain}/{BuildingId}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        if (onlyMain === undefined || onlyMain === null)
            throw new Error("The parameter 'onlyMain' must be defined.");
        url_ = url_.replace("{OnlyMain}", encodeURIComponent("" + onlyMain));
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiariesForSubcontractorUser(_response);
        });
    }

    protected processGetDiariesForSubcontractorUser(response: AxiosResponse): Promise<GetDiariesForSubcontractorUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiariesForSubcontractorUserResponse.fromJS(resultData200);
            return Promise.resolve<GetDiariesForSubcontractorUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiariesForSubcontractorUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSubcontractorDiaries(body: DeleteSubcontractorDiariesRequest | undefined, cancelToken?: CancelToken): Promise<DeleteSubcontractorDiariesResponse> {
        let url_ = this.baseUrl + "/Subcontractor/DeleteSubcontractorDiaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSubcontractorDiaries(_response);
        });
    }

    protected processDeleteSubcontractorDiaries(response: AxiosResponse): Promise<DeleteSubcontractorDiariesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteSubcontractorDiariesResponse.fromJS(resultData200);
            return Promise.resolve<DeleteSubcontractorDiariesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteSubcontractorDiariesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSubcontractorDiaryPermissions( cancelToken?: CancelToken): Promise<GetSubcontractorDiaryPermissionsResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetSubcontractorDiaryPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubcontractorDiaryPermissions(_response);
        });
    }

    protected processGetSubcontractorDiaryPermissions(response: AxiosResponse): Promise<GetSubcontractorDiaryPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSubcontractorDiaryPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetSubcontractorDiaryPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSubcontractorDiaryPermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyNameForSubcontractorDiary( cancelToken?: CancelToken): Promise<GetCompanyNameForSubcontractorDiaryResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetCompanyNameForSubcontractorDiary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyNameForSubcontractorDiary(_response);
        });
    }

    protected processGetCompanyNameForSubcontractorDiary(response: AxiosResponse): Promise<GetCompanyNameForSubcontractorDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompanyNameForSubcontractorDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetCompanyNameForSubcontractorDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompanyNameForSubcontractorDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSubcontractorDiaryDataDetail(diaryId: number, cancelToken?: CancelToken): Promise<GetDiaryDataDetailResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetSubcontractorDiaryDataDetail/{DiaryId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubcontractorDiaryDataDetail(_response);
        });
    }

    protected processGetSubcontractorDiaryDataDetail(response: AxiosResponse): Promise<GetDiaryDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryDataDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveSubcontractorDiary(body: SaveSubcontractorDiaryRequest | undefined, cancelToken?: CancelToken): Promise<SaveSubcontractorDiaryResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveSubcontractorDiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSubcontractorDiary(_response);
        });
    }

    protected processSaveSubcontractorDiary(response: AxiosResponse): Promise<SaveSubcontractorDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveSubcontractorDiaryResponse.fromJS(resultData200);
            return Promise.resolve<SaveSubcontractorDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveSubcontractorDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiaryRecordSubcontractor(diaryRecordId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasPhotos: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Subcontractor/PrintDiaryRecordSubcontractor/{DiaryRecordId}/{OnlyMyNotes}/{HasDigitalSignatureField}/{HasPhotos}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        if (hasPhotos === undefined || hasPhotos === null)
            throw new Error("The parameter 'hasPhotos' must be defined.");
        url_ = url_.replace("{HasPhotos}", encodeURIComponent("" + hasPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryRecordSubcontractor(_response);
        });
    }

    protected processPrintDiaryRecordSubcontractor(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiarySubcontractorTitlePage(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Subcontractor/PrintDiarySubcontractorTitlePage/{DiaryId}/{OnlyMyNotes}/{HasDigitalSignatureField}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiarySubcontractorTitlePage(_response);
        });
    }

    protected processPrintDiarySubcontractorTitlePage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printDiarySubcontractor(diaryId: number, onlyMyNotes: boolean, hasDigitalSignatureField: boolean, hasPhotos: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Subcontractor/PrintDiarySubcontractor/{DiaryId}/{OnlyMyNotes}/{HasDigitalSignatureField}/{HasPhotos}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        if (hasDigitalSignatureField === undefined || hasDigitalSignatureField === null)
            throw new Error("The parameter 'hasDigitalSignatureField' must be defined.");
        url_ = url_.replace("{HasDigitalSignatureField}", encodeURIComponent("" + hasDigitalSignatureField));
        if (hasPhotos === undefined || hasPhotos === null)
            throw new Error("The parameter 'hasPhotos' must be defined.");
        url_ = url_.replace("{HasPhotos}", encodeURIComponent("" + hasPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiarySubcontractor(_response);
        });
    }

    protected processPrintDiarySubcontractor(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printWholeSubcontractorDiary(diaryId: number, onlyMyNotes: boolean, cancelToken?: CancelToken): Promise<GetPrintWholeSubcontractorDiaryOldErpResponse> {
        let url_ = this.baseUrl + "/Subcontractor/PrintWholeSubcontractorDiary/{DiaryId}/{OnlyMyNotes}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        if (onlyMyNotes === undefined || onlyMyNotes === null)
            throw new Error("The parameter 'onlyMyNotes' must be defined.");
        url_ = url_.replace("{OnlyMyNotes}", encodeURIComponent("" + onlyMyNotes));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintWholeSubcontractorDiary(_response);
        });
    }

    protected processPrintWholeSubcontractorDiary(response: AxiosResponse): Promise<GetPrintWholeSubcontractorDiaryOldErpResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPrintWholeSubcontractorDiaryOldErpResponse.fromJS(resultData200);
            return Promise.resolve<GetPrintWholeSubcontractorDiaryOldErpResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPrintWholeSubcontractorDiaryOldErpResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSubcontractorDownloadLinkOldErp(body: GetDownloadForSignedSubcontractorDiaryRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetSubcontractorDownloadLinkOldErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubcontractorDownloadLinkOldErp(_response);
        });
    }

    protected processGetSubcontractorDownloadLinkOldErp(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDailyRecordsForSubcontractorAndDiary(diaryId: number, cancelToken?: CancelToken): Promise<GetDailyRecordsForSubcontractorAndDiaryResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDailyRecordsForSubcontractorAndDiary/{DiaryId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyRecordsForSubcontractorAndDiary(_response);
        });
    }

    protected processGetDailyRecordsForSubcontractorAndDiary(response: AxiosResponse): Promise<GetDailyRecordsForSubcontractorAndDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyRecordsForSubcontractorAndDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyRecordsForSubcontractorAndDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyRecordsForSubcontractorAndDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    subcontractorGroup( cancelToken?: CancelToken): Promise<SubcontractorGroupResponse> {
        let url_ = this.baseUrl + "/Subcontractor/subcontractorGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubcontractorGroup(_response);
        });
    }

    protected processSubcontractorGroup(response: AxiosResponse): Promise<SubcontractorGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubcontractorGroupResponse.fromJS(resultData200);
            return Promise.resolve<SubcontractorGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubcontractorGroupResponse>(null as any);
    }

    /**
     * @return Success
     */
    buildingSubcontractor(diaryId: number, cancelToken?: CancelToken): Promise<GetBuildingForSubcontractorResponse> {
        let url_ = this.baseUrl + "/Subcontractor/buildingSubcontractor/{DiaryId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildingSubcontractor(_response);
        });
    }

    protected processBuildingSubcontractor(response: AxiosResponse): Promise<GetBuildingForSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingForSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingForSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingForSubcontractorResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDailyRecordsForSubcontractorByRecordId(recordId: number, cancelToken?: CancelToken): Promise<GetDailyRecordsForSubcontractorByRecordIdResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDailyRecordsForSubcontractorByRecordId/{RecordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{RecordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyRecordsForSubcontractorByRecordId(_response);
        });
    }

    protected processGetDailyRecordsForSubcontractorByRecordId(response: AxiosResponse): Promise<GetDailyRecordsForSubcontractorByRecordIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyRecordsForSubcontractorByRecordIdResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyRecordsForSubcontractorByRecordIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyRecordsForSubcontractorByRecordIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    diaryRecordDataNotTablesSubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetDiaryRecordDataNotTablesResponse> {
        let url_ = this.baseUrl + "/Subcontractor/DiaryRecordDataNotTablesSubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiaryRecordDataNotTablesSubcontractor(_response);
        });
    }

    protected processDiaryRecordDataNotTablesSubcontractor(response: AxiosResponse): Promise<GetDiaryRecordDataNotTablesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryRecordDataNotTablesResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryRecordDataNotTablesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryRecordDataNotTablesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDiaryContentsSubcontractor(body: SaveDiaryContentsSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<SaveDiaryContentsSubcontractorResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveDiaryContentsSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDiaryContentsSubcontractor(_response);
        });
    }

    protected processSaveDiaryContentsSubcontractor(response: AxiosResponse): Promise<SaveDiaryContentsSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveDiaryContentsSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<SaveDiaryContentsSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveDiaryContentsSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendMessageSubcontractorDiary(body: SendMessageSubcontractorDiaryRequest | undefined, cancelToken?: CancelToken): Promise<SendMessageDiaryResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SendMessageSubcontractorDiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMessageSubcontractorDiary(_response);
        });
    }

    protected processSendMessageSubcontractorDiary(response: AxiosResponse): Promise<SendMessageDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendMessageDiaryResponse.fromJS(resultData200);
            return Promise.resolve<SendMessageDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendMessageDiaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSubcontractorDiaryRecord(body: CreateSubcontractorDailyRecordRequest | undefined, cancelToken?: CancelToken): Promise<CreateDailyRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/CreateSubcontractorDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSubcontractorDiaryRecord(_response);
        });
    }

    protected processCreateSubcontractorDiaryRecord(response: AxiosResponse): Promise<CreateDailyRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDailyRecordResponse.fromJS(resultData200);
            return Promise.resolve<CreateDailyRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDailyRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lockUnlockSubcontractorDiaryRecord(body: LockSubcontractorDiaryRecordRequest | undefined, cancelToken?: CancelToken): Promise<LockDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/LockUnlockSubcontractorDiaryRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLockUnlockSubcontractorDiaryRecord(_response);
        });
    }

    protected processLockUnlockSubcontractorDiaryRecord(response: AxiosResponse): Promise<LockDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LockDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<LockDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LockDiaryRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSignaturesForSubcontractorRecord(diaryRecordId: number, getBase64: boolean, cancelToken?: CancelToken): Promise<GetSignaturesForRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetSignaturesForSubcontractorRecord/{DiaryRecordId}/{GetBase64}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (getBase64 === undefined || getBase64 === null)
            throw new Error("The parameter 'getBase64' must be defined.");
        url_ = url_.replace("{GetBase64}", encodeURIComponent("" + getBase64));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignaturesForSubcontractorRecord(_response);
        });
    }

    protected processGetSignaturesForSubcontractorRecord(response: AxiosResponse): Promise<GetSignaturesForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignaturesForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetSignaturesForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignaturesForRecordResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadDigitallySignedPDFSubcontractor(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadDigitalSignedPDFResponse> {
        let url_ = this.baseUrl + "/Subcontractor/UploadDigitallySignedPDFSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDigitallySignedPDFSubcontractor(_response);
        });
    }

    protected processUploadDigitallySignedPDFSubcontractor(response: AxiosResponse): Promise<UploadDigitalSignedPDFResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadDigitalSignedPDFResponse.fromJS(resultData200);
            return Promise.resolve<UploadDigitalSignedPDFResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadDigitalSignedPDFResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @param isInvestor (optional) 
     * @return Success
     */
    uploadSignatureSubcontractor(diaryRecordId: number | undefined, file: FileParameter | undefined, isInvestor: boolean | undefined, cancelToken?: CancelToken): Promise<SaveDiarySignatureAdminUserResponse> {
        let url_ = this.baseUrl + "/Subcontractor/UploadSignatureSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (isInvestor === null || isInvestor === undefined)
            throw new Error("The parameter 'isInvestor' cannot be null.");
        else
            content_.append("IsInvestor", isInvestor.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSignatureSubcontractor(_response);
        });
    }

    protected processUploadSignatureSubcontractor(response: AxiosResponse): Promise<SaveDiarySignatureAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveDiarySignatureAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<SaveDiarySignatureAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveDiarySignatureAdminUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCompletedWorksSubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetCompletedWorksResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetCompletedWorksSubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompletedWorksSubcontractor(_response);
        });
    }

    protected processGetCompletedWorksSubcontractor(response: AxiosResponse): Promise<GetCompletedWorksResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompletedWorksResponse.fromJS(resultData200);
            return Promise.resolve<GetCompletedWorksResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompletedWorksResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryImagesSubcontractor(diaryRecordId: number, getBase64: boolean, cancelToken?: CancelToken): Promise<GetImagesUrlsForRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDiaryImagesSubcontractor/{DiaryRecordId}/{GetBase64}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (getBase64 === undefined || getBase64 === null)
            throw new Error("The parameter 'getBase64' must be defined.");
        url_ = url_.replace("{GetBase64}", encodeURIComponent("" + getBase64));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryImagesSubcontractor(_response);
        });
    }

    protected processGetDiaryImagesSubcontractor(response: AxiosResponse): Promise<GetImagesUrlsForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetImagesUrlsForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetImagesUrlsForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetImagesUrlsForRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPhotosBuildingToChooseSubcontractor(diaryRecordId: number, onlyTodaysPhotos: boolean, cancelToken?: CancelToken): Promise<GetPhotosFromBuildingToDiaryChooseResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetPhotosBuildingToChooseSubcontractor/{DiaryRecordId}/{OnlyTodaysPhotos}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        if (onlyTodaysPhotos === undefined || onlyTodaysPhotos === null)
            throw new Error("The parameter 'onlyTodaysPhotos' must be defined.");
        url_ = url_.replace("{OnlyTodaysPhotos}", encodeURIComponent("" + onlyTodaysPhotos));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhotosBuildingToChooseSubcontractor(_response);
        });
    }

    protected processGetPhotosBuildingToChooseSubcontractor(response: AxiosResponse): Promise<GetPhotosFromBuildingToDiaryChooseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPhotosFromBuildingToDiaryChooseResponse.fromJS(resultData200);
            return Promise.resolve<GetPhotosFromBuildingToDiaryChooseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPhotosFromBuildingToDiaryChooseResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFilesForDiarySubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetFilesForBuildingRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetFilesForDiarySubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilesForDiarySubcontractor(_response);
        });
    }

    protected processGetFilesForDiarySubcontractor(response: AxiosResponse): Promise<GetFilesForBuildingRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilesForBuildingRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetFilesForBuildingRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilesForBuildingRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFileRelSubcontractor(body: DeleteFileRelationDiarySubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<DeleteFileRelationDiaryResponse> {
        let url_ = this.baseUrl + "/Subcontractor/DeleteFileRelSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFileRelSubcontractor(_response);
        });
    }

    protected processDeleteFileRelSubcontractor(response: AxiosResponse): Promise<DeleteFileRelationDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteFileRelationDiaryResponse.fromJS(resultData200);
            return Promise.resolve<DeleteFileRelationDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteFileRelationDiaryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWeatherForRecordSubcontractor(body: GetWeatherForRecordSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetWeatherForRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetWeatherForRecordSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeatherForRecordSubcontractor(_response);
        });
    }

    protected processGetWeatherForRecordSubcontractor(response: AxiosResponse): Promise<GetWeatherForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWeatherForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetWeatherForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWeatherForRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWeathersSubcontractor(body: SaveWeathersSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<SaveWeathersResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveWeathersSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWeathersSubcontractor(_response);
        });
    }

    protected processSaveWeathersSubcontractor(response: AxiosResponse): Promise<SaveWeathersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWeathersResponse.fromJS(resultData200);
            return Promise.resolve<SaveWeathersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWeathersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWeatherForDiaryRecordSubcontractor(body: GetBuildingWeatherByDiaryIdSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetBuildingWeatherByDiaryIdResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetWeatherForDiaryRecordSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeatherForDiaryRecordSubcontractor(_response);
        });
    }

    protected processGetWeatherForDiaryRecordSubcontractor(response: AxiosResponse): Promise<GetBuildingWeatherByDiaryIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingWeatherByDiaryIdResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingWeatherByDiaryIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingWeatherByDiaryIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWeatherToDiaryRecordSubcontractor(body: SaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<SaveBuildingWeatherToDiaryDiaryByIdResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveWeatherToDiaryRecordSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWeatherToDiaryRecordSubcontractor(_response);
        });
    }

    protected processSaveWeatherToDiaryRecordSubcontractor(response: AxiosResponse): Promise<SaveBuildingWeatherToDiaryDiaryByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveBuildingWeatherToDiaryDiaryByIdResponse.fromJS(resultData200);
            return Promise.resolve<SaveBuildingWeatherToDiaryDiaryByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveBuildingWeatherToDiaryDiaryByIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWorkersForRecordSubcontractor(body: GetWorkersForRecordSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetWorkersForRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetWorkersForRecordSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkersForRecordSubcontractor(_response);
        });
    }

    protected processGetWorkersForRecordSubcontractor(response: AxiosResponse): Promise<GetWorkersForRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWorkersForRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetWorkersForRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWorkersForRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWorkersSubcontractor(body: SaveWorkersSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<SaveWorkersResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveWorkersSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWorkersSubcontractor(_response);
        });
    }

    protected processSaveWorkersSubcontractor(response: AxiosResponse): Promise<SaveWorkersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWorkersResponse.fromJS(resultData200);
            return Promise.resolve<SaveWorkersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWorkersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesWithGroupsSubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetEmployeesWithGroupsResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetEmployeesWithGroupsSubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeesWithGroupsSubcontractor(_response);
        });
    }

    protected processGetEmployeesWithGroupsSubcontractor(response: AxiosResponse): Promise<GetEmployeesWithGroupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeesWithGroupsResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeesWithGroupsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeesWithGroupsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addEmployeesToWorkersSubcontractor(body: AddEmployeesToWorkersSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<AddEmployeesToWorkersResponse> {
        let url_ = this.baseUrl + "/Subcontractor/AddEmployeesToWorkersSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddEmployeesToWorkersSubcontractor(_response);
        });
    }

    protected processAddEmployeesToWorkersSubcontractor(response: AxiosResponse): Promise<AddEmployeesToWorkersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddEmployeesToWorkersResponse.fromJS(resultData200);
            return Promise.resolve<AddEmployeesToWorkersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddEmployeesToWorkersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMaterialsForRecordTableSubcontractor(body: GetMaterialsForRecordTableSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetMaterialsForRecordTableResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetMaterialsForRecordTableSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialsForRecordTableSubcontractor(_response);
        });
    }

    protected processGetMaterialsForRecordTableSubcontractor(response: AxiosResponse): Promise<GetMaterialsForRecordTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMaterialsForRecordTableResponse.fromJS(resultData200);
            return Promise.resolve<GetMaterialsForRecordTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMaterialsForRecordTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMaterialsTableSubcontractor(body: SaveMaterialsTableSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<SaveMaterialsTableResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveMaterialsTableSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMaterialsTableSubcontractor(_response);
        });
    }

    protected processSaveMaterialsTableSubcontractor(response: AxiosResponse): Promise<SaveMaterialsTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMaterialsTableResponse.fromJS(resultData200);
            return Promise.resolve<SaveMaterialsTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMaterialsTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMachinesForRecordTableSubcontractor(body: GetMachinesForRecordTableSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetMachinesForRecordTableResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetMachinesForRecordTableSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMachinesForRecordTableSubcontractor(_response);
        });
    }

    protected processGetMachinesForRecordTableSubcontractor(response: AxiosResponse): Promise<GetMachinesForRecordTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMachinesForRecordTableResponse.fromJS(resultData200);
            return Promise.resolve<GetMachinesForRecordTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMachinesForRecordTableResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMachinesTableSubcontractor(body: SaveMachinesTableSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<SaveMachinesTableResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveMachinesTableSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMachinesTableSubcontractor(_response);
        });
    }

    protected processSaveMachinesTableSubcontractor(response: AxiosResponse): Promise<SaveMachinesTableResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMachinesTableResponse.fromJS(resultData200);
            return Promise.resolve<SaveMachinesTableResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMachinesTableResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthsForDiaryDialogSubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetWealthsForDiaryDialogResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetWealthsForDiaryDialogSubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthsForDiaryDialogSubcontractor(_response);
        });
    }

    protected processGetWealthsForDiaryDialogSubcontractor(response: AxiosResponse): Promise<GetWealthsForDiaryDialogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthsForDiaryDialogResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthsForDiaryDialogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthsForDiaryDialogResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addWealthsToMechanismsSubcontractor(body: AddWealthsToMechanismsSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<AddWealthsToMechanismsResponse> {
        let url_ = this.baseUrl + "/Subcontractor/AddWealthsToMechanismsSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddWealthsToMechanismsSubcontractor(_response);
        });
    }

    protected processAddWealthsToMechanismsSubcontractor(response: AxiosResponse): Promise<AddWealthsToMechanismsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddWealthsToMechanismsResponse.fromJS(resultData200);
            return Promise.resolve<AddWealthsToMechanismsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddWealthsToMechanismsResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    getOneDayPDFLoggedSubcontractor(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetOneDayPDFLoggedSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOneDayPDFLoggedSubcontractor(_response);
        });
    }

    protected processGetOneDayPDFLoggedSubcontractor(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fullDayRecordSubcontractor(body: GetDailyFullRecordSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetDailyFullRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/FullDayRecordSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFullDayRecordSubcontractor(_response);
        });
    }

    protected processFullDayRecordSubcontractor(response: AxiosResponse): Promise<GetDailyFullRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDailyFullRecordResponse.fromJS(resultData200);
            return Promise.resolve<GetDailyFullRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDailyFullRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDiarySearchResultSubcontractor(body: GetDiarySearchResultSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetDiarySearchResultResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDiarySearchResultSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiarySearchResultSubcontractor(_response);
        });
    }

    protected processGetDiarySearchResultSubcontractor(response: AxiosResponse): Promise<GetDiarySearchResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiarySearchResultResponse.fromJS(resultData200);
            return Promise.resolve<GetDiarySearchResultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiarySearchResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyDiaryRecordSubcontractor(body: CopyDiaryRecordSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<CopyDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/CopyDiaryRecordSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyDiaryRecordSubcontractor(_response);
        });
    }

    protected processCopyDiaryRecordSubcontractor(response: AxiosResponse): Promise<CopyDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<CopyDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyDiaryRecordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodosForDiarySubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetTodosForDiaryResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetTodosForDiarySubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodosForDiarySubcontractor(_response);
        });
    }

    protected processGetTodosForDiarySubcontractor(response: AxiosResponse): Promise<GetTodosForDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosForDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosForDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosForDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorsChatMessagesSubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetDiaryInvestorsChatResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetInvestorsChatMessagesSubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestorsChatMessagesSubcontractor(_response);
        });
    }

    protected processGetInvestorsChatMessagesSubcontractor(response: AxiosResponse): Promise<GetDiaryInvestorsChatResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryInvestorsChatResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryInvestorsChatResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryInvestorsChatResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSubcontractorsChatForSubcontractorMessages(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetDiarySubcontractorsChatForSubcontractorResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetSubcontractorsChatForSubcontractorMessages/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubcontractorsChatForSubcontractorMessages(_response);
        });
    }

    protected processGetSubcontractorsChatForSubcontractorMessages(response: AxiosResponse): Promise<GetDiarySubcontractorsChatForSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiarySubcontractorsChatForSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<GetDiarySubcontractorsChatForSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiarySubcontractorsChatForSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInvestorsChatMessageSubcontractor(body: PostDiaryChatMessageInvestorsSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<PostDiaryChatMessageInvestorsResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SendInvestorsChatMessageSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInvestorsChatMessageSubcontractor(_response);
        });
    }

    protected processSendInvestorsChatMessageSubcontractor(response: AxiosResponse): Promise<PostDiaryChatMessageInvestorsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostDiaryChatMessageInvestorsResponse.fromJS(resultData200);
            return Promise.resolve<PostDiaryChatMessageInvestorsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDiaryChatMessageInvestorsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSubcontractorsChatMessageAsSubcontractor(body: PostDiaryChatMessageSubcontractorsAsSubcontractorsRequest | undefined, cancelToken?: CancelToken): Promise<PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SendSubcontractorsChatMessageAsSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSubcontractorsChatMessageAsSubcontractor(_response);
        });
    }

    protected processSendSubcontractorsChatMessageAsSubcontractor(response: AxiosResponse): Promise<PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse.fromJS(resultData200);
            return Promise.resolve<PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRotatedImageSubcontractor(body: SaveRotatedImageSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<SaveRotatedImageSubcontractorResponse> {
        let url_ = this.baseUrl + "/Subcontractor/SaveRotatedImageSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRotatedImageSubcontractor(_response);
        });
    }

    protected processSaveRotatedImageSubcontractor(response: AxiosResponse): Promise<SaveRotatedImageSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveRotatedImageSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<SaveRotatedImageSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveRotatedImageSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transferPhotoFromProjectSubcontractor(body: TransferPhotosFromProjectSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<TransferPhotosFromProjectResponse> {
        let url_ = this.baseUrl + "/Subcontractor/TransferPhotoFromProjectSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferPhotoFromProjectSubcontractor(_response);
        });
    }

    protected processTransferPhotoFromProjectSubcontractor(response: AxiosResponse): Promise<TransferPhotosFromProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransferPhotosFromProjectResponse.fromJS(resultData200);
            return Promise.resolve<TransferPhotosFromProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransferPhotosFromProjectResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadImageSubcontractor(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<AddImageToProjectAndDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/UploadImageSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadImageSubcontractor(_response);
        });
    }

    protected processUploadImageSubcontractor(response: AxiosResponse): Promise<AddImageToProjectAndDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddImageToProjectAndDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<AddImageToProjectAndDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImageToProjectAndDiaryRecordResponse>(null as any);
    }

    /**
     * @param diaryRecordId (optional) 
     * @param file (optional) 
     * @return Success
     */
    addFileToRecordDirectSubcontractor(diaryRecordId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadFileToDiaryDirectResponse> {
        let url_ = this.baseUrl + "/Subcontractor/AddFileToRecordDirectSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (diaryRecordId === null || diaryRecordId === undefined)
            throw new Error("The parameter 'diaryRecordId' cannot be null.");
        else
            content_.append("DiaryRecordId", diaryRecordId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFileToRecordDirectSubcontractor(_response);
        });
    }

    protected processAddFileToRecordDirectSubcontractor(response: AxiosResponse): Promise<UploadFileToDiaryDirectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadFileToDiaryDirectResponse.fromJS(resultData200);
            return Promise.resolve<UploadFileToDiaryDirectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFileToDiaryDirectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFilesFromBuildingForDiarySubcontractor(diaryRecordId: number, cancelToken?: CancelToken): Promise<GetFilesFromBuildingForDiaryResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetFilesFromBuildingForDiarySubcontractor/{DiaryRecordId}";
        if (diaryRecordId === undefined || diaryRecordId === null)
            throw new Error("The parameter 'diaryRecordId' must be defined.");
        url_ = url_.replace("{DiaryRecordId}", encodeURIComponent("" + diaryRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilesFromBuildingForDiarySubcontractor(_response);
        });
    }

    protected processGetFilesFromBuildingForDiarySubcontractor(response: AxiosResponse): Promise<GetFilesFromBuildingForDiaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilesFromBuildingForDiaryResponse.fromJS(resultData200);
            return Promise.resolve<GetFilesFromBuildingForDiaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilesFromBuildingForDiaryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSubcontractorInfo(req: GetSubcontractorInfoRequest, cancelToken?: CancelToken): Promise<GetSubcontractorInfoResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetSubcontractorInfo";
        if (req === undefined || req === null)
            throw new Error("The parameter 'req' must be defined.");
        url_ = url_.replace("{req}", encodeURIComponent("" + req));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubcontractorInfo(_response);
        });
    }

    protected processGetSubcontractorInfo(response: AxiosResponse): Promise<GetSubcontractorInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSubcontractorInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetSubcontractorInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSubcontractorInfoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRemoveFilesDiaryRecordSubcontractor(body: AddRemoveFilesDiaryRecordSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<AddRemoveFilesDiaryRecordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/AddRemoveFilesDiaryRecordSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRemoveFilesDiaryRecordSubcontractor(_response);
        });
    }

    protected processAddRemoveFilesDiaryRecordSubcontractor(response: AxiosResponse): Promise<AddRemoveFilesDiaryRecordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddRemoveFilesDiaryRecordResponse.fromJS(resultData200);
            return Promise.resolve<AddRemoveFilesDiaryRecordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddRemoveFilesDiaryRecordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveDailyRecordsFromTrashSubcontractor(body: MoveDialyRecordsFromTrashSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<MoveDialyRecordsFromTrashResponse> {
        let url_ = this.baseUrl + "/Subcontractor/MoveDailyRecordsFromTrashSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveDailyRecordsFromTrashSubcontractor(_response);
        });
    }

    protected processMoveDailyRecordsFromTrashSubcontractor(response: AxiosResponse): Promise<MoveDialyRecordsFromTrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveDialyRecordsFromTrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveDialyRecordsFromTrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveDialyRecordsFromTrashResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSubcontractorPassword(body: UpdateSubcontractorPasswordRequest | undefined, cancelToken?: CancelToken): Promise<UpdateSubcontractorPasswordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/UpdateSubcontractorPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubcontractorPassword(_response);
        });
    }

    protected processUpdateSubcontractorPassword(response: AxiosResponse): Promise<UpdateSubcontractorPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateSubcontractorPasswordResponse.fromJS(resultData200);
            return Promise.resolve<UpdateSubcontractorPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateSubcontractorPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetSubcontractorPassword(body: ResetSubcontractorPasswordRequest | undefined, cancelToken?: CancelToken): Promise<ResetSubcontractorPasswordResponse> {
        let url_ = this.baseUrl + "/Subcontractor/ResetSubcontractorPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetSubcontractorPassword(_response);
        });
    }

    protected processResetSubcontractorPassword(response: AxiosResponse): Promise<ResetSubcontractorPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetSubcontractorPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ResetSubcontractorPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetSubcontractorPasswordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryRecordLogSubcontractor(recordId: number, cancelToken?: CancelToken): Promise<GetDiaryRecordLogResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDiaryRecordLogSubcontractor/{RecordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{RecordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryRecordLogSubcontractor(_response);
        });
    }

    protected processGetDiaryRecordLogSubcontractor(response: AxiosResponse): Promise<GetDiaryRecordLogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryRecordLogResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryRecordLogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryRecordLogResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiaryUsersForGroupSubcontractor(groupId: number, buildingId: number, cancelToken?: CancelToken): Promise<GetDiaryUsersForGroupSubcontractorResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetDiaryUsersForGroupSubcontractor/{GroupId}/{BuildingId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiaryUsersForGroupSubcontractor(_response);
        });
    }

    protected processGetDiaryUsersForGroupSubcontractor(response: AxiosResponse): Promise<GetDiaryUsersForGroupSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDiaryUsersForGroupSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<GetDiaryUsersForGroupSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDiaryUsersForGroupSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMaterialsForRecordsExcelSubcontractor(body: GetMaterialsForRecordsExcelSubcontractorRequest | undefined, cancelToken?: CancelToken): Promise<GetMaterialsForRecordsExcelSubcontractorResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetMaterialsForRecordsExcelSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialsForRecordsExcelSubcontractor(_response);
        });
    }

    protected processGetMaterialsForRecordsExcelSubcontractor(response: AxiosResponse): Promise<GetMaterialsForRecordsExcelSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMaterialsForRecordsExcelSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<GetMaterialsForRecordsExcelSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMaterialsForRecordsExcelSubcontractorResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserIdSub(req: GetUserIdRequest, cancelToken?: CancelToken): Promise<GetUserIdResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetUserIdSub";
        if (req === undefined || req === null)
            throw new Error("The parameter 'req' must be defined.");
        url_ = url_.replace("{req}", encodeURIComponent("" + req));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserIdSub(_response);
        });
    }

    protected processGetUserIdSub(response: AxiosResponse): Promise<GetUserIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserIdResponse.fromJS(resultData200);
            return Promise.resolve<GetUserIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPrintStatusSubcontractor(body: GetPrintStatusRequest | undefined, cancelToken?: CancelToken): Promise<GetPrintStatusResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetPrintStatusSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrintStatusSubcontractor(_response);
        });
    }

    protected processGetPrintStatusSubcontractor(response: AxiosResponse): Promise<GetPrintStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPrintStatusResponse.fromJS(resultData200);
            return Promise.resolve<GetPrintStatusResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPrintStatusResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserRoleForSubcontractorSubcontractor( cancelToken?: CancelToken): Promise<GetUserRoleForSubcontractorResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetUserRoleForSubcontractorSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoleForSubcontractorSubcontractor(_response);
        });
    }

    protected processGetUserRoleForSubcontractorSubcontractor(response: AxiosResponse): Promise<GetUserRoleForSubcontractorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserRoleForSubcontractorResponse.fromJS(resultData200);
            return Promise.resolve<GetUserRoleForSubcontractorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserRoleForSubcontractorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printDiaryInDateRangeSubcontractor(body: GetPrintDiaryInDateRangeRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Subcontractor/PrintDiaryInDateRangeSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryInDateRangeSubcontractor(_response);
        });
    }

    protected processPrintDiaryInDateRangeSubcontractor(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printDiaryBackgroundSubcontractor(body: PrintDiaryBackgroundRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Subcontractor/PrintDiaryBackgroundSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintDiaryBackgroundSubcontractor(_response);
        });
    }

    protected processPrintDiaryBackgroundSubcontractor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printSignedDiaryRecordsZIPSubcontractor(body: PrintSignedDiaryRecordsZIPRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Subcontractor/PrintSignedDiaryRecordsZIPSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintSignedDiaryRecordsZIPSubcontractor(_response);
        });
    }

    protected processPrintSignedDiaryRecordsZIPSubcontractor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getUsersForDiaryPrintSubcontractor(diaryId: number, cancelToken?: CancelToken): Promise<GetUsersForDiaryPrintResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetUsersForDiaryPrintSubcontractor/{DiaryId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersForDiaryPrintSubcontractor(_response);
        });
    }

    protected processGetUsersForDiaryPrintSubcontractor(response: AxiosResponse): Promise<GetUsersForDiaryPrintResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersForDiaryPrintResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersForDiaryPrintResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersForDiaryPrintResponse>(null as any);
    }

    /**
     * @param lastJokeId (optional) 
     * @param language (optional) 
     * @return Success
     */
    getJokeForSubcontractor(lastJokeId: number | undefined, language: string | undefined, cancelToken?: CancelToken): Promise<GetJokeForUserResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetJokeForSubcontractor?";
        if (lastJokeId === null)
            throw new Error("The parameter 'lastJokeId' cannot be null.");
        else if (lastJokeId !== undefined)
            url_ += "LastJokeId=" + encodeURIComponent("" + lastJokeId) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJokeForSubcontractor(_response);
        });
    }

    protected processGetJokeForSubcontractor(response: AxiosResponse): Promise<GetJokeForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJokeForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetJokeForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJokeForUserResponse>(null as any);
    }

    /**
     * @param lastHintId (optional) 
     * @param language (optional) 
     * @return Success
     */
    getHintForSubcontractor(lastHintId: number | undefined, language: string | undefined, cancelToken?: CancelToken): Promise<GetHintForUserResponse> {
        let url_ = this.baseUrl + "/Subcontractor/GetHintForSubcontractor?";
        if (lastHintId === null)
            throw new Error("The parameter 'lastHintId' cannot be null.");
        else if (lastHintId !== undefined)
            url_ += "LastHintId=" + encodeURIComponent("" + lastHintId) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHintForSubcontractor(_response);
        });
    }

    protected processGetHintForSubcontractor(response: AxiosResponse): Promise<GetHintForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHintForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetHintForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHintForUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImagesByIdForDiaryRecordZipSubcontractor(body: GetImagesByIdForDiaryRecordZipRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Subcontractor/GetImagesByIdForDiaryRecordZipSubcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImagesByIdForDiaryRecordZipSubcontractor(_response);
        });
    }

    protected processGetImagesByIdForDiaryRecordZipSubcontractor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    jokesList( cancelToken?: CancelToken): Promise<GetAllJokesResponse> {
        let url_ = this.baseUrl + "/Superadmin/JokesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJokesList(_response);
        });
    }

    protected processJokesList(response: AxiosResponse): Promise<GetAllJokesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllJokesResponse.fromJS(resultData200);
            return Promise.resolve<GetAllJokesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllJokesResponse>(null as any);
    }

    /**
     * @return Success
     */
    hintsList( cancelToken?: CancelToken): Promise<GetAllHintsResponse> {
        let url_ = this.baseUrl + "/Superadmin/HintsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHintsList(_response);
        });
    }

    protected processHintsList(response: AxiosResponse): Promise<GetAllHintsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllHintsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllHintsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllHintsResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteJoke(id: number, cancelToken?: CancelToken): Promise<DeleteJokeResponse> {
        let url_ = this.baseUrl + "/Superadmin/DeleteJoke/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJoke(_response);
        });
    }

    protected processDeleteJoke(response: AxiosResponse): Promise<DeleteJokeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteJokeResponse.fromJS(resultData200);
            return Promise.resolve<DeleteJokeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteJokeResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteHint(id: number, cancelToken?: CancelToken): Promise<DeleteHintResponse> {
        let url_ = this.baseUrl + "/Superadmin/DeleteHint/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteHint(_response);
        });
    }

    protected processDeleteHint(response: AxiosResponse): Promise<DeleteHintResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteHintResponse.fromJS(resultData200);
            return Promise.resolve<DeleteHintResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteHintResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createJoke(body: AddJokeRequest | undefined, cancelToken?: CancelToken): Promise<AddJokeResponse> {
        let url_ = this.baseUrl + "/Superadmin/CreateJoke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJoke(_response);
        });
    }

    protected processCreateJoke(response: AxiosResponse): Promise<AddJokeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddJokeResponse.fromJS(resultData200);
            return Promise.resolve<AddJokeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddJokeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createHint(body: AddHintRequest | undefined, cancelToken?: CancelToken): Promise<AddHintResponse> {
        let url_ = this.baseUrl + "/Superadmin/CreateHint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateHint(_response);
        });
    }

    protected processCreateHint(response: AxiosResponse): Promise<AddHintResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddHintResponse.fromJS(resultData200);
            return Promise.resolve<AddHintResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddHintResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateJoke(body: UpdateJokeRequest | undefined, cancelToken?: CancelToken): Promise<UpdateJokeResponse> {
        let url_ = this.baseUrl + "/Superadmin/UpdateJoke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJoke(_response);
        });
    }

    protected processUpdateJoke(response: AxiosResponse): Promise<UpdateJokeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateJokeResponse.fromJS(resultData200);
            return Promise.resolve<UpdateJokeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateJokeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHint(body: UpdateHintRequest | undefined, cancelToken?: CancelToken): Promise<UpdateHintResponse> {
        let url_ = this.baseUrl + "/Superadmin/UpdateHint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHint(_response);
        });
    }

    protected processUpdateHint(response: AxiosResponse): Promise<UpdateHintResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateHintResponse.fromJS(resultData200);
            return Promise.resolve<UpdateHintResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateHintResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTasksForAdminUser(deleted: boolean, cancelToken?: CancelToken): Promise<GetTasksForAdminUserResponse> {
        let url_ = this.baseUrl + "/Task/GetTasksForAdminUser/{Deleted}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTasksForAdminUser(_response);
        });
    }

    protected processGetTasksForAdminUser(response: AxiosResponse): Promise<GetTasksForAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTasksForAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<GetTasksForAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTasksForAdminUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTaskDetails(wealthId: string, cancelToken?: CancelToken): Promise<GetTaskDetailsResponse> {
        let url_ = this.baseUrl + "/Task/GetTaskDetails/{WealthId}";
        if (wealthId === undefined || wealthId === null)
            throw new Error("The parameter 'wealthId' must be defined.");
        url_ = url_.replace("{WealthId}", encodeURIComponent("" + wealthId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskDetails(_response);
        });
    }

    protected processGetTaskDetails(response: AxiosResponse): Promise<GetTaskDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTaskDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetTaskDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTaskDetailsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTaskDetails(body: SaveTaskDetailsRequest | undefined, cancelToken?: CancelToken): Promise<SaveTaskDetailsResponse> {
        let url_ = this.baseUrl + "/Task/SaveTaskDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTaskDetails(_response);
        });
    }

    protected processSaveTaskDetails(response: AxiosResponse): Promise<SaveTaskDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveTaskDetailsResponse.fromJS(resultData200);
            return Promise.resolve<SaveTaskDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveTaskDetailsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUTC( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/Test/getUTC";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUTC(_response);
        });
    }

    protected processGetUTC(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    testPath3( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Test/testPath3";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestPath3(_response);
        });
    }

    protected processTestPath3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getTodos( cancelToken?: CancelToken): Promise<GetTodosForUserResponse> {
        let url_ = this.baseUrl + "/TodoMain/getTodos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodos(_response);
        });
    }

    protected processGetTodos(response: AxiosResponse): Promise<GetTodosForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosForUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodosForBuilding(buildingId: number, cancelToken?: CancelToken): Promise<GetTodosForUserResponse> {
        let url_ = this.baseUrl + "/TodoMain/GetTodosForBuilding/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodosForBuilding(_response);
        });
    }

    protected processGetTodosForBuilding(response: AxiosResponse): Promise<GetTodosForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosForUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodoDetail(todoId: number, cancelToken?: CancelToken): Promise<GetTodoDetailResponse> {
        let url_ = this.baseUrl + "/TodoMain/getTodoDetail/{TodoId}";
        if (todoId === undefined || todoId === null)
            throw new Error("The parameter 'todoId' must be defined.");
        url_ = url_.replace("{TodoId}", encodeURIComponent("" + todoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodoDetail(_response);
        });
    }

    protected processGetTodoDetail(response: AxiosResponse): Promise<GetTodoDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTodo(body: AddTodoRequest | undefined, cancelToken?: CancelToken): Promise<AddTodoResponse> {
        let url_ = this.baseUrl + "/TodoMain/addTodo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTodo(_response);
        });
    }

    protected processAddTodo(response: AxiosResponse): Promise<AddTodoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddTodoResponse.fromJS(resultData200);
            return Promise.resolve<AddTodoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddTodoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTodo(body: UpdateTodoRequest | undefined, cancelToken?: CancelToken): Promise<UpdateTodoResponse> {
        let url_ = this.baseUrl + "/TodoMain/updateTodo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTodo(_response);
        });
    }

    protected processUpdateTodo(response: AxiosResponse): Promise<UpdateTodoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTodoResponse.fromJS(resultData200);
            return Promise.resolve<UpdateTodoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTodoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTodoGantt(body: UpdateTodoGanttRequest | undefined, cancelToken?: CancelToken): Promise<UpdateTodoGanttResponse> {
        let url_ = this.baseUrl + "/TodoMain/UpdateTodoGantt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTodoGantt(_response);
        });
    }

    protected processUpdateTodoGantt(response: AxiosResponse): Promise<UpdateTodoGanttResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTodoGanttResponse.fromJS(resultData200);
            return Promise.resolve<UpdateTodoGanttResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTodoGanttResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTodos(body: DeleteTodosRequest | undefined, cancelToken?: CancelToken): Promise<DeleteTodosResponse> {
        let url_ = this.baseUrl + "/TodoMain/deleteTodos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTodos(_response);
        });
    }

    protected processDeleteTodos(response: AxiosResponse): Promise<DeleteTodosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteTodosResponse.fromJS(resultData200);
            return Promise.resolve<DeleteTodosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteTodosResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTodoConversationNotification(body: DeleteTodoConversationNotificationRequest | undefined, cancelToken?: CancelToken): Promise<DeleteTodoConversationNotificationResponse> {
        let url_ = this.baseUrl + "/TodoMain/DeleteTodoConversationNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTodoConversationNotification(_response);
        });
    }

    protected processDeleteTodoConversationNotification(response: AxiosResponse): Promise<DeleteTodoConversationNotificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteTodoConversationNotificationResponse.fromJS(resultData200);
            return Promise.resolve<DeleteTodoConversationNotificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteTodoConversationNotificationResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodoAllPossibleAssignees(buildingId: number, cancelToken?: CancelToken): Promise<GetTodoAllPossibleAssigneesResponse> {
        let url_ = this.baseUrl + "/TodoMain/GetTodoAllPossibleAssignees/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodoAllPossibleAssignees(_response);
        });
    }

    protected processGetTodoAllPossibleAssignees(response: AxiosResponse): Promise<GetTodoAllPossibleAssigneesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoAllPossibleAssigneesResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoAllPossibleAssigneesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoAllPossibleAssigneesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodoAllPossibleMessageAssignees(requestId: number, cancelToken?: CancelToken): Promise<GetTodoAllPossibleMessageAssigneesResponse> {
        let url_ = this.baseUrl + "/TodoMain/GetTodoAllPossibleMessageAssignees/{RequestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{RequestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodoAllPossibleMessageAssignees(_response);
        });
    }

    protected processGetTodoAllPossibleMessageAssignees(response: AxiosResponse): Promise<GetTodoAllPossibleMessageAssigneesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoAllPossibleMessageAssigneesResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoAllPossibleMessageAssigneesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoAllPossibleMessageAssigneesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getGanttTodos( cancelToken?: CancelToken): Promise<GetTodosForGanttResponse> {
        let url_ = this.baseUrl + "/TodoMain/getGanttTodos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGanttTodos(_response);
        });
    }

    protected processGetGanttTodos(response: AxiosResponse): Promise<GetTodosForGanttResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosForGanttResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosForGanttResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosForGanttResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodoChatConversations(requestId: number, cancelToken?: CancelToken): Promise<GetTodoChatConversationsResponse> {
        let url_ = this.baseUrl + "/TodoMain/getTodoChatConversations/{RequestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{RequestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodoChatConversations(_response);
        });
    }

    protected processGetTodoChatConversations(response: AxiosResponse): Promise<GetTodoChatConversationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoChatConversationsResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoChatConversationsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoChatConversationsResponse>(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param text (optional) 
     * @param toEmployee (optional) 
     * @param toInvestor (optional) 
     * @param file (optional) 
     * @return Success
     */
    addTodoConversationWithFile(requestId: number | undefined, text: string | undefined, toEmployee: boolean | undefined, toInvestor: boolean | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<AddTodoConversationResponse> {
        let url_ = this.baseUrl + "/TodoMain/addTodoConversationWithFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requestId === null || requestId === undefined)
            throw new Error("The parameter 'requestId' cannot be null.");
        else
            content_.append("RequestId", requestId.toString());
        if (text === null || text === undefined)
            throw new Error("The parameter 'text' cannot be null.");
        else
            content_.append("Text", text.toString());
        if (toEmployee === null || toEmployee === undefined)
            throw new Error("The parameter 'toEmployee' cannot be null.");
        else
            content_.append("ToEmployee", toEmployee.toString());
        if (toInvestor === null || toInvestor === undefined)
            throw new Error("The parameter 'toInvestor' cannot be null.");
        else
            content_.append("ToInvestor", toInvestor.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTodoConversationWithFile(_response);
        });
    }

    protected processAddTodoConversationWithFile(response: AxiosResponse): Promise<AddTodoConversationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddTodoConversationResponse.fromJS(resultData200);
            return Promise.resolve<AddTodoConversationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddTodoConversationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTodoConversation(body: AddTodoConversationRequest | undefined, cancelToken?: CancelToken): Promise<AddTodoConversationResponse> {
        let url_ = this.baseUrl + "/TodoMain/addTodoConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTodoConversation(_response);
        });
    }

    protected processAddTodoConversation(response: AxiosResponse): Promise<AddTodoConversationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddTodoConversationResponse.fromJS(resultData200);
            return Promise.resolve<AddTodoConversationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddTodoConversationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTodoConversation(body: UpdateTodoConversationRequest | undefined, cancelToken?: CancelToken): Promise<UpdateTodoConversationResponse> {
        let url_ = this.baseUrl + "/TodoMain/updateTodoConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTodoConversation(_response);
        });
    }

    protected processUpdateTodoConversation(response: AxiosResponse): Promise<UpdateTodoConversationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTodoConversationResponse.fromJS(resultData200);
            return Promise.resolve<UpdateTodoConversationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTodoConversationResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDeletedTodos( cancelToken?: CancelToken): Promise<GetDeletedTodosResponse> {
        let url_ = this.baseUrl + "/TodoMain/GetDeletedTodos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeletedTodos(_response);
        });
    }

    protected processGetDeletedTodos(response: AxiosResponse): Promise<GetDeletedTodosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeletedTodosResponse.fromJS(resultData200);
            return Promise.resolve<GetDeletedTodosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeletedTodosResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTodosFromThrash(body: MoveTodosFromThrashRequest | undefined, cancelToken?: CancelToken): Promise<MoveTodosFromThrashResponse> {
        let url_ = this.baseUrl + "/TodoMain/MoveTodosFromThrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveTodosFromThrash(_response);
        });
    }

    protected processMoveTodosFromThrash(response: AxiosResponse): Promise<MoveTodosFromThrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveTodosFromThrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveTodosFromThrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveTodosFromThrashResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodoHistory(todoId: number, cancelToken?: CancelToken): Promise<GetTodoHistoryResponse> {
        let url_ = this.baseUrl + "/TodoMain/GetTodoHistory/{TodoId}";
        if (todoId === undefined || todoId === null)
            throw new Error("The parameter 'todoId' must be defined.");
        url_ = url_.replace("{TodoId}", encodeURIComponent("" + todoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodoHistory(_response);
        });
    }

    protected processGetTodoHistory(response: AxiosResponse): Promise<GetTodoHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoHistoryResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoHistoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoHistoryResponse>(null as any);
    }

    /**
     * @return Success
     */
    tasksMapForProject(projectId: number, cancelToken?: CancelToken): Promise<GetTodosMapsListForProjectResponse> {
        let url_ = this.baseUrl + "/TodoMain/tasks-map-for-project/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTasksMapForProject(_response);
        });
    }

    protected processTasksMapForProject(response: AxiosResponse): Promise<GetTodosMapsListForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosMapsListForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosMapsListForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosMapsListForProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    tasksMapsList( cancelToken?: CancelToken): Promise<GetTodosMapsListResponse> {
        let url_ = this.baseUrl + "/TodoMain/tasks-maps-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTasksMapsList(_response);
        });
    }

    protected processTasksMapsList(response: AxiosResponse): Promise<GetTodosMapsListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosMapsListResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosMapsListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosMapsListResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTasksForMap(mapId: number, cancelToken?: CancelToken): Promise<GetTodosForUserAndMapResponse> {
        let url_ = this.baseUrl + "/TodoMain/get-tasks-for-map/{MapId}";
        if (mapId === undefined || mapId === null)
            throw new Error("The parameter 'mapId' must be defined.");
        url_ = url_.replace("{MapId}", encodeURIComponent("" + mapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTasksForMap(_response);
        });
    }

    protected processGetTasksForMap(response: AxiosResponse): Promise<GetTodosForUserAndMapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosForUserAndMapResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosForUserAndMapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosForUserAndMapResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param projectId (optional) 
     * @param name (optional) 
     * @return Success
     */
    uploadImageToProjectTodosMap(file: FileParameter | undefined, projectId: number | undefined, name: string | undefined, cancelToken?: CancelToken): Promise<UploadImageToProjectTodosMapResponse> {
        let url_ = this.baseUrl + "/TodoMain/upload-image-to-project-todos-map";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (projectId === null || projectId === undefined)
            throw new Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadImageToProjectTodosMap(_response);
        });
    }

    protected processUploadImageToProjectTodosMap(response: AxiosResponse): Promise<UploadImageToProjectTodosMapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadImageToProjectTodosMapResponse.fromJS(resultData200);
            return Promise.resolve<UploadImageToProjectTodosMapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadImageToProjectTodosMapResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeMarkersPositions(body: UpdateMarkersPositionsRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMarkersPositionsResponse> {
        let url_ = this.baseUrl + "/TodoMain/change-markers-positions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeMarkersPositions(_response);
        });
    }

    protected processChangeMarkersPositions(response: AxiosResponse): Promise<UpdateMarkersPositionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMarkersPositionsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMarkersPositionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMarkersPositionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveImageMapTodoDetail(body: SaveImageMapTodoDetailRequest | undefined, cancelToken?: CancelToken): Promise<SaveImageMapTodoDetailResponse> {
        let url_ = this.baseUrl + "/TodoMain/save-image-map-todo-detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveImageMapTodoDetail(_response);
        });
    }

    protected processSaveImageMapTodoDetail(response: AxiosResponse): Promise<SaveImageMapTodoDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveImageMapTodoDetailResponse.fromJS(resultData200);
            return Promise.resolve<SaveImageMapTodoDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveImageMapTodoDetailResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeTaskFromMap(taskId: number, cancelToken?: CancelToken): Promise<RemoveTaskFromMapResponse> {
        let url_ = this.baseUrl + "/TodoMain/remove-task-from-map/{TaskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{TaskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveTaskFromMap(_response);
        });
    }

    protected processRemoveTaskFromMap(response: AxiosResponse): Promise<RemoveTaskFromMapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveTaskFromMapResponse.fromJS(resultData200);
            return Promise.resolve<RemoveTaskFromMapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveTaskFromMapResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRequestsPermissions( cancelToken?: CancelToken): Promise<GetRequestsPermissionsResponse> {
        let url_ = this.baseUrl + "/TodoMain/GetRequestsPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestsPermissions(_response);
        });
    }

    protected processGetRequestsPermissions(response: AxiosResponse): Promise<GetRequestsPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestsPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetRequestsPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestsPermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTodosAttachmentsList(requestId: number, cancelToken?: CancelToken): Promise<GetTodosAttachmentsListResponse> {
        let url_ = this.baseUrl + "/TodoMain/GetTodosAttachmentsList/{RequestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{RequestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodosAttachmentsList(_response);
        });
    }

    protected processGetTodosAttachmentsList(response: AxiosResponse): Promise<GetTodosAttachmentsListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosAttachmentsListResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosAttachmentsListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosAttachmentsListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateKanban(body: UpdateTodoKanbanRequest | undefined, cancelToken?: CancelToken): Promise<UpdateTodoKanbanReponse> {
        let url_ = this.baseUrl + "/TodoMain/update-kanban";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateKanban(_response);
        });
    }

    protected processUpdateKanban(response: AxiosResponse): Promise<UpdateTodoKanbanReponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTodoKanbanReponse.fromJS(resultData200);
            return Promise.resolve<UpdateTodoKanbanReponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTodoKanbanReponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilesByIdForTodoZip(body: GetFilesByIdForTodoZipRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TodoMain/GetFilesByIdForTodoZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilesByIdForTodoZip(_response);
        });
    }

    protected processGetFilesByIdForTodoZip(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTodoState(body: UpdateTodoStateRequest | undefined, cancelToken?: CancelToken): Promise<UpdateTodoStateResponse> {
        let url_ = this.baseUrl + "/TodoMain/UpdateTodoState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTodoState(_response);
        });
    }

    protected processUpdateTodoState(response: AxiosResponse): Promise<UpdateTodoStateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTodoStateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateTodoStateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTodoStateResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteImageMap(imageMapId: number, cancelToken?: CancelToken): Promise<DeleteImageMapResponse> {
        let url_ = this.baseUrl + "/TodoMain/delete-image-map/{ImageMapId}";
        if (imageMapId === undefined || imageMapId === null)
            throw new Error("The parameter 'imageMapId' must be defined.");
        url_ = url_.replace("{ImageMapId}", encodeURIComponent("" + imageMapId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteImageMap(_response);
        });
    }

    protected processDeleteImageMap(response: AxiosResponse): Promise<DeleteImageMapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteImageMapResponse.fromJS(resultData200);
            return Promise.resolve<DeleteImageMapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteImageMapResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersAndEmployeesIdsAndNames( cancelToken?: CancelToken): Promise<GetUsersAndEmployeesIdsAndNamesResponse> {
        let url_ = this.baseUrl + "/User/getUsersAndEmployeesIdsAndNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersAndEmployeesIdsAndNames(_response);
        });
    }

    protected processGetUsersAndEmployeesIdsAndNames(response: AxiosResponse): Promise<GetUsersAndEmployeesIdsAndNamesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersAndEmployeesIdsAndNamesResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersAndEmployeesIdsAndNamesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersAndEmployeesIdsAndNamesResponse>(null as any);
    }

    /**
     * @return Success
     */
    userGroups( cancelToken?: CancelToken): Promise<UserGroupsResponse> {
        let url_ = this.baseUrl + "/User/userGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGroups(_response);
        });
    }

    protected processUserGroups(response: AxiosResponse): Promise<UserGroupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserGroupsResponse.fromJS(resultData200);
            return Promise.resolve<UserGroupsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSubcontractorUser(body: CreateSubcontractorUserRequest | undefined, cancelToken?: CancelToken): Promise<CreateSubcontractorUserResponse> {
        let url_ = this.baseUrl + "/User/CreateSubcontractorUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSubcontractorUser(_response);
        });
    }

    protected processCreateSubcontractorUser(response: AxiosResponse): Promise<CreateSubcontractorUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateSubcontractorUserResponse.fromJS(resultData200);
            return Promise.resolve<CreateSubcontractorUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateSubcontractorUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserId(req: GetUserIdRequest, cancelToken?: CancelToken): Promise<GetUserIdResponse> {
        let url_ = this.baseUrl + "/User/GetUserId";
        if (req === undefined || req === null)
            throw new Error("The parameter 'req' must be defined.");
        url_ = url_.replace("{req}", encodeURIComponent("" + req));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserId(_response);
        });
    }

    protected processGetUserId(response: AxiosResponse): Promise<GetUserIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserIdResponse.fromJS(resultData200);
            return Promise.resolve<GetUserIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordRequest | undefined, cancelToken?: CancelToken): Promise<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ResetPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ResetPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordResponse>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationUsers( cancelToken?: CancelToken): Promise<GetApplicationUsersResponse> {
        let url_ = this.baseUrl + "/User/GetApplicationUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationUsers(_response);
        });
    }

    protected processGetApplicationUsers(response: AxiosResponse): Promise<GetApplicationUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationUsersResponse.fromJS(resultData200);
            return Promise.resolve<GetApplicationUsersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationUsersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersForDiaryPrint(diaryId: number, cancelToken?: CancelToken): Promise<GetUsersForDiaryPrintResponse> {
        let url_ = this.baseUrl + "/User/GetUsersForDiaryPrint/{DiaryId}";
        if (diaryId === undefined || diaryId === null)
            throw new Error("The parameter 'diaryId' must be defined.");
        url_ = url_.replace("{DiaryId}", encodeURIComponent("" + diaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersForDiaryPrint(_response);
        });
    }

    protected processGetUsersForDiaryPrint(response: AxiosResponse): Promise<GetUsersForDiaryPrintResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersForDiaryPrintResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersForDiaryPrintResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersForDiaryPrintResponse>(null as any);
    }

    /**
     * @param lastJokeId (optional) 
     * @param language (optional) 
     * @return Success
     */
    getJokeForUser(lastJokeId: number | undefined, language: string | undefined, cancelToken?: CancelToken): Promise<GetJokeForUserResponse> {
        let url_ = this.baseUrl + "/User/GetJokeForUser?";
        if (lastJokeId === null)
            throw new Error("The parameter 'lastJokeId' cannot be null.");
        else if (lastJokeId !== undefined)
            url_ += "LastJokeId=" + encodeURIComponent("" + lastJokeId) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJokeForUser(_response);
        });
    }

    protected processGetJokeForUser(response: AxiosResponse): Promise<GetJokeForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJokeForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetJokeForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJokeForUserResponse>(null as any);
    }

    /**
     * @param lastHintId (optional) 
     * @param language (optional) 
     * @return Success
     */
    getHintForUser(lastHintId: number | undefined, language: string | undefined, cancelToken?: CancelToken): Promise<GetHintForUserResponse> {
        let url_ = this.baseUrl + "/User/GetHintForUser?";
        if (lastHintId === null)
            throw new Error("The parameter 'lastHintId' cannot be null.");
        else if (lastHintId !== undefined)
            url_ += "LastHintId=" + encodeURIComponent("" + lastHintId) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHintForUser(_response);
        });
    }

    protected processGetHintForUser(response: AxiosResponse): Promise<GetHintForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHintForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetHintForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHintForUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvestorUser(body: CreateInvestorUserRequest | undefined, cancelToken?: CancelToken): Promise<CreateInvestorUserResponse> {
        let url_ = this.baseUrl + "/User/CreateInvestorUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvestorUser(_response);
        });
    }

    protected processCreateInvestorUser(response: AxiosResponse): Promise<CreateInvestorUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateInvestorUserResponse.fromJS(resultData200);
            return Promise.resolve<CreateInvestorUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateInvestorUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getInvestorRoles( cancelToken?: CancelToken): Promise<GetInvestorRolesResponse> {
        let url_ = this.baseUrl + "/User/GetInvestorRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvestorRoles(_response);
        });
    }

    protected processGetInvestorRoles(response: AxiosResponse): Promise<GetInvestorRolesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvestorRolesResponse.fromJS(resultData200);
            return Promise.resolve<GetInvestorRolesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvestorRolesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWarehousesForAdminUser( cancelToken?: CancelToken): Promise<GetWarehousesForAdminUserResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehousesForAdminUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehousesForAdminUser(_response);
        });
    }

    protected processGetWarehousesForAdminUser(response: AxiosResponse): Promise<GetWarehousesForAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehousesForAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehousesForAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehousesForAdminUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWarehousesListPage(isfavorite: boolean, cancelToken?: CancelToken): Promise<GetWarehousesListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehousesListPage/{Isfavorite}";
        if (isfavorite === undefined || isfavorite === null)
            throw new Error("The parameter 'isfavorite' must be defined.");
        url_ = url_.replace("{Isfavorite}", encodeURIComponent("" + isfavorite));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehousesListPage(_response);
        });
    }

    protected processGetWarehousesListPage(response: AxiosResponse): Promise<GetWarehousesListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehousesListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehousesListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehousesListPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWarehouseDetail(warehouseId: number, cancelToken?: CancelToken): Promise<GetWarehouseDataDetailResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehouseDetail/{WarehouseId}";
        if (warehouseId === undefined || warehouseId === null)
            throw new Error("The parameter 'warehouseId' must be defined.");
        url_ = url_.replace("{WarehouseId}", encodeURIComponent("" + warehouseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseDetail(_response);
        });
    }

    protected processGetWarehouseDetail(response: AxiosResponse): Promise<GetWarehouseDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehouseDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehouseDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehouseDataDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setWarehouseIsActive(body: SetWarehouseIsActiveRequest | undefined, cancelToken?: CancelToken): Promise<SetWarehouseIsActiveResponse> {
        let url_ = this.baseUrl + "/Warehouse/SetWarehouseIsActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetWarehouseIsActive(_response);
        });
    }

    protected processSetWarehouseIsActive(response: AxiosResponse): Promise<SetWarehouseIsActiveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetWarehouseIsActiveResponse.fromJS(resultData200);
            return Promise.resolve<SetWarehouseIsActiveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetWarehouseIsActiveResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWarehouse(body: SaveWarehouseRequest | undefined, cancelToken?: CancelToken): Promise<SaveWarehouseResponse> {
        let url_ = this.baseUrl + "/Warehouse/SaveWarehouse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWarehouse(_response);
        });
    }

    protected processSaveWarehouse(response: AxiosResponse): Promise<SaveWarehouseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWarehouseResponse.fromJS(resultData200);
            return Promise.resolve<SaveWarehouseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWarehouseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWarehouses(body: DeleteWarehousesRequest | undefined, cancelToken?: CancelToken): Promise<DeleteWarehousesResponse> {
        let url_ = this.baseUrl + "/Warehouse/DeleteWarehouses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWarehouses(_response);
        });
    }

    protected processDeleteWarehouses(response: AxiosResponse): Promise<DeleteWarehousesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteWarehousesResponse.fromJS(resultData200);
            return Promise.resolve<DeleteWarehousesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteWarehousesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getManufacturersListPage( cancelToken?: CancelToken): Promise<GetManufacturersListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetManufacturersListPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturersListPage(_response);
        });
    }

    protected processGetManufacturersListPage(response: AxiosResponse): Promise<GetManufacturersListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturersListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturersListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturersListPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getManufacturerDetail(manufacturerId: number, cancelToken?: CancelToken): Promise<GetManufacturerDataDetailResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetManufacturerDetail/{ManufacturerId}";
        if (manufacturerId === undefined || manufacturerId === null)
            throw new Error("The parameter 'manufacturerId' must be defined.");
        url_ = url_.replace("{ManufacturerId}", encodeURIComponent("" + manufacturerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManufacturerDetail(_response);
        });
    }

    protected processGetManufacturerDetail(response: AxiosResponse): Promise<GetManufacturerDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetManufacturerDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetManufacturerDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetManufacturerDataDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveManufacturer(body: SaveManufacturerRequest | undefined, cancelToken?: CancelToken): Promise<SaveManufacturerResponse> {
        let url_ = this.baseUrl + "/Warehouse/SaveManufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveManufacturer(_response);
        });
    }

    protected processSaveManufacturer(response: AxiosResponse): Promise<SaveManufacturerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveManufacturerResponse.fromJS(resultData200);
            return Promise.resolve<SaveManufacturerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveManufacturerResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteManufacturers(body: DeleteManufacturersRequest | undefined, cancelToken?: CancelToken): Promise<DeleteManufacturersResponse> {
        let url_ = this.baseUrl + "/Warehouse/DeleteManufacturers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteManufacturers(_response);
        });
    }

    protected processDeleteManufacturers(response: AxiosResponse): Promise<DeleteManufacturersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteManufacturersResponse.fromJS(resultData200);
            return Promise.resolve<DeleteManufacturersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteManufacturersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProductCategoriesListPage( cancelToken?: CancelToken): Promise<GetProductCategoriesListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetProductCategoriesListPage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCategoriesListPage(_response);
        });
    }

    protected processGetProductCategoriesListPage(response: AxiosResponse): Promise<GetProductCategoriesListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductCategoriesListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetProductCategoriesListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductCategoriesListPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProductCategoryDetail(productCategoryId: number, cancelToken?: CancelToken): Promise<GetProductCategoryDataDetailResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetProductCategoryDetail/{ProductCategoryId}";
        if (productCategoryId === undefined || productCategoryId === null)
            throw new Error("The parameter 'productCategoryId' must be defined.");
        url_ = url_.replace("{ProductCategoryId}", encodeURIComponent("" + productCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCategoryDetail(_response);
        });
    }

    protected processGetProductCategoryDetail(response: AxiosResponse): Promise<GetProductCategoryDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductCategoryDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetProductCategoryDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductCategoryDataDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProductCategory(body: SaveProductCategoryRequest | undefined, cancelToken?: CancelToken): Promise<SaveProductCategoryResponse> {
        let url_ = this.baseUrl + "/Warehouse/SaveProductCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProductCategory(_response);
        });
    }

    protected processSaveProductCategory(response: AxiosResponse): Promise<SaveProductCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveProductCategoryResponse.fromJS(resultData200);
            return Promise.resolve<SaveProductCategoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveProductCategoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProductCategories(body: DeleteProductCategoriesRequest | undefined, cancelToken?: CancelToken): Promise<DeleteProductCategoriesResponse> {
        let url_ = this.baseUrl + "/Warehouse/DeleteProductCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProductCategories(_response);
        });
    }

    protected processDeleteProductCategories(response: AxiosResponse): Promise<DeleteProductCategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteProductCategoriesResponse.fromJS(resultData200);
            return Promise.resolve<DeleteProductCategoriesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteProductCategoriesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProductsListPage(lang: string, cancelToken?: CancelToken): Promise<GetProductsListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetProductsListPage/{Lang}";
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{Lang}", encodeURIComponent("" + lang));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsListPage(_response);
        });
    }

    protected processGetProductsListPage(response: AxiosResponse): Promise<GetProductsListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductsListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetProductsListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductsListPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProductDetail(productId: number, cancelToken?: CancelToken): Promise<GetProductDataDetailResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetProductDetail/{ProductId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{ProductId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDetail(_response);
        });
    }

    protected processGetProductDetail(response: AxiosResponse): Promise<GetProductDataDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductDataDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetProductDataDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductDataDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProduct(body: SaveProductRequest | undefined, cancelToken?: CancelToken): Promise<SaveProductResponse> {
        let url_ = this.baseUrl + "/Warehouse/SaveProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProduct(_response);
        });
    }

    protected processSaveProduct(response: AxiosResponse): Promise<SaveProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveProductResponse.fromJS(resultData200);
            return Promise.resolve<SaveProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveProductResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProducts(body: DeleteProductsRequest | undefined, cancelToken?: CancelToken): Promise<DeleteProductsResponse> {
        let url_ = this.baseUrl + "/Warehouse/DeleteProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProducts(_response);
        });
    }

    protected processDeleteProducts(response: AxiosResponse): Promise<DeleteProductsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteProductsResponse.fromJS(resultData200);
            return Promise.resolve<DeleteProductsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteProductsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProductsForDiaryDialog(lang: string, cancelToken?: CancelToken): Promise<GetProductsForDiaryDialogResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetProductsForDiaryDialog/{Lang}";
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{Lang}", encodeURIComponent("" + lang));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsForDiaryDialog(_response);
        });
    }

    protected processGetProductsForDiaryDialog(response: AxiosResponse): Promise<GetProductsForDiaryDialogResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductsForDiaryDialogResponse.fromJS(resultData200);
            return Promise.resolve<GetProductsForDiaryDialogResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductsForDiaryDialogResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addProductsToMaterials(body: AddProductsToMaterialsRequest | undefined, cancelToken?: CancelToken): Promise<AddProductsToMaterialsResponse> {
        let url_ = this.baseUrl + "/Warehouse/AddProductsToMaterials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductsToMaterials(_response);
        });
    }

    protected processAddProductsToMaterials(response: AxiosResponse): Promise<AddProductsToMaterialsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddProductsToMaterialsResponse.fromJS(resultData200);
            return Promise.resolve<AddProductsToMaterialsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddProductsToMaterialsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWarehouseProductsListPage(body: GetWarehouseProductsListPageRequest | undefined, cancelToken?: CancelToken): Promise<GetWarehouseProductsListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehouseProductsListPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseProductsListPage(_response);
        });
    }

    protected processGetWarehouseProductsListPage(response: AxiosResponse): Promise<GetWarehouseProductsListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehouseProductsListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehouseProductsListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehouseProductsListPageResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWarehouseProductsWithPriceListPage(body: GetWarehouseProductsWithPriceListPageRequest | undefined, cancelToken?: CancelToken): Promise<GetWarehouseProductsWithPriceListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehouseProductsWithPriceListPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseProductsWithPriceListPage(_response);
        });
    }

    protected processGetWarehouseProductsWithPriceListPage(response: AxiosResponse): Promise<GetWarehouseProductsWithPriceListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehouseProductsWithPriceListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehouseProductsWithPriceListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehouseProductsWithPriceListPageResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStockItems(body: GetStockItemsRequest | undefined, cancelToken?: CancelToken): Promise<GetStockItemsResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetStockItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockItems(_response);
        });
    }

    protected processGetStockItems(response: AxiosResponse): Promise<GetStockItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStockItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetStockItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStockItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStockItemsWithPrice(body: GetStockItemsWithPriceRequest | undefined, cancelToken?: CancelToken): Promise<GetStockItemsWithPriceResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetStockItemsWithPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStockItemsWithPrice(_response);
        });
    }

    protected processGetStockItemsWithPrice(response: AxiosResponse): Promise<GetStockItemsWithPriceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStockItemsWithPriceResponse.fromJS(resultData200);
            return Promise.resolve<GetStockItemsWithPriceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStockItemsWithPriceResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveListWithItems(body: SaveListWithItemsRequest | undefined, cancelToken?: CancelToken): Promise<SaveListWithItemsResponse> {
        let url_ = this.baseUrl + "/Warehouse/SaveListWithItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveListWithItems(_response);
        });
    }

    protected processSaveListWithItems(response: AxiosResponse): Promise<SaveListWithItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveListWithItemsResponse.fromJS(resultData200);
            return Promise.resolve<SaveListWithItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveListWithItemsResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteListWithItems(stockListId: number, cancelToken?: CancelToken): Promise<DeleteListWithItemsResponse> {
        let url_ = this.baseUrl + "/Warehouse/DeleteListWithItems/{StockListId}";
        if (stockListId === undefined || stockListId === null)
            throw new Error("The parameter 'stockListId' must be defined.");
        url_ = url_.replace("{StockListId}", encodeURIComponent("" + stockListId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListWithItems(_response);
        });
    }

    protected processDeleteListWithItems(response: AxiosResponse): Promise<DeleteListWithItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteListWithItemsResponse.fromJS(resultData200);
            return Promise.resolve<DeleteListWithItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteListWithItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWarehouseActions(body: GetWarehouseActionsRequest | undefined, cancelToken?: CancelToken): Promise<GetWarehouseActionsResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehouseActions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehouseActions(_response);
        });
    }

    protected processGetWarehouseActions(response: AxiosResponse): Promise<GetWarehouseActionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehouseActionsResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehouseActionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehouseActionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    updateBlockToDraftOut(stockListId: number, cancelToken?: CancelToken): Promise<UpdateBlockToDraftOutResponse> {
        let url_ = this.baseUrl + "/Warehouse/UpdateBlockToDraftOut/{StockListId}";
        if (stockListId === undefined || stockListId === null)
            throw new Error("The parameter 'stockListId' must be defined.");
        url_ = url_.replace("{StockListId}", encodeURIComponent("" + stockListId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBlockToDraftOut(_response);
        });
    }

    protected processUpdateBlockToDraftOut(response: AxiosResponse): Promise<UpdateBlockToDraftOutResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateBlockToDraftOutResponse.fromJS(resultData200);
            return Promise.resolve<UpdateBlockToDraftOutResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateBlockToDraftOutResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWarehousesReportListPage(body: GetWarehousesReportListPageRequest | undefined, cancelToken?: CancelToken): Promise<GetWarehousesReportListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehousesReportListPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehousesReportListPage(_response);
        });
    }

    protected processGetWarehousesReportListPage(response: AxiosResponse): Promise<GetWarehousesReportListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehousesReportListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehousesReportListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehousesReportListPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWarehousesPermissions( cancelToken?: CancelToken): Promise<GetWarehousesPermissionsResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehousesPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehousesPermissions(_response);
        });
    }

    protected processGetWarehousesPermissions(response: AxiosResponse): Promise<GetWarehousesPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehousesPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehousesPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehousesPermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    updateInWaitingForSignatureToIn(stockListId: number, cancelToken?: CancelToken): Promise<UpdateInWaitingForSignatureToInResponse> {
        let url_ = this.baseUrl + "/Warehouse/UpdateInWaitingForSignatureToIn/{StockListId}";
        if (stockListId === undefined || stockListId === null)
            throw new Error("The parameter 'stockListId' must be defined.");
        url_ = url_.replace("{StockListId}", encodeURIComponent("" + stockListId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInWaitingForSignatureToIn(_response);
        });
    }

    protected processUpdateInWaitingForSignatureToIn(response: AxiosResponse): Promise<UpdateInWaitingForSignatureToInResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInWaitingForSignatureToInResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInWaitingForSignatureToInResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInWaitingForSignatureToInResponse>(null as any);
    }

    /**
     * @param stockListId (optional) 
     * @param isIn (optional) 
     * @param file (optional) 
     * @return Success
     */
    updateStockListSignature(stockListId: number | undefined, isIn: boolean | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UpdateStockListSignatureResponse> {
        let url_ = this.baseUrl + "/Warehouse/UpdateStockListSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (stockListId === null || stockListId === undefined)
            throw new Error("The parameter 'stockListId' cannot be null.");
        else
            content_.append("StockListId", stockListId.toString());
        if (isIn === null || isIn === undefined)
            throw new Error("The parameter 'isIn' cannot be null.");
        else
            content_.append("IsIn", isIn.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStockListSignature(_response);
        });
    }

    protected processUpdateStockListSignature(response: AxiosResponse): Promise<UpdateStockListSignatureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateStockListSignatureResponse.fromJS(resultData200);
            return Promise.resolve<UpdateStockListSignatureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateStockListSignatureResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setProductIsActive(body: SetProductIsActiveRequest | undefined, cancelToken?: CancelToken): Promise<SetProductIsActiveResponse> {
        let url_ = this.baseUrl + "/Warehouse/SetProductIsActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetProductIsActive(_response);
        });
    }

    protected processSetProductIsActive(response: AxiosResponse): Promise<SetProductIsActiveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetProductIsActiveResponse.fromJS(resultData200);
            return Promise.resolve<SetProductIsActiveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetProductIsActiveResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMeasureUnitsListPage(lang: string, cancelToken?: CancelToken): Promise<GetMeasureUnitsListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetMeasureUnitsListPage/{Lang}";
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{Lang}", encodeURIComponent("" + lang));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeasureUnitsListPage(_response);
        });
    }

    protected processGetMeasureUnitsListPage(response: AxiosResponse): Promise<GetMeasureUnitsListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMeasureUnitsListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetMeasureUnitsListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMeasureUnitsListPageResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProductMovementsListPage(body: GetProductMovementsListPageRequest | undefined, cancelToken?: CancelToken): Promise<GetProductMovementsListPageResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetProductMovementsListPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductMovementsListPage(_response);
        });
    }

    protected processGetProductMovementsListPage(response: AxiosResponse): Promise<GetProductMovementsListPageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductMovementsListPageResponse.fromJS(resultData200);
            return Promise.resolve<GetProductMovementsListPageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductMovementsListPageResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWarehousesByBuildingId(buildingId: number, cancelToken?: CancelToken): Promise<GetWarehousesByBuildingIdResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetWarehousesByBuildingId/{BuildingId}";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined.");
        url_ = url_.replace("{BuildingId}", encodeURIComponent("" + buildingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWarehousesByBuildingId(_response);
        });
    }

    protected processGetWarehousesByBuildingId(response: AxiosResponse): Promise<GetWarehousesByBuildingIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWarehousesByBuildingIdResponse.fromJS(resultData200);
            return Promise.resolve<GetWarehousesByBuildingIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWarehousesByBuildingIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBuildingsWithWarehouse(warehouseId: number, cancelToken?: CancelToken): Promise<GetBuildingsWithWarehouseResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetBuildingsWithWarehouse/{WarehouseId}";
        if (warehouseId === undefined || warehouseId === null)
            throw new Error("The parameter 'warehouseId' must be defined.");
        url_ = url_.replace("{WarehouseId}", encodeURIComponent("" + warehouseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildingsWithWarehouse(_response);
        });
    }

    protected processGetBuildingsWithWarehouse(response: AxiosResponse): Promise<GetBuildingsWithWarehouseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingsWithWarehouseResponse.fromJS(resultData200);
            return Promise.resolve<GetBuildingsWithWarehouseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingsWithWarehouseResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addManufacturers(body: AddManufacturersRequest | undefined, cancelToken?: CancelToken): Promise<AddManufacturersResponse> {
        let url_ = this.baseUrl + "/Warehouse/AddManufacturers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddManufacturers(_response);
        });
    }

    protected processAddManufacturers(response: AxiosResponse): Promise<AddManufacturersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddManufacturersResponse.fromJS(resultData200);
            return Promise.resolve<AddManufacturersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddManufacturersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addProductCategories(body: AddProductCategoriesRequest | undefined, cancelToken?: CancelToken): Promise<AddProductCategoriesResponse> {
        let url_ = this.baseUrl + "/Warehouse/AddProductCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddProductCategories(_response);
        });
    }

    protected processAddProductCategories(response: AxiosResponse): Promise<AddProductCategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddProductCategoriesResponse.fromJS(resultData200);
            return Promise.resolve<AddProductCategoriesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddProductCategoriesResponse>(null as any);
    }

    /**
     * @return Success
     */
    getIsStockUniqueIdentCode( cancelToken?: CancelToken): Promise<GetIsStockUniqueIdentCodeResponse> {
        let url_ = this.baseUrl + "/Warehouse/GetIsStockUniqueIdentCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsStockUniqueIdentCode(_response);
        });
    }

    protected processGetIsStockUniqueIdentCode(response: AxiosResponse): Promise<GetIsStockUniqueIdentCodeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIsStockUniqueIdentCodeResponse.fromJS(resultData200);
            return Promise.resolve<GetIsStockUniqueIdentCodeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIsStockUniqueIdentCodeResponse>(null as any);
    }

    /**
     * @return Success
     */
    printStockItemsReport(warehouseId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Warehouse/PrintStockItemsReport/{warehouseId}";
        if (warehouseId === undefined || warehouseId === null)
            throw new Error("The parameter 'warehouseId' must be defined.");
        url_ = url_.replace("{warehouseId}", encodeURIComponent("" + warehouseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintStockItemsReport(_response);
        });
    }

    protected processPrintStockItemsReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthsForAdminUser(deleted: boolean, cancelToken?: CancelToken): Promise<GetWealthsForAdminUserResponse> {
        let url_ = this.baseUrl + "/Wealth/GetWealthsForAdminUser/{Deleted}";
        if (deleted === undefined || deleted === null)
            throw new Error("The parameter 'deleted' must be defined.");
        url_ = url_.replace("{Deleted}", encodeURIComponent("" + deleted));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthsForAdminUser(_response);
        });
    }

    protected processGetWealthsForAdminUser(response: AxiosResponse): Promise<GetWealthsForAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthsForAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthsForAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthsForAdminUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthDetails(wealthId: number, cancelToken?: CancelToken): Promise<GetWealthDetailsResponse> {
        let url_ = this.baseUrl + "/Wealth/GetWealthDetails/{WealthId}";
        if (wealthId === undefined || wealthId === null)
            throw new Error("The parameter 'wealthId' must be defined.");
        url_ = url_.replace("{WealthId}", encodeURIComponent("" + wealthId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthDetails(_response);
        });
    }

    protected processGetWealthDetails(response: AxiosResponse): Promise<GetWealthDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthDetailsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthExpenditures(wealthId: number, cancelToken?: CancelToken): Promise<GetWealthExpendituresResponse> {
        let url_ = this.baseUrl + "/Wealth/GetWealthExpenditures/{WealthId}";
        if (wealthId === undefined || wealthId === null)
            throw new Error("The parameter 'wealthId' must be defined.");
        url_ = url_.replace("{WealthId}", encodeURIComponent("" + wealthId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthExpenditures(_response);
        });
    }

    protected processGetWealthExpenditures(response: AxiosResponse): Promise<GetWealthExpendituresResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthExpendituresResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthExpendituresResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthExpendituresResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWealthDetails(body: SaveWealthDetailsRequest | undefined, cancelToken?: CancelToken): Promise<SaveWealthDetailsResponse> {
        let url_ = this.baseUrl + "/Wealth/SaveWealthDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWealthDetails(_response);
        });
    }

    protected processSaveWealthDetails(response: AxiosResponse): Promise<SaveWealthDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWealthDetailsResponse.fromJS(resultData200);
            return Promise.resolve<SaveWealthDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWealthDetailsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWealthExpenditures(body: SaveWealthExpendituresRequest | undefined, cancelToken?: CancelToken): Promise<SaveWealthExpendituresResponse> {
        let url_ = this.baseUrl + "/Wealth/SaveWealthExpenditures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWealthExpenditures(_response);
        });
    }

    protected processSaveWealthExpenditures(response: AxiosResponse): Promise<SaveWealthExpendituresResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWealthExpendituresResponse.fromJS(resultData200);
            return Promise.resolve<SaveWealthExpendituresResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWealthExpendituresResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWealths(body: DeleteWealthRequest | undefined, cancelToken?: CancelToken): Promise<DeleteWealthResponse> {
        let url_ = this.baseUrl + "/Wealth/DeleteWealths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWealths(_response);
        });
    }

    protected processDeleteWealths(response: AxiosResponse): Promise<DeleteWealthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteWealthResponse.fromJS(resultData200);
            return Promise.resolve<DeleteWealthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteWealthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveWealthsFromTrash(body: MoveWealthsFromTrashRequest | undefined, cancelToken?: CancelToken): Promise<MoveWealthsFromTrashResponse> {
        let url_ = this.baseUrl + "/Wealth/MoveWealthsFromTrash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveWealthsFromTrash(_response);
        });
    }

    protected processMoveWealthsFromTrash(response: AxiosResponse): Promise<MoveWealthsFromTrashResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MoveWealthsFromTrashResponse.fromJS(resultData200);
            return Promise.resolve<MoveWealthsFromTrashResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MoveWealthsFromTrashResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeGroupsForAdminUser( cancelToken?: CancelToken): Promise<GetEmployeeGroupsForAdminUserResponse> {
        let url_ = this.baseUrl + "/Wealth/GetEmployeeGroupsForAdminUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeGroupsForAdminUser(_response);
        });
    }

    protected processGetEmployeeGroupsForAdminUser(response: AxiosResponse): Promise<GetEmployeeGroupsForAdminUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeGroupsForAdminUserResponse.fromJS(resultData200);
            return Promise.resolve<GetEmployeeGroupsForAdminUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeGroupsForAdminUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthHistory(wealthId: number, cancelToken?: CancelToken): Promise<GetWealthHistoryResponse> {
        let url_ = this.baseUrl + "/Wealth/GetWealthHistory/{WealthId}";
        if (wealthId === undefined || wealthId === null)
            throw new Error("The parameter 'wealthId' must be defined.");
        url_ = url_.replace("{WealthId}", encodeURIComponent("" + wealthId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthHistory(_response);
        });
    }

    protected processGetWealthHistory(response: AxiosResponse): Promise<GetWealthHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthHistoryResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthHistoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthHistoryResponse>(null as any);
    }

    /**
     * @return Success
     */
    getWealthRental(wealthId: number, rentalId: number, cancelToken?: CancelToken): Promise<GetWealthRentalResponse> {
        let url_ = this.baseUrl + "/Wealth/GetWealthRental/{RentalId}/{WealthId}";
        if (wealthId === undefined || wealthId === null)
            throw new Error("The parameter 'wealthId' must be defined.");
        url_ = url_.replace("{WealthId}", encodeURIComponent("" + wealthId));
        if (rentalId === undefined || rentalId === null)
            throw new Error("The parameter 'rentalId' must be defined.");
        url_ = url_.replace("{RentalId}", encodeURIComponent("" + rentalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthRental(_response);
        });
    }

    protected processGetWealthRental(response: AxiosResponse): Promise<GetWealthRentalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthRentalResponse.fromJS(resultData200);
            return Promise.resolve<GetWealthRentalResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthRentalResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWealthRental(body: SaveWealthRentalRequest | undefined, cancelToken?: CancelToken): Promise<SaveWealthRentalResponse> {
        let url_ = this.baseUrl + "/Wealth/SaveWealthRental";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWealthRental(_response);
        });
    }

    protected processSaveWealthRental(response: AxiosResponse): Promise<SaveWealthRentalResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWealthRentalResponse.fromJS(resultData200);
            return Promise.resolve<SaveWealthRentalResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWealthRentalResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    saveWealthRentalSignature(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<SaveWealthRentalSignatureResponse> {
        let url_ = this.baseUrl + "/Wealth/SaveWealthRentalSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWealthRentalSignature(_response);
        });
    }

    protected processSaveWealthRentalSignature(response: AxiosResponse): Promise<SaveWealthRentalSignatureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveWealthRentalSignatureResponse.fromJS(resultData200);
            return Promise.resolve<SaveWealthRentalSignatureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveWealthRentalSignatureResponse>(null as any);
    }
}

export class ActionsResponseDTO implements IActionsResponseDTO {
    type?: string | undefined;
    wage?: number;
    dateTime?: Date;
    minutes?: number;

    constructor(data?: IActionsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.wage = _data["wage"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): ActionsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActionsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["wage"] = this.wage;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface IActionsResponseDTO {
    type?: string | undefined;
    wage?: number;
    dateTime?: Date;
    minutes?: number;
}

export class AddEmployeesToWorkersRequest implements IAddEmployeesToWorkersRequest {
    diaryRecordsId?: number;
    employees?: EmployeeInGroupDTO[] | undefined;

    constructor(data?: IAddEmployeesToWorkersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordsId = _data["diaryRecordsId"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeInGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddEmployeesToWorkersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmployeesToWorkersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordsId"] = this.diaryRecordsId;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddEmployeesToWorkersRequest {
    diaryRecordsId?: number;
    employees?: EmployeeInGroupDTO[] | undefined;
}

export class AddEmployeesToWorkersResponse implements IAddEmployeesToWorkersResponse {
    ok?: boolean;

    constructor(data?: IAddEmployeesToWorkersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddEmployeesToWorkersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmployeesToWorkersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddEmployeesToWorkersResponse {
    ok?: boolean;
}

export class AddEmployeesToWorkersSubcontractorRequest implements IAddEmployeesToWorkersSubcontractorRequest {
    diaryRecordsId?: number;
    employees?: EmployeeInGroupDTO[] | undefined;

    constructor(data?: IAddEmployeesToWorkersSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordsId = _data["diaryRecordsId"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeInGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddEmployeesToWorkersSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmployeesToWorkersSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordsId"] = this.diaryRecordsId;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddEmployeesToWorkersSubcontractorRequest {
    diaryRecordsId?: number;
    employees?: EmployeeInGroupDTO[] | undefined;
}

export class AddHintRequest implements IAddHintRequest {
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;

    constructor(data?: IAddHintRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): AddHintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddHintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["language"] = this.language;
        return data;
    }
}

export interface IAddHintRequest {
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
}

export class AddHintResponse implements IAddHintResponse {
    id?: number;

    constructor(data?: IAddHintResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddHintResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddHintResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAddHintResponse {
    id?: number;
}

export class AddImageCategoryRequest implements IAddImageCategoryRequest {
    buildingId?: number;
    name?: string | undefined;

    constructor(data?: IAddImageCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddImageCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddImageCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["name"] = this.name;
        return data;
    }
}

export interface IAddImageCategoryRequest {
    buildingId?: number;
    name?: string | undefined;
}

export class AddImageCategoryResponse implements IAddImageCategoryResponse {
    ok?: boolean;
    id?: number;

    constructor(data?: IAddImageCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddImageCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddImageCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface IAddImageCategoryResponse {
    ok?: boolean;
    id?: number;
}

export class AddImagesToBuildingRequest implements IAddImagesToBuildingRequest {
    buildingId?: number;
    images?: string[] | undefined;
    categoryId?: number | undefined;

    constructor(data?: IAddImagesToBuildingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): AddImagesToBuildingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddImagesToBuildingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface IAddImagesToBuildingRequest {
    buildingId?: number;
    images?: string[] | undefined;
    categoryId?: number | undefined;
}

export class AddImagesToBuildingResponse implements IAddImagesToBuildingResponse {
    ok?: boolean;
    message?: string | undefined;

    constructor(data?: IAddImagesToBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AddImagesToBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddImagesToBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        return data;
    }
}

export interface IAddImagesToBuildingResponse {
    ok?: boolean;
    message?: string | undefined;
}

export class AddImageToProjectAndDiaryRecordResponse implements IAddImageToProjectAndDiaryRecordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;

    constructor(data?: IAddImageToProjectAndDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AddImageToProjectAndDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddImageToProjectAndDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["url"] = this.url;
        return data;
    }
}

export interface IAddImageToProjectAndDiaryRecordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;
}

export class AddImageToProjectResponse implements IAddImageToProjectResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;

    constructor(data?: IAddImageToProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AddImageToProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddImageToProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["url"] = this.url;
        return data;
    }
}

export interface IAddImageToProjectResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;
}

export class AddJokeRequest implements IAddJokeRequest {
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;

    constructor(data?: IAddJokeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): AddJokeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddJokeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["language"] = this.language;
        return data;
    }
}

export interface IAddJokeRequest {
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
}

export class AddJokeResponse implements IAddJokeResponse {
    id?: number;

    constructor(data?: IAddJokeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddJokeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddJokeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAddJokeResponse {
    id?: number;
}

export class AddManufacturersRequest implements IAddManufacturersRequest {
    id?: number;
    names?: string[] | undefined;

    constructor(data?: IAddManufacturersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
        }
    }

    static fromJS(data: any): AddManufacturersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddManufacturersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        return data;
    }
}

export interface IAddManufacturersRequest {
    id?: number;
    names?: string[] | undefined;
}

export class AddManufacturersResponse implements IAddManufacturersResponse {
    ok?: boolean;

    constructor(data?: IAddManufacturersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddManufacturersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddManufacturersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddManufacturersResponse {
    ok?: boolean;
}

export class AddMessageRequestDTO implements IAddMessageRequestDTO {
    messageImage?: string | undefined;
    messageFile?: string | undefined;
    messageFileName?: string | undefined;
    messageText?: string | undefined;
    requestId?: number;

    constructor(data?: IAddMessageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageImage = _data["messageImage"];
            this.messageFile = _data["messageFile"];
            this.messageFileName = _data["messageFileName"];
            this.messageText = _data["messageText"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): AddMessageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddMessageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageImage"] = this.messageImage;
        data["messageFile"] = this.messageFile;
        data["messageFileName"] = this.messageFileName;
        data["messageText"] = this.messageText;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IAddMessageRequestDTO {
    messageImage?: string | undefined;
    messageFile?: string | undefined;
    messageFileName?: string | undefined;
    messageText?: string | undefined;
    requestId?: number;
}

export class AddMessageRequestEmployeeMobileRequest implements IAddMessageRequestEmployeeMobileRequest {
    message?: AddMessageRequestDTO;

    constructor(data?: IAddMessageRequestEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] ? AddMessageRequestDTO.fromJS(_data["message"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddMessageRequestEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMessageRequestEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddMessageRequestEmployeeMobileRequest {
    message?: AddMessageRequestDTO;
}

export class AddMessageRequestEmployeeMobileResponse implements IAddMessageRequestEmployeeMobileResponse {
    message?: InsertMessageResponseDTO;

    constructor(data?: IAddMessageRequestEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] ? InsertMessageResponseDTO.fromJS(_data["message"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddMessageRequestEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMessageRequestEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddMessageRequestEmployeeMobileResponse {
    message?: InsertMessageResponseDTO;
}

export class AddProductCategoriesRequest implements IAddProductCategoriesRequest {
    id?: number;
    names?: string[] | undefined;

    constructor(data?: IAddProductCategoriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
        }
    }

    static fromJS(data: any): AddProductCategoriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductCategoriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        return data;
    }
}

export interface IAddProductCategoriesRequest {
    id?: number;
    names?: string[] | undefined;
}

export class AddProductCategoriesResponse implements IAddProductCategoriesResponse {
    ok?: boolean;

    constructor(data?: IAddProductCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddProductCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddProductCategoriesResponse {
    ok?: boolean;
}

export class AddProductsToMaterialsRequest implements IAddProductsToMaterialsRequest {
    diaryRecordsId?: number;
    checkedProductsIds?: number[] | undefined;
    lang?: string | undefined;

    constructor(data?: IAddProductsToMaterialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordsId = _data["diaryRecordsId"];
            if (Array.isArray(_data["checkedProductsIds"])) {
                this.checkedProductsIds = [] as any;
                for (let item of _data["checkedProductsIds"])
                    this.checkedProductsIds!.push(item);
            }
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): AddProductsToMaterialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductsToMaterialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordsId"] = this.diaryRecordsId;
        if (Array.isArray(this.checkedProductsIds)) {
            data["checkedProductsIds"] = [];
            for (let item of this.checkedProductsIds)
                data["checkedProductsIds"].push(item);
        }
        data["lang"] = this.lang;
        return data;
    }
}

export interface IAddProductsToMaterialsRequest {
    diaryRecordsId?: number;
    checkedProductsIds?: number[] | undefined;
    lang?: string | undefined;
}

export class AddProductsToMaterialsResponse implements IAddProductsToMaterialsResponse {
    ok?: boolean;

    constructor(data?: IAddProductsToMaterialsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddProductsToMaterialsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductsToMaterialsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddProductsToMaterialsResponse {
    ok?: boolean;
}

export class AddRemoveFileDiaryRecordDTO implements IAddRemoveFileDiaryRecordDTO {
    id?: number;
    isSelected?: boolean;

    constructor(data?: IAddRemoveFileDiaryRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): AddRemoveFileDiaryRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemoveFileDiaryRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IAddRemoveFileDiaryRecordDTO {
    id?: number;
    isSelected?: boolean;
}

export class AddRemoveFilesDiaryRecordRequest implements IAddRemoveFilesDiaryRecordRequest {
    diaryRecordId?: number;
    files?: AddRemoveFileDiaryRecordDTO[] | undefined;

    constructor(data?: IAddRemoveFilesDiaryRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AddRemoveFileDiaryRecordDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddRemoveFilesDiaryRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemoveFilesDiaryRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddRemoveFilesDiaryRecordRequest {
    diaryRecordId?: number;
    files?: AddRemoveFileDiaryRecordDTO[] | undefined;
}

export class AddRemoveFilesDiaryRecordResponse implements IAddRemoveFilesDiaryRecordResponse {
    ok?: boolean;

    constructor(data?: IAddRemoveFilesDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddRemoveFilesDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemoveFilesDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddRemoveFilesDiaryRecordResponse {
    ok?: boolean;
}

export class AddRemoveFilesDiaryRecordSubcontractorRequest implements IAddRemoveFilesDiaryRecordSubcontractorRequest {
    diaryRecordId?: number;
    files?: AddRemoveFileDiaryRecordDTO[] | undefined;

    constructor(data?: IAddRemoveFilesDiaryRecordSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AddRemoveFileDiaryRecordDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddRemoveFilesDiaryRecordSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemoveFilesDiaryRecordSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddRemoveFilesDiaryRecordSubcontractorRequest {
    diaryRecordId?: number;
    files?: AddRemoveFileDiaryRecordDTO[] | undefined;
}

export class AddRequestDTO implements IAddRequestDTO {
    adminId?: number;
    buildingId?: number | undefined;
    datetimeTo?: Date | undefined;
    description?: string | undefined;
    images?: string[] | undefined;
    text?: string | undefined;
    wealthId?: number | undefined;

    constructor(data?: IAddRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminId = _data["adminId"];
            this.buildingId = _data["buildingId"];
            this.datetimeTo = _data["datetimeTo"] ? new Date(_data["datetimeTo"].toString()) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.text = _data["text"];
            this.wealthId = _data["wealthId"];
        }
    }

    static fromJS(data: any): AddRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminId"] = this.adminId;
        data["buildingId"] = this.buildingId;
        data["datetimeTo"] = this.datetimeTo ? this.datetimeTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["text"] = this.text;
        data["wealthId"] = this.wealthId;
        return data;
    }
}

export interface IAddRequestDTO {
    adminId?: number;
    buildingId?: number | undefined;
    datetimeTo?: Date | undefined;
    description?: string | undefined;
    images?: string[] | undefined;
    text?: string | undefined;
    wealthId?: number | undefined;
}

export class AddRequestEmployeeMobileRequest implements IAddRequestEmployeeMobileRequest {
    request?: AddRequestDTO;

    constructor(data?: IAddRequestEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? AddRequestDTO.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddRequestEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRequestEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddRequestEmployeeMobileRequest {
    request?: AddRequestDTO;
}

export class AddRequestEmployeeMobileResponse implements IAddRequestEmployeeMobileResponse {
    request?: RequestResponseDTO;

    constructor(data?: IAddRequestEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? RequestResponseDTO.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddRequestEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRequestEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddRequestEmployeeMobileResponse {
    request?: RequestResponseDTO;
}

export class AddTodoConversationRequest implements IAddTodoConversationRequest {
    requestId?: number;
    text?: string | undefined;
    toEmployee?: boolean;
    toInvestor?: boolean;

    constructor(data?: IAddTodoConversationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.text = _data["text"];
            this.toEmployee = _data["toEmployee"];
            this.toInvestor = _data["toInvestor"];
        }
    }

    static fromJS(data: any): AddTodoConversationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoConversationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["text"] = this.text;
        data["toEmployee"] = this.toEmployee;
        data["toInvestor"] = this.toInvestor;
        return data;
    }
}

export interface IAddTodoConversationRequest {
    requestId?: number;
    text?: string | undefined;
    toEmployee?: boolean;
    toInvestor?: boolean;
}

export class AddTodoConversationResponse implements IAddTodoConversationResponse {
    sent?: boolean;

    constructor(data?: IAddTodoConversationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sent = _data["sent"];
        }
    }

    static fromJS(data: any): AddTodoConversationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoConversationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sent"] = this.sent;
        return data;
    }
}

export interface IAddTodoConversationResponse {
    sent?: boolean;
}

export class AddTodoRequest implements IAddTodoRequest {
    data?: TodoDTO;

    constructor(data?: IAddTodoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TodoDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddTodoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddTodoRequest {
    data?: TodoDTO;
}

export class AddTodoResponse implements IAddTodoResponse {
    id?: number;
    rowVersion?: string | undefined;

    constructor(data?: IAddTodoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): AddTodoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IAddTodoResponse {
    id?: number;
    rowVersion?: string | undefined;
}

export class AddWealthsToMechanismsRequest implements IAddWealthsToMechanismsRequest {
    diaryRecordsId?: number;
    checkedWealthsIds?: number[] | undefined;

    constructor(data?: IAddWealthsToMechanismsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordsId = _data["diaryRecordsId"];
            if (Array.isArray(_data["checkedWealthsIds"])) {
                this.checkedWealthsIds = [] as any;
                for (let item of _data["checkedWealthsIds"])
                    this.checkedWealthsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddWealthsToMechanismsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddWealthsToMechanismsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordsId"] = this.diaryRecordsId;
        if (Array.isArray(this.checkedWealthsIds)) {
            data["checkedWealthsIds"] = [];
            for (let item of this.checkedWealthsIds)
                data["checkedWealthsIds"].push(item);
        }
        return data;
    }
}

export interface IAddWealthsToMechanismsRequest {
    diaryRecordsId?: number;
    checkedWealthsIds?: number[] | undefined;
}

export class AddWealthsToMechanismsResponse implements IAddWealthsToMechanismsResponse {
    ok?: boolean;

    constructor(data?: IAddWealthsToMechanismsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddWealthsToMechanismsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddWealthsToMechanismsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddWealthsToMechanismsResponse {
    ok?: boolean;
}

export class AddWealthsToMechanismsSubcontractorRequest implements IAddWealthsToMechanismsSubcontractorRequest {
    diaryRecordsId?: number;
    checkedWealthsIds?: number[] | undefined;

    constructor(data?: IAddWealthsToMechanismsSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordsId = _data["diaryRecordsId"];
            if (Array.isArray(_data["checkedWealthsIds"])) {
                this.checkedWealthsIds = [] as any;
                for (let item of _data["checkedWealthsIds"])
                    this.checkedWealthsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddWealthsToMechanismsSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddWealthsToMechanismsSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordsId"] = this.diaryRecordsId;
        if (Array.isArray(this.checkedWealthsIds)) {
            data["checkedWealthsIds"] = [];
            for (let item of this.checkedWealthsIds)
                data["checkedWealthsIds"].push(item);
        }
        return data;
    }
}

export interface IAddWealthsToMechanismsSubcontractorRequest {
    diaryRecordsId?: number;
    checkedWealthsIds?: number[] | undefined;
}

export class AdminApplicationDataDTO implements IAdminApplicationDataDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    key?: string | undefined;
    dataAmount?: number;
    createdDate?: Date | undefined;
    createdSource?: string | undefined;
    isActive?: boolean;
    isPaying?: boolean;
    showNotPaying?: boolean;
    defaultLanguage?: string | undefined;
    idFakturoid?: string | undefined;
    ico?: string | undefined;
    dic?: string | undefined;
    email?: string | undefined;
    addressStreet?: string | undefined;
    addressCity?: string | undefined;
    addressZipCode?: string | undefined;
    addressState?: string | undefined;

    constructor(data?: IAdminApplicationDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.key = _data["key"];
            this.dataAmount = _data["dataAmount"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdSource = _data["createdSource"];
            this.isActive = _data["isActive"];
            this.isPaying = _data["isPaying"];
            this.showNotPaying = _data["showNotPaying"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.idFakturoid = _data["idFakturoid"];
            this.ico = _data["ico"];
            this.dic = _data["dic"];
            this.email = _data["email"];
            this.addressStreet = _data["addressStreet"];
            this.addressCity = _data["addressCity"];
            this.addressZipCode = _data["addressZipCode"];
            this.addressState = _data["addressState"];
        }
    }

    static fromJS(data: any): AdminApplicationDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdminApplicationDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["key"] = this.key;
        data["dataAmount"] = this.dataAmount;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdSource"] = this.createdSource;
        data["isActive"] = this.isActive;
        data["isPaying"] = this.isPaying;
        data["showNotPaying"] = this.showNotPaying;
        data["defaultLanguage"] = this.defaultLanguage;
        data["idFakturoid"] = this.idFakturoid;
        data["ico"] = this.ico;
        data["dic"] = this.dic;
        data["email"] = this.email;
        data["addressStreet"] = this.addressStreet;
        data["addressCity"] = this.addressCity;
        data["addressZipCode"] = this.addressZipCode;
        data["addressState"] = this.addressState;
        return data;
    }
}

export interface IAdminApplicationDataDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    key?: string | undefined;
    dataAmount?: number;
    createdDate?: Date | undefined;
    createdSource?: string | undefined;
    isActive?: boolean;
    isPaying?: boolean;
    showNotPaying?: boolean;
    defaultLanguage?: string | undefined;
    idFakturoid?: string | undefined;
    ico?: string | undefined;
    dic?: string | undefined;
    email?: string | undefined;
    addressStreet?: string | undefined;
    addressCity?: string | undefined;
    addressZipCode?: string | undefined;
    addressState?: string | undefined;
}

export class AdminApplicationDTO implements IAdminApplicationDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    key?: string | undefined;
    dataAmount?: number;
    createdDate?: Date;
    createdSource?: string | undefined;
    isActive?: boolean;
    isPaying?: boolean;
    showNotPaying?: boolean;

    constructor(data?: IAdminApplicationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.key = _data["key"];
            this.dataAmount = _data["dataAmount"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdSource = _data["createdSource"];
            this.isActive = _data["isActive"];
            this.isPaying = _data["isPaying"];
            this.showNotPaying = _data["showNotPaying"];
        }
    }

    static fromJS(data: any): AdminApplicationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdminApplicationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["key"] = this.key;
        data["dataAmount"] = this.dataAmount;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdSource"] = this.createdSource;
        data["isActive"] = this.isActive;
        data["isPaying"] = this.isPaying;
        data["showNotPaying"] = this.showNotPaying;
        return data;
    }
}

export interface IAdminApplicationDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    key?: string | undefined;
    dataAmount?: number;
    createdDate?: Date;
    createdSource?: string | undefined;
    isActive?: boolean;
    isPaying?: boolean;
    showNotPaying?: boolean;
}

export class AdminUserDTO implements IAdminUserDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IAdminUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdminUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAdminUserDTO {
    id?: number;
    name?: string | undefined;
}

export class AdminUsersDTO implements IAdminUsersDTO {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    application?: string | undefined;
    applicationId?: number;

    constructor(data?: IAdminUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.application = _data["application"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): AdminUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["application"] = this.application;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IAdminUsersDTO {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    application?: string | undefined;
    applicationId?: number;
}

export class AiImageRecognizeResponse implements IAiImageRecognizeResponse {
    state?: string | undefined;

    constructor(data?: IAiImageRecognizeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): AiImageRecognizeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiImageRecognizeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        return data;
    }
}

export interface IAiImageRecognizeResponse {
    state?: string | undefined;
}

export class AiImagesDescriptionDto implements IAiImagesDescriptionDto {
    id?: number;
    applicationsId?: number;
    applicationsName?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    date?: Date;
    generatedDescription?: string | undefined;
    workCategory?: string | undefined;
    workCategoryNext?: string | undefined;
    workCategoryAfterNext?: string | undefined;
    urls?: string[] | undefined;

    constructor(data?: IAiImagesDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationsId = _data["applicationsId"];
            this.applicationsName = _data["applicationsName"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.generatedDescription = _data["generatedDescription"];
            this.workCategory = _data["workCategory"];
            this.workCategoryNext = _data["workCategoryNext"];
            this.workCategoryAfterNext = _data["workCategoryAfterNext"];
            if (Array.isArray(_data["urls"])) {
                this.urls = [] as any;
                for (let item of _data["urls"])
                    this.urls!.push(item);
            }
        }
    }

    static fromJS(data: any): AiImagesDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiImagesDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationsId"] = this.applicationsId;
        data["applicationsName"] = this.applicationsName;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["generatedDescription"] = this.generatedDescription;
        data["workCategory"] = this.workCategory;
        data["workCategoryNext"] = this.workCategoryNext;
        data["workCategoryAfterNext"] = this.workCategoryAfterNext;
        if (Array.isArray(this.urls)) {
            data["urls"] = [];
            for (let item of this.urls)
                data["urls"].push(item);
        }
        return data;
    }
}

export interface IAiImagesDescriptionDto {
    id?: number;
    applicationsId?: number;
    applicationsName?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    date?: Date;
    generatedDescription?: string | undefined;
    workCategory?: string | undefined;
    workCategoryNext?: string | undefined;
    workCategoryAfterNext?: string | undefined;
    urls?: string[] | undefined;
}

export class ApplicationListDTO implements IApplicationListDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IApplicationListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ApplicationListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IApplicationListDTO {
    id?: number;
    name?: string | undefined;
}

export class ApplyCategoryTemplateRequest implements IApplyCategoryTemplateRequest {
    buildingId?: number;
    categoryTemplateId?: number;

    constructor(data?: IApplyCategoryTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.categoryTemplateId = _data["categoryTemplateId"];
        }
    }

    static fromJS(data: any): ApplyCategoryTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyCategoryTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["categoryTemplateId"] = this.categoryTemplateId;
        return data;
    }
}

export interface IApplyCategoryTemplateRequest {
    buildingId?: number;
    categoryTemplateId?: number;
}

export class ApplyCategoryTemplateResponse implements IApplyCategoryTemplateResponse {
    ok?: boolean;

    constructor(data?: IApplyCategoryTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ApplyCategoryTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyCategoryTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IApplyCategoryTemplateResponse {
    ok?: boolean;
}

export class AssignedEmployeeDTO implements IAssignedEmployeeDTO {
    id?: number;
    code?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    groupId?: number | undefined;
    group?: string | undefined;
    isAssigned?: boolean;

    constructor(data?: IAssignedEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): AssignedEmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedEmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        data["isAssigned"] = this.isAssigned;
        return data;
    }
}

export interface IAssignedEmployeeDTO {
    id?: number;
    code?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    groupId?: number | undefined;
    group?: string | undefined;
    isAssigned?: boolean;
}

export class AssignedUserDTO implements IAssignedUserDTO {
    id?: number;
    name?: string | undefined;
    isAssigned?: boolean;
    notificationsEnabledRequests?: boolean;
    notificationsEnabledBuildingDiaryRecords?: boolean;
    groupId?: number | undefined;
    group?: string | undefined;

    constructor(data?: IAssignedUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAssigned = _data["isAssigned"];
            this.notificationsEnabledRequests = _data["notificationsEnabledRequests"];
            this.notificationsEnabledBuildingDiaryRecords = _data["notificationsEnabledBuildingDiaryRecords"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
        }
    }

    static fromJS(data: any): AssignedUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAssigned"] = this.isAssigned;
        data["notificationsEnabledRequests"] = this.notificationsEnabledRequests;
        data["notificationsEnabledBuildingDiaryRecords"] = this.notificationsEnabledBuildingDiaryRecords;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        return data;
    }
}

export interface IAssignedUserDTO {
    id?: number;
    name?: string | undefined;
    isAssigned?: boolean;
    notificationsEnabledRequests?: boolean;
    notificationsEnabledBuildingDiaryRecords?: boolean;
    groupId?: number | undefined;
    group?: string | undefined;
}

export class AssignedUserForProjectsListPageDTO implements IAssignedUserForProjectsListPageDTO {
    adminUsersId?: number;
    name?: string | undefined;

    constructor(data?: IAssignedUserForProjectsListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminUsersId = _data["adminUsersId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AssignedUserForProjectsListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserForProjectsListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminUsersId"] = this.adminUsersId;
        data["name"] = this.name;
        return data;
    }
}

export interface IAssignedUserForProjectsListPageDTO {
    adminUsersId?: number;
    name?: string | undefined;
}

export class AssigneeDto implements IAssigneeDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IAssigneeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AssigneeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAssigneeDto {
    id?: number;
    name?: string | undefined;
}

export class AssigneeResponseDTO implements IAssigneeResponseDTO {
    id?: number;
    name?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    constructor(data?: IAssigneeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AssigneeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAssigneeResponseDTO {
    id?: number;
    name?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export class AttendanceResponseDTO implements IAttendanceResponseDTO {
    date?: Date;
    minutes?: number;
    note?: string | undefined;
    isAdminEdited?: boolean;
    deposit?: number;
    depositIsPaid?: string | undefined;
    depositNote?: string | undefined;
    actions?: ActionsResponseDTO[] | undefined;
    type?: string | undefined;

    constructor(data?: IAttendanceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.minutes = _data["minutes"];
            this.note = _data["note"];
            this.isAdminEdited = _data["isAdminEdited"];
            this.deposit = _data["deposit"];
            this.depositIsPaid = _data["depositIsPaid"];
            this.depositNote = _data["depositNote"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionsResponseDTO.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AttendanceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["minutes"] = this.minutes;
        data["note"] = this.note;
        data["isAdminEdited"] = this.isAdminEdited;
        data["deposit"] = this.deposit;
        data["depositIsPaid"] = this.depositIsPaid;
        data["depositNote"] = this.depositNote;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data;
    }
}

export interface IAttendanceResponseDTO {
    date?: Date;
    minutes?: number;
    note?: string | undefined;
    isAdminEdited?: boolean;
    deposit?: number;
    depositIsPaid?: string | undefined;
    depositNote?: string | undefined;
    actions?: ActionsResponseDTO[] | undefined;
    type?: string | undefined;
}

export class AuthEmpToAdminUserRequest implements IAuthEmpToAdminUserRequest {
    employeeId?: number;
    employeeToken?: string | undefined;
    adminUsersId?: number;

    constructor(data?: IAuthEmpToAdminUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeToken = _data["employeeToken"];
            this.adminUsersId = _data["adminUsersId"];
        }
    }

    static fromJS(data: any): AuthEmpToAdminUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthEmpToAdminUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeToken"] = this.employeeToken;
        data["adminUsersId"] = this.adminUsersId;
        return data;
    }
}

export interface IAuthEmpToAdminUserRequest {
    employeeId?: number;
    employeeToken?: string | undefined;
    adminUsersId?: number;
}

export class AuthEmpToAdminUserResponse implements IAuthEmpToAdminUserResponse {
    token?: string | undefined;
    userName?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;

    constructor(data?: IAuthEmpToAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.userName = _data["userName"];
            this.refreshToken = _data["refreshToken"];
            this.dateTimeExpires = _data["dateTimeExpires"] ? new Date(_data["dateTimeExpires"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthEmpToAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthEmpToAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["userName"] = this.userName;
        data["refreshToken"] = this.refreshToken;
        data["dateTimeExpires"] = this.dateTimeExpires ? this.dateTimeExpires.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthEmpToAdminUserResponse {
    token?: string | undefined;
    userName?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
}

export class AuthInvestorRequest implements IAuthInvestorRequest {
    application?: string | undefined;
    investorUsername?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthInvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"];
            this.investorUsername = _data["investorUsername"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthInvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application;
        data["investorUsername"] = this.investorUsername;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthInvestorRequest {
    application?: string | undefined;
    investorUsername?: string | undefined;
    password?: string | undefined;
}

export class AuthInvestorResponse implements IAuthInvestorResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IAuthInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.dateTimeExpires = _data["dateTimeExpires"] ? new Date(_data["dateTimeExpires"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AuthInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["dateTimeExpires"] = this.dateTimeExpires ? this.dateTimeExpires.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        return data;
    }
}

export interface IAuthInvestorResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
}

export class AuthKrosSuperAdminRequest implements IAuthKrosSuperAdminRequest {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthKrosSuperAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthKrosSuperAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthKrosSuperAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthKrosSuperAdminRequest {
    username?: string | undefined;
    password?: string | undefined;
}

export class AuthKrosSuperAdminResponse implements IAuthKrosSuperAdminResponse {
    id?: number;
    token?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IAuthKrosSuperAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.dateTimeExpires = _data["dateTimeExpires"] ? new Date(_data["dateTimeExpires"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AuthKrosSuperAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthKrosSuperAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["dateTimeExpires"] = this.dateTimeExpires ? this.dateTimeExpires.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IAuthKrosSuperAdminResponse {
    id?: number;
    token?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
    name?: string | undefined;
    email?: string | undefined;
}

export class AuthMobileEmployeeRequest implements IAuthMobileEmployeeRequest {
    domain?: string | undefined;
    code?: string | undefined;
    pin?: string | undefined;
    messaginToken?: string | undefined;

    constructor(data?: IAuthMobileEmployeeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.code = _data["code"];
            this.pin = _data["pin"];
            this.messaginToken = _data["messaginToken"];
        }
    }

    static fromJS(data: any): AuthMobileEmployeeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMobileEmployeeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["code"] = this.code;
        data["pin"] = this.pin;
        data["messaginToken"] = this.messaginToken;
        return data;
    }
}

export interface IAuthMobileEmployeeRequest {
    domain?: string | undefined;
    code?: string | undefined;
    pin?: string | undefined;
    messaginToken?: string | undefined;
}

export class AuthMobileEmployeeResponse implements IAuthMobileEmployeeResponse {
    message?: string | undefined;
    mobileToken?: string | undefined;
    employeeToken?: string | undefined;
    employeeRefreshToken?: string | undefined;
    adminAccessToken?: string | undefined;
    adminRefreshToken?: string | undefined;

    constructor(data?: IAuthMobileEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.mobileToken = _data["mobileToken"];
            this.employeeToken = _data["employeeToken"];
            this.employeeRefreshToken = _data["employeeRefreshToken"];
            this.adminAccessToken = _data["adminAccessToken"];
            this.adminRefreshToken = _data["adminRefreshToken"];
        }
    }

    static fromJS(data: any): AuthMobileEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMobileEmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["mobileToken"] = this.mobileToken;
        data["employeeToken"] = this.employeeToken;
        data["employeeRefreshToken"] = this.employeeRefreshToken;
        data["adminAccessToken"] = this.adminAccessToken;
        data["adminRefreshToken"] = this.adminRefreshToken;
        return data;
    }
}

export interface IAuthMobileEmployeeResponse {
    message?: string | undefined;
    mobileToken?: string | undefined;
    employeeToken?: string | undefined;
    employeeRefreshToken?: string | undefined;
    adminAccessToken?: string | undefined;
    adminRefreshToken?: string | undefined;
}

export class AuthOldErpAdminUsersRequest implements IAuthOldErpAdminUsersRequest {
    token?: string | undefined;
    adminUserId?: number;

    constructor(data?: IAuthOldErpAdminUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
        }
    }

    static fromJS(data: any): AuthOldErpAdminUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthOldErpAdminUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        return data;
    }
}

export interface IAuthOldErpAdminUsersRequest {
    token?: string | undefined;
    adminUserId?: number;
}

export class AuthOldErpAdminUsersResponse implements IAuthOldErpAdminUsersResponse {
    token?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IAuthOldErpAdminUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AuthOldErpAdminUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthOldErpAdminUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAuthOldErpAdminUsersResponse {
    token?: string | undefined;
    userName?: string | undefined;
}

export class AuthOldErpSubcontractorRequest implements IAuthOldErpSubcontractorRequest {
    token?: string | undefined;
    adminUserId?: number;

    constructor(data?: IAuthOldErpSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
        }
    }

    static fromJS(data: any): AuthOldErpSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthOldErpSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        return data;
    }
}

export interface IAuthOldErpSubcontractorRequest {
    token?: string | undefined;
    adminUserId?: number;
}

export class AuthOldErpSubcontractorResponse implements IAuthOldErpSubcontractorResponse {
    token?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IAuthOldErpSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AuthOldErpSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthOldErpSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAuthOldErpSubcontractorResponse {
    token?: string | undefined;
    userName?: string | undefined;
}

export class AuthRequest implements IAuthRequest {
    application?: string | undefined;
    adminUsername?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"];
            this.adminUsername = _data["adminUsername"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application;
        data["adminUsername"] = this.adminUsername;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthRequest {
    application?: string | undefined;
    adminUsername?: string | undefined;
    password?: string | undefined;
}

export class AuthResponse implements IAuthResponse {
    id?: number;
    token?: string | undefined;
    userName?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.userName = _data["userName"];
            this.refreshToken = _data["refreshToken"];
            this.dateTimeExpires = _data["dateTimeExpires"] ? new Date(_data["dateTimeExpires"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["userName"] = this.userName;
        data["refreshToken"] = this.refreshToken;
        data["dateTimeExpires"] = this.dateTimeExpires ? this.dateTimeExpires.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthResponse {
    id?: number;
    token?: string | undefined;
    userName?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
}

export class AuthSubcontractorRequest implements IAuthSubcontractorRequest {
    application?: string | undefined;
    subcontractorUsername?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"];
            this.subcontractorUsername = _data["subcontractorUsername"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application;
        data["subcontractorUsername"] = this.subcontractorUsername;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthSubcontractorRequest {
    application?: string | undefined;
    subcontractorUsername?: string | undefined;
    password?: string | undefined;
}

export class AuthSubcontractorResponse implements IAuthSubcontractorResponse {
    id?: number;
    token?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    isSubcontractor?: boolean;

    constructor(data?: IAuthSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.dateTimeExpires = _data["dateTimeExpires"] ? new Date(_data["dateTimeExpires"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.isSubcontractor = _data["isSubcontractor"];
        }
    }

    static fromJS(data: any): AuthSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["dateTimeExpires"] = this.dateTimeExpires ? this.dateTimeExpires.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["isSubcontractor"] = this.isSubcontractor;
        return data;
    }
}

export interface IAuthSubcontractorResponse {
    id?: number;
    token?: string | undefined;
    refreshToken?: string | undefined;
    dateTimeExpires?: Date;
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    isSubcontractor?: boolean;
}

export class BozpDocumentNewsResponseDTO implements IBozpDocumentNewsResponseDTO {
    type?: BozpDocumentNewsType;
    id?: number;
    name?: string | undefined;
    file?: string | undefined;
    isRead?: boolean;
    isRejected?: boolean;

    constructor(data?: IBozpDocumentNewsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.file = _data["file"];
            this.isRead = _data["isRead"];
            this.isRejected = _data["isRejected"];
        }
    }

    static fromJS(data: any): BozpDocumentNewsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BozpDocumentNewsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["name"] = this.name;
        data["file"] = this.file;
        data["isRead"] = this.isRead;
        data["isRejected"] = this.isRejected;
        return data;
    }
}

export interface IBozpDocumentNewsResponseDTO {
    type?: BozpDocumentNewsType;
    id?: number;
    name?: string | undefined;
    file?: string | undefined;
    isRead?: boolean;
    isRejected?: boolean;
}

export enum BozpDocumentNewsType {
    Bozp = 0,
    Document = 1,
    News = 2,
}

export class BuildingBillsForInvoicesPageDTO implements IBuildingBillsForInvoicesPageDTO {
    id?: number;
    name?: string | undefined;
    project?: string | undefined;
    dateExpire?: Date;
    dateTaxable?: Date;
    isDone?: boolean;
    isApproved?: boolean;
    isPostponed?: boolean;
    isPosted?: boolean;
    priceWithoutVat?: number;
    priceWithVat?: number;

    constructor(data?: IBuildingBillsForInvoicesPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.dateExpire = _data["dateExpire"] ? new Date(_data["dateExpire"].toString()) : <any>undefined;
            this.dateTaxable = _data["dateTaxable"] ? new Date(_data["dateTaxable"].toString()) : <any>undefined;
            this.isDone = _data["isDone"];
            this.isApproved = _data["isApproved"];
            this.isPostponed = _data["isPostponed"];
            this.isPosted = _data["isPosted"];
            this.priceWithoutVat = _data["priceWithoutVat"];
            this.priceWithVat = _data["priceWithVat"];
        }
    }

    static fromJS(data: any): BuildingBillsForInvoicesPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingBillsForInvoicesPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["dateExpire"] = this.dateExpire ? this.dateExpire.toISOString() : <any>undefined;
        data["dateTaxable"] = this.dateTaxable ? this.dateTaxable.toISOString() : <any>undefined;
        data["isDone"] = this.isDone;
        data["isApproved"] = this.isApproved;
        data["isPostponed"] = this.isPostponed;
        data["isPosted"] = this.isPosted;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["priceWithVat"] = this.priceWithVat;
        return data;
    }
}

export interface IBuildingBillsForInvoicesPageDTO {
    id?: number;
    name?: string | undefined;
    project?: string | undefined;
    dateExpire?: Date;
    dateTaxable?: Date;
    isDone?: boolean;
    isApproved?: boolean;
    isPostponed?: boolean;
    isPosted?: boolean;
    priceWithoutVat?: number;
    priceWithVat?: number;
}

export class BuildingDTO implements IBuildingDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IBuildingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BuildingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBuildingDTO {
    id?: number;
    name?: string | undefined;
}

export class BuildingEmployeeDTO implements IBuildingEmployeeDTO {
    id?: number;
    name?: string | undefined;
    isAssigned?: boolean;

    constructor(data?: IBuildingEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): BuildingEmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingEmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAssigned"] = this.isAssigned;
        return data;
    }
}

export interface IBuildingEmployeeDTO {
    id?: number;
    name?: string | undefined;
    isAssigned?: boolean;
}

export class BuildingFileDTO implements IBuildingFileDTO {
    id?: number;
    name?: string | undefined;
    file?: string | undefined;

    constructor(data?: IBuildingFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): BuildingFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["file"] = this.file;
        return data;
    }
}

export interface IBuildingFileDTO {
    id?: number;
    name?: string | undefined;
    file?: string | undefined;
}

export class BuildingForProjectsListPageDTO implements IBuildingForProjectsListPageDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    hourRate?: number | undefined;
    projectType?: string | undefined;
    contractNumber?: string | undefined;
    investor?: string | undefined;
    projektant?: string | undefined;
    address?: string | undefined;
    state?: BuildingStateEnum;
    assignedUsersForProjectListPage?: AssignedUserForProjectsListPageDTO[] | undefined;
    assignedUsersString?: string | undefined;

    constructor(data?: IBuildingForProjectsListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.showToEmployees = _data["showToEmployees"];
            this.hourRate = _data["hourRate"];
            this.projectType = _data["projectType"];
            this.contractNumber = _data["contractNumber"];
            this.investor = _data["investor"];
            this.projektant = _data["projektant"];
            this.address = _data["address"];
            this.state = _data["state"];
            if (Array.isArray(_data["assignedUsersForProjectListPage"])) {
                this.assignedUsersForProjectListPage = [] as any;
                for (let item of _data["assignedUsersForProjectListPage"])
                    this.assignedUsersForProjectListPage!.push(AssignedUserForProjectsListPageDTO.fromJS(item));
            }
            this.assignedUsersString = _data["assignedUsersString"];
        }
    }

    static fromJS(data: any): BuildingForProjectsListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingForProjectsListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["showToEmployees"] = this.showToEmployees;
        data["hourRate"] = this.hourRate;
        data["projectType"] = this.projectType;
        data["contractNumber"] = this.contractNumber;
        data["investor"] = this.investor;
        data["projektant"] = this.projektant;
        data["address"] = this.address;
        data["state"] = this.state;
        if (Array.isArray(this.assignedUsersForProjectListPage)) {
            data["assignedUsersForProjectListPage"] = [];
            for (let item of this.assignedUsersForProjectListPage)
                data["assignedUsersForProjectListPage"].push(item.toJSON());
        }
        data["assignedUsersString"] = this.assignedUsersString;
        return data;
    }
}

export interface IBuildingForProjectsListPageDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    hourRate?: number | undefined;
    projectType?: string | undefined;
    contractNumber?: string | undefined;
    investor?: string | undefined;
    projektant?: string | undefined;
    address?: string | undefined;
    state?: BuildingStateEnum;
    assignedUsersForProjectListPage?: AssignedUserForProjectsListPageDTO[] | undefined;
    assignedUsersString?: string | undefined;
}

export class BuildingInfoDTO implements IBuildingInfoDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IBuildingInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BuildingInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBuildingInfoDTO {
    id?: number;
    name?: string | undefined;
}

export class BuildingNoteDTO implements IBuildingNoteDTO {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;

    constructor(data?: IBuildingNoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): BuildingNoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingNoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["text"] = this.text;
        return data;
    }
}

export interface IBuildingNoteDTO {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;
}

export enum BuildingStateEnum {
    Preparing = 0,
    Realization = 1,
    Done = 2,
    Cancelled = 3,
}

export class CalculateEyetowerPriceRequest implements ICalculateEyetowerPriceRequest {
    eyetowerType?: EyetowerType;
    installation?: boolean;
    deinstallation?: boolean;
    from?: Date;
    to?: Date;

    constructor(data?: ICalculateEyetowerPriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eyetowerType = _data["eyetowerType"];
            this.installation = _data["installation"];
            this.deinstallation = _data["deinstallation"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CalculateEyetowerPriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateEyetowerPriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eyetowerType"] = this.eyetowerType;
        data["installation"] = this.installation;
        data["deinstallation"] = this.deinstallation;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICalculateEyetowerPriceRequest {
    eyetowerType?: EyetowerType;
    installation?: boolean;
    deinstallation?: boolean;
    from?: Date;
    to?: Date;
}

export class CalculateEyetowerPriceResponse implements ICalculateEyetowerPriceResponse {
    price?: number;

    constructor(data?: ICalculateEyetowerPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CalculateEyetowerPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateEyetowerPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        return data;
    }
}

export interface ICalculateEyetowerPriceResponse {
    price?: number;
}

export class CategoryTemplateDTO implements ICategoryTemplateDTO {
    id?: number;
    name?: string | undefined;
    templateItems?: CategoryTemplateItemDTO[] | undefined;

    constructor(data?: ICategoryTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["templateItems"])) {
                this.templateItems = [] as any;
                for (let item of _data["templateItems"])
                    this.templateItems!.push(CategoryTemplateItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.templateItems)) {
            data["templateItems"] = [];
            for (let item of this.templateItems)
                data["templateItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryTemplateDTO {
    id?: number;
    name?: string | undefined;
    templateItems?: CategoryTemplateItemDTO[] | undefined;
}

export class CategoryTemplateItemDTO implements ICategoryTemplateItemDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICategoryTemplateItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CategoryTemplateItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTemplateItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICategoryTemplateItemDTO {
    id?: number;
    name?: string | undefined;
}

export class CompleteRegistrationRequest implements ICompleteRegistrationRequest {
    pendingRegistrationId?: number;
    companyName?: string | undefined;
    email?: string | undefined;
    phonePrefix?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    source?: string | undefined;
    ico?: string | undefined;
    hasDiaryModule?: boolean;
    hasAttendanceModule?: boolean;
    hasTasksModule?: boolean;
    hasWealthModule?: boolean;
    hasWarehousesModule?: boolean;
    hasGanttModule?: boolean;
    hasAIModule?: boolean;
    hasReportsModule?: boolean;

    constructor(data?: ICompleteRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingRegistrationId = _data["pendingRegistrationId"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.phonePrefix = _data["phonePrefix"];
            this.phoneNumber = _data["phoneNumber"];
            this.language = _data["language"];
            this.source = _data["source"];
            this.ico = _data["ico"];
            this.hasDiaryModule = _data["hasDiaryModule"];
            this.hasAttendanceModule = _data["hasAttendanceModule"];
            this.hasTasksModule = _data["hasTasksModule"];
            this.hasWealthModule = _data["hasWealthModule"];
            this.hasWarehousesModule = _data["hasWarehousesModule"];
            this.hasGanttModule = _data["hasGanttModule"];
            this.hasAIModule = _data["hasAIModule"];
            this.hasReportsModule = _data["hasReportsModule"];
        }
    }

    static fromJS(data: any): CompleteRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingRegistrationId"] = this.pendingRegistrationId;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["phonePrefix"] = this.phonePrefix;
        data["phoneNumber"] = this.phoneNumber;
        data["language"] = this.language;
        data["source"] = this.source;
        data["ico"] = this.ico;
        data["hasDiaryModule"] = this.hasDiaryModule;
        data["hasAttendanceModule"] = this.hasAttendanceModule;
        data["hasTasksModule"] = this.hasTasksModule;
        data["hasWealthModule"] = this.hasWealthModule;
        data["hasWarehousesModule"] = this.hasWarehousesModule;
        data["hasGanttModule"] = this.hasGanttModule;
        data["hasAIModule"] = this.hasAIModule;
        data["hasReportsModule"] = this.hasReportsModule;
        return data;
    }
}

export interface ICompleteRegistrationRequest {
    pendingRegistrationId?: number;
    companyName?: string | undefined;
    email?: string | undefined;
    phonePrefix?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    source?: string | undefined;
    ico?: string | undefined;
    hasDiaryModule?: boolean;
    hasAttendanceModule?: boolean;
    hasTasksModule?: boolean;
    hasWealthModule?: boolean;
    hasWarehousesModule?: boolean;
    hasGanttModule?: boolean;
    hasAIModule?: boolean;
    hasReportsModule?: boolean;
}

export class CompleteRegistrationResponse implements ICompleteRegistrationResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number | undefined;

    constructor(data?: ICompleteRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompleteRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface ICompleteRegistrationResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number | undefined;
}

export class ConversationDto implements IConversationDto {
    id?: number;
    applicationsId?: number | undefined;
    applicationName?: string | undefined;
    employeeId?: number | undefined;
    employee?: string | undefined;
    adminUserId?: number | undefined;
    adminUser?: string | undefined;
    investorId?: number | undefined;
    investor?: string | undefined;
    text?: string | undefined;
    datetime?: Date;
    image?: string | undefined;
    todoId?: number | undefined;
    toEmployee?: boolean;
    toAdmin?: boolean;
    toInvestor?: boolean;
    isNotification?: boolean;
    fileUrl?: string | undefined;
    fileThumbnailUrl?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IConversationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationsId = _data["applicationsId"];
            this.applicationName = _data["applicationName"];
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"];
            this.adminUserId = _data["adminUserId"];
            this.adminUser = _data["adminUser"];
            this.investorId = _data["investorId"];
            this.investor = _data["investor"];
            this.text = _data["text"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.image = _data["image"];
            this.todoId = _data["todoId"];
            this.toEmployee = _data["toEmployee"];
            this.toAdmin = _data["toAdmin"];
            this.toInvestor = _data["toInvestor"];
            this.isNotification = _data["isNotification"];
            this.fileUrl = _data["fileUrl"];
            this.fileThumbnailUrl = _data["fileThumbnailUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ConversationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationsId"] = this.applicationsId;
        data["applicationName"] = this.applicationName;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee;
        data["adminUserId"] = this.adminUserId;
        data["adminUser"] = this.adminUser;
        data["investorId"] = this.investorId;
        data["investor"] = this.investor;
        data["text"] = this.text;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["image"] = this.image;
        data["todoId"] = this.todoId;
        data["toEmployee"] = this.toEmployee;
        data["toAdmin"] = this.toAdmin;
        data["toInvestor"] = this.toInvestor;
        data["isNotification"] = this.isNotification;
        data["fileUrl"] = this.fileUrl;
        data["fileThumbnailUrl"] = this.fileThumbnailUrl;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IConversationDto {
    id?: number;
    applicationsId?: number | undefined;
    applicationName?: string | undefined;
    employeeId?: number | undefined;
    employee?: string | undefined;
    adminUserId?: number | undefined;
    adminUser?: string | undefined;
    investorId?: number | undefined;
    investor?: string | undefined;
    text?: string | undefined;
    datetime?: Date;
    image?: string | undefined;
    todoId?: number | undefined;
    toEmployee?: boolean;
    toAdmin?: boolean;
    toInvestor?: boolean;
    isNotification?: boolean;
    fileUrl?: string | undefined;
    fileThumbnailUrl?: string | undefined;
    fileName?: string | undefined;
}

export class ConversationFileDto implements IConversationFileDto {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;
    created?: Date;
    creator?: string | undefined;
    fileUrl?: string | undefined;
    fileThumbnailUrl?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IConversationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.creator = _data["creator"];
            this.fileUrl = _data["fileUrl"];
            this.fileThumbnailUrl = _data["fileThumbnailUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ConversationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["text"] = this.text;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["creator"] = this.creator;
        data["fileUrl"] = this.fileUrl;
        data["fileThumbnailUrl"] = this.fileThumbnailUrl;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IConversationFileDto {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;
    created?: Date;
    creator?: string | undefined;
    fileUrl?: string | undefined;
    fileThumbnailUrl?: string | undefined;
    fileName?: string | undefined;
}

export class CopyCutPasteEmployeeFileRequest implements ICopyCutPasteEmployeeFileRequest {
    sourceEmployeeDocumentId?: number | undefined;
    targetEmployeeDocumentId?: number;
    documentFiledIds?: number[] | undefined;
    type?: CopyCutPasteType;

    constructor(data?: ICopyCutPasteEmployeeFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEmployeeDocumentId = _data["sourceEmployeeDocumentId"];
            this.targetEmployeeDocumentId = _data["targetEmployeeDocumentId"];
            if (Array.isArray(_data["documentFiledIds"])) {
                this.documentFiledIds = [] as any;
                for (let item of _data["documentFiledIds"])
                    this.documentFiledIds!.push(item);
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CopyCutPasteEmployeeFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyCutPasteEmployeeFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEmployeeDocumentId"] = this.sourceEmployeeDocumentId;
        data["targetEmployeeDocumentId"] = this.targetEmployeeDocumentId;
        if (Array.isArray(this.documentFiledIds)) {
            data["documentFiledIds"] = [];
            for (let item of this.documentFiledIds)
                data["documentFiledIds"].push(item);
        }
        data["type"] = this.type;
        return data;
    }
}

export interface ICopyCutPasteEmployeeFileRequest {
    sourceEmployeeDocumentId?: number | undefined;
    targetEmployeeDocumentId?: number;
    documentFiledIds?: number[] | undefined;
    type?: CopyCutPasteType;
}

export class CopyCutPasteEmployeeFileResponse implements ICopyCutPasteEmployeeFileResponse {
    ok?: boolean;

    constructor(data?: ICopyCutPasteEmployeeFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CopyCutPasteEmployeeFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyCutPasteEmployeeFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICopyCutPasteEmployeeFileResponse {
    ok?: boolean;
}

export class CopyCutPasteProjectFileRequest implements ICopyCutPasteProjectFileRequest {
    sourceBuildingDocumentId?: number | undefined;
    targetBuildingDocumentId?: number;
    documentFiledIds?: number[] | undefined;
    type?: CopyCutPasteType;

    constructor(data?: ICopyCutPasteProjectFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceBuildingDocumentId = _data["sourceBuildingDocumentId"];
            this.targetBuildingDocumentId = _data["targetBuildingDocumentId"];
            if (Array.isArray(_data["documentFiledIds"])) {
                this.documentFiledIds = [] as any;
                for (let item of _data["documentFiledIds"])
                    this.documentFiledIds!.push(item);
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CopyCutPasteProjectFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyCutPasteProjectFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceBuildingDocumentId"] = this.sourceBuildingDocumentId;
        data["targetBuildingDocumentId"] = this.targetBuildingDocumentId;
        if (Array.isArray(this.documentFiledIds)) {
            data["documentFiledIds"] = [];
            for (let item of this.documentFiledIds)
                data["documentFiledIds"].push(item);
        }
        data["type"] = this.type;
        return data;
    }
}

export interface ICopyCutPasteProjectFileRequest {
    sourceBuildingDocumentId?: number | undefined;
    targetBuildingDocumentId?: number;
    documentFiledIds?: number[] | undefined;
    type?: CopyCutPasteType;
}

export class CopyCutPasteProjectFileResponse implements ICopyCutPasteProjectFileResponse {
    ok?: boolean;

    constructor(data?: ICopyCutPasteProjectFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CopyCutPasteProjectFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyCutPasteProjectFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICopyCutPasteProjectFileResponse {
    ok?: boolean;
}

export enum CopyCutPasteType {
    Copy = 0,
    Cut = 1,
    CopyFile = 2,
    CutFile = 3,
}

export class CopyDiaryRecordRequest implements ICopyDiaryRecordRequest {
    diaryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    onlyWorkDays?: boolean;
    completedWorks?: string | undefined;
    machines?: SaveMachinesTableReqDTO[] | undefined;
    materials?: SaveMaterialsTableReqDTO[] | undefined;
    workers?: SaveWorkerReqDTO[] | undefined;

    constructor(data?: ICopyDiaryRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.onlyWorkDays = _data["onlyWorkDays"];
            this.completedWorks = _data["completedWorks"];
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(SaveMachinesTableReqDTO.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(SaveMaterialsTableReqDTO.fromJS(item));
            }
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(SaveWorkerReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CopyDiaryRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDiaryRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["onlyWorkDays"] = this.onlyWorkDays;
        data["completedWorks"] = this.completedWorks;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICopyDiaryRecordRequest {
    diaryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    onlyWorkDays?: boolean;
    completedWorks?: string | undefined;
    machines?: SaveMachinesTableReqDTO[] | undefined;
    materials?: SaveMaterialsTableReqDTO[] | undefined;
    workers?: SaveWorkerReqDTO[] | undefined;
}

export class CopyDiaryRecordResponse implements ICopyDiaryRecordResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: ICopyDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CopyDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface ICopyDiaryRecordResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class CopyDiaryRecordSubcontractorRequest implements ICopyDiaryRecordSubcontractorRequest {
    diaryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    onlyWorkDays?: boolean;
    completedWorks?: string | undefined;
    machines?: SaveMachinesTableReqDTO[] | undefined;
    materials?: SaveMaterialsTableReqDTO[] | undefined;
    workers?: SaveWorkerReqDTO[] | undefined;

    constructor(data?: ICopyDiaryRecordSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.onlyWorkDays = _data["onlyWorkDays"];
            this.completedWorks = _data["completedWorks"];
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(SaveMachinesTableReqDTO.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(SaveMaterialsTableReqDTO.fromJS(item));
            }
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(SaveWorkerReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CopyDiaryRecordSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDiaryRecordSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["onlyWorkDays"] = this.onlyWorkDays;
        data["completedWorks"] = this.completedWorks;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICopyDiaryRecordSubcontractorRequest {
    diaryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    onlyWorkDays?: boolean;
    completedWorks?: string | undefined;
    machines?: SaveMachinesTableReqDTO[] | undefined;
    materials?: SaveMaterialsTableReqDTO[] | undefined;
    workers?: SaveWorkerReqDTO[] | undefined;
}

export class CreateCategoryTemplateRequest implements ICreateCategoryTemplateRequest {
    template?: CategoryTemplateDTO;

    constructor(data?: ICreateCategoryTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? CategoryTemplateDTO.fromJS(_data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCategoryTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCategoryTemplateRequest {
    template?: CategoryTemplateDTO;
}

export class CreateCategoryTemplateResponse implements ICreateCategoryTemplateResponse {
    ok?: boolean;

    constructor(data?: ICreateCategoryTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateCategoryTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateCategoryTemplateResponse {
    ok?: boolean;
}

export class CreateCustomFieldForApplicationRequest implements ICreateCustomFieldForApplicationRequest {
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: CustomFieldDataType;
    enumOptions?: string[] | undefined;

    constructor(data?: ICreateCustomFieldForApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.dataType = _data["dataType"];
            if (Array.isArray(_data["enumOptions"])) {
                this.enumOptions = [] as any;
                for (let item of _data["enumOptions"])
                    this.enumOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateCustomFieldForApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomFieldForApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["dataType"] = this.dataType;
        if (Array.isArray(this.enumOptions)) {
            data["enumOptions"] = [];
            for (let item of this.enumOptions)
                data["enumOptions"].push(item);
        }
        return data;
    }
}

export interface ICreateCustomFieldForApplicationRequest {
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: CustomFieldDataType;
    enumOptions?: string[] | undefined;
}

export class CreateCustomFieldForApplicationResponse implements ICreateCustomFieldForApplicationResponse {
    customField?: CustomFieldDto;

    constructor(data?: ICreateCustomFieldForApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customField = _data["customField"] ? CustomFieldDto.fromJS(_data["customField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateCustomFieldForApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomFieldForApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customField"] = this.customField ? this.customField.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCustomFieldForApplicationResponse {
    customField?: CustomFieldDto;
}

export class CreateDailyRecordInvestorRequest implements ICreateDailyRecordInvestorRequest {
    diaryId?: number;
    date?: Date;

    constructor(data?: ICreateDailyRecordInvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateDailyRecordInvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDailyRecordInvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateDailyRecordInvestorRequest {
    diaryId?: number;
    date?: Date;
}

export class CreateDailyRecordInvestorResponse implements ICreateDailyRecordInvestorResponse {
    newId?: number | undefined;
    error?: string | undefined;

    constructor(data?: ICreateDailyRecordInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newId = _data["newId"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateDailyRecordInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDailyRecordInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newId"] = this.newId;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateDailyRecordInvestorResponse {
    newId?: number | undefined;
    error?: string | undefined;
}

export class CreateDailyRecordRequest implements ICreateDailyRecordRequest {
    diaryId?: number;
    date?: Date;

    constructor(data?: ICreateDailyRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateDailyRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDailyRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateDailyRecordRequest {
    diaryId?: number;
    date?: Date;
}

export class CreateDailyRecordResponse implements ICreateDailyRecordResponse {
    newId?: number | undefined;
    error?: string | undefined;

    constructor(data?: ICreateDailyRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newId = _data["newId"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateDailyRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDailyRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newId"] = this.newId;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateDailyRecordResponse {
    newId?: number | undefined;
    error?: string | undefined;
}

export class CreateDiaryRequest implements ICreateDiaryRequest {
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    authorizedPerson?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICreateDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.diaryName = _data["diaryName"];
            this.responsibleCompany = _data["responsibleCompany"];
            this.section = _data["section"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.place = _data["place"];
            this.investor = _data["investor"];
            this.tdsPermament = _data["tdsPermament"];
            this.tdsTemporary = _data["tdsTemporary"];
            this.authorWatch = _data["authorWatch"];
            this.generalContractor = _data["generalContractor"];
            this.constructionContractor = _data["constructionContractor"];
            this.technologicallContractor = _data["technologicallContractor"];
            this.subcontractors = _data["subcontractors"];
            this.projectManager = _data["projectManager"];
            this.constructionManager = _data["constructionManager"];
            this.generalArchitect = _data["generalArchitect"];
            this.responsibleArchitect = _data["responsibleArchitect"];
            this.groupId = _data["groupId"];
            this.parentDiaryId = _data["parentDiaryId"];
            this.authorizedPerson = _data["authorizedPerson"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["diaryName"] = this.diaryName;
        data["responsibleCompany"] = this.responsibleCompany;
        data["section"] = this.section;
        data["district"] = this.district;
        data["city"] = this.city;
        data["place"] = this.place;
        data["investor"] = this.investor;
        data["tdsPermament"] = this.tdsPermament;
        data["tdsTemporary"] = this.tdsTemporary;
        data["authorWatch"] = this.authorWatch;
        data["generalContractor"] = this.generalContractor;
        data["constructionContractor"] = this.constructionContractor;
        data["technologicallContractor"] = this.technologicallContractor;
        data["subcontractors"] = this.subcontractors;
        data["projectManager"] = this.projectManager;
        data["constructionManager"] = this.constructionManager;
        data["generalArchitect"] = this.generalArchitect;
        data["responsibleArchitect"] = this.responsibleArchitect;
        data["groupId"] = this.groupId;
        data["parentDiaryId"] = this.parentDiaryId;
        data["authorizedPerson"] = this.authorizedPerson;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateDiaryRequest {
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    authorizedPerson?: string | undefined;
    isActive?: boolean;
}

export class CreateDiaryResponse implements ICreateDiaryResponse {
    diaryId?: number;

    constructor(data?: ICreateDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
        }
    }

    static fromJS(data: any): CreateDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        return data;
    }
}

export interface ICreateDiaryResponse {
    diaryId?: number;
}

export class CreateEmployeeFileRequest implements ICreateEmployeeFileRequest {
    employeeId?: number;
    parentDocumentId?: number | undefined;
    name?: string | undefined;

    constructor(data?: ICreateEmployeeFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.parentDocumentId = _data["parentDocumentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateEmployeeFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["parentDocumentId"] = this.parentDocumentId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateEmployeeFileRequest {
    employeeId?: number;
    parentDocumentId?: number | undefined;
    name?: string | undefined;
}

export class CreateEmployeeFileResponse implements ICreateEmployeeFileResponse {
    ok?: boolean;

    constructor(data?: ICreateEmployeeFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateEmployeeFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateEmployeeFileResponse {
    ok?: boolean;
}

export class CreateEmployeeFilesFromPathsRequest implements ICreateEmployeeFilesFromPathsRequest {
    employeeId?: number;
    parentDocumentId?: number | undefined;
    paths?: string[] | undefined;

    constructor(data?: ICreateEmployeeFilesFromPathsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.parentDocumentId = _data["parentDocumentId"];
            if (Array.isArray(_data["paths"])) {
                this.paths = [] as any;
                for (let item of _data["paths"])
                    this.paths!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateEmployeeFilesFromPathsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeFilesFromPathsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["parentDocumentId"] = this.parentDocumentId;
        if (Array.isArray(this.paths)) {
            data["paths"] = [];
            for (let item of this.paths)
                data["paths"].push(item);
        }
        return data;
    }
}

export interface ICreateEmployeeFilesFromPathsRequest {
    employeeId?: number;
    parentDocumentId?: number | undefined;
    paths?: string[] | undefined;
}

export class CreateEmployeeFilesFromPathsResponse implements ICreateEmployeeFilesFromPathsResponse {
    ok?: boolean;

    constructor(data?: ICreateEmployeeFilesFromPathsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateEmployeeFilesFromPathsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeFilesFromPathsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateEmployeeFilesFromPathsResponse {
    ok?: boolean;
}

export class CreateInvestorUserRequest implements ICreateInvestorUserRequest {
    email?: string | undefined;
    name?: string | undefined;
    buildingId?: number | undefined;
    roleId?: number | undefined;

    constructor(data?: ICreateInvestorUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateInvestorUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvestorUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateInvestorUserRequest {
    email?: string | undefined;
    name?: string | undefined;
    buildingId?: number | undefined;
    roleId?: number | undefined;
}

export class CreateInvestorUserResponse implements ICreateInvestorUserResponse {
    ok?: boolean;
    id?: number;

    constructor(data?: ICreateInvestorUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateInvestorUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvestorUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateInvestorUserResponse {
    ok?: boolean;
    id?: number;
}

export class CreateInvoiceRequest implements ICreateInvoiceRequest {
    invoiceName?: string | undefined;

    constructor(data?: ICreateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceName = _data["invoiceName"];
        }
    }

    static fromJS(data: any): CreateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceName"] = this.invoiceName;
        return data;
    }
}

export interface ICreateInvoiceRequest {
    invoiceName?: string | undefined;
}

export class CreateInvoiceResponse implements ICreateInvoiceResponse {
    invoiceId?: number;

    constructor(data?: ICreateInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
        }
    }

    static fromJS(data: any): CreateInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        return data;
    }
}

export interface ICreateInvoiceResponse {
    invoiceId?: number;
}

export class CreateOrUpdatePromptRequest implements ICreateOrUpdatePromptRequest {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;
    type?: PromptType;
    realationId?: number;

    constructor(data?: ICreateOrUpdatePromptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.type = _data["type"];
            this.realationId = _data["realationId"];
        }
    }

    static fromJS(data: any): CreateOrUpdatePromptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePromptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["text"] = this.text;
        data["type"] = this.type;
        data["realationId"] = this.realationId;
        return data;
    }
}

export interface ICreateOrUpdatePromptRequest {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;
    type?: PromptType;
    realationId?: number;
}

export class CreateOrUpdatePromptResponse implements ICreateOrUpdatePromptResponse {
    promptId?: number;

    constructor(data?: ICreateOrUpdatePromptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptId = _data["promptId"];
        }
    }

    static fromJS(data: any): CreateOrUpdatePromptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePromptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptId"] = this.promptId;
        return data;
    }
}

export interface ICreateOrUpdatePromptResponse {
    promptId?: number;
}

export class CreateProjectFileRequest implements ICreateProjectFileRequest {
    buildingId?: number;
    parentDocumentId?: number | undefined;
    name?: string | undefined;

    constructor(data?: ICreateProjectFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.parentDocumentId = _data["parentDocumentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateProjectFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["parentDocumentId"] = this.parentDocumentId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateProjectFileRequest {
    buildingId?: number;
    parentDocumentId?: number | undefined;
    name?: string | undefined;
}

export class CreateProjectFileResponse implements ICreateProjectFileResponse {
    ok?: boolean;

    constructor(data?: ICreateProjectFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateProjectFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateProjectFileResponse {
    ok?: boolean;
}

export class CreateProjectFilesFromPathsRequest implements ICreateProjectFilesFromPathsRequest {
    buildingId?: number;
    parentDocumentId?: number | undefined;
    paths?: string[] | undefined;

    constructor(data?: ICreateProjectFilesFromPathsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.parentDocumentId = _data["parentDocumentId"];
            if (Array.isArray(_data["paths"])) {
                this.paths = [] as any;
                for (let item of _data["paths"])
                    this.paths!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateProjectFilesFromPathsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectFilesFromPathsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["parentDocumentId"] = this.parentDocumentId;
        if (Array.isArray(this.paths)) {
            data["paths"] = [];
            for (let item of this.paths)
                data["paths"].push(item);
        }
        return data;
    }
}

export interface ICreateProjectFilesFromPathsRequest {
    buildingId?: number;
    parentDocumentId?: number | undefined;
    paths?: string[] | undefined;
}

export class CreateProjectFilesFromPathsResponse implements ICreateProjectFilesFromPathsResponse {
    ok?: boolean;

    constructor(data?: ICreateProjectFilesFromPathsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateProjectFilesFromPathsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectFilesFromPathsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateProjectFilesFromPathsResponse {
    ok?: boolean;
}

export class CreateRequestImageBuildingCommentResponse implements ICreateRequestImageBuildingCommentResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ICreateRequestImageBuildingCommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CreateRequestImageBuildingCommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestImageBuildingCommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICreateRequestImageBuildingCommentResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class CreateRequestImageBuildingRequest implements ICreateRequestImageBuildingRequest {
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    dateTo?: Date | undefined;
    imageUrl?: string | undefined;
    responsiblePersonId?: number;

    constructor(data?: ICreateRequestImageBuildingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.buildingId = _data["buildingId"];
            this.buildingDiaryId = _data["buildingDiaryId"];
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
            this.responsiblePersonId = _data["responsiblePersonId"];
        }
    }

    static fromJS(data: any): CreateRequestImageBuildingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestImageBuildingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["buildingId"] = this.buildingId;
        data["buildingDiaryId"] = this.buildingDiaryId;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        data["responsiblePersonId"] = this.responsiblePersonId;
        return data;
    }
}

export interface ICreateRequestImageBuildingRequest {
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    dateTo?: Date | undefined;
    imageUrl?: string | undefined;
    responsiblePersonId?: number;
}

export class CreateRequestImageBuildingResponse implements ICreateRequestImageBuildingResponse {
    ok?: boolean;
    id?: number;
    errorMessage?: string | undefined;

    constructor(data?: ICreateRequestImageBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CreateRequestImageBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestImageBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICreateRequestImageBuildingResponse {
    ok?: boolean;
    id?: number;
    errorMessage?: string | undefined;
}

export class CreateSubcontractorDailyRecordRequest implements ICreateSubcontractorDailyRecordRequest {
    diaryId?: number;
    date?: Date;

    constructor(data?: ICreateSubcontractorDailyRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSubcontractorDailyRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubcontractorDailyRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateSubcontractorDailyRecordRequest {
    diaryId?: number;
    date?: Date;
}

export class CreateSubcontractorUserRequest implements ICreateSubcontractorUserRequest {
    email?: string | undefined;
    name?: string | undefined;
    groupId?: number | undefined;
    diaryId?: number | undefined;
    roleId?: number | undefined;

    constructor(data?: ICreateSubcontractorUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.groupId = _data["groupId"];
            this.diaryId = _data["diaryId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateSubcontractorUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubcontractorUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["groupId"] = this.groupId;
        data["diaryId"] = this.diaryId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateSubcontractorUserRequest {
    email?: string | undefined;
    name?: string | undefined;
    groupId?: number | undefined;
    diaryId?: number | undefined;
    roleId?: number | undefined;
}

export class CreateSubcontractorUserResponse implements ICreateSubcontractorUserResponse {
    ok?: boolean;
    id?: number;

    constructor(data?: ICreateSubcontractorUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSubcontractorUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubcontractorUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateSubcontractorUserResponse {
    ok?: boolean;
    id?: number;
}

export class CustomButtonDto implements ICustomButtonDto {
    name?: string | undefined;
    type?: number;
    textColor?: string | undefined;
    backgroundColor?: string | undefined;
    disabled?: boolean;
    disabledStart?: string | undefined;
    disabledEnd?: string | undefined;

    constructor(data?: ICustomButtonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.textColor = _data["textColor"];
            this.backgroundColor = _data["backgroundColor"];
            this.disabled = _data["disabled"];
            this.disabledStart = _data["disabledStart"];
            this.disabledEnd = _data["disabledEnd"];
        }
    }

    static fromJS(data: any): CustomButtonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomButtonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["textColor"] = this.textColor;
        data["backgroundColor"] = this.backgroundColor;
        data["disabled"] = this.disabled;
        data["disabledStart"] = this.disabledStart;
        data["disabledEnd"] = this.disabledEnd;
        return data;
    }
}

export interface ICustomButtonDto {
    name?: string | undefined;
    type?: number;
    textColor?: string | undefined;
    backgroundColor?: string | undefined;
    disabled?: boolean;
    disabledStart?: string | undefined;
    disabledEnd?: string | undefined;
}

export enum CustomFieldDataType {
    String = 0,
    Integer = 1,
    Decimal = 2,
    DateTime = 3,
    Boolean = 4,
    Enum = 5,
    Paragraph = 6,
}

export class CustomFieldDto implements ICustomFieldDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    showOnBuilding?: boolean;
    dataType?: CustomFieldDataType;

    constructor(data?: ICustomFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.showOnBuilding = _data["showOnBuilding"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): CustomFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["showOnBuilding"] = this.showOnBuilding;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface ICustomFieldDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    showOnBuilding?: boolean;
    dataType?: CustomFieldDataType;
}

export class CustomFieldOptionDto implements ICustomFieldOptionDto {
    id?: number;
    value?: string | undefined;

    constructor(data?: ICustomFieldOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomFieldOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomFieldOptionDto {
    id?: number;
    value?: string | undefined;
}

export class CustomFieldWithValueDto implements ICustomFieldWithValueDto {
    customField?: CustomFieldDto;
    value?: string | undefined;
    valueId?: number | undefined;

    constructor(data?: ICustomFieldWithValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customField = _data["customField"] ? CustomFieldDto.fromJS(_data["customField"]) : <any>undefined;
            this.value = _data["value"];
            this.valueId = _data["valueId"];
        }
    }

    static fromJS(data: any): CustomFieldWithValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldWithValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customField"] = this.customField ? this.customField.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["valueId"] = this.valueId;
        return data;
    }
}

export interface ICustomFieldWithValueDto {
    customField?: CustomFieldDto;
    value?: string | undefined;
    valueId?: number | undefined;
}

export class DailyRecordSearchDTO implements IDailyRecordSearchDTO {
    id?: number;
    date?: Date;
    works?: RecordSearchDTO[] | undefined;
    otherNotes?: RecordSearchDTO[] | undefined;
    machines?: RecordSearchDTO[] | undefined;
    employees?: RecordSearchDTO[] | undefined;
    materials?: RecordSearchDTO[] | undefined;

    constructor(data?: IDailyRecordSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["works"])) {
                this.works = [] as any;
                for (let item of _data["works"])
                    this.works!.push(RecordSearchDTO.fromJS(item));
            }
            if (Array.isArray(_data["otherNotes"])) {
                this.otherNotes = [] as any;
                for (let item of _data["otherNotes"])
                    this.otherNotes!.push(RecordSearchDTO.fromJS(item));
            }
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(RecordSearchDTO.fromJS(item));
            }
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(RecordSearchDTO.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(RecordSearchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyRecordSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailyRecordSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.works)) {
            data["works"] = [];
            for (let item of this.works)
                data["works"].push(item.toJSON());
        }
        if (Array.isArray(this.otherNotes)) {
            data["otherNotes"] = [];
            for (let item of this.otherNotes)
                data["otherNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDailyRecordSearchDTO {
    id?: number;
    date?: Date;
    works?: RecordSearchDTO[] | undefined;
    otherNotes?: RecordSearchDTO[] | undefined;
    machines?: RecordSearchDTO[] | undefined;
    employees?: RecordSearchDTO[] | undefined;
    materials?: RecordSearchDTO[] | undefined;
}

export class DeleteApplicationKrosAdminRequest implements IDeleteApplicationKrosAdminRequest {
    appId?: number;

    constructor(data?: IDeleteApplicationKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): DeleteApplicationKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteApplicationKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        return data;
    }
}

export interface IDeleteApplicationKrosAdminRequest {
    appId?: number;
}

export class DeleteApplicationKrosAdminResponse implements IDeleteApplicationKrosAdminResponse {
    ok?: boolean;

    constructor(data?: IDeleteApplicationKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteApplicationKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteApplicationKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteApplicationKrosAdminResponse {
    ok?: boolean;
}

export class DeleteBuildingNoteRequest implements IDeleteBuildingNoteRequest {
    id?: number;

    constructor(data?: IDeleteBuildingNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteBuildingNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBuildingNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteBuildingNoteRequest {
    id?: number;
}

export class DeleteBuildingNoteResponse implements IDeleteBuildingNoteResponse {
    ok?: boolean;

    constructor(data?: IDeleteBuildingNoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteBuildingNoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBuildingNoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteBuildingNoteResponse {
    ok?: boolean;
}

export class DeleteBuildingsRequest implements IDeleteBuildingsRequest {
    buildingsIds?: number[] | undefined;

    constructor(data?: IDeleteBuildingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildingsIds"])) {
                this.buildingsIds = [] as any;
                for (let item of _data["buildingsIds"])
                    this.buildingsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteBuildingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBuildingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildingsIds)) {
            data["buildingsIds"] = [];
            for (let item of this.buildingsIds)
                data["buildingsIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteBuildingsRequest {
    buildingsIds?: number[] | undefined;
}

export class DeleteBuildingsResponse implements IDeleteBuildingsResponse {
    ok?: boolean;

    constructor(data?: IDeleteBuildingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteBuildingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBuildingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteBuildingsResponse {
    ok?: boolean;
}

export class DeleteCategoryTemplateRequest implements IDeleteCategoryTemplateRequest {
    id?: number;

    constructor(data?: IDeleteCategoryTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCategoryTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCategoryTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteCategoryTemplateRequest {
    id?: number;
}

export class DeleteCategoryTemplateResponse implements IDeleteCategoryTemplateResponse {
    ok?: boolean;

    constructor(data?: IDeleteCategoryTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteCategoryTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCategoryTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteCategoryTemplateResponse {
    ok?: boolean;
}

export class DeleteCurrentFcmTokenRequest implements IDeleteCurrentFcmTokenRequest {
    fcmToken?: string | undefined;

    constructor(data?: IDeleteCurrentFcmTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fcmToken = _data["fcmToken"];
        }
    }

    static fromJS(data: any): DeleteCurrentFcmTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCurrentFcmTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fcmToken"] = this.fcmToken;
        return data;
    }
}

export interface IDeleteCurrentFcmTokenRequest {
    fcmToken?: string | undefined;
}

export class DeleteCurrentFcmTokenResponse implements IDeleteCurrentFcmTokenResponse {
    ok?: boolean;

    constructor(data?: IDeleteCurrentFcmTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteCurrentFcmTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCurrentFcmTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteCurrentFcmTokenResponse {
    ok?: boolean;
}

export class DeleteCustomFieldForApplicationResponse implements IDeleteCustomFieldForApplicationResponse {
    ok?: boolean;

    constructor(data?: IDeleteCustomFieldForApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteCustomFieldForApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCustomFieldForApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteCustomFieldForApplicationResponse {
    ok?: boolean;
}

export class DeleteDailyRecordRequest implements IDeleteDailyRecordRequest {
    diaryRecordsIds?: number[] | undefined;

    constructor(data?: IDeleteDailyRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaryRecordsIds"])) {
                this.diaryRecordsIds = [] as any;
                for (let item of _data["diaryRecordsIds"])
                    this.diaryRecordsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteDailyRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDailyRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaryRecordsIds)) {
            data["diaryRecordsIds"] = [];
            for (let item of this.diaryRecordsIds)
                data["diaryRecordsIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteDailyRecordRequest {
    diaryRecordsIds?: number[] | undefined;
}

export class DeleteDailyRecordResponse implements IDeleteDailyRecordResponse {
    ok?: boolean;

    constructor(data?: IDeleteDailyRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteDailyRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDailyRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteDailyRecordResponse {
    ok?: boolean;
}

export class DeleteDiariesRequest implements IDeleteDiariesRequest {
    diaryIds?: number[] | undefined;

    constructor(data?: IDeleteDiariesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaryIds"])) {
                this.diaryIds = [] as any;
                for (let item of _data["diaryIds"])
                    this.diaryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteDiariesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDiariesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaryIds)) {
            data["diaryIds"] = [];
            for (let item of this.diaryIds)
                data["diaryIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteDiariesRequest {
    diaryIds?: number[] | undefined;
}

export class DeleteDiariesResponse implements IDeleteDiariesResponse {
    ok?: boolean;

    constructor(data?: IDeleteDiariesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteDiariesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDiariesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteDiariesResponse {
    ok?: boolean;
}

export class DeleteEmployeeFileDocumentRequest implements IDeleteEmployeeFileDocumentRequest {
    documentFileId?: number;

    constructor(data?: IDeleteEmployeeFileDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentFileId = _data["documentFileId"];
        }
    }

    static fromJS(data: any): DeleteEmployeeFileDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeFileDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentFileId"] = this.documentFileId;
        return data;
    }
}

export interface IDeleteEmployeeFileDocumentRequest {
    documentFileId?: number;
}

export class DeleteEmployeeFileDocumentResponse implements IDeleteEmployeeFileDocumentResponse {
    ok?: boolean;

    constructor(data?: IDeleteEmployeeFileDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteEmployeeFileDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeFileDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteEmployeeFileDocumentResponse {
    ok?: boolean;
}

export class DeleteEmployeeFileRequest implements IDeleteEmployeeFileRequest {
    documentId?: number;

    constructor(data?: IDeleteEmployeeFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): DeleteEmployeeFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IDeleteEmployeeFileRequest {
    documentId?: number;
}

export class DeleteEmployeeFileResponse implements IDeleteEmployeeFileResponse {
    ok?: boolean;

    constructor(data?: IDeleteEmployeeFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteEmployeeFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteEmployeeFileResponse {
    ok?: boolean;
}

export class DeleteEmployeeNoteRequest implements IDeleteEmployeeNoteRequest {
    id?: number;

    constructor(data?: IDeleteEmployeeNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteEmployeeNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteEmployeeNoteRequest {
    id?: number;
}

export class DeleteEmployeeNoteResponse implements IDeleteEmployeeNoteResponse {
    ok?: boolean;

    constructor(data?: IDeleteEmployeeNoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteEmployeeNoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeNoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteEmployeeNoteResponse {
    ok?: boolean;
}

export class DeleteEmployeeSignatureRequest implements IDeleteEmployeeSignatureRequest {
    employeeId?: number;

    constructor(data?: IDeleteEmployeeSignatureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): DeleteEmployeeSignatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeSignatureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IDeleteEmployeeSignatureRequest {
    employeeId?: number;
}

export class DeleteEmployeeSignatureResponse implements IDeleteEmployeeSignatureResponse {
    ok?: boolean;

    constructor(data?: IDeleteEmployeeSignatureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteEmployeeSignatureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeeSignatureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteEmployeeSignatureResponse {
    ok?: boolean;
}

export class DeleteEmployeesRequest implements IDeleteEmployeesRequest {
    deletedEmployeeIds?: number[] | undefined;

    constructor(data?: IDeleteEmployeesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedEmployeeIds"])) {
                this.deletedEmployeeIds = [] as any;
                for (let item of _data["deletedEmployeeIds"])
                    this.deletedEmployeeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteEmployeesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedEmployeeIds)) {
            data["deletedEmployeeIds"] = [];
            for (let item of this.deletedEmployeeIds)
                data["deletedEmployeeIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteEmployeesRequest {
    deletedEmployeeIds?: number[] | undefined;
}

export class DeleteEmployeesResponse implements IDeleteEmployeesResponse {
    ok?: boolean;

    constructor(data?: IDeleteEmployeesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteEmployeesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmployeesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteEmployeesResponse {
    ok?: boolean;
}

export class DeleteFileRelationDiaryRequest implements IDeleteFileRelationDiaryRequest {
    diaryRecordsId?: number;
    fileId?: number;

    constructor(data?: IDeleteFileRelationDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordsId = _data["diaryRecordsId"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): DeleteFileRelationDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFileRelationDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordsId"] = this.diaryRecordsId;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IDeleteFileRelationDiaryRequest {
    diaryRecordsId?: number;
    fileId?: number;
}

export class DeleteFileRelationDiaryResponse implements IDeleteFileRelationDiaryResponse {
    ok?: boolean;

    constructor(data?: IDeleteFileRelationDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteFileRelationDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFileRelationDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteFileRelationDiaryResponse {
    ok?: boolean;
}

export class DeleteFileRelationDiarySubcontractorRequest implements IDeleteFileRelationDiarySubcontractorRequest {
    diaryRecordsId?: number;
    fileId?: number;

    constructor(data?: IDeleteFileRelationDiarySubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordsId = _data["diaryRecordsId"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): DeleteFileRelationDiarySubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFileRelationDiarySubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordsId"] = this.diaryRecordsId;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IDeleteFileRelationDiarySubcontractorRequest {
    diaryRecordsId?: number;
    fileId?: number;
}

export class DeleteHintResponse implements IDeleteHintResponse {
    ok?: boolean;

    constructor(data?: IDeleteHintResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteHintResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteHintResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteHintResponse {
    ok?: boolean;
}

export class DeleteImageCategoryBuildingRequest implements IDeleteImageCategoryBuildingRequest {
    categoryId?: number;

    constructor(data?: IDeleteImageCategoryBuildingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): DeleteImageCategoryBuildingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImageCategoryBuildingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface IDeleteImageCategoryBuildingRequest {
    categoryId?: number;
}

export class DeleteImageCategoryBuildingResponse implements IDeleteImageCategoryBuildingResponse {
    ok?: boolean;

    constructor(data?: IDeleteImageCategoryBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteImageCategoryBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImageCategoryBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteImageCategoryBuildingResponse {
    ok?: boolean;
}

export class DeleteImageMapResponse implements IDeleteImageMapResponse {
    ok?: boolean;

    constructor(data?: IDeleteImageMapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteImageMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImageMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteImageMapResponse {
    ok?: boolean;
}

export class DeleteImageRelationFromDiaryRecordResponse implements IDeleteImageRelationFromDiaryRecordResponse {
    ok?: boolean;

    constructor(data?: IDeleteImageRelationFromDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteImageRelationFromDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImageRelationFromDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteImageRelationFromDiaryRecordResponse {
    ok?: boolean;
}

export class DeleteImageRelationFromSubcontractorDiaryRecordResponse implements IDeleteImageRelationFromSubcontractorDiaryRecordResponse {
    ok?: boolean;

    constructor(data?: IDeleteImageRelationFromSubcontractorDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteImageRelationFromSubcontractorDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImageRelationFromSubcontractorDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteImageRelationFromSubcontractorDiaryRecordResponse {
    ok?: boolean;
}

export class DeleteImagesBuildingRequest implements IDeleteImagesBuildingRequest {
    imagesId?: number[] | undefined;

    constructor(data?: IDeleteImagesBuildingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imagesId"])) {
                this.imagesId = [] as any;
                for (let item of _data["imagesId"])
                    this.imagesId!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteImagesBuildingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImagesBuildingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imagesId)) {
            data["imagesId"] = [];
            for (let item of this.imagesId)
                data["imagesId"].push(item);
        }
        return data;
    }
}

export interface IDeleteImagesBuildingRequest {
    imagesId?: number[] | undefined;
}

export class DeleteImagesBuildingResponse implements IDeleteImagesBuildingResponse {
    ok?: boolean;

    constructor(data?: IDeleteImagesBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteImagesBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImagesBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteImagesBuildingResponse {
    ok?: boolean;
}

export class DeleteInvoicesRequest implements IDeleteInvoicesRequest {
    invoicesIds?: number[] | undefined;

    constructor(data?: IDeleteInvoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoicesIds"])) {
                this.invoicesIds = [] as any;
                for (let item of _data["invoicesIds"])
                    this.invoicesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteInvoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInvoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoicesIds)) {
            data["invoicesIds"] = [];
            for (let item of this.invoicesIds)
                data["invoicesIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteInvoicesRequest {
    invoicesIds?: number[] | undefined;
}

export class DeleteInvoicesResponse implements IDeleteInvoicesResponse {
    ok?: boolean;

    constructor(data?: IDeleteInvoicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteInvoicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInvoicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteInvoicesResponse {
    ok?: boolean;
}

export class DeleteJokeResponse implements IDeleteJokeResponse {
    ok?: boolean;

    constructor(data?: IDeleteJokeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteJokeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteJokeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteJokeResponse {
    ok?: boolean;
}

export class DeleteListWithItemsResponse implements IDeleteListWithItemsResponse {
    ok?: boolean;

    constructor(data?: IDeleteListWithItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteListWithItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteListWithItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteListWithItemsResponse {
    ok?: boolean;
}

export class DeleteManufacturersRequest implements IDeleteManufacturersRequest {
    manufacturersIds?: number[] | undefined;

    constructor(data?: IDeleteManufacturersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturersIds"])) {
                this.manufacturersIds = [] as any;
                for (let item of _data["manufacturersIds"])
                    this.manufacturersIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteManufacturersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteManufacturersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturersIds)) {
            data["manufacturersIds"] = [];
            for (let item of this.manufacturersIds)
                data["manufacturersIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteManufacturersRequest {
    manufacturersIds?: number[] | undefined;
}

export class DeleteManufacturersResponse implements IDeleteManufacturersResponse {
    ok?: boolean;

    constructor(data?: IDeleteManufacturersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteManufacturersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteManufacturersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteManufacturersResponse {
    ok?: boolean;
}

export class DeleteProductCategoriesRequest implements IDeleteProductCategoriesRequest {
    productCategoriesIds?: number[] | undefined;

    constructor(data?: IDeleteProductCategoriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCategoriesIds"])) {
                this.productCategoriesIds = [] as any;
                for (let item of _data["productCategoriesIds"])
                    this.productCategoriesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteProductCategoriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProductCategoriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCategoriesIds)) {
            data["productCategoriesIds"] = [];
            for (let item of this.productCategoriesIds)
                data["productCategoriesIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteProductCategoriesRequest {
    productCategoriesIds?: number[] | undefined;
}

export class DeleteProductCategoriesResponse implements IDeleteProductCategoriesResponse {
    ok?: boolean;

    constructor(data?: IDeleteProductCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteProductCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProductCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteProductCategoriesResponse {
    ok?: boolean;
}

export class DeleteProductsRequest implements IDeleteProductsRequest {
    productsIds?: number[] | undefined;

    constructor(data?: IDeleteProductsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productsIds"])) {
                this.productsIds = [] as any;
                for (let item of _data["productsIds"])
                    this.productsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteProductsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProductsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productsIds)) {
            data["productsIds"] = [];
            for (let item of this.productsIds)
                data["productsIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteProductsRequest {
    productsIds?: number[] | undefined;
}

export class DeleteProductsResponse implements IDeleteProductsResponse {
    ok?: boolean;

    constructor(data?: IDeleteProductsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteProductsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProductsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteProductsResponse {
    ok?: boolean;
}

export class DeleteProjectFileDocumentRequest implements IDeleteProjectFileDocumentRequest {
    documentFileId?: number;

    constructor(data?: IDeleteProjectFileDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentFileId = _data["documentFileId"];
        }
    }

    static fromJS(data: any): DeleteProjectFileDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectFileDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentFileId"] = this.documentFileId;
        return data;
    }
}

export interface IDeleteProjectFileDocumentRequest {
    documentFileId?: number;
}

export class DeleteProjectFileDocumentResponse implements IDeleteProjectFileDocumentResponse {
    ok?: boolean;

    constructor(data?: IDeleteProjectFileDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteProjectFileDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectFileDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteProjectFileDocumentResponse {
    ok?: boolean;
}

export class DeleteProjectFileRequest implements IDeleteProjectFileRequest {
    documentId?: number;

    constructor(data?: IDeleteProjectFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): DeleteProjectFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IDeleteProjectFileRequest {
    documentId?: number;
}

export class DeleteProjectFileResponse implements IDeleteProjectFileResponse {
    ok?: boolean;

    constructor(data?: IDeleteProjectFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteProjectFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteProjectFileResponse {
    ok?: boolean;
}

export class DeletePromptRequest implements IDeletePromptRequest {
    promptId?: number;

    constructor(data?: IDeletePromptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptId = _data["promptId"];
        }
    }

    static fromJS(data: any): DeletePromptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePromptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptId"] = this.promptId;
        return data;
    }
}

export interface IDeletePromptRequest {
    promptId?: number;
}

export class DeletePromptResponse implements IDeletePromptResponse {
    ok?: boolean;

    constructor(data?: IDeletePromptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeletePromptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePromptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeletePromptResponse {
    ok?: boolean;
}

export class DeleteRequestDTO implements IDeleteRequestDTO {
    id?: number;
    rowVersion?: string | undefined;

    constructor(data?: IDeleteRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): DeleteRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IDeleteRequestDTO {
    id?: number;
    rowVersion?: string | undefined;
}

export class DeleteRequestsRequest implements IDeleteRequestsRequest {
    deleteRequests?: DeleteRequestDTO[] | undefined;

    constructor(data?: IDeleteRequestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deleteRequests"])) {
                this.deleteRequests = [] as any;
                for (let item of _data["deleteRequests"])
                    this.deleteRequests!.push(DeleteRequestDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeleteRequestsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRequestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deleteRequests)) {
            data["deleteRequests"] = [];
            for (let item of this.deleteRequests)
                data["deleteRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeleteRequestsRequest {
    deleteRequests?: DeleteRequestDTO[] | undefined;
}

export class DeleteRequestsResponse implements IDeleteRequestsResponse {

    constructor(data?: IDeleteRequestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteRequestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRequestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteRequestsResponse {
}

export class DeleteSubcontractorDailyRecordRequest implements IDeleteSubcontractorDailyRecordRequest {
    diaryRecordsIds?: number[] | undefined;

    constructor(data?: IDeleteSubcontractorDailyRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaryRecordsIds"])) {
                this.diaryRecordsIds = [] as any;
                for (let item of _data["diaryRecordsIds"])
                    this.diaryRecordsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteSubcontractorDailyRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSubcontractorDailyRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaryRecordsIds)) {
            data["diaryRecordsIds"] = [];
            for (let item of this.diaryRecordsIds)
                data["diaryRecordsIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteSubcontractorDailyRecordRequest {
    diaryRecordsIds?: number[] | undefined;
}

export class DeleteSubcontractorDailyRecordResponse implements IDeleteSubcontractorDailyRecordResponse {
    ok?: boolean;

    constructor(data?: IDeleteSubcontractorDailyRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteSubcontractorDailyRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSubcontractorDailyRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteSubcontractorDailyRecordResponse {
    ok?: boolean;
}

export class DeleteSubcontractorDiariesRequest implements IDeleteSubcontractorDiariesRequest {
    diaryIds?: number[] | undefined;

    constructor(data?: IDeleteSubcontractorDiariesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaryIds"])) {
                this.diaryIds = [] as any;
                for (let item of _data["diaryIds"])
                    this.diaryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteSubcontractorDiariesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSubcontractorDiariesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaryIds)) {
            data["diaryIds"] = [];
            for (let item of this.diaryIds)
                data["diaryIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteSubcontractorDiariesRequest {
    diaryIds?: number[] | undefined;
}

export class DeleteSubcontractorDiariesResponse implements IDeleteSubcontractorDiariesResponse {
    ok?: boolean;

    constructor(data?: IDeleteSubcontractorDiariesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteSubcontractorDiariesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSubcontractorDiariesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteSubcontractorDiariesResponse {
    ok?: boolean;
}

export class DeleteTodoConversationNotificationRequest implements IDeleteTodoConversationNotificationRequest {
    conversationId?: number;

    constructor(data?: IDeleteTodoConversationNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"];
        }
    }

    static fromJS(data: any): DeleteTodoConversationNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTodoConversationNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId;
        return data;
    }
}

export interface IDeleteTodoConversationNotificationRequest {
    conversationId?: number;
}

export class DeleteTodoConversationNotificationResponse implements IDeleteTodoConversationNotificationResponse {
    ok?: boolean;

    constructor(data?: IDeleteTodoConversationNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteTodoConversationNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTodoConversationNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteTodoConversationNotificationResponse {
    ok?: boolean;
}

export class DeleteTodosRequest implements IDeleteTodosRequest {
    selectedTodos?: number[] | undefined;

    constructor(data?: IDeleteTodosRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedTodos"])) {
                this.selectedTodos = [] as any;
                for (let item of _data["selectedTodos"])
                    this.selectedTodos!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteTodosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTodosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedTodos)) {
            data["selectedTodos"] = [];
            for (let item of this.selectedTodos)
                data["selectedTodos"].push(item);
        }
        return data;
    }
}

export interface IDeleteTodosRequest {
    selectedTodos?: number[] | undefined;
}

export class DeleteTodosResponse implements IDeleteTodosResponse {
    ok?: boolean;

    constructor(data?: IDeleteTodosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteTodosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTodosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteTodosResponse {
    ok?: boolean;
}

export class DeleteUserKrosAdminRequest implements IDeleteUserKrosAdminRequest {
    userId?: number;

    constructor(data?: IDeleteUserKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DeleteUserKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IDeleteUserKrosAdminRequest {
    userId?: number;
}

export class DeleteUserKrosAdminResponse implements IDeleteUserKrosAdminResponse {
    ok?: boolean;

    constructor(data?: IDeleteUserKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteUserKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteUserKrosAdminResponse {
    ok?: boolean;
}

export class DeleteWarehousesRequest implements IDeleteWarehousesRequest {
    warehousesIds?: number[] | undefined;

    constructor(data?: IDeleteWarehousesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehousesIds"])) {
                this.warehousesIds = [] as any;
                for (let item of _data["warehousesIds"])
                    this.warehousesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteWarehousesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteWarehousesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehousesIds)) {
            data["warehousesIds"] = [];
            for (let item of this.warehousesIds)
                data["warehousesIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteWarehousesRequest {
    warehousesIds?: number[] | undefined;
}

export class DeleteWarehousesResponse implements IDeleteWarehousesResponse {
    ok?: boolean;

    constructor(data?: IDeleteWarehousesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteWarehousesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteWarehousesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteWarehousesResponse {
    ok?: boolean;
}

export class DeleteWealthRequest implements IDeleteWealthRequest {
    wealthIds?: number[] | undefined;

    constructor(data?: IDeleteWealthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealthIds"])) {
                this.wealthIds = [] as any;
                for (let item of _data["wealthIds"])
                    this.wealthIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteWealthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteWealthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealthIds)) {
            data["wealthIds"] = [];
            for (let item of this.wealthIds)
                data["wealthIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteWealthRequest {
    wealthIds?: number[] | undefined;
}

export class DeleteWealthResponse implements IDeleteWealthResponse {
    ok?: boolean;

    constructor(data?: IDeleteWealthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteWealthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteWealthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteWealthResponse {
    ok?: boolean;
}

export class DiaryListDTO implements IDiaryListDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IDiaryListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DiaryListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDiaryListDTO {
    id?: number;
    name?: string | undefined;
}

export enum DiaryLogActionType {
    Unknown = 0,
    Save = 1,
    Add = 2,
    Delete = 3,
    Update = 4,
    Upload = 5,
}

export class DiaryLogDTO implements IDiaryLogDTO {
    id?: number;
    userName?: string | undefined;
    ip?: string | undefined;
    columnName?: string | undefined;
    tableName?: string | undefined;
    value?: string | undefined;
    oldValue?: string | undefined;
    date?: Date;
    actionType?: DiaryLogActionType;

    constructor(data?: IDiaryLogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.ip = _data["ip"];
            this.columnName = _data["columnName"];
            this.tableName = _data["tableName"];
            this.value = _data["value"];
            this.oldValue = _data["oldValue"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): DiaryLogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryLogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["ip"] = this.ip;
        data["columnName"] = this.columnName;
        data["tableName"] = this.tableName;
        data["value"] = this.value;
        data["oldValue"] = this.oldValue;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["actionType"] = this.actionType;
        return data;
    }
}

export interface IDiaryLogDTO {
    id?: number;
    userName?: string | undefined;
    ip?: string | undefined;
    columnName?: string | undefined;
    tableName?: string | undefined;
    value?: string | undefined;
    oldValue?: string | undefined;
    date?: Date;
    actionType?: DiaryLogActionType;
}

export enum DiaryPrintType {
    Diary = 0,
    DiaryInRange = 1,
    DiaryInvestor = 2,
    DiarySubcontractor = 3,
}

export class DiaryViewerItemDTO implements IDiaryViewerItemDTO {
    id?: number;
    date?: Date;
    signatureType?: number;
    downloadUri?: string | undefined;
    hasWeatherRecords?: boolean;
    hasWorkerRecords?: boolean;
    hasCompletedWorksRecords?: boolean;
    hasPhotos?: boolean;
    isLocked?: boolean;

    constructor(data?: IDiaryViewerItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.signatureType = _data["signatureType"];
            this.downloadUri = _data["downloadUri"];
            this.hasWeatherRecords = _data["hasWeatherRecords"];
            this.hasWorkerRecords = _data["hasWorkerRecords"];
            this.hasCompletedWorksRecords = _data["hasCompletedWorksRecords"];
            this.hasPhotos = _data["hasPhotos"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): DiaryViewerItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryViewerItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["signatureType"] = this.signatureType;
        data["downloadUri"] = this.downloadUri;
        data["hasWeatherRecords"] = this.hasWeatherRecords;
        data["hasWorkerRecords"] = this.hasWorkerRecords;
        data["hasCompletedWorksRecords"] = this.hasCompletedWorksRecords;
        data["hasPhotos"] = this.hasPhotos;
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IDiaryViewerItemDTO {
    id?: number;
    date?: Date;
    signatureType?: number;
    downloadUri?: string | undefined;
    hasWeatherRecords?: boolean;
    hasWorkerRecords?: boolean;
    hasCompletedWorksRecords?: boolean;
    hasPhotos?: boolean;
    isLocked?: boolean;
}

export class DocumentResponseDTO implements IDocumentResponseDTO {
    documentType!: string;
    documentId!: number;
    name!: string;
    file!: string;
    isRead!: boolean;
    isRejected!: boolean;

    constructor(data?: IDocumentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.documentId = _data["documentId"];
            this.name = _data["name"];
            this.file = _data["file"];
            this.isRead = _data["isRead"];
            this.isRejected = _data["isRejected"];
        }
    }

    static fromJS(data: any): DocumentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentId"] = this.documentId;
        data["name"] = this.name;
        data["file"] = this.file;
        data["isRead"] = this.isRead;
        data["isRejected"] = this.isRejected;
        return data;
    }
}

export interface IDocumentResponseDTO {
    documentType: string;
    documentId: number;
    name: string;
    file: string;
    isRead: boolean;
    isRejected: boolean;
}

export class DocumentSearchResultDTO implements IDocumentSearchResultDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IDocumentSearchResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocumentSearchResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSearchResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDocumentSearchResultDTO {
    id?: number;
    name?: string | undefined;
}

export class DochazkaRecordDTO implements IDochazkaRecordDTO {
    recordId?: number;
    employee?: string | undefined;
    building?: string | undefined;

    constructor(data?: IDochazkaRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"];
            this.employee = _data["employee"];
            this.building = _data["building"];
        }
    }

    static fromJS(data: any): DochazkaRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DochazkaRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId;
        data["employee"] = this.employee;
        data["building"] = this.building;
        return data;
    }
}

export interface IDochazkaRecordDTO {
    recordId?: number;
    employee?: string | undefined;
    building?: string | undefined;
}

export class DownloadBillPaymentsRequest implements IDownloadBillPaymentsRequest {
    invoiceIds?: number[] | undefined;

    constructor(data?: IDownloadBillPaymentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadBillPaymentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadBillPaymentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        return data;
    }
}

export interface IDownloadBillPaymentsRequest {
    invoiceIds?: number[] | undefined;
}

export class DownloadImageRequest implements IDownloadImageRequest {
    imageUrl?: string | undefined;

    constructor(data?: IDownloadImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): DownloadImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IDownloadImageRequest {
    imageUrl?: string | undefined;
}

export class DownloadInvoiceFilesRequest implements IDownloadInvoiceFilesRequest {
    invoiceIds?: number[] | undefined;

    constructor(data?: IDownloadInvoiceFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadInvoiceFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadInvoiceFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        return data;
    }
}

export interface IDownloadInvoiceFilesRequest {
    invoiceIds?: number[] | undefined;
}

export class EditWorkTimeNotifyRequest implements IEditWorkTimeNotifyRequest {
    workTimeNotifyFrom?: Date | undefined;
    workTimeNotifyTo?: Date | undefined;

    constructor(data?: IEditWorkTimeNotifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workTimeNotifyFrom = _data["workTimeNotifyFrom"] ? new Date(_data["workTimeNotifyFrom"].toString()) : <any>undefined;
            this.workTimeNotifyTo = _data["workTimeNotifyTo"] ? new Date(_data["workTimeNotifyTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EditWorkTimeNotifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditWorkTimeNotifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workTimeNotifyFrom"] = this.workTimeNotifyFrom ? this.workTimeNotifyFrom.toISOString() : <any>undefined;
        data["workTimeNotifyTo"] = this.workTimeNotifyTo ? this.workTimeNotifyTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEditWorkTimeNotifyRequest {
    workTimeNotifyFrom?: Date | undefined;
    workTimeNotifyTo?: Date | undefined;
}

export class EditWorkTimeNotifyResponse implements IEditWorkTimeNotifyResponse {
    ok?: boolean;
    message?: string | undefined;

    constructor(data?: IEditWorkTimeNotifyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): EditWorkTimeNotifyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditWorkTimeNotifyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        return data;
    }
}

export interface IEditWorkTimeNotifyResponse {
    ok?: boolean;
    message?: string | undefined;
}

export class EmailTemplateDTO implements IEmailTemplateDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEmailTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmailTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEmailTemplateDTO {
    id?: number;
    name?: string | undefined;
}

export class EmployeeDeletedDTO implements IEmployeeDeletedDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    code?: string | undefined;

    constructor(data?: IEmployeeDeletedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): EmployeeDeletedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDeletedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["code"] = this.code;
        return data;
    }
}

export interface IEmployeeDeletedDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    code?: string | undefined;
}

export class EmployeeDetailDTO implements IEmployeeDetailDTO {
    id?: number;
    code?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    isActive?: boolean;
    wage?: number;
    phonePrefix?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    emailAlt?: string | undefined;
    addressCorrespondent?: string | undefined;
    addressPermanent?: string | undefined;
    accountNumber?: string | undefined;
    insurance?: HealthInsuranceEnum;
    notes?: string | undefined;
    employeeGroupId?: number | undefined;
    pin?: string | undefined;
    holidayCount?: number;
    holidaySeconds?: number;
    signatureImage?: string | undefined;
    creditForTaxPayer?: boolean;
    studentUnder26?: boolean;
    invalidity?: InvalidityEnum;
    childrenCount?: number;
    title?: string | undefined;
    birthLastname?: string | undefined;
    birthDate?: Date | undefined;
    birthPlace?: string | undefined;
    birthNumber?: string | undefined;
    driverLicenseNumber?: string | undefined;
    maritalStatus?: MaritalStatusEnum;
    employment?: EmploymentEnum;
    workTime?: WorkTimeEnum;
    clothesSize?: number | undefined;
    clothesSizeSecondary?: number | undefined;
    shoesSize?: string | undefined;
    ico?: string | undefined;
    dic?: string | undefined;
    workTimeFrom?: Date | undefined;
    workTimeNotifyFrom?: Date | undefined;
    workTimeTo?: Date | undefined;
    workTimeNotifyTo?: Date | undefined;
    earlyExitPenalty?: number | undefined;
    lateArrivalPenalty?: number | undefined;
    breakLength?: number | undefined;
    workTimeRound?: boolean;
    workTimeFromRoundLow?: Date | undefined;
    workTimeFromRoundHigh?: Date | undefined;
    workTimeToRoundLow?: Date | undefined;
    workTimeToRoundHigh?: Date | undefined;
    iban?: string | undefined;
    swiftBc?: string | undefined;
    autoEndWorkTime?: boolean | undefined;
    addressCorrespondentStreet1?: string | undefined;
    addressCorrespondentStreet2?: string | undefined;
    addressCorrespondentCity?: string | undefined;
    addressCorrespondentZip?: string | undefined;
    addressCorrespondentCountry?: string | undefined;
    addressCorrespondentState?: number;
    addressPermanentStreet1?: string | undefined;
    addressPermanentStreet2?: string | undefined;
    addressPermanentCity?: string | undefined;
    addressPermanentZip?: string | undefined;
    addressPermanentCountry?: string | undefined;
    addressPermanentState?: number;
    takeLoginPhoto?: LoginPhotoEnum;
    docsRead?: boolean | undefined;
    wealthRead?: boolean | undefined;
    citizenship?: string | undefined;
    adminUserEmployees?: AssignedUserDTO[] | undefined;
    buildings?: BuildingEmployeeDTO[] | undefined;
    noteList?: EmployeeNoteDTO[] | undefined;

    constructor(data?: IEmployeeDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.isActive = _data["isActive"];
            this.wage = _data["wage"];
            this.phonePrefix = _data["phonePrefix"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.emailAlt = _data["emailAlt"];
            this.addressCorrespondent = _data["addressCorrespondent"];
            this.addressPermanent = _data["addressPermanent"];
            this.accountNumber = _data["accountNumber"];
            this.insurance = _data["insurance"];
            this.notes = _data["notes"];
            this.employeeGroupId = _data["employeeGroupId"];
            this.pin = _data["pin"];
            this.holidayCount = _data["holidayCount"];
            this.holidaySeconds = _data["holidaySeconds"];
            this.signatureImage = _data["signatureImage"];
            this.creditForTaxPayer = _data["creditForTaxPayer"];
            this.studentUnder26 = _data["studentUnder26"];
            this.invalidity = _data["invalidity"];
            this.childrenCount = _data["childrenCount"];
            this.title = _data["title"];
            this.birthLastname = _data["birthLastname"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = _data["birthPlace"];
            this.birthNumber = _data["birthNumber"];
            this.driverLicenseNumber = _data["driverLicenseNumber"];
            this.maritalStatus = _data["maritalStatus"];
            this.employment = _data["employment"];
            this.workTime = _data["workTime"];
            this.clothesSize = _data["clothesSize"];
            this.clothesSizeSecondary = _data["clothesSizeSecondary"];
            this.shoesSize = _data["shoesSize"];
            this.ico = _data["ico"];
            this.dic = _data["dic"];
            this.workTimeFrom = _data["workTimeFrom"] ? new Date(_data["workTimeFrom"].toString()) : <any>undefined;
            this.workTimeNotifyFrom = _data["workTimeNotifyFrom"] ? new Date(_data["workTimeNotifyFrom"].toString()) : <any>undefined;
            this.workTimeTo = _data["workTimeTo"] ? new Date(_data["workTimeTo"].toString()) : <any>undefined;
            this.workTimeNotifyTo = _data["workTimeNotifyTo"] ? new Date(_data["workTimeNotifyTo"].toString()) : <any>undefined;
            this.earlyExitPenalty = _data["earlyExitPenalty"];
            this.lateArrivalPenalty = _data["lateArrivalPenalty"];
            this.breakLength = _data["breakLength"];
            this.workTimeRound = _data["workTimeRound"];
            this.workTimeFromRoundLow = _data["workTimeFromRoundLow"] ? new Date(_data["workTimeFromRoundLow"].toString()) : <any>undefined;
            this.workTimeFromRoundHigh = _data["workTimeFromRoundHigh"] ? new Date(_data["workTimeFromRoundHigh"].toString()) : <any>undefined;
            this.workTimeToRoundLow = _data["workTimeToRoundLow"] ? new Date(_data["workTimeToRoundLow"].toString()) : <any>undefined;
            this.workTimeToRoundHigh = _data["workTimeToRoundHigh"] ? new Date(_data["workTimeToRoundHigh"].toString()) : <any>undefined;
            this.iban = _data["iban"];
            this.swiftBc = _data["swiftBc"];
            this.autoEndWorkTime = _data["autoEndWorkTime"];
            this.addressCorrespondentStreet1 = _data["addressCorrespondentStreet1"];
            this.addressCorrespondentStreet2 = _data["addressCorrespondentStreet2"];
            this.addressCorrespondentCity = _data["addressCorrespondentCity"];
            this.addressCorrespondentZip = _data["addressCorrespondentZip"];
            this.addressCorrespondentCountry = _data["addressCorrespondentCountry"];
            this.addressCorrespondentState = _data["addressCorrespondentState"];
            this.addressPermanentStreet1 = _data["addressPermanentStreet1"];
            this.addressPermanentStreet2 = _data["addressPermanentStreet2"];
            this.addressPermanentCity = _data["addressPermanentCity"];
            this.addressPermanentZip = _data["addressPermanentZip"];
            this.addressPermanentCountry = _data["addressPermanentCountry"];
            this.addressPermanentState = _data["addressPermanentState"];
            this.takeLoginPhoto = _data["takeLoginPhoto"];
            this.docsRead = _data["docsRead"];
            this.wealthRead = _data["wealthRead"];
            this.citizenship = _data["citizenship"];
            if (Array.isArray(_data["adminUserEmployees"])) {
                this.adminUserEmployees = [] as any;
                for (let item of _data["adminUserEmployees"])
                    this.adminUserEmployees!.push(AssignedUserDTO.fromJS(item));
            }
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingEmployeeDTO.fromJS(item));
            }
            if (Array.isArray(_data["noteList"])) {
                this.noteList = [] as any;
                for (let item of _data["noteList"])
                    this.noteList!.push(EmployeeNoteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["isActive"] = this.isActive;
        data["wage"] = this.wage;
        data["phonePrefix"] = this.phonePrefix;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["emailAlt"] = this.emailAlt;
        data["addressCorrespondent"] = this.addressCorrespondent;
        data["addressPermanent"] = this.addressPermanent;
        data["accountNumber"] = this.accountNumber;
        data["insurance"] = this.insurance;
        data["notes"] = this.notes;
        data["employeeGroupId"] = this.employeeGroupId;
        data["pin"] = this.pin;
        data["holidayCount"] = this.holidayCount;
        data["holidaySeconds"] = this.holidaySeconds;
        data["signatureImage"] = this.signatureImage;
        data["creditForTaxPayer"] = this.creditForTaxPayer;
        data["studentUnder26"] = this.studentUnder26;
        data["invalidity"] = this.invalidity;
        data["childrenCount"] = this.childrenCount;
        data["title"] = this.title;
        data["birthLastname"] = this.birthLastname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["birthNumber"] = this.birthNumber;
        data["driverLicenseNumber"] = this.driverLicenseNumber;
        data["maritalStatus"] = this.maritalStatus;
        data["employment"] = this.employment;
        data["workTime"] = this.workTime;
        data["clothesSize"] = this.clothesSize;
        data["clothesSizeSecondary"] = this.clothesSizeSecondary;
        data["shoesSize"] = this.shoesSize;
        data["ico"] = this.ico;
        data["dic"] = this.dic;
        data["workTimeFrom"] = this.workTimeFrom ? this.workTimeFrom.toISOString() : <any>undefined;
        data["workTimeNotifyFrom"] = this.workTimeNotifyFrom ? this.workTimeNotifyFrom.toISOString() : <any>undefined;
        data["workTimeTo"] = this.workTimeTo ? this.workTimeTo.toISOString() : <any>undefined;
        data["workTimeNotifyTo"] = this.workTimeNotifyTo ? this.workTimeNotifyTo.toISOString() : <any>undefined;
        data["earlyExitPenalty"] = this.earlyExitPenalty;
        data["lateArrivalPenalty"] = this.lateArrivalPenalty;
        data["breakLength"] = this.breakLength;
        data["workTimeRound"] = this.workTimeRound;
        data["workTimeFromRoundLow"] = this.workTimeFromRoundLow ? this.workTimeFromRoundLow.toISOString() : <any>undefined;
        data["workTimeFromRoundHigh"] = this.workTimeFromRoundHigh ? this.workTimeFromRoundHigh.toISOString() : <any>undefined;
        data["workTimeToRoundLow"] = this.workTimeToRoundLow ? this.workTimeToRoundLow.toISOString() : <any>undefined;
        data["workTimeToRoundHigh"] = this.workTimeToRoundHigh ? this.workTimeToRoundHigh.toISOString() : <any>undefined;
        data["iban"] = this.iban;
        data["swiftBc"] = this.swiftBc;
        data["autoEndWorkTime"] = this.autoEndWorkTime;
        data["addressCorrespondentStreet1"] = this.addressCorrespondentStreet1;
        data["addressCorrespondentStreet2"] = this.addressCorrespondentStreet2;
        data["addressCorrespondentCity"] = this.addressCorrespondentCity;
        data["addressCorrespondentZip"] = this.addressCorrespondentZip;
        data["addressCorrespondentCountry"] = this.addressCorrespondentCountry;
        data["addressCorrespondentState"] = this.addressCorrespondentState;
        data["addressPermanentStreet1"] = this.addressPermanentStreet1;
        data["addressPermanentStreet2"] = this.addressPermanentStreet2;
        data["addressPermanentCity"] = this.addressPermanentCity;
        data["addressPermanentZip"] = this.addressPermanentZip;
        data["addressPermanentCountry"] = this.addressPermanentCountry;
        data["addressPermanentState"] = this.addressPermanentState;
        data["takeLoginPhoto"] = this.takeLoginPhoto;
        data["docsRead"] = this.docsRead;
        data["wealthRead"] = this.wealthRead;
        data["citizenship"] = this.citizenship;
        if (Array.isArray(this.adminUserEmployees)) {
            data["adminUserEmployees"] = [];
            for (let item of this.adminUserEmployees)
                data["adminUserEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        if (Array.isArray(this.noteList)) {
            data["noteList"] = [];
            for (let item of this.noteList)
                data["noteList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeDetailDTO {
    id?: number;
    code?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    isActive?: boolean;
    wage?: number;
    phonePrefix?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    emailAlt?: string | undefined;
    addressCorrespondent?: string | undefined;
    addressPermanent?: string | undefined;
    accountNumber?: string | undefined;
    insurance?: HealthInsuranceEnum;
    notes?: string | undefined;
    employeeGroupId?: number | undefined;
    pin?: string | undefined;
    holidayCount?: number;
    holidaySeconds?: number;
    signatureImage?: string | undefined;
    creditForTaxPayer?: boolean;
    studentUnder26?: boolean;
    invalidity?: InvalidityEnum;
    childrenCount?: number;
    title?: string | undefined;
    birthLastname?: string | undefined;
    birthDate?: Date | undefined;
    birthPlace?: string | undefined;
    birthNumber?: string | undefined;
    driverLicenseNumber?: string | undefined;
    maritalStatus?: MaritalStatusEnum;
    employment?: EmploymentEnum;
    workTime?: WorkTimeEnum;
    clothesSize?: number | undefined;
    clothesSizeSecondary?: number | undefined;
    shoesSize?: string | undefined;
    ico?: string | undefined;
    dic?: string | undefined;
    workTimeFrom?: Date | undefined;
    workTimeNotifyFrom?: Date | undefined;
    workTimeTo?: Date | undefined;
    workTimeNotifyTo?: Date | undefined;
    earlyExitPenalty?: number | undefined;
    lateArrivalPenalty?: number | undefined;
    breakLength?: number | undefined;
    workTimeRound?: boolean;
    workTimeFromRoundLow?: Date | undefined;
    workTimeFromRoundHigh?: Date | undefined;
    workTimeToRoundLow?: Date | undefined;
    workTimeToRoundHigh?: Date | undefined;
    iban?: string | undefined;
    swiftBc?: string | undefined;
    autoEndWorkTime?: boolean | undefined;
    addressCorrespondentStreet1?: string | undefined;
    addressCorrespondentStreet2?: string | undefined;
    addressCorrespondentCity?: string | undefined;
    addressCorrespondentZip?: string | undefined;
    addressCorrespondentCountry?: string | undefined;
    addressCorrespondentState?: number;
    addressPermanentStreet1?: string | undefined;
    addressPermanentStreet2?: string | undefined;
    addressPermanentCity?: string | undefined;
    addressPermanentZip?: string | undefined;
    addressPermanentCountry?: string | undefined;
    addressPermanentState?: number;
    takeLoginPhoto?: LoginPhotoEnum;
    docsRead?: boolean | undefined;
    wealthRead?: boolean | undefined;
    citizenship?: string | undefined;
    adminUserEmployees?: AssignedUserDTO[] | undefined;
    buildings?: BuildingEmployeeDTO[] | undefined;
    noteList?: EmployeeNoteDTO[] | undefined;
}

export class EmployeeDTO implements IEmployeeDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;

    constructor(data?: IEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
        }
    }

    static fromJS(data: any): EmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        return data;
    }
}

export interface IEmployeeDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
}

export class EmployeeFileDTO implements IEmployeeFileDTO {
    id?: number;
    name?: string | undefined;
    file?: string | undefined;

    constructor(data?: IEmployeeFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): EmployeeFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["file"] = this.file;
        return data;
    }
}

export interface IEmployeeFileDTO {
    id?: number;
    name?: string | undefined;
    file?: string | undefined;
}

export class EmployeeGroupDTO implements IEmployeeGroupDTO {
    id?: number | undefined;
    name?: string | undefined;
    employees?: EmployeeInGroupDTO[] | undefined;
    isSelected?: boolean;

    constructor(data?: IEmployeeGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeInGroupDTO.fromJS(item));
            }
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): EmployeeGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IEmployeeGroupDTO {
    id?: number | undefined;
    name?: string | undefined;
    employees?: EmployeeInGroupDTO[] | undefined;
    isSelected?: boolean;
}

export class EmployeeGroupListDTO implements IEmployeeGroupListDTO {
    name?: string | undefined;
    id?: number;

    constructor(data?: IEmployeeGroupListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeGroupListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeeGroupListDTO {
    name?: string | undefined;
    id?: number;
}

export class EmployeeGroupNameDTO implements IEmployeeGroupNameDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEmployeeGroupNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmployeeGroupNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEmployeeGroupNameDTO {
    id?: number;
    name?: string | undefined;
}

export class EmployeeGroupsDTO implements IEmployeeGroupsDTO {
    id?: number;
    selectedId?: number;
    name?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IEmployeeGroupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selectedId = _data["selectedId"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): EmployeeGroupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selectedId"] = this.selectedId;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IEmployeeGroupsDTO {
    id?: number;
    selectedId?: number;
    name?: string | undefined;
    isDeleted?: boolean;
}

export class EmployeeIdAndNameDTO implements IEmployeeIdAndNameDTO {
    id?: number;
    code?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    groupId?: number | undefined;
    group?: string | undefined;

    constructor(data?: IEmployeeIdAndNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
        }
    }

    static fromJS(data: any): EmployeeIdAndNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeIdAndNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        return data;
    }
}

export interface IEmployeeIdAndNameDTO {
    id?: number;
    code?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    groupId?: number | undefined;
    group?: string | undefined;
}

export class EmployeeInGroupDTO implements IEmployeeInGroupDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isSelected?: boolean;
    groupName?: string | undefined;

    constructor(data?: IEmployeeInGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): EmployeeInGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface IEmployeeInGroupDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isSelected?: boolean;
    groupName?: string | undefined;
}

export class EmployeeListDTO implements IEmployeeListDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    code?: string | undefined;
    groupName?: string | undefined;
    phonePrefix?: string | undefined;
    phoneNumber?: string | undefined;
    wage?: string | undefined;
    isActive?: boolean;

    constructor(data?: IEmployeeListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.code = _data["code"];
            this.groupName = _data["groupName"];
            this.phonePrefix = _data["phonePrefix"];
            this.phoneNumber = _data["phoneNumber"];
            this.wage = _data["wage"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmployeeListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["code"] = this.code;
        data["groupName"] = this.groupName;
        data["phonePrefix"] = this.phonePrefix;
        data["phoneNumber"] = this.phoneNumber;
        data["wage"] = this.wage;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEmployeeListDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    code?: string | undefined;
    groupName?: string | undefined;
    phonePrefix?: string | undefined;
    phoneNumber?: string | undefined;
    wage?: string | undefined;
    isActive?: boolean;
}

export class EmployeeMobileDTO implements IEmployeeMobileDTO {
    name?: string | undefined;
    code?: string | undefined;
    adminId?: number | undefined;

    constructor(data?: IEmployeeMobileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.adminId = _data["adminId"];
        }
    }

    static fromJS(data: any): EmployeeMobileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMobileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["adminId"] = this.adminId;
        return data;
    }
}

export interface IEmployeeMobileDTO {
    name?: string | undefined;
    code?: string | undefined;
    adminId?: number | undefined;
}

export class EmployeeNoteDTO implements IEmployeeNoteDTO {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;

    constructor(data?: IEmployeeNoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): EmployeeNoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeNoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["text"] = this.text;
        return data;
    }
}

export interface IEmployeeNoteDTO {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;
}

export enum EmploymentEnum {
    NaDobuUrcitou = 1,
    NaDobuNeurcitou = 2,
    DohodaOProvedeniPrace = 3,
    DohodaOPracovniCinnosti = 4,
    HppNaDobuUrcitous = 5,
    HppNaDObuNeurcitou = 6,
    Dpp = 7,
    Dpc = 8,
    Osvc = 9,
    HppNaDobuUrcitouPlusDpp = 10,
    HppNaDobuNeurcitouPlusDpp = 11,
    DppPlusDpc = 12,
    OsvcPlusDpp = 13,
    HppNaDobuUrcitouPlusDppPlusOsvc = 14,
}

export enum EyetowerType {
    StavarioTowerLight = 0,
    StavarioTowerMicro = 1,
}

export class FileDiaryDTO implements IFileDiaryDTO {
    fileId?: number;
    fileName?: string | undefined;
    url?: string | undefined;
    createdAt?: Date;
    extension?: string | undefined;

    constructor(data?: IFileDiaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): FileDiaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDiaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IFileDiaryDTO {
    fileId?: number;
    fileName?: string | undefined;
    url?: string | undefined;
    createdAt?: Date;
    extension?: string | undefined;
}

export class FileDirectoryDeleteDTO implements IFileDirectoryDeleteDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    isDirectory?: boolean;
    isSelected?: boolean;
    parent?: string | undefined;
    children?: FileDirectoryDeleteDTO[] | undefined;
    hasChildren?: boolean;
    path?: string | undefined;
    showToClient?: boolean;
    isExpanded?: boolean;
    isDeleted?: boolean;

    constructor(data?: IFileDirectoryDeleteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.isDirectory = _data["isDirectory"];
            this.isSelected = _data["isSelected"];
            this.parent = _data["parent"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FileDirectoryDeleteDTO.fromJS(item));
            }
            this.hasChildren = _data["hasChildren"];
            this.path = _data["path"];
            this.showToClient = _data["showToClient"];
            this.isExpanded = _data["isExpanded"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): FileDirectoryDeleteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDirectoryDeleteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["isDirectory"] = this.isDirectory;
        data["isSelected"] = this.isSelected;
        data["parent"] = this.parent;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["hasChildren"] = this.hasChildren;
        data["path"] = this.path;
        data["showToClient"] = this.showToClient;
        data["isExpanded"] = this.isExpanded;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IFileDirectoryDeleteDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    isDirectory?: boolean;
    isSelected?: boolean;
    parent?: string | undefined;
    children?: FileDirectoryDeleteDTO[] | undefined;
    hasChildren?: boolean;
    path?: string | undefined;
    showToClient?: boolean;
    isExpanded?: boolean;
    isDeleted?: boolean;
}

export class FileDirectoryDTO implements IFileDirectoryDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    isDirectory?: boolean;
    isSelected?: boolean;
    parent?: string | undefined;
    children?: FileDirectoryDTO[] | undefined;
    hasChildren?: boolean;
    path?: string | undefined;
    showToClient?: boolean;
    isExpanded?: boolean;
    parentId?: number | undefined;

    constructor(data?: IFileDirectoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.isDirectory = _data["isDirectory"];
            this.isSelected = _data["isSelected"];
            this.parent = _data["parent"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FileDirectoryDTO.fromJS(item));
            }
            this.hasChildren = _data["hasChildren"];
            this.path = _data["path"];
            this.showToClient = _data["showToClient"];
            this.isExpanded = _data["isExpanded"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FileDirectoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDirectoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["isDirectory"] = this.isDirectory;
        data["isSelected"] = this.isSelected;
        data["parent"] = this.parent;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["hasChildren"] = this.hasChildren;
        data["path"] = this.path;
        data["showToClient"] = this.showToClient;
        data["isExpanded"] = this.isExpanded;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFileDirectoryDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    isDirectory?: boolean;
    isSelected?: boolean;
    parent?: string | undefined;
    children?: FileDirectoryDTO[] | undefined;
    hasChildren?: boolean;
    path?: string | undefined;
    showToClient?: boolean;
    isExpanded?: boolean;
    parentId?: number | undefined;
}

export class FileToTransferDTO implements IFileToTransferDTO {
    name?: string | undefined;
    isNewlySelected?: boolean;

    constructor(data?: IFileToTransferDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isNewlySelected = _data["isNewlySelected"];
        }
    }

    static fromJS(data: any): FileToTransferDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileToTransferDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isNewlySelected"] = this.isNewlySelected;
        return data;
    }
}

export interface IFileToTransferDTO {
    name?: string | undefined;
    isNewlySelected?: boolean;
}

export class GetAdditionalNotesResponse implements IGetAdditionalNotesResponse {
    additionalNotes?: string | undefined;

    constructor(data?: IGetAdditionalNotesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalNotes = _data["additionalNotes"];
        }
    }

    static fromJS(data: any): GetAdditionalNotesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdditionalNotesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalNotes"] = this.additionalNotes;
        return data;
    }
}

export interface IGetAdditionalNotesResponse {
    additionalNotes?: string | undefined;
}

export class GetAiRecognizedImagesResponse implements IGetAiRecognizedImagesResponse {
    aiImagesDescriptions?: AiImagesDescriptionDto[] | undefined;

    constructor(data?: IGetAiRecognizedImagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["aiImagesDescriptions"])) {
                this.aiImagesDescriptions = [] as any;
                for (let item of _data["aiImagesDescriptions"])
                    this.aiImagesDescriptions!.push(AiImagesDescriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAiRecognizedImagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAiRecognizedImagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.aiImagesDescriptions)) {
            data["aiImagesDescriptions"] = [];
            for (let item of this.aiImagesDescriptions)
                data["aiImagesDescriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAiRecognizedImagesResponse {
    aiImagesDescriptions?: AiImagesDescriptionDto[] | undefined;
}

export class GetAllActionsResponse implements IGetAllActionsResponse {
    buttons?: CustomButtonDto[] | undefined;

    constructor(data?: IGetAllActionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buttons"])) {
                this.buttons = [] as any;
                for (let item of _data["buttons"])
                    this.buttons!.push(CustomButtonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllActionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllActionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buttons)) {
            data["buttons"] = [];
            for (let item of this.buttons)
                data["buttons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllActionsResponse {
    buttons?: CustomButtonDto[] | undefined;
}

export class GetAllBozpDocumentNewsEmployeeMobileResponse implements IGetAllBozpDocumentNewsEmployeeMobileResponse {
    bozpDocumentNews?: BozpDocumentNewsResponseDTO[] | undefined;

    constructor(data?: IGetAllBozpDocumentNewsEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bozpDocumentNews"])) {
                this.bozpDocumentNews = [] as any;
                for (let item of _data["bozpDocumentNews"])
                    this.bozpDocumentNews!.push(BozpDocumentNewsResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllBozpDocumentNewsEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBozpDocumentNewsEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bozpDocumentNews)) {
            data["bozpDocumentNews"] = [];
            for (let item of this.bozpDocumentNews)
                data["bozpDocumentNews"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllBozpDocumentNewsEmployeeMobileResponse {
    bozpDocumentNews?: BozpDocumentNewsResponseDTO[] | undefined;
}

export class GetAllBuildingsResponse implements IGetAllBuildingsResponse {
    buildings?: MobileBuildingDTO[] | undefined;

    constructor(data?: IGetAllBuildingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(MobileBuildingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllBuildingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBuildingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllBuildingsResponse {
    buildings?: MobileBuildingDTO[] | undefined;
}

export class GetAllCustomFieldsForApplicationResponse implements IGetAllCustomFieldsForApplicationResponse {
    customFields?: CustomFieldDto[] | undefined;

    constructor(data?: IGetAllCustomFieldsForApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllCustomFieldsForApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCustomFieldsForApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllCustomFieldsForApplicationResponse {
    customFields?: CustomFieldDto[] | undefined;
}

export class GetAllDocumentsEmployeeMobileResponse implements IGetAllDocumentsEmployeeMobileResponse {
    documents?: DocumentResponseDTO[] | undefined;

    constructor(data?: IGetAllDocumentsEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDocumentsEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDocumentsEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllDocumentsEmployeeMobileResponse {
    documents?: DocumentResponseDTO[] | undefined;
}

export class GetAllEmployeesBuildingResponse implements IGetAllEmployeesBuildingResponse {
    employees?: EmployeeMobileDTO[] | undefined;

    constructor(data?: IGetAllEmployeesBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeMobileDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllEmployeesBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEmployeesBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllEmployeesBuildingResponse {
    employees?: EmployeeMobileDTO[] | undefined;
}

export class GetAllHintsResponse implements IGetAllHintsResponse {
    hints?: HintDTO[] | undefined;
    hintsAdmin?: boolean;

    constructor(data?: IGetAllHintsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hints"])) {
                this.hints = [] as any;
                for (let item of _data["hints"])
                    this.hints!.push(HintDTO.fromJS(item));
            }
            this.hintsAdmin = _data["hintsAdmin"];
        }
    }

    static fromJS(data: any): GetAllHintsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllHintsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hints)) {
            data["hints"] = [];
            for (let item of this.hints)
                data["hints"].push(item.toJSON());
        }
        data["hintsAdmin"] = this.hintsAdmin;
        return data;
    }
}

export interface IGetAllHintsResponse {
    hints?: HintDTO[] | undefined;
    hintsAdmin?: boolean;
}

export class GetAllJokesResponse implements IGetAllJokesResponse {
    jokes?: JokeDTO[] | undefined;
    isJokesAdmin?: boolean;

    constructor(data?: IGetAllJokesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jokes"])) {
                this.jokes = [] as any;
                for (let item of _data["jokes"])
                    this.jokes!.push(JokeDTO.fromJS(item));
            }
            this.isJokesAdmin = _data["isJokesAdmin"];
        }
    }

    static fromJS(data: any): GetAllJokesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllJokesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jokes)) {
            data["jokes"] = [];
            for (let item of this.jokes)
                data["jokes"].push(item.toJSON());
        }
        data["isJokesAdmin"] = this.isJokesAdmin;
        return data;
    }
}

export interface IGetAllJokesResponse {
    jokes?: JokeDTO[] | undefined;
    isJokesAdmin?: boolean;
}

export class GetAllRequestsEmployeeMobileResponse implements IGetAllRequestsEmployeeMobileResponse {
    requests?: RequestResponseWithBuildingDTO[] | undefined;

    constructor(data?: IGetAllRequestsEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(RequestResponseWithBuildingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllRequestsEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRequestsEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllRequestsEmployeeMobileResponse {
    requests?: RequestResponseWithBuildingDTO[] | undefined;
}

export class GetApplicationDataKrosAdminResponse implements IGetApplicationDataKrosAdminResponse {
    application?: AdminApplicationDataDTO;

    constructor(data?: IGetApplicationDataKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? AdminApplicationDataDTO.fromJS(_data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetApplicationDataKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationDataKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetApplicationDataKrosAdminResponse {
    application?: AdminApplicationDataDTO;
}

export class GetApplicationInvestorsResponse implements IGetApplicationInvestorsResponse {
    investors?: AdminUserDTO[] | undefined;

    constructor(data?: IGetApplicationInvestorsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["investors"])) {
                this.investors = [] as any;
                for (let item of _data["investors"])
                    this.investors!.push(AdminUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetApplicationInvestorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationInvestorsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.investors)) {
            data["investors"] = [];
            for (let item of this.investors)
                data["investors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetApplicationInvestorsResponse {
    investors?: AdminUserDTO[] | undefined;
}

export class GetApplicationListKrosAdminResponse implements IGetApplicationListKrosAdminResponse {
    applications?: ApplicationListDTO[] | undefined;

    constructor(data?: IGetApplicationListKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(ApplicationListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetApplicationListKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationListKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetApplicationListKrosAdminResponse {
    applications?: ApplicationListDTO[] | undefined;
}

export class GetApplicationPermissionsKrosAdminResponse implements IGetApplicationPermissionsKrosAdminResponse {
    permissions?: KrosAdminApplicationPermissionDTO;

    constructor(data?: IGetApplicationPermissionsKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissions = _data["permissions"] ? KrosAdminApplicationPermissionDTO.fromJS(_data["permissions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetApplicationPermissionsKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationPermissionsKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetApplicationPermissionsKrosAdminResponse {
    permissions?: KrosAdminApplicationPermissionDTO;
}

export class GetApplicationsCurrencyResponse implements IGetApplicationsCurrencyResponse {
    currency?: string | undefined;

    constructor(data?: IGetApplicationsCurrencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): GetApplicationsCurrencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationsCurrencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        return data;
    }
}

export interface IGetApplicationsCurrencyResponse {
    currency?: string | undefined;
}

export class GetApplicationsKrosAdminResponse implements IGetApplicationsKrosAdminResponse {
    applications?: AdminApplicationDTO[] | undefined;

    constructor(data?: IGetApplicationsKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(AdminApplicationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetApplicationsKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationsKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetApplicationsKrosAdminResponse {
    applications?: AdminApplicationDTO[] | undefined;
}

export class GetApplicationUsersResponse implements IGetApplicationUsersResponse {
    users?: AdminUserDTO[] | undefined;

    constructor(data?: IGetApplicationUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AdminUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetApplicationUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetApplicationUsersResponse {
    users?: AdminUserDTO[] | undefined;
}

export class GetAppLogoResponse implements IGetAppLogoResponse {
    url?: string | undefined;

    constructor(data?: IGetAppLogoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetAppLogoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppLogoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IGetAppLogoResponse {
    url?: string | undefined;
}

export class GetAttendanceForEmployeeMobileRequest implements IGetAttendanceForEmployeeMobileRequest {
    month?: number;
    year?: number;

    constructor(data?: IGetAttendanceForEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): GetAttendanceForEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceForEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IGetAttendanceForEmployeeMobileRequest {
    month?: number;
    year?: number;
}

export class GetAttendanceForEmployeeMobileResponse implements IGetAttendanceForEmployeeMobileResponse {
    attendance?: GetAttendanceResponseDTO;

    constructor(data?: IGetAttendanceForEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendance = _data["attendance"] ? GetAttendanceResponseDTO.fromJS(_data["attendance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttendanceForEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceForEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendance"] = this.attendance ? this.attendance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAttendanceForEmployeeMobileResponse {
    attendance?: GetAttendanceResponseDTO;
}

export class GetAttendanceResponseDTO implements IGetAttendanceResponseDTO {
    month?: number;
    readonly dates?: { [key: string]: AttendanceResponseDTO; } | undefined;
    readonly data?: AttendanceResponseDTO[] | undefined;

    constructor(data?: IGetAttendanceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            if (_data["dates"]) {
                (<any>this).dates = {} as any;
                for (let key in _data["dates"]) {
                    if (_data["dates"].hasOwnProperty(key))
                        (<any>(<any>this).dates)![key] = _data["dates"][key] ? AttendanceResponseDTO.fromJS(_data["dates"][key]) : new AttendanceResponseDTO();
                }
            }
            if (Array.isArray(_data["data"])) {
                (<any>this).data = [] as any;
                for (let item of _data["data"])
                    (<any>this).data!.push(AttendanceResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAttendanceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        if (this.dates) {
            data["dates"] = {};
            for (let key in this.dates) {
                if (this.dates.hasOwnProperty(key))
                    (<any>data["dates"])[key] = this.dates[key] ? this.dates[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAttendanceResponseDTO {
    month?: number;
    dates?: { [key: string]: AttendanceResponseDTO; } | undefined;
    data?: AttendanceResponseDTO[] | undefined;
}

export class GetBillsInvoicesForBuildingResponse implements IGetBillsInvoicesForBuildingResponse {
    bills?: BuildingBillsForInvoicesPageDTO[] | undefined;
    currency?: string | undefined;

    constructor(data?: IGetBillsInvoicesForBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bills"])) {
                this.bills = [] as any;
                for (let item of _data["bills"])
                    this.bills!.push(BuildingBillsForInvoicesPageDTO.fromJS(item));
            }
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): GetBillsInvoicesForBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillsInvoicesForBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        return data;
    }
}

export interface IGetBillsInvoicesForBuildingResponse {
    bills?: BuildingBillsForInvoicesPageDTO[] | undefined;
    currency?: string | undefined;
}

export class GetBillsPermissionsResponse implements IGetBillsPermissionsResponse {
    buildingBillsCreate?: boolean;
    buildingBillsDelete?: boolean;
    buildingBillsDetail?: boolean;
    buildingBillsEdit?: boolean;
    buildingBillsDropzoneFiles?: boolean;
    buildingBillsSetDateExpires?: boolean;
    buildingBillsSetDateReceive?: boolean;
    buildingBillsSetDateTaxable?: boolean;
    buildingBillsSetFrom?: boolean;
    buildingBillsSetIsApproved?: boolean;
    buildingBillsSetIsDone?: boolean;
    buildingBillsSetIsPosted?: boolean;
    buildingBillsSetIsPostponed?: boolean;
    buildingBillsSetName?: boolean;
    buildingBillsSetNewComment?: boolean;
    buildingBillsSetPaymentValues?: boolean;
    buildingBillsSetRelItemValues?: boolean;
    buildingBillsSetSubject?: boolean;
    buildingBillsSetSupplier?: boolean;
    buildingBillsSetTo?: boolean;
    buildingBillsSetVariableSymbol?: boolean;
    buildingBillsList?: boolean;
    buildingBillsLog?: boolean;

    constructor(data?: IGetBillsPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingBillsCreate = _data["buildingBillsCreate"];
            this.buildingBillsDelete = _data["buildingBillsDelete"];
            this.buildingBillsDetail = _data["buildingBillsDetail"];
            this.buildingBillsEdit = _data["buildingBillsEdit"];
            this.buildingBillsDropzoneFiles = _data["buildingBillsDropzoneFiles"];
            this.buildingBillsSetDateExpires = _data["buildingBillsSetDateExpires"];
            this.buildingBillsSetDateReceive = _data["buildingBillsSetDateReceive"];
            this.buildingBillsSetDateTaxable = _data["buildingBillsSetDateTaxable"];
            this.buildingBillsSetFrom = _data["buildingBillsSetFrom"];
            this.buildingBillsSetIsApproved = _data["buildingBillsSetIsApproved"];
            this.buildingBillsSetIsDone = _data["buildingBillsSetIsDone"];
            this.buildingBillsSetIsPosted = _data["buildingBillsSetIsPosted"];
            this.buildingBillsSetIsPostponed = _data["buildingBillsSetIsPostponed"];
            this.buildingBillsSetName = _data["buildingBillsSetName"];
            this.buildingBillsSetNewComment = _data["buildingBillsSetNewComment"];
            this.buildingBillsSetPaymentValues = _data["buildingBillsSetPaymentValues"];
            this.buildingBillsSetRelItemValues = _data["buildingBillsSetRelItemValues"];
            this.buildingBillsSetSubject = _data["buildingBillsSetSubject"];
            this.buildingBillsSetSupplier = _data["buildingBillsSetSupplier"];
            this.buildingBillsSetTo = _data["buildingBillsSetTo"];
            this.buildingBillsSetVariableSymbol = _data["buildingBillsSetVariableSymbol"];
            this.buildingBillsList = _data["buildingBillsList"];
            this.buildingBillsLog = _data["buildingBillsLog"];
        }
    }

    static fromJS(data: any): GetBillsPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillsPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingBillsCreate"] = this.buildingBillsCreate;
        data["buildingBillsDelete"] = this.buildingBillsDelete;
        data["buildingBillsDetail"] = this.buildingBillsDetail;
        data["buildingBillsEdit"] = this.buildingBillsEdit;
        data["buildingBillsDropzoneFiles"] = this.buildingBillsDropzoneFiles;
        data["buildingBillsSetDateExpires"] = this.buildingBillsSetDateExpires;
        data["buildingBillsSetDateReceive"] = this.buildingBillsSetDateReceive;
        data["buildingBillsSetDateTaxable"] = this.buildingBillsSetDateTaxable;
        data["buildingBillsSetFrom"] = this.buildingBillsSetFrom;
        data["buildingBillsSetIsApproved"] = this.buildingBillsSetIsApproved;
        data["buildingBillsSetIsDone"] = this.buildingBillsSetIsDone;
        data["buildingBillsSetIsPosted"] = this.buildingBillsSetIsPosted;
        data["buildingBillsSetIsPostponed"] = this.buildingBillsSetIsPostponed;
        data["buildingBillsSetName"] = this.buildingBillsSetName;
        data["buildingBillsSetNewComment"] = this.buildingBillsSetNewComment;
        data["buildingBillsSetPaymentValues"] = this.buildingBillsSetPaymentValues;
        data["buildingBillsSetRelItemValues"] = this.buildingBillsSetRelItemValues;
        data["buildingBillsSetSubject"] = this.buildingBillsSetSubject;
        data["buildingBillsSetSupplier"] = this.buildingBillsSetSupplier;
        data["buildingBillsSetTo"] = this.buildingBillsSetTo;
        data["buildingBillsSetVariableSymbol"] = this.buildingBillsSetVariableSymbol;
        data["buildingBillsList"] = this.buildingBillsList;
        data["buildingBillsLog"] = this.buildingBillsLog;
        return data;
    }
}

export interface IGetBillsPermissionsResponse {
    buildingBillsCreate?: boolean;
    buildingBillsDelete?: boolean;
    buildingBillsDetail?: boolean;
    buildingBillsEdit?: boolean;
    buildingBillsDropzoneFiles?: boolean;
    buildingBillsSetDateExpires?: boolean;
    buildingBillsSetDateReceive?: boolean;
    buildingBillsSetDateTaxable?: boolean;
    buildingBillsSetFrom?: boolean;
    buildingBillsSetIsApproved?: boolean;
    buildingBillsSetIsDone?: boolean;
    buildingBillsSetIsPosted?: boolean;
    buildingBillsSetIsPostponed?: boolean;
    buildingBillsSetName?: boolean;
    buildingBillsSetNewComment?: boolean;
    buildingBillsSetPaymentValues?: boolean;
    buildingBillsSetRelItemValues?: boolean;
    buildingBillsSetSubject?: boolean;
    buildingBillsSetSupplier?: boolean;
    buildingBillsSetTo?: boolean;
    buildingBillsSetVariableSymbol?: boolean;
    buildingBillsList?: boolean;
    buildingBillsLog?: boolean;
}

export class GetBuildingBillsForInvoicesPageResponse implements IGetBuildingBillsForInvoicesPageResponse {
    buildingBillsForInvoicesPage?: BuildingBillsForInvoicesPageDTO[] | undefined;
    currency?: string | undefined;

    constructor(data?: IGetBuildingBillsForInvoicesPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildingBillsForInvoicesPage"])) {
                this.buildingBillsForInvoicesPage = [] as any;
                for (let item of _data["buildingBillsForInvoicesPage"])
                    this.buildingBillsForInvoicesPage!.push(BuildingBillsForInvoicesPageDTO.fromJS(item));
            }
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): GetBuildingBillsForInvoicesPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingBillsForInvoicesPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildingBillsForInvoicesPage)) {
            data["buildingBillsForInvoicesPage"] = [];
            for (let item of this.buildingBillsForInvoicesPage)
                data["buildingBillsForInvoicesPage"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        return data;
    }
}

export interface IGetBuildingBillsForInvoicesPageResponse {
    buildingBillsForInvoicesPage?: BuildingBillsForInvoicesPageDTO[] | undefined;
    currency?: string | undefined;
}

export class GetBuildingDataDetailResponse implements IGetBuildingDataDetailResponse {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    contractNumber?: string | undefined;
    gpsX1?: number;
    gpsY1?: number;
    gpsDiff1?: number;
    address1?: string | undefined;
    parcelNumber1?: string | undefined;
    gpsX2?: number;
    gpsY2?: number;
    gpsDiff2?: number;
    address2?: string | undefined;
    parcelNumber2?: string | undefined;
    gpsActive2?: boolean;
    gpsX3?: number;
    gpsY3?: number;
    gpsDiff3?: number;
    address3?: string | undefined;
    parcelNumber3?: string | undefined;
    gpsActive3?: boolean;
    gpsX4?: number;
    gpsY4?: number;
    gpsDiff4?: number;
    address4?: string | undefined;
    parcelNumber4?: string | undefined;
    gpsActive4?: boolean;
    city?: string | undefined;
    client?: string | undefined;
    architect?: string | undefined;
    houseType?: string | undefined;
    notes?: string | undefined;
    hourlyRate?: number | undefined;
    state?: BuildingStateEnum;
    assignedUsers?: AssignedUserDTO[] | undefined;
    assignedEmployees?: AssignedEmployeeDTO[] | undefined;
    assignedInvestors?: InvestorDTO[] | undefined;
    noteList?: BuildingNoteDTO[] | undefined;
    createDiary?: boolean | undefined;
    createWarehouse?: boolean | undefined;

    constructor(data?: IGetBuildingDataDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
            this.showToEmployees = _data["showToEmployees"];
            this.contractNumber = _data["contractNumber"];
            this.gpsX1 = _data["gpsX1"];
            this.gpsY1 = _data["gpsY1"];
            this.gpsDiff1 = _data["gpsDiff1"];
            this.address1 = _data["address1"];
            this.parcelNumber1 = _data["parcelNumber1"];
            this.gpsX2 = _data["gpsX2"];
            this.gpsY2 = _data["gpsY2"];
            this.gpsDiff2 = _data["gpsDiff2"];
            this.address2 = _data["address2"];
            this.parcelNumber2 = _data["parcelNumber2"];
            this.gpsActive2 = _data["gpsActive2"];
            this.gpsX3 = _data["gpsX3"];
            this.gpsY3 = _data["gpsY3"];
            this.gpsDiff3 = _data["gpsDiff3"];
            this.address3 = _data["address3"];
            this.parcelNumber3 = _data["parcelNumber3"];
            this.gpsActive3 = _data["gpsActive3"];
            this.gpsX4 = _data["gpsX4"];
            this.gpsY4 = _data["gpsY4"];
            this.gpsDiff4 = _data["gpsDiff4"];
            this.address4 = _data["address4"];
            this.parcelNumber4 = _data["parcelNumber4"];
            this.gpsActive4 = _data["gpsActive4"];
            this.city = _data["city"];
            this.client = _data["client"];
            this.architect = _data["architect"];
            this.houseType = _data["houseType"];
            this.notes = _data["notes"];
            this.hourlyRate = _data["hourlyRate"];
            this.state = _data["state"];
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(AssignedUserDTO.fromJS(item));
            }
            if (Array.isArray(_data["assignedEmployees"])) {
                this.assignedEmployees = [] as any;
                for (let item of _data["assignedEmployees"])
                    this.assignedEmployees!.push(AssignedEmployeeDTO.fromJS(item));
            }
            if (Array.isArray(_data["assignedInvestors"])) {
                this.assignedInvestors = [] as any;
                for (let item of _data["assignedInvestors"])
                    this.assignedInvestors!.push(InvestorDTO.fromJS(item));
            }
            if (Array.isArray(_data["noteList"])) {
                this.noteList = [] as any;
                for (let item of _data["noteList"])
                    this.noteList!.push(BuildingNoteDTO.fromJS(item));
            }
            this.createDiary = _data["createDiary"];
            this.createWarehouse = _data["createWarehouse"];
        }
    }

    static fromJS(data: any): GetBuildingDataDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingDataDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["showToEmployees"] = this.showToEmployees;
        data["contractNumber"] = this.contractNumber;
        data["gpsX1"] = this.gpsX1;
        data["gpsY1"] = this.gpsY1;
        data["gpsDiff1"] = this.gpsDiff1;
        data["address1"] = this.address1;
        data["parcelNumber1"] = this.parcelNumber1;
        data["gpsX2"] = this.gpsX2;
        data["gpsY2"] = this.gpsY2;
        data["gpsDiff2"] = this.gpsDiff2;
        data["address2"] = this.address2;
        data["parcelNumber2"] = this.parcelNumber2;
        data["gpsActive2"] = this.gpsActive2;
        data["gpsX3"] = this.gpsX3;
        data["gpsY3"] = this.gpsY3;
        data["gpsDiff3"] = this.gpsDiff3;
        data["address3"] = this.address3;
        data["parcelNumber3"] = this.parcelNumber3;
        data["gpsActive3"] = this.gpsActive3;
        data["gpsX4"] = this.gpsX4;
        data["gpsY4"] = this.gpsY4;
        data["gpsDiff4"] = this.gpsDiff4;
        data["address4"] = this.address4;
        data["parcelNumber4"] = this.parcelNumber4;
        data["gpsActive4"] = this.gpsActive4;
        data["city"] = this.city;
        data["client"] = this.client;
        data["architect"] = this.architect;
        data["houseType"] = this.houseType;
        data["notes"] = this.notes;
        data["hourlyRate"] = this.hourlyRate;
        data["state"] = this.state;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedEmployees)) {
            data["assignedEmployees"] = [];
            for (let item of this.assignedEmployees)
                data["assignedEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedInvestors)) {
            data["assignedInvestors"] = [];
            for (let item of this.assignedInvestors)
                data["assignedInvestors"].push(item.toJSON());
        }
        if (Array.isArray(this.noteList)) {
            data["noteList"] = [];
            for (let item of this.noteList)
                data["noteList"].push(item.toJSON());
        }
        data["createDiary"] = this.createDiary;
        data["createWarehouse"] = this.createWarehouse;
        return data;
    }
}

export interface IGetBuildingDataDetailResponse {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    contractNumber?: string | undefined;
    gpsX1?: number;
    gpsY1?: number;
    gpsDiff1?: number;
    address1?: string | undefined;
    parcelNumber1?: string | undefined;
    gpsX2?: number;
    gpsY2?: number;
    gpsDiff2?: number;
    address2?: string | undefined;
    parcelNumber2?: string | undefined;
    gpsActive2?: boolean;
    gpsX3?: number;
    gpsY3?: number;
    gpsDiff3?: number;
    address3?: string | undefined;
    parcelNumber3?: string | undefined;
    gpsActive3?: boolean;
    gpsX4?: number;
    gpsY4?: number;
    gpsDiff4?: number;
    address4?: string | undefined;
    parcelNumber4?: string | undefined;
    gpsActive4?: boolean;
    city?: string | undefined;
    client?: string | undefined;
    architect?: string | undefined;
    houseType?: string | undefined;
    notes?: string | undefined;
    hourlyRate?: number | undefined;
    state?: BuildingStateEnum;
    assignedUsers?: AssignedUserDTO[] | undefined;
    assignedEmployees?: AssignedEmployeeDTO[] | undefined;
    assignedInvestors?: InvestorDTO[] | undefined;
    noteList?: BuildingNoteDTO[] | undefined;
    createDiary?: boolean | undefined;
    createWarehouse?: boolean | undefined;
}

export class GetBuildingForAdminUserResponse implements IGetBuildingForAdminUserResponse {
    buildings?: BuildingDTO[] | undefined;

    constructor(data?: IGetBuildingForAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuildingForAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingForAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuildingForAdminUserResponse {
    buildings?: BuildingDTO[] | undefined;
}

export class GetBuildingForSubcontractorResponse implements IGetBuildingForSubcontractorResponse {
    buildings?: BuildingDTO[] | undefined;

    constructor(data?: IGetBuildingForSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuildingForSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingForSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuildingForSubcontractorResponse {
    buildings?: BuildingDTO[] | undefined;
}

export class GetBuildingPhotosResponse implements IGetBuildingPhotosResponse {
    photos?: ImageDiaryDTO[] | undefined;

    constructor(data?: IGetBuildingPhotosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["photos"])) {
                this.photos = [] as any;
                for (let item of _data["photos"])
                    this.photos!.push(ImageDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuildingPhotosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingPhotosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuildingPhotosResponse {
    photos?: ImageDiaryDTO[] | undefined;
}

export class GetBuildingsForProjectsListPageResponse implements IGetBuildingsForProjectsListPageResponse {
    buildingsForProjectsListPage?: BuildingForProjectsListPageDTO[] | undefined;

    constructor(data?: IGetBuildingsForProjectsListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildingsForProjectsListPage"])) {
                this.buildingsForProjectsListPage = [] as any;
                for (let item of _data["buildingsForProjectsListPage"])
                    this.buildingsForProjectsListPage!.push(BuildingForProjectsListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuildingsForProjectsListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingsForProjectsListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildingsForProjectsListPage)) {
            data["buildingsForProjectsListPage"] = [];
            for (let item of this.buildingsForProjectsListPage)
                data["buildingsForProjectsListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuildingsForProjectsListPageResponse {
    buildingsForProjectsListPage?: BuildingForProjectsListPageDTO[] | undefined;
}

export class GetBuildingsPermissionsResponse implements IGetBuildingsPermissionsResponse {
    buildingsAssign?: boolean;
    buildingsBills?: boolean;
    buildingsCanSeeAll?: boolean;
    buildingsCreate?: boolean;
    buildingsDelete?: boolean;
    buildingsDetail?: boolean;
    buildingsDocuments?: boolean;
    buildingsEdit?: boolean;
    buildingsList?: boolean;
    buildingsNotes?: boolean;
    buildingsPhotos?: boolean;
    buildingsRequests?: boolean;
    buildingsRequestsWeather?: boolean;

    constructor(data?: IGetBuildingsPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingsAssign = _data["buildingsAssign"];
            this.buildingsBills = _data["buildingsBills"];
            this.buildingsCanSeeAll = _data["buildingsCanSeeAll"];
            this.buildingsCreate = _data["buildingsCreate"];
            this.buildingsDelete = _data["buildingsDelete"];
            this.buildingsDetail = _data["buildingsDetail"];
            this.buildingsDocuments = _data["buildingsDocuments"];
            this.buildingsEdit = _data["buildingsEdit"];
            this.buildingsList = _data["buildingsList"];
            this.buildingsNotes = _data["buildingsNotes"];
            this.buildingsPhotos = _data["buildingsPhotos"];
            this.buildingsRequests = _data["buildingsRequests"];
            this.buildingsRequestsWeather = _data["buildingsRequestsWeather"];
        }
    }

    static fromJS(data: any): GetBuildingsPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingsPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingsAssign"] = this.buildingsAssign;
        data["buildingsBills"] = this.buildingsBills;
        data["buildingsCanSeeAll"] = this.buildingsCanSeeAll;
        data["buildingsCreate"] = this.buildingsCreate;
        data["buildingsDelete"] = this.buildingsDelete;
        data["buildingsDetail"] = this.buildingsDetail;
        data["buildingsDocuments"] = this.buildingsDocuments;
        data["buildingsEdit"] = this.buildingsEdit;
        data["buildingsList"] = this.buildingsList;
        data["buildingsNotes"] = this.buildingsNotes;
        data["buildingsPhotos"] = this.buildingsPhotos;
        data["buildingsRequests"] = this.buildingsRequests;
        data["buildingsRequestsWeather"] = this.buildingsRequestsWeather;
        return data;
    }
}

export interface IGetBuildingsPermissionsResponse {
    buildingsAssign?: boolean;
    buildingsBills?: boolean;
    buildingsCanSeeAll?: boolean;
    buildingsCreate?: boolean;
    buildingsDelete?: boolean;
    buildingsDetail?: boolean;
    buildingsDocuments?: boolean;
    buildingsEdit?: boolean;
    buildingsList?: boolean;
    buildingsNotes?: boolean;
    buildingsPhotos?: boolean;
    buildingsRequests?: boolean;
    buildingsRequestsWeather?: boolean;
}

export class GetBuildingsWithWarehouseResponse implements IGetBuildingsWithWarehouseResponse {
    buildings?: BuildingDTO[] | undefined;

    constructor(data?: IGetBuildingsWithWarehouseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuildingsWithWarehouseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingsWithWarehouseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuildingsWithWarehouseResponse {
    buildings?: BuildingDTO[] | undefined;
}

export class GetBuildingWeatherByDiaryIdRequest implements IGetBuildingWeatherByDiaryIdRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;

    constructor(data?: IGetBuildingWeatherByDiaryIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dairyRecordId = _data["dairyRecordId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.hour = _data["hour"];
        }
    }

    static fromJS(data: any): GetBuildingWeatherByDiaryIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingWeatherByDiaryIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dairyRecordId"] = this.dairyRecordId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["hour"] = this.hour;
        return data;
    }
}

export interface IGetBuildingWeatherByDiaryIdRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;
}

export class GetBuildingWeatherByDiaryIdResponse implements IGetBuildingWeatherByDiaryIdResponse {
    description?: string | undefined;
    temperature?: string | undefined;
    wind?: string | undefined;
    precipitation?: string | undefined;
    humidity?: string | undefined;
    readonly isEmpty?: boolean;

    constructor(data?: IGetBuildingWeatherByDiaryIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.temperature = _data["temperature"];
            this.wind = _data["wind"];
            this.precipitation = _data["precipitation"];
            this.humidity = _data["humidity"];
            (<any>this).isEmpty = _data["isEmpty"];
        }
    }

    static fromJS(data: any): GetBuildingWeatherByDiaryIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingWeatherByDiaryIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["temperature"] = this.temperature;
        data["wind"] = this.wind;
        data["precipitation"] = this.precipitation;
        data["humidity"] = this.humidity;
        data["isEmpty"] = this.isEmpty;
        return data;
    }
}

export interface IGetBuildingWeatherByDiaryIdResponse {
    description?: string | undefined;
    temperature?: string | undefined;
    wind?: string | undefined;
    precipitation?: string | undefined;
    humidity?: string | undefined;
    isEmpty?: boolean;
}

export class GetBuildingWeatherByDiaryIdSubcontractorRequest implements IGetBuildingWeatherByDiaryIdSubcontractorRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;

    constructor(data?: IGetBuildingWeatherByDiaryIdSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dairyRecordId = _data["dairyRecordId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.hour = _data["hour"];
        }
    }

    static fromJS(data: any): GetBuildingWeatherByDiaryIdSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingWeatherByDiaryIdSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dairyRecordId"] = this.dairyRecordId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["hour"] = this.hour;
        return data;
    }
}

export interface IGetBuildingWeatherByDiaryIdSubcontractorRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;
}

export class GetBuildingWeatherResponse implements IGetBuildingWeatherResponse {
    weather?: WeatherInfoDTO[] | undefined;

    constructor(data?: IGetBuildingWeatherResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weather"])) {
                this.weather = [] as any;
                for (let item of _data["weather"])
                    this.weather!.push(WeatherInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBuildingWeatherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingWeatherResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weather)) {
            data["weather"] = [];
            for (let item of this.weather)
                data["weather"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBuildingWeatherResponse {
    weather?: WeatherInfoDTO[] | undefined;
}

export class GetCategoryTemplateDetailResponse implements IGetCategoryTemplateDetailResponse {
    template?: CategoryTemplateDTO;

    constructor(data?: IGetCategoryTemplateDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? CategoryTemplateDTO.fromJS(_data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCategoryTemplateDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryTemplateDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCategoryTemplateDetailResponse {
    template?: CategoryTemplateDTO;
}

export class GetCategoryTemplatesResponse implements IGetCategoryTemplatesResponse {
    templates?: CategoryTemplateDTO[] | undefined;

    constructor(data?: IGetCategoryTemplatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(CategoryTemplateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCategoryTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryTemplatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCategoryTemplatesResponse {
    templates?: CategoryTemplateDTO[] | undefined;
}

export class GetCompanyNameForDiaryResponse implements IGetCompanyNameForDiaryResponse {
    companyName?: string | undefined;

    constructor(data?: IGetCompanyNameForDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetCompanyNameForDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyNameForDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetCompanyNameForDiaryResponse {
    companyName?: string | undefined;
}

export class GetCompanyNameForSubcontractorDiaryResponse implements IGetCompanyNameForSubcontractorDiaryResponse {
    companyName?: string | undefined;

    constructor(data?: IGetCompanyNameForSubcontractorDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetCompanyNameForSubcontractorDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyNameForSubcontractorDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetCompanyNameForSubcontractorDiaryResponse {
    companyName?: string | undefined;
}

export class GetCompletedWorksResponse implements IGetCompletedWorksResponse {
    completedWorks?: string | undefined;

    constructor(data?: IGetCompletedWorksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedWorks = _data["completedWorks"];
        }
    }

    static fromJS(data: any): GetCompletedWorksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompletedWorksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedWorks"] = this.completedWorks;
        return data;
    }
}

export interface IGetCompletedWorksResponse {
    completedWorks?: string | undefined;
}

export class GetCustomFieldsForBuildingResponse implements IGetCustomFieldsForBuildingResponse {
    customFields?: CustomFieldWithValueDto[] | undefined;

    constructor(data?: IGetCustomFieldsForBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomFieldWithValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomFieldsForBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomFieldsForBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomFieldsForBuildingResponse {
    customFields?: CustomFieldWithValueDto[] | undefined;
}

export class GetDailyFullRecordRequest implements IGetDailyFullRecordRequest {
    diaryRecordId?: number;
    domain?: string | undefined;
    getBase64Images?: boolean;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetDailyFullRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.domain = _data["domain"];
            this.getBase64Images = _data["getBase64Images"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetDailyFullRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyFullRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["domain"] = this.domain;
        data["getBase64Images"] = this.getBase64Images;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetDailyFullRecordRequest {
    diaryRecordId?: number;
    domain?: string | undefined;
    getBase64Images?: boolean;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetDailyFullRecordResponse implements IGetDailyFullRecordResponse {
    buildingName?: string | undefined;
    diaryName?: string | undefined;
    date?: Date;
    isLocked?: boolean;
    machines?: string | undefined;
    materials?: string | undefined;
    completedWork?: string | undefined;
    additionalNotes?: string | undefined;
    weathers?: GetWeatherForRecordDTO[] | undefined;
    workers?: GetWorkerForRecordDTO[] | undefined;
    materialsTable?: GetMaterialsForRecordTableDTO[] | undefined;
    machinesTable?: GetMachinesForRecordTableDTO[] | undefined;
    messages?: InvestorsChatMessageDTO[] | undefined;
    images?: ImageDiaryDTO[] | undefined;
    signatures?: GetSignaturesForRecordResponse;
    groups?: GroupDTO[] | undefined;
    showEmployeesGroup?: boolean;
    totalWorkHoursOnSite?: boolean;
    showWorkHours?: boolean;
    timeStamp?: number;

    constructor(data?: IGetDailyFullRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingName = _data["buildingName"];
            this.diaryName = _data["diaryName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isLocked = _data["isLocked"];
            this.machines = _data["machines"];
            this.materials = _data["materials"];
            this.completedWork = _data["completedWork"];
            this.additionalNotes = _data["additionalNotes"];
            if (Array.isArray(_data["weathers"])) {
                this.weathers = [] as any;
                for (let item of _data["weathers"])
                    this.weathers!.push(GetWeatherForRecordDTO.fromJS(item));
            }
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(GetWorkerForRecordDTO.fromJS(item));
            }
            if (Array.isArray(_data["materialsTable"])) {
                this.materialsTable = [] as any;
                for (let item of _data["materialsTable"])
                    this.materialsTable!.push(GetMaterialsForRecordTableDTO.fromJS(item));
            }
            if (Array.isArray(_data["machinesTable"])) {
                this.machinesTable = [] as any;
                for (let item of _data["machinesTable"])
                    this.machinesTable!.push(GetMachinesForRecordTableDTO.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(InvestorsChatMessageDTO.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDiaryDTO.fromJS(item));
            }
            this.signatures = _data["signatures"] ? GetSignaturesForRecordResponse.fromJS(_data["signatures"]) : <any>undefined;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupDTO.fromJS(item));
            }
            this.showEmployeesGroup = _data["showEmployeesGroup"];
            this.totalWorkHoursOnSite = _data["totalWorkHoursOnSite"];
            this.showWorkHours = _data["showWorkHours"];
            this.timeStamp = _data["timeStamp"];
        }
    }

    static fromJS(data: any): GetDailyFullRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyFullRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingName"] = this.buildingName;
        data["diaryName"] = this.diaryName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isLocked"] = this.isLocked;
        data["machines"] = this.machines;
        data["materials"] = this.materials;
        data["completedWork"] = this.completedWork;
        data["additionalNotes"] = this.additionalNotes;
        if (Array.isArray(this.weathers)) {
            data["weathers"] = [];
            for (let item of this.weathers)
                data["weathers"].push(item.toJSON());
        }
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        if (Array.isArray(this.materialsTable)) {
            data["materialsTable"] = [];
            for (let item of this.materialsTable)
                data["materialsTable"].push(item.toJSON());
        }
        if (Array.isArray(this.machinesTable)) {
            data["machinesTable"] = [];
            for (let item of this.machinesTable)
                data["machinesTable"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["signatures"] = this.signatures ? this.signatures.toJSON() : <any>undefined;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["showEmployeesGroup"] = this.showEmployeesGroup;
        data["totalWorkHoursOnSite"] = this.totalWorkHoursOnSite;
        data["showWorkHours"] = this.showWorkHours;
        data["timeStamp"] = this.timeStamp;
        return data;
    }
}

export interface IGetDailyFullRecordResponse {
    buildingName?: string | undefined;
    diaryName?: string | undefined;
    date?: Date;
    isLocked?: boolean;
    machines?: string | undefined;
    materials?: string | undefined;
    completedWork?: string | undefined;
    additionalNotes?: string | undefined;
    weathers?: GetWeatherForRecordDTO[] | undefined;
    workers?: GetWorkerForRecordDTO[] | undefined;
    materialsTable?: GetMaterialsForRecordTableDTO[] | undefined;
    machinesTable?: GetMachinesForRecordTableDTO[] | undefined;
    messages?: InvestorsChatMessageDTO[] | undefined;
    images?: ImageDiaryDTO[] | undefined;
    signatures?: GetSignaturesForRecordResponse;
    groups?: GroupDTO[] | undefined;
    showEmployeesGroup?: boolean;
    totalWorkHoursOnSite?: boolean;
    showWorkHours?: boolean;
    timeStamp?: number;
}

export class GetDailyFullRecordSubcontractorRequest implements IGetDailyFullRecordSubcontractorRequest {
    diaryRecordId?: number;
    domain?: string | undefined;
    getBase64Images?: boolean;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetDailyFullRecordSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.domain = _data["domain"];
            this.getBase64Images = _data["getBase64Images"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetDailyFullRecordSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyFullRecordSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["domain"] = this.domain;
        data["getBase64Images"] = this.getBase64Images;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetDailyFullRecordSubcontractorRequest {
    diaryRecordId?: number;
    domain?: string | undefined;
    getBase64Images?: boolean;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetDailyRecordsForSubcontractorAndDiaryResponse implements IGetDailyRecordsForSubcontractorAndDiaryResponse {
    viewerRecords?: DiaryViewerItemDTO[] | undefined;

    constructor(data?: IGetDailyRecordsForSubcontractorAndDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["viewerRecords"])) {
                this.viewerRecords = [] as any;
                for (let item of _data["viewerRecords"])
                    this.viewerRecords!.push(DiaryViewerItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDailyRecordsForSubcontractorAndDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyRecordsForSubcontractorAndDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.viewerRecords)) {
            data["viewerRecords"] = [];
            for (let item of this.viewerRecords)
                data["viewerRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDailyRecordsForSubcontractorAndDiaryResponse {
    viewerRecords?: DiaryViewerItemDTO[] | undefined;
}

export class GetDailyRecordsForSubcontractorByRecordIdResponse implements IGetDailyRecordsForSubcontractorByRecordIdResponse {
    buildingId?: number;
    buildingName?: string | undefined;
    diaryId?: number;
    diaryName?: string | undefined;
    diaryDate?: Date;
    isActive?: boolean;
    viewerRecords?: DiaryViewerItemDTO[] | undefined;

    constructor(data?: IGetDailyRecordsForSubcontractorByRecordIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.diaryId = _data["diaryId"];
            this.diaryName = _data["diaryName"];
            this.diaryDate = _data["diaryDate"] ? new Date(_data["diaryDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["viewerRecords"])) {
                this.viewerRecords = [] as any;
                for (let item of _data["viewerRecords"])
                    this.viewerRecords!.push(DiaryViewerItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDailyRecordsForSubcontractorByRecordIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyRecordsForSubcontractorByRecordIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["diaryId"] = this.diaryId;
        data["diaryName"] = this.diaryName;
        data["diaryDate"] = this.diaryDate ? this.diaryDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.viewerRecords)) {
            data["viewerRecords"] = [];
            for (let item of this.viewerRecords)
                data["viewerRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDailyRecordsForSubcontractorByRecordIdResponse {
    buildingId?: number;
    buildingName?: string | undefined;
    diaryId?: number;
    diaryName?: string | undefined;
    diaryDate?: Date;
    isActive?: boolean;
    viewerRecords?: DiaryViewerItemDTO[] | undefined;
}

export class GetDailyRecordsForSubcontractorUserResponse implements IGetDailyRecordsForSubcontractorUserResponse {
    diaries?: GetDailyRecordsForUserDTO[] | undefined;

    constructor(data?: IGetDailyRecordsForSubcontractorUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaries"])) {
                this.diaries = [] as any;
                for (let item of _data["diaries"])
                    this.diaries!.push(GetDailyRecordsForUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDailyRecordsForSubcontractorUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyRecordsForSubcontractorUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaries)) {
            data["diaries"] = [];
            for (let item of this.diaries)
                data["diaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDailyRecordsForSubcontractorUserResponse {
    diaries?: GetDailyRecordsForUserDTO[] | undefined;
}

export class GetDailyRecordsForUserAndDiaryByRecordIdResponse implements IGetDailyRecordsForUserAndDiaryByRecordIdResponse {
    buildingId?: number;
    buildingName?: string | undefined;
    diaryId?: number;
    diaryName?: string | undefined;
    diaryDate?: Date;
    isActive?: boolean;
    viewerRecords?: DiaryViewerItemDTO[] | undefined;

    constructor(data?: IGetDailyRecordsForUserAndDiaryByRecordIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.diaryId = _data["diaryId"];
            this.diaryName = _data["diaryName"];
            this.diaryDate = _data["diaryDate"] ? new Date(_data["diaryDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["viewerRecords"])) {
                this.viewerRecords = [] as any;
                for (let item of _data["viewerRecords"])
                    this.viewerRecords!.push(DiaryViewerItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDailyRecordsForUserAndDiaryByRecordIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyRecordsForUserAndDiaryByRecordIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["diaryId"] = this.diaryId;
        data["diaryName"] = this.diaryName;
        data["diaryDate"] = this.diaryDate ? this.diaryDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.viewerRecords)) {
            data["viewerRecords"] = [];
            for (let item of this.viewerRecords)
                data["viewerRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDailyRecordsForUserAndDiaryByRecordIdResponse {
    buildingId?: number;
    buildingName?: string | undefined;
    diaryId?: number;
    diaryName?: string | undefined;
    diaryDate?: Date;
    isActive?: boolean;
    viewerRecords?: DiaryViewerItemDTO[] | undefined;
}

export class GetDailyRecordsForUserAndDiaryResponse implements IGetDailyRecordsForUserAndDiaryResponse {
    viewerRecords?: DiaryViewerItemDTO[] | undefined;

    constructor(data?: IGetDailyRecordsForUserAndDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["viewerRecords"])) {
                this.viewerRecords = [] as any;
                for (let item of _data["viewerRecords"])
                    this.viewerRecords!.push(DiaryViewerItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDailyRecordsForUserAndDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyRecordsForUserAndDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.viewerRecords)) {
            data["viewerRecords"] = [];
            for (let item of this.viewerRecords)
                data["viewerRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDailyRecordsForUserAndDiaryResponse {
    viewerRecords?: DiaryViewerItemDTO[] | undefined;
}

export class GetDailyRecordsForUserDTO implements IGetDailyRecordsForUserDTO {
    id?: number;
    diaryName?: string | undefined;
    mainDiaryName?: string | undefined;
    date?: Date;
    buildingId?: number;
    buildingName?: string | undefined;
    isFilled?: boolean;
    signatureType?: number;
    investorSigned?: boolean;
    diaryId?: number;
    hasWeatherRecords?: boolean;
    hasWorkerRecords?: boolean;
    hasCompletedWorksRecords?: boolean;
    hasPhotos?: boolean;
    hasClientSigned?: boolean;
    hasAttachment?: boolean;
    isLocked?: boolean;
    signatures?: SignatueListDTO[] | undefined;
    parentDiaryId?: number | undefined;
    groupId?: number | undefined;
    signedPdfPath?: string | undefined;
    signedPdfAuthor?: string | undefined;
    isSignedPdfAuthorInvestor?: boolean;

    constructor(data?: IGetDailyRecordsForUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.diaryName = _data["diaryName"];
            this.mainDiaryName = _data["mainDiaryName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.isFilled = _data["isFilled"];
            this.signatureType = _data["signatureType"];
            this.investorSigned = _data["investorSigned"];
            this.diaryId = _data["diaryId"];
            this.hasWeatherRecords = _data["hasWeatherRecords"];
            this.hasWorkerRecords = _data["hasWorkerRecords"];
            this.hasCompletedWorksRecords = _data["hasCompletedWorksRecords"];
            this.hasPhotos = _data["hasPhotos"];
            this.hasClientSigned = _data["hasClientSigned"];
            this.hasAttachment = _data["hasAttachment"];
            this.isLocked = _data["isLocked"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(SignatueListDTO.fromJS(item));
            }
            this.parentDiaryId = _data["parentDiaryId"];
            this.groupId = _data["groupId"];
            this.signedPdfPath = _data["signedPdfPath"];
            this.signedPdfAuthor = _data["signedPdfAuthor"];
            this.isSignedPdfAuthorInvestor = _data["isSignedPdfAuthorInvestor"];
        }
    }

    static fromJS(data: any): GetDailyRecordsForUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyRecordsForUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["diaryName"] = this.diaryName;
        data["mainDiaryName"] = this.mainDiaryName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["isFilled"] = this.isFilled;
        data["signatureType"] = this.signatureType;
        data["investorSigned"] = this.investorSigned;
        data["diaryId"] = this.diaryId;
        data["hasWeatherRecords"] = this.hasWeatherRecords;
        data["hasWorkerRecords"] = this.hasWorkerRecords;
        data["hasCompletedWorksRecords"] = this.hasCompletedWorksRecords;
        data["hasPhotos"] = this.hasPhotos;
        data["hasClientSigned"] = this.hasClientSigned;
        data["hasAttachment"] = this.hasAttachment;
        data["isLocked"] = this.isLocked;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item.toJSON());
        }
        data["parentDiaryId"] = this.parentDiaryId;
        data["groupId"] = this.groupId;
        data["signedPdfPath"] = this.signedPdfPath;
        data["signedPdfAuthor"] = this.signedPdfAuthor;
        data["isSignedPdfAuthorInvestor"] = this.isSignedPdfAuthorInvestor;
        return data;
    }
}

export interface IGetDailyRecordsForUserDTO {
    id?: number;
    diaryName?: string | undefined;
    mainDiaryName?: string | undefined;
    date?: Date;
    buildingId?: number;
    buildingName?: string | undefined;
    isFilled?: boolean;
    signatureType?: number;
    investorSigned?: boolean;
    diaryId?: number;
    hasWeatherRecords?: boolean;
    hasWorkerRecords?: boolean;
    hasCompletedWorksRecords?: boolean;
    hasPhotos?: boolean;
    hasClientSigned?: boolean;
    hasAttachment?: boolean;
    isLocked?: boolean;
    signatures?: SignatueListDTO[] | undefined;
    parentDiaryId?: number | undefined;
    groupId?: number | undefined;
    signedPdfPath?: string | undefined;
    signedPdfAuthor?: string | undefined;
    isSignedPdfAuthorInvestor?: boolean;
}

export class GetDailyRecordsForUserResponse implements IGetDailyRecordsForUserResponse {
    diaries?: GetDailyRecordsForUserDTO[] | undefined;

    constructor(data?: IGetDailyRecordsForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaries"])) {
                this.diaries = [] as any;
                for (let item of _data["diaries"])
                    this.diaries!.push(GetDailyRecordsForUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDailyRecordsForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyRecordsForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaries)) {
            data["diaries"] = [];
            for (let item of this.diaries)
                data["diaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDailyRecordsForUserResponse {
    diaries?: GetDailyRecordsForUserDTO[] | undefined;
}

export class GetDeletedEmployeeDocumentFilesToRestoreResponse implements IGetDeletedEmployeeDocumentFilesToRestoreResponse {
    files?: FileDirectoryDeleteDTO[] | undefined;

    constructor(data?: IGetDeletedEmployeeDocumentFilesToRestoreResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDeleteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedEmployeeDocumentFilesToRestoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedEmployeeDocumentFilesToRestoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeletedEmployeeDocumentFilesToRestoreResponse {
    files?: FileDirectoryDeleteDTO[] | undefined;
}

export class GetDeletedEmployeesResponse implements IGetDeletedEmployeesResponse {
    employees?: EmployeeDeletedDTO[] | undefined;

    constructor(data?: IGetDeletedEmployeesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeDeletedDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedEmployeesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedEmployeesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeletedEmployeesResponse {
    employees?: EmployeeDeletedDTO[] | undefined;
}

export class GetDeletedProjectDocumentFilesToRestoreResponse implements IGetDeletedProjectDocumentFilesToRestoreResponse {
    files?: FileDirectoryDeleteDTO[] | undefined;

    constructor(data?: IGetDeletedProjectDocumentFilesToRestoreResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDeleteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedProjectDocumentFilesToRestoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedProjectDocumentFilesToRestoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeletedProjectDocumentFilesToRestoreResponse {
    files?: FileDirectoryDeleteDTO[] | undefined;
}

export class GetDeletedProjectFilesToRestoreResponse implements IGetDeletedProjectFilesToRestoreResponse {
    files?: FileDirectoryDeleteDTO[] | undefined;

    constructor(data?: IGetDeletedProjectFilesToRestoreResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDeleteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedProjectFilesToRestoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedProjectFilesToRestoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeletedProjectFilesToRestoreResponse {
    files?: FileDirectoryDeleteDTO[] | undefined;
}

export class GetDeletedTodosResponse implements IGetDeletedTodosResponse {
    todos?: TodoListDTO[] | undefined;

    constructor(data?: IGetDeletedTodosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(TodoListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedTodosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedTodosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeletedTodosResponse {
    todos?: TodoListDTO[] | undefined;
}

export class GetDiariesForBuildingResponse implements IGetDiariesForBuildingResponse {
    diaries?: DiaryListDTO[] | undefined;

    constructor(data?: IGetDiariesForBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaries"])) {
                this.diaries = [] as any;
                for (let item of _data["diaries"])
                    this.diaries!.push(DiaryListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiariesForBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiariesForBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaries)) {
            data["diaries"] = [];
            for (let item of this.diaries)
                data["diaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiariesForBuildingResponse {
    diaries?: DiaryListDTO[] | undefined;
}

export class GetDiariesForInvestorResponse implements IGetDiariesForInvestorResponse {
    diaries?: GetDiariesForUserDTO[] | undefined;

    constructor(data?: IGetDiariesForInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaries"])) {
                this.diaries = [] as any;
                for (let item of _data["diaries"])
                    this.diaries!.push(GetDiariesForUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiariesForInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiariesForInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaries)) {
            data["diaries"] = [];
            for (let item of this.diaries)
                data["diaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiariesForInvestorResponse {
    diaries?: GetDiariesForUserDTO[] | undefined;
}

export class GetDiariesForSubcontractorUserResponse implements IGetDiariesForSubcontractorUserResponse {
    diaries?: GetDiariesForUserDTO[] | undefined;

    constructor(data?: IGetDiariesForSubcontractorUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaries"])) {
                this.diaries = [] as any;
                for (let item of _data["diaries"])
                    this.diaries!.push(GetDiariesForUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiariesForSubcontractorUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiariesForSubcontractorUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaries)) {
            data["diaries"] = [];
            for (let item of this.diaries)
                data["diaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiariesForSubcontractorUserResponse {
    diaries?: GetDiariesForUserDTO[] | undefined;
}

export class GetDiariesForUserDTO implements IGetDiariesForUserDTO {
    id?: number;
    name?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    isSubcontractorDiary?: boolean;
    isActive?: boolean;

    constructor(data?: IGetDiariesForUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.isSubcontractorDiary = _data["isSubcontractorDiary"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetDiariesForUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiariesForUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["isSubcontractorDiary"] = this.isSubcontractorDiary;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetDiariesForUserDTO {
    id?: number;
    name?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    isSubcontractorDiary?: boolean;
    isActive?: boolean;
}

export class GetDiariesForUserResponse implements IGetDiariesForUserResponse {
    diaries?: GetDiariesForUserDTO[] | undefined;

    constructor(data?: IGetDiariesForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diaries"])) {
                this.diaries = [] as any;
                for (let item of _data["diaries"])
                    this.diaries!.push(GetDiariesForUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiariesForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiariesForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diaries)) {
            data["diaries"] = [];
            for (let item of this.diaries)
                data["diaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiariesForUserResponse {
    diaries?: GetDiariesForUserDTO[] | undefined;
}

export class GetDiaryDataDetailResponse implements IGetDiaryDataDetailResponse {
    id?: number;
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    authorizedPerson?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    hasRecords?: boolean;
    isActive?: boolean;
    users?: UsersGroupDiaryDTO[] | undefined;

    constructor(data?: IGetDiaryDataDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.diaryName = _data["diaryName"];
            this.responsibleCompany = _data["responsibleCompany"];
            this.section = _data["section"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.place = _data["place"];
            this.investor = _data["investor"];
            this.tdsPermament = _data["tdsPermament"];
            this.tdsTemporary = _data["tdsTemporary"];
            this.authorWatch = _data["authorWatch"];
            this.generalContractor = _data["generalContractor"];
            this.constructionContractor = _data["constructionContractor"];
            this.technologicallContractor = _data["technologicallContractor"];
            this.subcontractors = _data["subcontractors"];
            this.projectManager = _data["projectManager"];
            this.constructionManager = _data["constructionManager"];
            this.generalArchitect = _data["generalArchitect"];
            this.responsibleArchitect = _data["responsibleArchitect"];
            this.authorizedPerson = _data["authorizedPerson"];
            this.groupId = _data["groupId"];
            this.parentDiaryId = _data["parentDiaryId"];
            this.hasRecords = _data["hasRecords"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersGroupDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiaryDataDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryDataDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["diaryName"] = this.diaryName;
        data["responsibleCompany"] = this.responsibleCompany;
        data["section"] = this.section;
        data["district"] = this.district;
        data["city"] = this.city;
        data["place"] = this.place;
        data["investor"] = this.investor;
        data["tdsPermament"] = this.tdsPermament;
        data["tdsTemporary"] = this.tdsTemporary;
        data["authorWatch"] = this.authorWatch;
        data["generalContractor"] = this.generalContractor;
        data["constructionContractor"] = this.constructionContractor;
        data["technologicallContractor"] = this.technologicallContractor;
        data["subcontractors"] = this.subcontractors;
        data["projectManager"] = this.projectManager;
        data["constructionManager"] = this.constructionManager;
        data["generalArchitect"] = this.generalArchitect;
        data["responsibleArchitect"] = this.responsibleArchitect;
        data["authorizedPerson"] = this.authorizedPerson;
        data["groupId"] = this.groupId;
        data["parentDiaryId"] = this.parentDiaryId;
        data["hasRecords"] = this.hasRecords;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiaryDataDetailResponse {
    id?: number;
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    authorizedPerson?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    hasRecords?: boolean;
    isActive?: boolean;
    users?: UsersGroupDiaryDTO[] | undefined;
}

export class GetDiaryInvestorsChatResponse implements IGetDiaryInvestorsChatResponse {
    messages?: InvestorsChatMessageDTO[] | undefined;

    constructor(data?: IGetDiaryInvestorsChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(InvestorsChatMessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiaryInvestorsChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryInvestorsChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiaryInvestorsChatResponse {
    messages?: InvestorsChatMessageDTO[] | undefined;
}

export class GetDiaryPermissionsInvestorRequest implements IGetDiaryPermissionsInvestorRequest {

    constructor(data?: IGetDiaryPermissionsInvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDiaryPermissionsInvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryPermissionsInvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDiaryPermissionsInvestorRequest {
}

export class GetDiaryPermissionsInvestorResponse implements IGetDiaryPermissionsInvestorResponse {
    buildingDiaryRecordsEdit?: boolean;
    buildingDiaryRecordsList?: boolean;
    buildingDiaryRecordsSignLock?: boolean;
    buildingDocumentsList?: boolean;
    buildingImagesList?: boolean;
    buildingRequestsCreate?: boolean;
    buildingRequestsList?: boolean;
    employeesList?: boolean;
    investorDocumentsCreate?: boolean;
    investorDocumentsDelete?: boolean;
    investorDocumentsEdit?: boolean;
    investorDocumentsList?: boolean;
    investorRepresentativesCreate?: boolean;
    investorRepresentativesDelete?: boolean;
    investorRepresentativesEdit?: boolean;
    investorRepresentativesList?: boolean;

    constructor(data?: IGetDiaryPermissionsInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingDiaryRecordsEdit = _data["buildingDiaryRecordsEdit"];
            this.buildingDiaryRecordsList = _data["buildingDiaryRecordsList"];
            this.buildingDiaryRecordsSignLock = _data["buildingDiaryRecordsSignLock"];
            this.buildingDocumentsList = _data["buildingDocumentsList"];
            this.buildingImagesList = _data["buildingImagesList"];
            this.buildingRequestsCreate = _data["buildingRequestsCreate"];
            this.buildingRequestsList = _data["buildingRequestsList"];
            this.employeesList = _data["employeesList"];
            this.investorDocumentsCreate = _data["investorDocumentsCreate"];
            this.investorDocumentsDelete = _data["investorDocumentsDelete"];
            this.investorDocumentsEdit = _data["investorDocumentsEdit"];
            this.investorDocumentsList = _data["investorDocumentsList"];
            this.investorRepresentativesCreate = _data["investorRepresentativesCreate"];
            this.investorRepresentativesDelete = _data["investorRepresentativesDelete"];
            this.investorRepresentativesEdit = _data["investorRepresentativesEdit"];
            this.investorRepresentativesList = _data["investorRepresentativesList"];
        }
    }

    static fromJS(data: any): GetDiaryPermissionsInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryPermissionsInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingDiaryRecordsEdit"] = this.buildingDiaryRecordsEdit;
        data["buildingDiaryRecordsList"] = this.buildingDiaryRecordsList;
        data["buildingDiaryRecordsSignLock"] = this.buildingDiaryRecordsSignLock;
        data["buildingDocumentsList"] = this.buildingDocumentsList;
        data["buildingImagesList"] = this.buildingImagesList;
        data["buildingRequestsCreate"] = this.buildingRequestsCreate;
        data["buildingRequestsList"] = this.buildingRequestsList;
        data["employeesList"] = this.employeesList;
        data["investorDocumentsCreate"] = this.investorDocumentsCreate;
        data["investorDocumentsDelete"] = this.investorDocumentsDelete;
        data["investorDocumentsEdit"] = this.investorDocumentsEdit;
        data["investorDocumentsList"] = this.investorDocumentsList;
        data["investorRepresentativesCreate"] = this.investorRepresentativesCreate;
        data["investorRepresentativesDelete"] = this.investorRepresentativesDelete;
        data["investorRepresentativesEdit"] = this.investorRepresentativesEdit;
        data["investorRepresentativesList"] = this.investorRepresentativesList;
        return data;
    }
}

export interface IGetDiaryPermissionsInvestorResponse {
    buildingDiaryRecordsEdit?: boolean;
    buildingDiaryRecordsList?: boolean;
    buildingDiaryRecordsSignLock?: boolean;
    buildingDocumentsList?: boolean;
    buildingImagesList?: boolean;
    buildingRequestsCreate?: boolean;
    buildingRequestsList?: boolean;
    employeesList?: boolean;
    investorDocumentsCreate?: boolean;
    investorDocumentsDelete?: boolean;
    investorDocumentsEdit?: boolean;
    investorDocumentsList?: boolean;
    investorRepresentativesCreate?: boolean;
    investorRepresentativesDelete?: boolean;
    investorRepresentativesEdit?: boolean;
    investorRepresentativesList?: boolean;
}

export class GetDiaryPermissionsResponse implements IGetDiaryPermissionsResponse {
    canViewDiaryList?: boolean;
    canViewDiaryDetail?: boolean;
    canCreateDiary?: boolean;
    canEditDiary?: boolean;
    canDeleteDiary?: boolean;
    canPrintDiary?: boolean;
    canPrintDiaryOwnRecords?: boolean;
    canViewDiaryRecordsList?: boolean;
    canViewDiaryRecordsDetail?: boolean;
    canCreateDiaryRecord?: boolean;
    canEditDiaryRecord?: boolean;
    canDeleteDiaryRecord?: boolean;
    canPrintDiaryRecord?: boolean;
    canPrintDiaryRecordOwnRecords?: boolean;
    canPrintDiaryRecordOthers?: boolean;
    subcontractorsViewOnlyTheirPage?: boolean;
    canLockDailyRecords?: boolean;
    canUnlockDailyRecords?: boolean;
    seeOtherComments?: boolean;
    writeCommonCompletedWorks?: boolean;
    readCommonCompletedWorks?: boolean;
    writeOthersDiary?: boolean;
    attachments?: boolean;
    directAttachments?: boolean;
    deleteAttachments?: boolean;
    investorsComments?: boolean;
    canSeeChangelog?: boolean;
    hasSigni?: boolean;
    canDeleteInsideRecords?: boolean;

    constructor(data?: IGetDiaryPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewDiaryList = _data["canViewDiaryList"];
            this.canViewDiaryDetail = _data["canViewDiaryDetail"];
            this.canCreateDiary = _data["canCreateDiary"];
            this.canEditDiary = _data["canEditDiary"];
            this.canDeleteDiary = _data["canDeleteDiary"];
            this.canPrintDiary = _data["canPrintDiary"];
            this.canPrintDiaryOwnRecords = _data["canPrintDiaryOwnRecords"];
            this.canViewDiaryRecordsList = _data["canViewDiaryRecordsList"];
            this.canViewDiaryRecordsDetail = _data["canViewDiaryRecordsDetail"];
            this.canCreateDiaryRecord = _data["canCreateDiaryRecord"];
            this.canEditDiaryRecord = _data["canEditDiaryRecord"];
            this.canDeleteDiaryRecord = _data["canDeleteDiaryRecord"];
            this.canPrintDiaryRecord = _data["canPrintDiaryRecord"];
            this.canPrintDiaryRecordOwnRecords = _data["canPrintDiaryRecordOwnRecords"];
            this.canPrintDiaryRecordOthers = _data["canPrintDiaryRecordOthers"];
            this.subcontractorsViewOnlyTheirPage = _data["subcontractorsViewOnlyTheirPage"];
            this.canLockDailyRecords = _data["canLockDailyRecords"];
            this.canUnlockDailyRecords = _data["canUnlockDailyRecords"];
            this.seeOtherComments = _data["seeOtherComments"];
            this.writeCommonCompletedWorks = _data["writeCommonCompletedWorks"];
            this.readCommonCompletedWorks = _data["readCommonCompletedWorks"];
            this.writeOthersDiary = _data["writeOthersDiary"];
            this.attachments = _data["attachments"];
            this.directAttachments = _data["directAttachments"];
            this.deleteAttachments = _data["deleteAttachments"];
            this.investorsComments = _data["investorsComments"];
            this.canSeeChangelog = _data["canSeeChangelog"];
            this.hasSigni = _data["hasSigni"];
            this.canDeleteInsideRecords = _data["canDeleteInsideRecords"];
        }
    }

    static fromJS(data: any): GetDiaryPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewDiaryList"] = this.canViewDiaryList;
        data["canViewDiaryDetail"] = this.canViewDiaryDetail;
        data["canCreateDiary"] = this.canCreateDiary;
        data["canEditDiary"] = this.canEditDiary;
        data["canDeleteDiary"] = this.canDeleteDiary;
        data["canPrintDiary"] = this.canPrintDiary;
        data["canPrintDiaryOwnRecords"] = this.canPrintDiaryOwnRecords;
        data["canViewDiaryRecordsList"] = this.canViewDiaryRecordsList;
        data["canViewDiaryRecordsDetail"] = this.canViewDiaryRecordsDetail;
        data["canCreateDiaryRecord"] = this.canCreateDiaryRecord;
        data["canEditDiaryRecord"] = this.canEditDiaryRecord;
        data["canDeleteDiaryRecord"] = this.canDeleteDiaryRecord;
        data["canPrintDiaryRecord"] = this.canPrintDiaryRecord;
        data["canPrintDiaryRecordOwnRecords"] = this.canPrintDiaryRecordOwnRecords;
        data["canPrintDiaryRecordOthers"] = this.canPrintDiaryRecordOthers;
        data["subcontractorsViewOnlyTheirPage"] = this.subcontractorsViewOnlyTheirPage;
        data["canLockDailyRecords"] = this.canLockDailyRecords;
        data["canUnlockDailyRecords"] = this.canUnlockDailyRecords;
        data["seeOtherComments"] = this.seeOtherComments;
        data["writeCommonCompletedWorks"] = this.writeCommonCompletedWorks;
        data["readCommonCompletedWorks"] = this.readCommonCompletedWorks;
        data["writeOthersDiary"] = this.writeOthersDiary;
        data["attachments"] = this.attachments;
        data["directAttachments"] = this.directAttachments;
        data["deleteAttachments"] = this.deleteAttachments;
        data["investorsComments"] = this.investorsComments;
        data["canSeeChangelog"] = this.canSeeChangelog;
        data["hasSigni"] = this.hasSigni;
        data["canDeleteInsideRecords"] = this.canDeleteInsideRecords;
        return data;
    }
}

export interface IGetDiaryPermissionsResponse {
    canViewDiaryList?: boolean;
    canViewDiaryDetail?: boolean;
    canCreateDiary?: boolean;
    canEditDiary?: boolean;
    canDeleteDiary?: boolean;
    canPrintDiary?: boolean;
    canPrintDiaryOwnRecords?: boolean;
    canViewDiaryRecordsList?: boolean;
    canViewDiaryRecordsDetail?: boolean;
    canCreateDiaryRecord?: boolean;
    canEditDiaryRecord?: boolean;
    canDeleteDiaryRecord?: boolean;
    canPrintDiaryRecord?: boolean;
    canPrintDiaryRecordOwnRecords?: boolean;
    canPrintDiaryRecordOthers?: boolean;
    subcontractorsViewOnlyTheirPage?: boolean;
    canLockDailyRecords?: boolean;
    canUnlockDailyRecords?: boolean;
    seeOtherComments?: boolean;
    writeCommonCompletedWorks?: boolean;
    readCommonCompletedWorks?: boolean;
    writeOthersDiary?: boolean;
    attachments?: boolean;
    directAttachments?: boolean;
    deleteAttachments?: boolean;
    investorsComments?: boolean;
    canSeeChangelog?: boolean;
    hasSigni?: boolean;
    canDeleteInsideRecords?: boolean;
}

export class GetDiaryRecordDataNotTablesResponse implements IGetDiaryRecordDataNotTablesResponse {
    buildingName?: string | undefined;
    buildingId?: number | undefined;
    diaryName?: string | undefined;
    date?: Date;
    isLocked?: boolean;
    isReadOnly?: boolean;
    weather?: string | undefined;
    workers?: string | undefined;
    machines?: string | undefined;
    materials?: string | undefined;
    completedWork?: string | undefined;
    additionalNotes?: string | undefined;
    showEmployeesGroup?: boolean;
    totalWorkHoursOnSite?: boolean;
    showWorkHours?: boolean;
    subdiaries?: SubDiaryDTO[] | undefined;
    groups?: GroupDTO[] | undefined;
    privateContents?: GroupAdminDTO[] | undefined;
    timeStamp?: number;

    constructor(data?: IGetDiaryRecordDataNotTablesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingName = _data["buildingName"];
            this.buildingId = _data["buildingId"];
            this.diaryName = _data["diaryName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isLocked = _data["isLocked"];
            this.isReadOnly = _data["isReadOnly"];
            this.weather = _data["weather"];
            this.workers = _data["workers"];
            this.machines = _data["machines"];
            this.materials = _data["materials"];
            this.completedWork = _data["completedWork"];
            this.additionalNotes = _data["additionalNotes"];
            this.showEmployeesGroup = _data["showEmployeesGroup"];
            this.totalWorkHoursOnSite = _data["totalWorkHoursOnSite"];
            this.showWorkHours = _data["showWorkHours"];
            if (Array.isArray(_data["subdiaries"])) {
                this.subdiaries = [] as any;
                for (let item of _data["subdiaries"])
                    this.subdiaries!.push(SubDiaryDTO.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupDTO.fromJS(item));
            }
            if (Array.isArray(_data["privateContents"])) {
                this.privateContents = [] as any;
                for (let item of _data["privateContents"])
                    this.privateContents!.push(GroupAdminDTO.fromJS(item));
            }
            this.timeStamp = _data["timeStamp"];
        }
    }

    static fromJS(data: any): GetDiaryRecordDataNotTablesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryRecordDataNotTablesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingName"] = this.buildingName;
        data["buildingId"] = this.buildingId;
        data["diaryName"] = this.diaryName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isLocked"] = this.isLocked;
        data["isReadOnly"] = this.isReadOnly;
        data["weather"] = this.weather;
        data["workers"] = this.workers;
        data["machines"] = this.machines;
        data["materials"] = this.materials;
        data["completedWork"] = this.completedWork;
        data["additionalNotes"] = this.additionalNotes;
        data["showEmployeesGroup"] = this.showEmployeesGroup;
        data["totalWorkHoursOnSite"] = this.totalWorkHoursOnSite;
        data["showWorkHours"] = this.showWorkHours;
        if (Array.isArray(this.subdiaries)) {
            data["subdiaries"] = [];
            for (let item of this.subdiaries)
                data["subdiaries"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.privateContents)) {
            data["privateContents"] = [];
            for (let item of this.privateContents)
                data["privateContents"].push(item.toJSON());
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    }
}

export interface IGetDiaryRecordDataNotTablesResponse {
    buildingName?: string | undefined;
    buildingId?: number | undefined;
    diaryName?: string | undefined;
    date?: Date;
    isLocked?: boolean;
    isReadOnly?: boolean;
    weather?: string | undefined;
    workers?: string | undefined;
    machines?: string | undefined;
    materials?: string | undefined;
    completedWork?: string | undefined;
    additionalNotes?: string | undefined;
    showEmployeesGroup?: boolean;
    totalWorkHoursOnSite?: boolean;
    showWorkHours?: boolean;
    subdiaries?: SubDiaryDTO[] | undefined;
    groups?: GroupDTO[] | undefined;
    privateContents?: GroupAdminDTO[] | undefined;
    timeStamp?: number;
}

export class GetDiaryRecordLogResponse implements IGetDiaryRecordLogResponse {
    logs?: DiaryLogDTO[] | undefined;

    constructor(data?: IGetDiaryRecordLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(DiaryLogDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiaryRecordLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryRecordLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiaryRecordLogResponse {
    logs?: DiaryLogDTO[] | undefined;
}

export class GetDiarySearchResultRequest implements IGetDiarySearchResultRequest {
    diaryId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    searchText?: string | undefined;

    constructor(data?: IGetDiarySearchResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetDiarySearchResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiarySearchResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetDiarySearchResultRequest {
    diaryId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    searchText?: string | undefined;
}

export class GetDiarySearchResultResponse implements IGetDiarySearchResultResponse {
    records?: DailyRecordSearchDTO[] | undefined;

    constructor(data?: IGetDiarySearchResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(DailyRecordSearchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiarySearchResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiarySearchResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiarySearchResultResponse {
    records?: DailyRecordSearchDTO[] | undefined;
}

export class GetDiarySearchResultSubcontractorRequest implements IGetDiarySearchResultSubcontractorRequest {
    diaryId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    searchText?: string | undefined;

    constructor(data?: IGetDiarySearchResultSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): GetDiarySearchResultSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiarySearchResultSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IGetDiarySearchResultSubcontractorRequest {
    diaryId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    searchText?: string | undefined;
}

export class GetDiarySubcontractorsChatForSubcontractorResponse implements IGetDiarySubcontractorsChatForSubcontractorResponse {
    messages?: SubcontractorsChatMessageDTO[] | undefined;

    constructor(data?: IGetDiarySubcontractorsChatForSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(SubcontractorsChatMessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiarySubcontractorsChatForSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiarySubcontractorsChatForSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiarySubcontractorsChatForSubcontractorResponse {
    messages?: SubcontractorsChatMessageDTO[] | undefined;
}

export class GetDiarySubcontractorsChatResponse implements IGetDiarySubcontractorsChatResponse {
    groups?: ChatGroupDTO[] | undefined;

    constructor(data?: IGetDiarySubcontractorsChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ChatGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiarySubcontractorsChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiarySubcontractorsChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiarySubcontractorsChatResponse {
    groups?: ChatGroupDTO[] | undefined;
}

export class GetDiaryUsersForGroupResponse implements IGetDiaryUsersForGroupResponse {
    users?: UsersGroupDiaryDTO[] | undefined;

    constructor(data?: IGetDiaryUsersForGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersGroupDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiaryUsersForGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryUsersForGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiaryUsersForGroupResponse {
    users?: UsersGroupDiaryDTO[] | undefined;
}

export class GetDiaryUsersForGroupSubcontractorResponse implements IGetDiaryUsersForGroupSubcontractorResponse {
    users?: UsersGroupDiaryDTO[] | undefined;

    constructor(data?: IGetDiaryUsersForGroupSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersGroupDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiaryUsersForGroupSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiaryUsersForGroupSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiaryUsersForGroupSubcontractorResponse {
    users?: UsersGroupDiaryDTO[] | undefined;
}

export class GetDisabledModulesResponse implements IGetDisabledModulesResponse {
    disabledModules?: string[] | undefined;

    constructor(data?: IGetDisabledModulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["disabledModules"])) {
                this.disabledModules = [] as any;
                for (let item of _data["disabledModules"])
                    this.disabledModules!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDisabledModulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDisabledModulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.disabledModules)) {
            data["disabledModules"] = [];
            for (let item of this.disabledModules)
                data["disabledModules"].push(item);
        }
        return data;
    }
}

export interface IGetDisabledModulesResponse {
    disabledModules?: string[] | undefined;
}

export class GetDocumentsForInvestorAndBuildingDTO implements IGetDocumentsForInvestorAndBuildingDTO {
    buildingId?: number;
    buildingName?: string | undefined;
    files?: FileDirectoryDTO[] | undefined;

    constructor(data?: IGetDocumentsForInvestorAndBuildingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsForInvestorAndBuildingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsForInvestorAndBuildingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDocumentsForInvestorAndBuildingDTO {
    buildingId?: number;
    buildingName?: string | undefined;
    files?: FileDirectoryDTO[] | undefined;
}

export class GetDocumentsForInvestorAndBuildingResponse implements IGetDocumentsForInvestorAndBuildingResponse {
    filesBuildings?: GetDocumentsForInvestorAndBuildingDTO[] | undefined;

    constructor(data?: IGetDocumentsForInvestorAndBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filesBuildings"])) {
                this.filesBuildings = [] as any;
                for (let item of _data["filesBuildings"])
                    this.filesBuildings!.push(GetDocumentsForInvestorAndBuildingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsForInvestorAndBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsForInvestorAndBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filesBuildings)) {
            data["filesBuildings"] = [];
            for (let item of this.filesBuildings)
                data["filesBuildings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDocumentsForInvestorAndBuildingResponse {
    filesBuildings?: GetDocumentsForInvestorAndBuildingDTO[] | undefined;
}

export class GetDownloadForSignedDiaryRequest implements IGetDownloadForSignedDiaryRequest {
    url?: string | undefined;

    constructor(data?: IGetDownloadForSignedDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetDownloadForSignedDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDownloadForSignedDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IGetDownloadForSignedDiaryRequest {
    url?: string | undefined;
}

export class GetDownloadForSignedSubcontractorDiaryRequest implements IGetDownloadForSignedSubcontractorDiaryRequest {
    url?: string | undefined;

    constructor(data?: IGetDownloadForSignedSubcontractorDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetDownloadForSignedSubcontractorDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDownloadForSignedSubcontractorDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IGetDownloadForSignedSubcontractorDiaryRequest {
    url?: string | undefined;
}

export class GetEmailTemplatesResponse implements IGetEmailTemplatesResponse {
    templates?: EmailTemplateDTO[] | undefined;

    constructor(data?: IGetEmailTemplatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(EmailTemplateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmailTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmailTemplatesResponse {
    templates?: EmailTemplateDTO[] | undefined;
}

export class GetEmployeeAttendanceHeliosRequest implements IGetEmployeeAttendanceHeliosRequest {
    employeeId?: number;
    year?: number;
    month?: number;
    adminUserId?: number;
    token?: string | undefined;

    constructor(data?: IGetEmployeeAttendanceHeliosRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.adminUserId = _data["adminUserId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetEmployeeAttendanceHeliosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeAttendanceHeliosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["adminUserId"] = this.adminUserId;
        data["token"] = this.token;
        return data;
    }
}

export interface IGetEmployeeAttendanceHeliosRequest {
    employeeId?: number;
    year?: number;
    month?: number;
    adminUserId?: number;
    token?: string | undefined;
}

export class GetEmployeeAttendanceHeliosResponse implements IGetEmployeeAttendanceHeliosResponse {
    export?: string | undefined;

    constructor(data?: IGetEmployeeAttendanceHeliosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.export = _data["export"];
        }
    }

    static fromJS(data: any): GetEmployeeAttendanceHeliosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeAttendanceHeliosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["export"] = this.export;
        return data;
    }
}

export interface IGetEmployeeAttendanceHeliosResponse {
    export?: string | undefined;
}

export class GetEmployeeDetailResponse implements IGetEmployeeDetailResponse {
    employee?: EmployeeDetailDTO;

    constructor(data?: IGetEmployeeDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeDetailDTO.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeDetailResponse {
    employee?: EmployeeDetailDTO;
}

export class GetEmployeeFileDetailResponse implements IGetEmployeeFileDetailResponse {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    signatureImage?: string | undefined;
    employeeId?: number | undefined;
    isRead?: boolean;
    isRejected?: boolean;
    dateRead?: Date | undefined;
    dateChanged?: Date | undefined;
    employeeIdTo?: number | undefined;
    showToEmployee?: boolean;
    text?: string | undefined;

    constructor(data?: IGetEmployeeFileDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.isDone = _data["isDone"];
            this.isCategory = _data["isCategory"];
            this.adminUserFromId = _data["adminUserFromId"];
            this.adminUserToId = _data["adminUserToId"];
            this.signatureImage = _data["signatureImage"];
            this.employeeId = _data["employeeId"];
            this.isRead = _data["isRead"];
            this.isRejected = _data["isRejected"];
            this.dateRead = _data["dateRead"] ? new Date(_data["dateRead"].toString()) : <any>undefined;
            this.dateChanged = _data["dateChanged"] ? new Date(_data["dateChanged"].toString()) : <any>undefined;
            this.employeeIdTo = _data["employeeIdTo"];
            this.showToEmployee = _data["showToEmployee"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GetEmployeeFileDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeFileDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isDone"] = this.isDone;
        data["isCategory"] = this.isCategory;
        data["adminUserFromId"] = this.adminUserFromId;
        data["adminUserToId"] = this.adminUserToId;
        data["signatureImage"] = this.signatureImage;
        data["employeeId"] = this.employeeId;
        data["isRead"] = this.isRead;
        data["isRejected"] = this.isRejected;
        data["dateRead"] = this.dateRead ? this.dateRead.toISOString() : <any>undefined;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toISOString() : <any>undefined;
        data["employeeIdTo"] = this.employeeIdTo;
        data["showToEmployee"] = this.showToEmployee;
        data["text"] = this.text;
        return data;
    }
}

export interface IGetEmployeeFileDetailResponse {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    signatureImage?: string | undefined;
    employeeId?: number | undefined;
    isRead?: boolean;
    isRejected?: boolean;
    dateRead?: Date | undefined;
    dateChanged?: Date | undefined;
    employeeIdTo?: number | undefined;
    showToEmployee?: boolean;
    text?: string | undefined;
}

export class GetEmployeeFileDocumentsResponse implements IGetEmployeeFileDocumentsResponse {
    files?: EmployeeFileDTO[] | undefined;

    constructor(data?: IGetEmployeeFileDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(EmployeeFileDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeFileDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeFileDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeeFileDocumentsResponse {
    files?: EmployeeFileDTO[] | undefined;
}

export class GetEmployeeFilesTreeResponse implements IGetEmployeeFilesTreeResponse {
    files?: FileDirectoryDTO[] | undefined;

    constructor(data?: IGetEmployeeFilesTreeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeFilesTreeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeFilesTreeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeeFilesTreeResponse {
    files?: FileDirectoryDTO[] | undefined;
}

export class GetEmployeeForBuildingResponse implements IGetEmployeeForBuildingResponse {
    employees?: EmployeeDTO[] | undefined;

    constructor(data?: IGetEmployeeForBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeForBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeeForBuildingResponse {
    employees?: EmployeeDTO[] | undefined;
}

export class GetEmployeeGroupsForAdminUserResponse implements IGetEmployeeGroupsForAdminUserResponse {
    employeeGroups?: EmployeeGroupsDTO[] | undefined;

    constructor(data?: IGetEmployeeGroupsForAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["employeeGroups"])
                    this.employeeGroups!.push(EmployeeGroupsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeGroupsForAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeGroupsForAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeGroups)) {
            data["employeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["employeeGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeeGroupsForAdminUserResponse {
    employeeGroups?: EmployeeGroupsDTO[] | undefined;
}

export class GetEmployeeGroupsNamesResponse implements IGetEmployeeGroupsNamesResponse {
    employeeGroupsNames?: EmployeeGroupNameDTO[] | undefined;

    constructor(data?: IGetEmployeeGroupsNamesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeGroupsNames"])) {
                this.employeeGroupsNames = [] as any;
                for (let item of _data["employeeGroupsNames"])
                    this.employeeGroupsNames!.push(EmployeeGroupNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeGroupsNamesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeGroupsNamesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeGroupsNames)) {
            data["employeeGroupsNames"] = [];
            for (let item of this.employeeGroupsNames)
                data["employeeGroupsNames"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeeGroupsNamesResponse {
    employeeGroupsNames?: EmployeeGroupNameDTO[] | undefined;
}

export class GetEmployeeGroupsResponse implements IGetEmployeeGroupsResponse {
    groups?: EmployeeGroupListDTO[] | undefined;

    constructor(data?: IGetEmployeeGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(EmployeeGroupListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeeGroupsResponse {
    groups?: EmployeeGroupListDTO[] | undefined;
}

export class GetEmployeesForAdminUserResponse implements IGetEmployeesForAdminUserResponse {
    employees?: EmployeeDTO[] | undefined;

    constructor(data?: IGetEmployeesForAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeesForAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesForAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeesForAdminUserResponse {
    employees?: EmployeeDTO[] | undefined;
}

export class GetEmployeesListResponse implements IGetEmployeesListResponse {
    employees?: EmployeeListDTO[] | undefined;

    constructor(data?: IGetEmployeesListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeesListResponse {
    employees?: EmployeeListDTO[] | undefined;
}

export class GetEmployeesPermissionsResponse implements IGetEmployeesPermissionsResponse {
    employeesBasic?: boolean;
    employeesBozp?: boolean;
    employeesCreate?: boolean;
    employeesDelete?: boolean;
    employeesDetail?: boolean;
    employeesDocuments?: boolean;
    employeesEdit?: boolean;
    employeesEditWage?: boolean;
    employeesHoliday?: boolean;
    employeesList?: boolean;
    employeesLittleWealth?: boolean;
    employeesPersonal?: boolean;
    employeesRecords?: boolean;
    employeesRecountWage?: boolean;
    employeesResetPin?: boolean;
    employeesWealth?: boolean;
    employeesWealthExpenditures?: boolean;

    constructor(data?: IGetEmployeesPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeesBasic = _data["employeesBasic"];
            this.employeesBozp = _data["employeesBozp"];
            this.employeesCreate = _data["employeesCreate"];
            this.employeesDelete = _data["employeesDelete"];
            this.employeesDetail = _data["employeesDetail"];
            this.employeesDocuments = _data["employeesDocuments"];
            this.employeesEdit = _data["employeesEdit"];
            this.employeesEditWage = _data["employeesEditWage"];
            this.employeesHoliday = _data["employeesHoliday"];
            this.employeesList = _data["employeesList"];
            this.employeesLittleWealth = _data["employeesLittleWealth"];
            this.employeesPersonal = _data["employeesPersonal"];
            this.employeesRecords = _data["employeesRecords"];
            this.employeesRecountWage = _data["employeesRecountWage"];
            this.employeesResetPin = _data["employeesResetPin"];
            this.employeesWealth = _data["employeesWealth"];
            this.employeesWealthExpenditures = _data["employeesWealthExpenditures"];
        }
    }

    static fromJS(data: any): GetEmployeesPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeesBasic"] = this.employeesBasic;
        data["employeesBozp"] = this.employeesBozp;
        data["employeesCreate"] = this.employeesCreate;
        data["employeesDelete"] = this.employeesDelete;
        data["employeesDetail"] = this.employeesDetail;
        data["employeesDocuments"] = this.employeesDocuments;
        data["employeesEdit"] = this.employeesEdit;
        data["employeesEditWage"] = this.employeesEditWage;
        data["employeesHoliday"] = this.employeesHoliday;
        data["employeesList"] = this.employeesList;
        data["employeesLittleWealth"] = this.employeesLittleWealth;
        data["employeesPersonal"] = this.employeesPersonal;
        data["employeesRecords"] = this.employeesRecords;
        data["employeesRecountWage"] = this.employeesRecountWage;
        data["employeesResetPin"] = this.employeesResetPin;
        data["employeesWealth"] = this.employeesWealth;
        data["employeesWealthExpenditures"] = this.employeesWealthExpenditures;
        return data;
    }
}

export interface IGetEmployeesPermissionsResponse {
    employeesBasic?: boolean;
    employeesBozp?: boolean;
    employeesCreate?: boolean;
    employeesDelete?: boolean;
    employeesDetail?: boolean;
    employeesDocuments?: boolean;
    employeesEdit?: boolean;
    employeesEditWage?: boolean;
    employeesHoliday?: boolean;
    employeesList?: boolean;
    employeesLittleWealth?: boolean;
    employeesPersonal?: boolean;
    employeesRecords?: boolean;
    employeesRecountWage?: boolean;
    employeesResetPin?: boolean;
    employeesWealth?: boolean;
    employeesWealthExpenditures?: boolean;
}

export class GetEmployeesWealthResponse implements IGetEmployeesWealthResponse {
    ok?: boolean;
    message?: string | undefined;
    wealth?: MobileWealthDTO[] | undefined;

    constructor(data?: IGetEmployeesWealthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            if (Array.isArray(_data["wealth"])) {
                this.wealth = [] as any;
                for (let item of _data["wealth"])
                    this.wealth!.push(MobileWealthDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeesWealthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesWealthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        if (Array.isArray(this.wealth)) {
            data["wealth"] = [];
            for (let item of this.wealth)
                data["wealth"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeesWealthResponse {
    ok?: boolean;
    message?: string | undefined;
    wealth?: MobileWealthDTO[] | undefined;
}

export class GetEmployeesWithGroupsResponse implements IGetEmployeesWithGroupsResponse {
    employeesWithGroups?: EmployeeGroupDTO[] | undefined;

    constructor(data?: IGetEmployeesWithGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeesWithGroups"])) {
                this.employeesWithGroups = [] as any;
                for (let item of _data["employeesWithGroups"])
                    this.employeesWithGroups!.push(EmployeeGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeesWithGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesWithGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeesWithGroups)) {
            data["employeesWithGroups"] = [];
            for (let item of this.employeesWithGroups)
                data["employeesWithGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeesWithGroupsResponse {
    employeesWithGroups?: EmployeeGroupDTO[] | undefined;
}

export class GetFilesByIdForTodoZipRequest implements IGetFilesByIdForTodoZipRequest {
    todoId?: number;
    fileIds?: number[] | undefined;
    apiAdress?: string | undefined;

    constructor(data?: IGetFilesByIdForTodoZipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todoId = _data["todoId"];
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            this.apiAdress = _data["apiAdress"];
        }
    }

    static fromJS(data: any): GetFilesByIdForTodoZipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilesByIdForTodoZipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todoId"] = this.todoId;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        data["apiAdress"] = this.apiAdress;
        return data;
    }
}

export interface IGetFilesByIdForTodoZipRequest {
    todoId?: number;
    fileIds?: number[] | undefined;
    apiAdress?: string | undefined;
}

export class GetFilesFoldersForBuildingApplicationResponse implements IGetFilesFoldersForBuildingApplicationResponse {
    files?: FileDirectoryDTO[] | undefined;

    constructor(data?: IGetFilesFoldersForBuildingApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilesFoldersForBuildingApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilesFoldersForBuildingApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilesFoldersForBuildingApplicationResponse {
    files?: FileDirectoryDTO[] | undefined;
}

export class GetFilesFoldersForBuildingResponse implements IGetFilesFoldersForBuildingResponse {
    folders?: FileDirectoryDTO[] | undefined;

    constructor(data?: IGetFilesFoldersForBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(FileDirectoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilesFoldersForBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilesFoldersForBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilesFoldersForBuildingResponse {
    folders?: FileDirectoryDTO[] | undefined;
}

export class GetFilesForBuildingRecordResponse implements IGetFilesForBuildingRecordResponse {
    files?: FileDiaryDTO[] | undefined;

    constructor(data?: IGetFilesForBuildingRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilesForBuildingRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilesForBuildingRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilesForBuildingRecordResponse {
    files?: FileDiaryDTO[] | undefined;
}

export class GetFilesFromBuildingForDiaryResponse implements IGetFilesFromBuildingForDiaryResponse {
    files?: FileDirectoryDTO[] | undefined;

    constructor(data?: IGetFilesFromBuildingForDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilesFromBuildingForDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilesFromBuildingForDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilesFromBuildingForDiaryResponse {
    files?: FileDirectoryDTO[] | undefined;
}

export class GetGptDiaryDescriptionOneDayFromPhotosRequest implements IGetGptDiaryDescriptionOneDayFromPhotosRequest {
    diaryRecordId?: number;

    constructor(data?: IGetGptDiaryDescriptionOneDayFromPhotosRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
        }
    }

    static fromJS(data: any): GetGptDiaryDescriptionOneDayFromPhotosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGptDiaryDescriptionOneDayFromPhotosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        return data;
    }
}

export interface IGetGptDiaryDescriptionOneDayFromPhotosRequest {
    diaryRecordId?: number;
}

export class GetGptDiaryDescriptionOneDayFromPhotosResponse implements IGetGptDiaryDescriptionOneDayFromPhotosResponse {
    dailyRecord?: string | undefined;

    constructor(data?: IGetGptDiaryDescriptionOneDayFromPhotosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyRecord = _data["dailyRecord"];
        }
    }

    static fromJS(data: any): GetGptDiaryDescriptionOneDayFromPhotosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGptDiaryDescriptionOneDayFromPhotosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyRecord"] = this.dailyRecord;
        return data;
    }
}

export interface IGetGptDiaryDescriptionOneDayFromPhotosResponse {
    dailyRecord?: string | undefined;
}

export class GetGptDiaryDescriptionsFromPhotosRequest implements IGetGptDiaryDescriptionsFromPhotosRequest {
    start?: Date;
    end?: Date;
    buildingId?: number;
    buildingDiaryId?: number;

    constructor(data?: IGetGptDiaryDescriptionsFromPhotosRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.buildingDiaryId = _data["buildingDiaryId"];
        }
    }

    static fromJS(data: any): GetGptDiaryDescriptionsFromPhotosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGptDiaryDescriptionsFromPhotosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["buildingDiaryId"] = this.buildingDiaryId;
        return data;
    }
}

export interface IGetGptDiaryDescriptionsFromPhotosRequest {
    start?: Date;
    end?: Date;
    buildingId?: number;
    buildingDiaryId?: number;
}

export class GetGptDiaryDescriptionsFromPhotosResponse implements IGetGptDiaryDescriptionsFromPhotosResponse {

    constructor(data?: IGetGptDiaryDescriptionsFromPhotosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGptDiaryDescriptionsFromPhotosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGptDiaryDescriptionsFromPhotosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGptDiaryDescriptionsFromPhotosResponse {
}

export class GetHasUnreadBozpDocumentsNewsMobileResponse implements IGetHasUnreadBozpDocumentsNewsMobileResponse {
    unread?: boolean;

    constructor(data?: IGetHasUnreadBozpDocumentsNewsMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unread = _data["unread"];
        }
    }

    static fromJS(data: any): GetHasUnreadBozpDocumentsNewsMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHasUnreadBozpDocumentsNewsMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unread"] = this.unread;
        return data;
    }
}

export interface IGetHasUnreadBozpDocumentsNewsMobileResponse {
    unread?: boolean;
}

export class GetHasUnreadDocumentsMobileResponse implements IGetHasUnreadDocumentsMobileResponse {
    unread?: boolean;

    constructor(data?: IGetHasUnreadDocumentsMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unread = _data["unread"];
        }
    }

    static fromJS(data: any): GetHasUnreadDocumentsMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHasUnreadDocumentsMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unread"] = this.unread;
        return data;
    }
}

export interface IGetHasUnreadDocumentsMobileResponse {
    unread?: boolean;
}

export class GetHintForUserResponse implements IGetHintForUserResponse {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    isSuperAdmin?: boolean;

    constructor(data?: IGetHintForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): GetHintForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHintForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface IGetHintForUserResponse {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    isSuperAdmin?: boolean;
}

export class GetImageCategoriesResponse implements IGetImageCategoriesResponse {
    categories?: ImageCategoryMobileDTO[] | undefined;

    constructor(data?: IGetImageCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ImageCategoryMobileDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetImageCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetImageCategoriesResponse {
    categories?: ImageCategoryMobileDTO[] | undefined;
}

export class GetImagesBuildingResponse implements IGetImagesBuildingResponse {
    images?: ImageDiaryDTO[] | undefined;
    categories?: ImageCategoryDTO[] | undefined;

    constructor(data?: IGetImagesBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDiaryDTO.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ImageCategoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetImagesBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetImagesBuildingResponse {
    images?: ImageDiaryDTO[] | undefined;
    categories?: ImageCategoryDTO[] | undefined;
}

export class GetImagesByIdForBuildingZipRequest implements IGetImagesByIdForBuildingZipRequest {
    buildingId?: number;
    imageIds?: number[] | undefined;
    apiAdress?: string | undefined;

    constructor(data?: IGetImagesByIdForBuildingZipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
            this.apiAdress = _data["apiAdress"];
        }
    }

    static fromJS(data: any): GetImagesByIdForBuildingZipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesByIdForBuildingZipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        data["apiAdress"] = this.apiAdress;
        return data;
    }
}

export interface IGetImagesByIdForBuildingZipRequest {
    buildingId?: number;
    imageIds?: number[] | undefined;
    apiAdress?: string | undefined;
}

export class GetImagesByIdForDiaryRecordZipInvestorRequest implements IGetImagesByIdForDiaryRecordZipInvestorRequest {
    diaryRecordId?: number;
    selectedImages?: string[] | undefined;

    constructor(data?: IGetImagesByIdForDiaryRecordZipInvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            if (Array.isArray(_data["selectedImages"])) {
                this.selectedImages = [] as any;
                for (let item of _data["selectedImages"])
                    this.selectedImages!.push(item);
            }
        }
    }

    static fromJS(data: any): GetImagesByIdForDiaryRecordZipInvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesByIdForDiaryRecordZipInvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        if (Array.isArray(this.selectedImages)) {
            data["selectedImages"] = [];
            for (let item of this.selectedImages)
                data["selectedImages"].push(item);
        }
        return data;
    }
}

export interface IGetImagesByIdForDiaryRecordZipInvestorRequest {
    diaryRecordId?: number;
    selectedImages?: string[] | undefined;
}

export class GetImagesByIdForDiaryRecordZipRequest implements IGetImagesByIdForDiaryRecordZipRequest {
    diaryRecordId?: number;
    selectedImages?: string[] | undefined;

    constructor(data?: IGetImagesByIdForDiaryRecordZipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            if (Array.isArray(_data["selectedImages"])) {
                this.selectedImages = [] as any;
                for (let item of _data["selectedImages"])
                    this.selectedImages!.push(item);
            }
        }
    }

    static fromJS(data: any): GetImagesByIdForDiaryRecordZipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesByIdForDiaryRecordZipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        if (Array.isArray(this.selectedImages)) {
            data["selectedImages"] = [];
            for (let item of this.selectedImages)
                data["selectedImages"].push(item);
        }
        return data;
    }
}

export interface IGetImagesByIdForDiaryRecordZipRequest {
    diaryRecordId?: number;
    selectedImages?: string[] | undefined;
}

export class GetImagesInvestorResponse implements IGetImagesInvestorResponse {
    images?: ImageDiaryDTO[] | undefined;

    constructor(data?: IGetImagesInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetImagesInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetImagesInvestorResponse {
    images?: ImageDiaryDTO[] | undefined;
}

export class GetImagesUrlsForRecordResponse implements IGetImagesUrlsForRecordResponse {
    images?: ImageDiaryDTO[] | undefined;
    prompts?: PromptDTO[] | undefined;

    constructor(data?: IGetImagesUrlsForRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDiaryDTO.fromJS(item));
            }
            if (Array.isArray(_data["prompts"])) {
                this.prompts = [] as any;
                for (let item of _data["prompts"])
                    this.prompts!.push(PromptDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetImagesUrlsForRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesUrlsForRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.prompts)) {
            data["prompts"] = [];
            for (let item of this.prompts)
                data["prompts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetImagesUrlsForRecordResponse {
    images?: ImageDiaryDTO[] | undefined;
    prompts?: PromptDTO[] | undefined;
}

export class GetImageUrlsForDiaryResponse implements IGetImageUrlsForDiaryResponse {
    images?: ImageDiaryDTO[] | undefined;

    constructor(data?: IGetImageUrlsForDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetImageUrlsForDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageUrlsForDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetImageUrlsForDiaryResponse {
    images?: ImageDiaryDTO[] | undefined;
}

export class GetInvestorBuildingsRequest implements IGetInvestorBuildingsRequest {

    constructor(data?: IGetInvestorBuildingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetInvestorBuildingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorBuildingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetInvestorBuildingsRequest {
}

export class GetInvestorBuildingsResponse implements IGetInvestorBuildingsResponse {
    buildings?: BuildingInfoDTO[] | undefined;

    constructor(data?: IGetInvestorBuildingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(BuildingInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvestorBuildingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorBuildingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvestorBuildingsResponse {
    buildings?: BuildingInfoDTO[] | undefined;
}

export class GetInvestorDiaryRecordsResponse implements IGetInvestorDiaryRecordsResponse {
    records?: GetDailyRecordsForUserDTO[] | undefined;

    constructor(data?: IGetInvestorDiaryRecordsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(GetDailyRecordsForUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvestorDiaryRecordsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorDiaryRecordsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvestorDiaryRecordsResponse {
    records?: GetDailyRecordsForUserDTO[] | undefined;
}

export class GetInvestorDochazkaResponse implements IGetInvestorDochazkaResponse {
    dochazkaRecords?: DochazkaRecordDTO[] | undefined;

    constructor(data?: IGetInvestorDochazkaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dochazkaRecords"])) {
                this.dochazkaRecords = [] as any;
                for (let item of _data["dochazkaRecords"])
                    this.dochazkaRecords!.push(DochazkaRecordDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvestorDochazkaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorDochazkaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dochazkaRecords)) {
            data["dochazkaRecords"] = [];
            for (let item of this.dochazkaRecords)
                data["dochazkaRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvestorDochazkaResponse {
    dochazkaRecords?: DochazkaRecordDTO[] | undefined;
}

export class GetInvestorInfoResponse implements IGetInvestorInfoResponse {
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IGetInvestorInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetInvestorInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        return data;
    }
}

export interface IGetInvestorInfoResponse {
    name?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
}

export class GetInvestorRolesResponse implements IGetInvestorRolesResponse {
    roles?: InvestorRoleDTO[] | undefined;

    constructor(data?: IGetInvestorRolesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(InvestorRoleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvestorRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvestorRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvestorRolesResponse {
    roles?: InvestorRoleDTO[] | undefined;
}

export class GetInvoiceDataDetailResponse implements IGetInvoiceDataDetailResponse {
    id?: number;
    name?: string | undefined;
    isDone?: boolean;
    isApproved?: boolean;
    isPostponed?: boolean;
    isPosted?: boolean;
    dateTaxable?: Date;
    dateExpire?: Date;
    adminUserFrom?: number | undefined;
    adminUserTo?: number | undefined;
    supplier?: string | undefined;
    dateReceive?: Date | undefined;
    variableSymbol?: string | undefined;
    subject?: string | undefined;
    paymentPayerBankNumber?: string | undefined;
    paymentPayerBankCode?: string | undefined;
    paymentRecipientBankNumber?: string | undefined;
    paymentRecipientBankCode?: string | undefined;
    paymentDueDate?: Date | undefined;
    paymentRecipientName?: string | undefined;
    paymentMessage?: string | undefined;
    paymentVariableSymbol?: string | undefined;
    paymentConstantSymbol?: string | undefined;
    paymentSpecificSymbol?: string | undefined;
    comments?: string | undefined;
    commentAdd?: string | undefined;
    changeLogs?: ChangeLogRecord[] | undefined;
    files?: InvoiceFileDTO[] | undefined;
    buildingId?: number;

    constructor(data?: IGetInvoiceDataDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDone = _data["isDone"];
            this.isApproved = _data["isApproved"];
            this.isPostponed = _data["isPostponed"];
            this.isPosted = _data["isPosted"];
            this.dateTaxable = _data["dateTaxable"] ? new Date(_data["dateTaxable"].toString()) : <any>undefined;
            this.dateExpire = _data["dateExpire"] ? new Date(_data["dateExpire"].toString()) : <any>undefined;
            this.adminUserFrom = _data["adminUserFrom"];
            this.adminUserTo = _data["adminUserTo"];
            this.supplier = _data["supplier"];
            this.dateReceive = _data["dateReceive"] ? new Date(_data["dateReceive"].toString()) : <any>undefined;
            this.variableSymbol = _data["variableSymbol"];
            this.subject = _data["subject"];
            this.paymentPayerBankNumber = _data["paymentPayerBankNumber"];
            this.paymentPayerBankCode = _data["paymentPayerBankCode"];
            this.paymentRecipientBankNumber = _data["paymentRecipientBankNumber"];
            this.paymentRecipientBankCode = _data["paymentRecipientBankCode"];
            this.paymentDueDate = _data["paymentDueDate"] ? new Date(_data["paymentDueDate"].toString()) : <any>undefined;
            this.paymentRecipientName = _data["paymentRecipientName"];
            this.paymentMessage = _data["paymentMessage"];
            this.paymentVariableSymbol = _data["paymentVariableSymbol"];
            this.paymentConstantSymbol = _data["paymentConstantSymbol"];
            this.paymentSpecificSymbol = _data["paymentSpecificSymbol"];
            this.comments = _data["comments"];
            this.commentAdd = _data["commentAdd"];
            if (Array.isArray(_data["changeLogs"])) {
                this.changeLogs = [] as any;
                for (let item of _data["changeLogs"])
                    this.changeLogs!.push(ChangeLogRecord.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(InvoiceFileDTO.fromJS(item));
            }
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): GetInvoiceDataDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceDataDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDone"] = this.isDone;
        data["isApproved"] = this.isApproved;
        data["isPostponed"] = this.isPostponed;
        data["isPosted"] = this.isPosted;
        data["dateTaxable"] = this.dateTaxable ? this.dateTaxable.toISOString() : <any>undefined;
        data["dateExpire"] = this.dateExpire ? this.dateExpire.toISOString() : <any>undefined;
        data["adminUserFrom"] = this.adminUserFrom;
        data["adminUserTo"] = this.adminUserTo;
        data["supplier"] = this.supplier;
        data["dateReceive"] = this.dateReceive ? this.dateReceive.toISOString() : <any>undefined;
        data["variableSymbol"] = this.variableSymbol;
        data["subject"] = this.subject;
        data["paymentPayerBankNumber"] = this.paymentPayerBankNumber;
        data["paymentPayerBankCode"] = this.paymentPayerBankCode;
        data["paymentRecipientBankNumber"] = this.paymentRecipientBankNumber;
        data["paymentRecipientBankCode"] = this.paymentRecipientBankCode;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : <any>undefined;
        data["paymentRecipientName"] = this.paymentRecipientName;
        data["paymentMessage"] = this.paymentMessage;
        data["paymentVariableSymbol"] = this.paymentVariableSymbol;
        data["paymentConstantSymbol"] = this.paymentConstantSymbol;
        data["paymentSpecificSymbol"] = this.paymentSpecificSymbol;
        data["comments"] = this.comments;
        data["commentAdd"] = this.commentAdd;
        if (Array.isArray(this.changeLogs)) {
            data["changeLogs"] = [];
            for (let item of this.changeLogs)
                data["changeLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["buildingId"] = this.buildingId;
        return data;
    }
}

export interface IGetInvoiceDataDetailResponse {
    id?: number;
    name?: string | undefined;
    isDone?: boolean;
    isApproved?: boolean;
    isPostponed?: boolean;
    isPosted?: boolean;
    dateTaxable?: Date;
    dateExpire?: Date;
    adminUserFrom?: number | undefined;
    adminUserTo?: number | undefined;
    supplier?: string | undefined;
    dateReceive?: Date | undefined;
    variableSymbol?: string | undefined;
    subject?: string | undefined;
    paymentPayerBankNumber?: string | undefined;
    paymentPayerBankCode?: string | undefined;
    paymentRecipientBankNumber?: string | undefined;
    paymentRecipientBankCode?: string | undefined;
    paymentDueDate?: Date | undefined;
    paymentRecipientName?: string | undefined;
    paymentMessage?: string | undefined;
    paymentVariableSymbol?: string | undefined;
    paymentConstantSymbol?: string | undefined;
    paymentSpecificSymbol?: string | undefined;
    comments?: string | undefined;
    commentAdd?: string | undefined;
    changeLogs?: ChangeLogRecord[] | undefined;
    files?: InvoiceFileDTO[] | undefined;
    buildingId?: number;
}

export class GetInvoiceItemsResponse implements IGetInvoiceItemsResponse {
    currency?: string | undefined;
    invoiceItems?: InvoiceItem[] | undefined;

    constructor(data?: IGetInvoiceItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvoiceItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvoiceItemsResponse {
    currency?: string | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
}

export class GetIsStockUniqueIdentCodeResponse implements IGetIsStockUniqueIdentCodeResponse {
    isCode?: boolean;

    constructor(data?: IGetIsStockUniqueIdentCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCode = _data["isCode"];
        }
    }

    static fromJS(data: any): GetIsStockUniqueIdentCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIsStockUniqueIdentCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCode"] = this.isCode;
        return data;
    }
}

export interface IGetIsStockUniqueIdentCodeResponse {
    isCode?: boolean;
}

export class GetJokeForUserResponse implements IGetJokeForUserResponse {
    heading?: string | undefined;
    content?: string | undefined;
    id?: number;
    isSuperAdmin?: boolean;

    constructor(data?: IGetJokeForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.id = _data["id"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): GetJokeForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJokeForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["id"] = this.id;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface IGetJokeForUserResponse {
    heading?: string | undefined;
    content?: string | undefined;
    id?: number;
    isSuperAdmin?: boolean;
}

export class GetKrosAdminUserInfoResponse implements IGetKrosAdminUserInfoResponse {
    user?: AdminUsersDTO;

    constructor(data?: IGetKrosAdminUserInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? AdminUsersDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKrosAdminUserInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKrosAdminUserInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetKrosAdminUserInfoResponse {
    user?: AdminUsersDTO;
}

export class GetKrossUserTenantListResponse implements IGetKrossUserTenantListResponse {
    tenants?: UserTenantDTO[] | undefined;

    constructor(data?: IGetKrossUserTenantListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(UserTenantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKrossUserTenantListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKrossUserTenantListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKrossUserTenantListResponse {
    tenants?: UserTenantDTO[] | undefined;
}

export class GetLastRecordWithBreakResponse implements IGetLastRecordWithBreakResponse {
    action?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    date?: Date | undefined;
    type?: string | undefined;

    constructor(data?: IGetLastRecordWithBreakResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetLastRecordWithBreakResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLastRecordWithBreakResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetLastRecordWithBreakResponse {
    action?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    date?: Date | undefined;
    type?: string | undefined;
}

export class GetMachinesForRecordTableDTO implements IGetMachinesForRecordTableDTO {
    selected?: boolean;
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    created?: Date;
    lastUpdate?: Date;
    isShared?: boolean;
    adminCreatorId?: number | undefined;
    adminCreatorName?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IGetMachinesForRecordTableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.isShared = _data["isShared"];
            this.adminCreatorId = _data["adminCreatorId"];
            this.adminCreatorName = _data["adminCreatorName"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GetMachinesForRecordTableDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetMachinesForRecordTableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["isShared"] = this.isShared;
        data["adminCreatorId"] = this.adminCreatorId;
        data["adminCreatorName"] = this.adminCreatorName;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGetMachinesForRecordTableDTO {
    selected?: boolean;
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    created?: Date;
    lastUpdate?: Date;
    isShared?: boolean;
    adminCreatorId?: number | undefined;
    adminCreatorName?: string | undefined;
    isDeleted?: boolean;
}

export class GetMachinesForRecordTableRequest implements IGetMachinesForRecordTableRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetMachinesForRecordTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetMachinesForRecordTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMachinesForRecordTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetMachinesForRecordTableRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetMachinesForRecordTableResponse implements IGetMachinesForRecordTableResponse {
    machines?: GetMachinesForRecordTableDTO[] | undefined;

    constructor(data?: IGetMachinesForRecordTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(GetMachinesForRecordTableDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMachinesForRecordTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMachinesForRecordTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMachinesForRecordTableResponse {
    machines?: GetMachinesForRecordTableDTO[] | undefined;
}

export class GetMachinesForRecordTableSubcontractorRequest implements IGetMachinesForRecordTableSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetMachinesForRecordTableSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetMachinesForRecordTableSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMachinesForRecordTableSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetMachinesForRecordTableSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetManufacturerDataDetailResponse implements IGetManufacturerDataDetailResponse {
    id?: number;
    name?: string | undefined;

    constructor(data?: IGetManufacturerDataDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetManufacturerDataDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturerDataDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetManufacturerDataDetailResponse {
    id?: number;
    name?: string | undefined;
}

export class GetManufacturersListPageResponse implements IGetManufacturersListPageResponse {
    manufacturersListPage?: ManufacturerListPageDTO[] | undefined;

    constructor(data?: IGetManufacturersListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["manufacturersListPage"])) {
                this.manufacturersListPage = [] as any;
                for (let item of _data["manufacturersListPage"])
                    this.manufacturersListPage!.push(ManufacturerListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManufacturersListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturersListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturersListPage)) {
            data["manufacturersListPage"] = [];
            for (let item of this.manufacturersListPage)
                data["manufacturersListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetManufacturersListPageResponse {
    manufacturersListPage?: ManufacturerListPageDTO[] | undefined;
}

export class GetMaterialsForRecordsExcelRequest implements IGetMaterialsForRecordsExcelRequest {
    diaryId?: number;
    start?: Date;
    end?: Date;

    constructor(data?: IGetMaterialsForRecordsExcelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMaterialsForRecordsExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordsExcelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMaterialsForRecordsExcelRequest {
    diaryId?: number;
    start?: Date;
    end?: Date;
}

export class GetMaterialsForRecordsExcelResponse implements IGetMaterialsForRecordsExcelResponse {
    materials?: GetMaterialsForRecordTableDTO[] | undefined;

    constructor(data?: IGetMaterialsForRecordsExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(GetMaterialsForRecordTableDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMaterialsForRecordsExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordsExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMaterialsForRecordsExcelResponse {
    materials?: GetMaterialsForRecordTableDTO[] | undefined;
}

export class GetMaterialsForRecordsExcelSubcontractorRequest implements IGetMaterialsForRecordsExcelSubcontractorRequest {
    diaryId?: number;
    start?: Date;
    end?: Date;

    constructor(data?: IGetMaterialsForRecordsExcelSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMaterialsForRecordsExcelSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordsExcelSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMaterialsForRecordsExcelSubcontractorRequest {
    diaryId?: number;
    start?: Date;
    end?: Date;
}

export class GetMaterialsForRecordsExcelSubcontractorResponse implements IGetMaterialsForRecordsExcelSubcontractorResponse {
    materials?: GetMaterialsForRecordTableDTO[] | undefined;

    constructor(data?: IGetMaterialsForRecordsExcelSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(GetMaterialsForRecordTableDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMaterialsForRecordsExcelSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordsExcelSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMaterialsForRecordsExcelSubcontractorResponse {
    materials?: GetMaterialsForRecordTableDTO[] | undefined;
}

export class GetMaterialsForRecordTableDTO implements IGetMaterialsForRecordTableDTO {
    selected?: boolean;
    id?: number;
    name?: string | undefined;
    amount?: number | undefined;
    unit?: string | undefined;
    created?: Date;
    lastUpdate?: Date;
    isShared?: boolean;
    adminCreatorId?: number | undefined;
    adminCreatorName?: string | undefined;
    diaryDate?: Date;
    isDeleted?: boolean;

    constructor(data?: IGetMaterialsForRecordTableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.isShared = _data["isShared"];
            this.adminCreatorId = _data["adminCreatorId"];
            this.adminCreatorName = _data["adminCreatorName"];
            this.diaryDate = _data["diaryDate"] ? new Date(_data["diaryDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GetMaterialsForRecordTableDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordTableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["id"] = this.id;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["isShared"] = this.isShared;
        data["adminCreatorId"] = this.adminCreatorId;
        data["adminCreatorName"] = this.adminCreatorName;
        data["diaryDate"] = this.diaryDate ? this.diaryDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGetMaterialsForRecordTableDTO {
    selected?: boolean;
    id?: number;
    name?: string | undefined;
    amount?: number | undefined;
    unit?: string | undefined;
    created?: Date;
    lastUpdate?: Date;
    isShared?: boolean;
    adminCreatorId?: number | undefined;
    adminCreatorName?: string | undefined;
    diaryDate?: Date;
    isDeleted?: boolean;
}

export class GetMaterialsForRecordTableRequest implements IGetMaterialsForRecordTableRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetMaterialsForRecordTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetMaterialsForRecordTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetMaterialsForRecordTableRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetMaterialsForRecordTableResponse implements IGetMaterialsForRecordTableResponse {
    materials?: GetMaterialsForRecordTableDTO[] | undefined;

    constructor(data?: IGetMaterialsForRecordTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(GetMaterialsForRecordTableDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMaterialsForRecordTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMaterialsForRecordTableResponse {
    materials?: GetMaterialsForRecordTableDTO[] | undefined;
}

export class GetMaterialsForRecordTableSubcontractorRequest implements IGetMaterialsForRecordTableSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetMaterialsForRecordTableSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetMaterialsForRecordTableSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForRecordTableSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetMaterialsForRecordTableSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetMeasureUnitsListPageResponse implements IGetMeasureUnitsListPageResponse {
    measureUnitsListPage?: MeasureUnitListPageDTO[] | undefined;

    constructor(data?: IGetMeasureUnitsListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["measureUnitsListPage"])) {
                this.measureUnitsListPage = [] as any;
                for (let item of _data["measureUnitsListPage"])
                    this.measureUnitsListPage!.push(MeasureUnitListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMeasureUnitsListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasureUnitsListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.measureUnitsListPage)) {
            data["measureUnitsListPage"] = [];
            for (let item of this.measureUnitsListPage)
                data["measureUnitsListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMeasureUnitsListPageResponse {
    measureUnitsListPage?: MeasureUnitListPageDTO[] | undefined;
}

export class GetMeDetailResponse implements IGetMeDetailResponse {
    id?: number;
    initials?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    modulesVisibility?: GetModulesVisibilityResponse;

    constructor(data?: IGetMeDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.initials = _data["initials"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.modulesVisibility = _data["modulesVisibility"] ? GetModulesVisibilityResponse.fromJS(_data["modulesVisibility"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMeDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["initials"] = this.initials;
        data["name"] = this.name;
        data["email"] = this.email;
        data["modulesVisibility"] = this.modulesVisibility ? this.modulesVisibility.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMeDetailResponse {
    id?: number;
    initials?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    modulesVisibility?: GetModulesVisibilityResponse;
}

export class GetMobileDiaryRecordResponse implements IGetMobileDiaryRecordResponse {
    diaryRecord?: MobileDiaryRecordDTO;

    constructor(data?: IGetMobileDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecord = _data["diaryRecord"] ? MobileDiaryRecordDTO.fromJS(_data["diaryRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMobileDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMobileDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecord"] = this.diaryRecord ? this.diaryRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMobileDiaryRecordResponse {
    diaryRecord?: MobileDiaryRecordDTO;
}

export class GetModulesVisibilityResponse implements IGetModulesVisibilityResponse {
    dashboard?: boolean;
    projects?: boolean;
    diary?: boolean;
    wealth?: boolean;
    employees?: boolean;
    warehouse?: boolean;
    requests?: boolean;
    reports?: boolean;
    documents?: boolean;
    settings?: boolean;

    constructor(data?: IGetModulesVisibilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboard = _data["dashboard"];
            this.projects = _data["projects"];
            this.diary = _data["diary"];
            this.wealth = _data["wealth"];
            this.employees = _data["employees"];
            this.warehouse = _data["warehouse"];
            this.requests = _data["requests"];
            this.reports = _data["reports"];
            this.documents = _data["documents"];
            this.settings = _data["settings"];
        }
    }

    static fromJS(data: any): GetModulesVisibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModulesVisibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboard"] = this.dashboard;
        data["projects"] = this.projects;
        data["diary"] = this.diary;
        data["wealth"] = this.wealth;
        data["employees"] = this.employees;
        data["warehouse"] = this.warehouse;
        data["requests"] = this.requests;
        data["reports"] = this.reports;
        data["documents"] = this.documents;
        data["settings"] = this.settings;
        return data;
    }
}

export interface IGetModulesVisibilityResponse {
    dashboard?: boolean;
    projects?: boolean;
    diary?: boolean;
    wealth?: boolean;
    employees?: boolean;
    warehouse?: boolean;
    requests?: boolean;
    reports?: boolean;
    documents?: boolean;
    settings?: boolean;
}

export class GetOptionsForCustomFieldEnumTypeResponse implements IGetOptionsForCustomFieldEnumTypeResponse {
    customFieldOptions?: CustomFieldOptionDto[] | undefined;

    constructor(data?: IGetOptionsForCustomFieldEnumTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customFieldOptions"])) {
                this.customFieldOptions = [] as any;
                for (let item of _data["customFieldOptions"])
                    this.customFieldOptions!.push(CustomFieldOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOptionsForCustomFieldEnumTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOptionsForCustomFieldEnumTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customFieldOptions)) {
            data["customFieldOptions"] = [];
            for (let item of this.customFieldOptions)
                data["customFieldOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOptionsForCustomFieldEnumTypeResponse {
    customFieldOptions?: CustomFieldOptionDto[] | undefined;
}

export class GetPhotosFromBuildingToDiaryChooseResponse implements IGetPhotosFromBuildingToDiaryChooseResponse {
    images?: ImageDiaryDTO[] | undefined;

    constructor(data?: IGetPhotosFromBuildingToDiaryChooseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPhotosFromBuildingToDiaryChooseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPhotosFromBuildingToDiaryChooseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPhotosFromBuildingToDiaryChooseResponse {
    images?: ImageDiaryDTO[] | undefined;
}

export class GetPrintDiaryInDateRangeRequest implements IGetPrintDiaryInDateRangeRequest {
    diaryId?: number;
    onlyMyNotes?: boolean;
    hasDigitalSignatureField?: boolean;
    hasAttachments?: boolean;
    otherUserId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    hasPhotos?: boolean;

    constructor(data?: IGetPrintDiaryInDateRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.onlyMyNotes = _data["onlyMyNotes"];
            this.hasDigitalSignatureField = _data["hasDigitalSignatureField"];
            this.hasAttachments = _data["hasAttachments"];
            this.otherUserId = _data["otherUserId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.hasPhotos = _data["hasPhotos"];
        }
    }

    static fromJS(data: any): GetPrintDiaryInDateRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintDiaryInDateRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["onlyMyNotes"] = this.onlyMyNotes;
        data["hasDigitalSignatureField"] = this.hasDigitalSignatureField;
        data["hasAttachments"] = this.hasAttachments;
        data["otherUserId"] = this.otherUserId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["hasPhotos"] = this.hasPhotos;
        return data;
    }
}

export interface IGetPrintDiaryInDateRangeRequest {
    diaryId?: number;
    onlyMyNotes?: boolean;
    hasDigitalSignatureField?: boolean;
    hasAttachments?: boolean;
    otherUserId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    hasPhotos?: boolean;
}

export class GetPrintStatusRequest implements IGetPrintStatusRequest {
    diaryId?: number;
    onlyMyNotes?: boolean;
    hasDigitalSignatureField?: boolean;
    hasAttachments?: boolean;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;

    constructor(data?: IGetPrintStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.onlyMyNotes = _data["onlyMyNotes"];
            this.hasDigitalSignatureField = _data["hasDigitalSignatureField"];
            this.hasAttachments = _data["hasAttachments"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPrintStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["onlyMyNotes"] = this.onlyMyNotes;
        data["hasDigitalSignatureField"] = this.hasDigitalSignatureField;
        data["hasAttachments"] = this.hasAttachments;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPrintStatusRequest {
    diaryId?: number;
    onlyMyNotes?: boolean;
    hasDigitalSignatureField?: boolean;
    hasAttachments?: boolean;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
}

export class GetPrintStatusResponse implements IGetPrintStatusResponse {
    canDirectlyPrint?: boolean;

    constructor(data?: IGetPrintStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canDirectlyPrint = _data["canDirectlyPrint"];
        }
    }

    static fromJS(data: any): GetPrintStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canDirectlyPrint"] = this.canDirectlyPrint;
        return data;
    }
}

export interface IGetPrintStatusResponse {
    canDirectlyPrint?: boolean;
}

export class GetPrintWholeDiaryInDateRangeOldErpResponse implements IGetPrintWholeDiaryInDateRangeOldErpResponse {
    downloadUri?: string | undefined;

    constructor(data?: IGetPrintWholeDiaryInDateRangeOldErpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUri = _data["downloadUri"];
        }
    }

    static fromJS(data: any): GetPrintWholeDiaryInDateRangeOldErpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintWholeDiaryInDateRangeOldErpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUri"] = this.downloadUri;
        return data;
    }
}

export interface IGetPrintWholeDiaryInDateRangeOldErpResponse {
    downloadUri?: string | undefined;
}

export class GetPrintWholeDiaryOldErpResponse implements IGetPrintWholeDiaryOldErpResponse {
    downloadUri?: string | undefined;

    constructor(data?: IGetPrintWholeDiaryOldErpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUri = _data["downloadUri"];
        }
    }

    static fromJS(data: any): GetPrintWholeDiaryOldErpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintWholeDiaryOldErpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUri"] = this.downloadUri;
        return data;
    }
}

export interface IGetPrintWholeDiaryOldErpResponse {
    downloadUri?: string | undefined;
}

export class GetPrintWholeSubcontractorDiaryOldErpResponse implements IGetPrintWholeSubcontractorDiaryOldErpResponse {
    downloadUri?: string | undefined;

    constructor(data?: IGetPrintWholeSubcontractorDiaryOldErpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUri = _data["downloadUri"];
        }
    }

    static fromJS(data: any): GetPrintWholeSubcontractorDiaryOldErpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintWholeSubcontractorDiaryOldErpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUri"] = this.downloadUri;
        return data;
    }
}

export interface IGetPrintWholeSubcontractorDiaryOldErpResponse {
    downloadUri?: string | undefined;
}

export class GetProductCategoriesListPageResponse implements IGetProductCategoriesListPageResponse {
    productCategoriesListPage?: ProductCategoryListPageDTO[] | undefined;

    constructor(data?: IGetProductCategoriesListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCategoriesListPage"])) {
                this.productCategoriesListPage = [] as any;
                for (let item of _data["productCategoriesListPage"])
                    this.productCategoriesListPage!.push(ProductCategoryListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductCategoriesListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductCategoriesListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCategoriesListPage)) {
            data["productCategoriesListPage"] = [];
            for (let item of this.productCategoriesListPage)
                data["productCategoriesListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductCategoriesListPageResponse {
    productCategoriesListPage?: ProductCategoryListPageDTO[] | undefined;
}

export class GetProductCategoryDataDetailResponse implements IGetProductCategoryDataDetailResponse {
    id?: number;
    name?: string | undefined;

    constructor(data?: IGetProductCategoryDataDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetProductCategoryDataDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductCategoryDataDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetProductCategoryDataDetailResponse {
    id?: number;
    name?: string | undefined;
}

export class GetProductDataDetailResponse implements IGetProductDataDetailResponse {
    id?: number;
    stockManufacturerId?: number | undefined;
    stockProductCategoryId?: number | undefined;
    measureUnitId?: number | undefined;
    code?: string | undefined;
    eanCode?: string | undefined;
    name?: string | undefined;
    text?: string | undefined;
    rentPrice1?: number | undefined;
    unitWeight?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IGetProductDataDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockManufacturerId = _data["stockManufacturerId"];
            this.stockProductCategoryId = _data["stockProductCategoryId"];
            this.measureUnitId = _data["measureUnitId"];
            this.code = _data["code"];
            this.eanCode = _data["eanCode"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.rentPrice1 = _data["rentPrice1"];
            this.unitWeight = _data["unitWeight"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetProductDataDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductDataDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockManufacturerId"] = this.stockManufacturerId;
        data["stockProductCategoryId"] = this.stockProductCategoryId;
        data["measureUnitId"] = this.measureUnitId;
        data["code"] = this.code;
        data["eanCode"] = this.eanCode;
        data["name"] = this.name;
        data["text"] = this.text;
        data["rentPrice1"] = this.rentPrice1;
        data["unitWeight"] = this.unitWeight;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetProductDataDetailResponse {
    id?: number;
    stockManufacturerId?: number | undefined;
    stockProductCategoryId?: number | undefined;
    measureUnitId?: number | undefined;
    code?: string | undefined;
    eanCode?: string | undefined;
    name?: string | undefined;
    text?: string | undefined;
    rentPrice1?: number | undefined;
    unitWeight?: number | undefined;
    isActive?: boolean | undefined;
}

export class GetProductMovementsListPageRequest implements IGetProductMovementsListPageRequest {
    productId?: number;
    lang?: string | undefined;

    constructor(data?: IGetProductMovementsListPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetProductMovementsListPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMovementsListPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetProductMovementsListPageRequest {
    productId?: number;
    lang?: string | undefined;
}

export class GetProductMovementsListPageResponse implements IGetProductMovementsListPageResponse {
    productMovementListPage?: ProductMovementListPageDTO[] | undefined;

    constructor(data?: IGetProductMovementsListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productMovementListPage"])) {
                this.productMovementListPage = [] as any;
                for (let item of _data["productMovementListPage"])
                    this.productMovementListPage!.push(ProductMovementListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductMovementsListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMovementsListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productMovementListPage)) {
            data["productMovementListPage"] = [];
            for (let item of this.productMovementListPage)
                data["productMovementListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductMovementsListPageResponse {
    productMovementListPage?: ProductMovementListPageDTO[] | undefined;
}

export class GetProductsForDiaryDialogResponse implements IGetProductsForDiaryDialogResponse {
    productsForDiaryDialog?: ProductForDiaryDialogDTO[] | undefined;

    constructor(data?: IGetProductsForDiaryDialogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productsForDiaryDialog"])) {
                this.productsForDiaryDialog = [] as any;
                for (let item of _data["productsForDiaryDialog"])
                    this.productsForDiaryDialog!.push(ProductForDiaryDialogDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductsForDiaryDialogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductsForDiaryDialogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productsForDiaryDialog)) {
            data["productsForDiaryDialog"] = [];
            for (let item of this.productsForDiaryDialog)
                data["productsForDiaryDialog"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductsForDiaryDialogResponse {
    productsForDiaryDialog?: ProductForDiaryDialogDTO[] | undefined;
}

export class GetProductsListPageResponse implements IGetProductsListPageResponse {
    productsListPage?: ProductListPageDTO[] | undefined;

    constructor(data?: IGetProductsListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productsListPage"])) {
                this.productsListPage = [] as any;
                for (let item of _data["productsListPage"])
                    this.productsListPage!.push(ProductListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductsListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductsListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productsListPage)) {
            data["productsListPage"] = [];
            for (let item of this.productsListPage)
                data["productsListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductsListPageResponse {
    productsListPage?: ProductListPageDTO[] | undefined;
}

export class GetProjectFileDetailResponse implements IGetProjectFileDetailResponse {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    investorId?: number | undefined;
    showToClient?: boolean;
    signatureImage?: string | undefined;
    emailTemplateId?: number | undefined;
    canOrderSolution?: boolean;
    parentId?: number | undefined;

    constructor(data?: IGetProjectFileDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.isDone = _data["isDone"];
            this.isCategory = _data["isCategory"];
            this.adminUserFromId = _data["adminUserFromId"];
            this.adminUserToId = _data["adminUserToId"];
            this.investorId = _data["investorId"];
            this.showToClient = _data["showToClient"];
            this.signatureImage = _data["signatureImage"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.canOrderSolution = _data["canOrderSolution"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): GetProjectFileDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectFileDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isDone"] = this.isDone;
        data["isCategory"] = this.isCategory;
        data["adminUserFromId"] = this.adminUserFromId;
        data["adminUserToId"] = this.adminUserToId;
        data["investorId"] = this.investorId;
        data["showToClient"] = this.showToClient;
        data["signatureImage"] = this.signatureImage;
        data["emailTemplateId"] = this.emailTemplateId;
        data["canOrderSolution"] = this.canOrderSolution;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IGetProjectFileDetailResponse {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    investorId?: number | undefined;
    showToClient?: boolean;
    signatureImage?: string | undefined;
    emailTemplateId?: number | undefined;
    canOrderSolution?: boolean;
    parentId?: number | undefined;
}

export class GetProjectFileDocumentsResponse implements IGetProjectFileDocumentsResponse {
    files?: BuildingFileDTO[] | undefined;

    constructor(data?: IGetProjectFileDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(BuildingFileDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectFileDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectFileDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectFileDocumentsResponse {
    files?: BuildingFileDTO[] | undefined;
}

export class GetProjectFilesTreeResponse implements IGetProjectFilesTreeResponse {
    files?: FileDirectoryDTO[] | undefined;

    constructor(data?: IGetProjectFilesTreeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDirectoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectFilesTreeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectFilesTreeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectFilesTreeResponse {
    files?: FileDirectoryDTO[] | undefined;
}

export class GetRequestConversationResponse implements IGetRequestConversationResponse {
    conversation?: RequestConversationDTO[] | undefined;

    constructor(data?: IGetRequestConversationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conversation"])) {
                this.conversation = [] as any;
                for (let item of _data["conversation"])
                    this.conversation!.push(RequestConversationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRequestConversationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestConversationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversation)) {
            data["conversation"] = [];
            for (let item of this.conversation)
                data["conversation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRequestConversationResponse {
    conversation?: RequestConversationDTO[] | undefined;
}

export class GetRequestDetailResponse implements IGetRequestDetailResponse {
    request?: RequestResponseWithBuildingDTO;

    constructor(data?: IGetRequestDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? RequestResponseWithBuildingDTO.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequestDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRequestDetailResponse {
    request?: RequestResponseWithBuildingDTO;
}

export class GetRequestEyetowerDataResponse implements IGetRequestEyetowerDataResponse {
    data?: RequestEyetowerData;

    constructor(data?: IGetRequestEyetowerDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RequestEyetowerData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequestEyetowerDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestEyetowerDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRequestEyetowerDataResponse {
    data?: RequestEyetowerData;
}

export class GetRequestMessagesEmployeeMobileResponse implements IGetRequestMessagesEmployeeMobileResponse {
    messages?: MessageWithDateDTO[] | undefined;

    constructor(data?: IGetRequestMessagesEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageWithDateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRequestMessagesEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestMessagesEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRequestMessagesEmployeeMobileResponse {
    messages?: MessageWithDateDTO[] | undefined;
}

export class GetRequestResponse implements IGetRequestResponse {
    request?: RequestsDTO;

    constructor(data?: IGetRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? RequestsDTO.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRequestResponse {
    request?: RequestsDTO;
}

export class GetRequestsPermissionsResponse implements IGetRequestsPermissionsResponse {
    requestsCreate?: boolean;
    requestsDelete?: boolean;
    requestsDetail?: boolean;
    requestsEdit?: boolean;
    requestsList?: boolean;
    requestsLog?: boolean;
    requestsShowEmployeeFlow?: boolean;
    requestsShowOnlyItemsForMe?: boolean;

    constructor(data?: IGetRequestsPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestsCreate = _data["requestsCreate"];
            this.requestsDelete = _data["requestsDelete"];
            this.requestsDetail = _data["requestsDetail"];
            this.requestsEdit = _data["requestsEdit"];
            this.requestsList = _data["requestsList"];
            this.requestsLog = _data["requestsLog"];
            this.requestsShowEmployeeFlow = _data["requestsShowEmployeeFlow"];
            this.requestsShowOnlyItemsForMe = _data["requestsShowOnlyItemsForMe"];
        }
    }

    static fromJS(data: any): GetRequestsPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestsPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestsCreate"] = this.requestsCreate;
        data["requestsDelete"] = this.requestsDelete;
        data["requestsDetail"] = this.requestsDetail;
        data["requestsEdit"] = this.requestsEdit;
        data["requestsList"] = this.requestsList;
        data["requestsLog"] = this.requestsLog;
        data["requestsShowEmployeeFlow"] = this.requestsShowEmployeeFlow;
        data["requestsShowOnlyItemsForMe"] = this.requestsShowOnlyItemsForMe;
        return data;
    }
}

export interface IGetRequestsPermissionsResponse {
    requestsCreate?: boolean;
    requestsDelete?: boolean;
    requestsDetail?: boolean;
    requestsEdit?: boolean;
    requestsList?: boolean;
    requestsLog?: boolean;
    requestsShowEmployeeFlow?: boolean;
    requestsShowOnlyItemsForMe?: boolean;
}

export class GetRequestsResponse implements IGetRequestsResponse {
    requests?: RequestsDTO[] | undefined;

    constructor(data?: IGetRequestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(RequestsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRequestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRequestsResponse {
    requests?: RequestsDTO[] | undefined;
}

export class GetSignatureForEmployeeResponse implements IGetSignatureForEmployeeResponse {
    signature?: SignatureEmployeeDTO;

    constructor(data?: IGetSignatureForEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signature = _data["signature"] ? SignatureEmployeeDTO.fromJS(_data["signature"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSignatureForEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSignatureForEmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signature"] = this.signature ? this.signature.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSignatureForEmployeeResponse {
    signature?: SignatureEmployeeDTO;
}

export class GetSignaturesForRecordResponse implements IGetSignaturesForRecordResponse {
    signedByLoggedIn?: boolean;
    digitalSignaturePath?: string | undefined;
    signatures?: SignatureDTO[] | undefined;

    constructor(data?: IGetSignaturesForRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signedByLoggedIn = _data["signedByLoggedIn"];
            this.digitalSignaturePath = _data["digitalSignaturePath"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(SignatureDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSignaturesForRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSignaturesForRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signedByLoggedIn"] = this.signedByLoggedIn;
        data["digitalSignaturePath"] = this.digitalSignaturePath;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSignaturesForRecordResponse {
    signedByLoggedIn?: boolean;
    digitalSignaturePath?: string | undefined;
    signatures?: SignatureDTO[] | undefined;
}

export class GetSignInformationsForSigniWorkflowResponse implements IGetSignInformationsForSigniWorkflowResponse {
    users?: SignPeopleDTO[] | undefined;

    constructor(data?: IGetSignInformationsForSigniWorkflowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(SignPeopleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSignInformationsForSigniWorkflowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSignInformationsForSigniWorkflowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSignInformationsForSigniWorkflowResponse {
    users?: SignPeopleDTO[] | undefined;
}

export class GetStatisticsKrosAdminResponse implements IGetStatisticsKrosAdminResponse {
    data?: StatisticsKrosAdminDTO;

    constructor(data?: IGetStatisticsKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StatisticsKrosAdminDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetStatisticsKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatisticsKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetStatisticsKrosAdminResponse {
    data?: StatisticsKrosAdminDTO;
}

export class GetStockItemsRequest implements IGetStockItemsRequest {
    stockListId?: number;
    lang?: string | undefined;

    constructor(data?: IGetStockItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockListId = _data["stockListId"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetStockItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockListId"] = this.stockListId;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetStockItemsRequest {
    stockListId?: number;
    lang?: string | undefined;
}

export class GetStockItemsResponse implements IGetStockItemsResponse {
    datetime?: Date;
    toWarehouseBuildingId?: number | undefined;
    toWarehouseId?: number | undefined;
    note?: string | undefined;
    stockItems?: StockItemDTO[] | undefined;

    constructor(data?: IGetStockItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.toWarehouseBuildingId = _data["toWarehouseBuildingId"];
            this.toWarehouseId = _data["toWarehouseId"];
            this.note = _data["note"];
            if (Array.isArray(_data["stockItems"])) {
                this.stockItems = [] as any;
                for (let item of _data["stockItems"])
                    this.stockItems!.push(StockItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStockItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["toWarehouseBuildingId"] = this.toWarehouseBuildingId;
        data["toWarehouseId"] = this.toWarehouseId;
        data["note"] = this.note;
        if (Array.isArray(this.stockItems)) {
            data["stockItems"] = [];
            for (let item of this.stockItems)
                data["stockItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStockItemsResponse {
    datetime?: Date;
    toWarehouseBuildingId?: number | undefined;
    toWarehouseId?: number | undefined;
    note?: string | undefined;
    stockItems?: StockItemDTO[] | undefined;
}

export class GetStockItemsWithPriceRequest implements IGetStockItemsWithPriceRequest {
    stockListId?: number;
    lang?: string | undefined;

    constructor(data?: IGetStockItemsWithPriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockListId = _data["stockListId"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetStockItemsWithPriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockItemsWithPriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockListId"] = this.stockListId;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetStockItemsWithPriceRequest {
    stockListId?: number;
    lang?: string | undefined;
}

export class GetStockItemsWithPriceResponse implements IGetStockItemsWithPriceResponse {
    datetime?: Date;
    toWarehouseBuildingId?: number | undefined;
    toWarehouseId?: number | undefined;
    note?: string | undefined;
    stockItems?: StockItemDTO[] | undefined;

    constructor(data?: IGetStockItemsWithPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.toWarehouseBuildingId = _data["toWarehouseBuildingId"];
            this.toWarehouseId = _data["toWarehouseId"];
            this.note = _data["note"];
            if (Array.isArray(_data["stockItems"])) {
                this.stockItems = [] as any;
                for (let item of _data["stockItems"])
                    this.stockItems!.push(StockItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStockItemsWithPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockItemsWithPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["toWarehouseBuildingId"] = this.toWarehouseBuildingId;
        data["toWarehouseId"] = this.toWarehouseId;
        data["note"] = this.note;
        if (Array.isArray(this.stockItems)) {
            data["stockItems"] = [];
            for (let item of this.stockItems)
                data["stockItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStockItemsWithPriceResponse {
    datetime?: Date;
    toWarehouseBuildingId?: number | undefined;
    toWarehouseId?: number | undefined;
    note?: string | undefined;
    stockItems?: StockItemDTO[] | undefined;
}

export class GetSubcontractorDiaryPermissionsResponse implements IGetSubcontractorDiaryPermissionsResponse {
    canViewDiaryList?: boolean;
    canViewDiaryDetail?: boolean;
    canCreateDiary?: boolean;
    canEditDiary?: boolean;
    canDeleteDiary?: boolean;
    canPrintDiary?: boolean;
    canPrintDiaryOwnRecords?: boolean;
    canViewDiaryRecordsList?: boolean;
    canViewDiaryRecordsDetail?: boolean;
    canCreateDiaryRecord?: boolean;
    canEditDiaryRecord?: boolean;
    canDeleteDiaryRecord?: boolean;
    canPrintDiaryRecord?: boolean;
    canPrintDiaryRecordOwnRecords?: boolean;
    canPrintDiaryRecordOthers?: boolean;
    subcontractorsViewOnlyTheirPage?: boolean;
    canLockDailyRecords?: boolean;
    canUnlockDailyRecords?: boolean;
    seeOtherComments?: boolean;
    writeCommonCompletedWorks?: boolean;
    readCommonCompletedWorks?: boolean;
    writeOthersDiary?: boolean;
    attachments?: boolean;
    directAttachments?: boolean;
    deleteAttachments?: boolean;
    investorsComments?: boolean;
    canSeeChangelog?: boolean;
    hasSigni?: boolean;
    canDeleteInsideRecords?: boolean;

    constructor(data?: IGetSubcontractorDiaryPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewDiaryList = _data["canViewDiaryList"];
            this.canViewDiaryDetail = _data["canViewDiaryDetail"];
            this.canCreateDiary = _data["canCreateDiary"];
            this.canEditDiary = _data["canEditDiary"];
            this.canDeleteDiary = _data["canDeleteDiary"];
            this.canPrintDiary = _data["canPrintDiary"];
            this.canPrintDiaryOwnRecords = _data["canPrintDiaryOwnRecords"];
            this.canViewDiaryRecordsList = _data["canViewDiaryRecordsList"];
            this.canViewDiaryRecordsDetail = _data["canViewDiaryRecordsDetail"];
            this.canCreateDiaryRecord = _data["canCreateDiaryRecord"];
            this.canEditDiaryRecord = _data["canEditDiaryRecord"];
            this.canDeleteDiaryRecord = _data["canDeleteDiaryRecord"];
            this.canPrintDiaryRecord = _data["canPrintDiaryRecord"];
            this.canPrintDiaryRecordOwnRecords = _data["canPrintDiaryRecordOwnRecords"];
            this.canPrintDiaryRecordOthers = _data["canPrintDiaryRecordOthers"];
            this.subcontractorsViewOnlyTheirPage = _data["subcontractorsViewOnlyTheirPage"];
            this.canLockDailyRecords = _data["canLockDailyRecords"];
            this.canUnlockDailyRecords = _data["canUnlockDailyRecords"];
            this.seeOtherComments = _data["seeOtherComments"];
            this.writeCommonCompletedWorks = _data["writeCommonCompletedWorks"];
            this.readCommonCompletedWorks = _data["readCommonCompletedWorks"];
            this.writeOthersDiary = _data["writeOthersDiary"];
            this.attachments = _data["attachments"];
            this.directAttachments = _data["directAttachments"];
            this.deleteAttachments = _data["deleteAttachments"];
            this.investorsComments = _data["investorsComments"];
            this.canSeeChangelog = _data["canSeeChangelog"];
            this.hasSigni = _data["hasSigni"];
            this.canDeleteInsideRecords = _data["canDeleteInsideRecords"];
        }
    }

    static fromJS(data: any): GetSubcontractorDiaryPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubcontractorDiaryPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewDiaryList"] = this.canViewDiaryList;
        data["canViewDiaryDetail"] = this.canViewDiaryDetail;
        data["canCreateDiary"] = this.canCreateDiary;
        data["canEditDiary"] = this.canEditDiary;
        data["canDeleteDiary"] = this.canDeleteDiary;
        data["canPrintDiary"] = this.canPrintDiary;
        data["canPrintDiaryOwnRecords"] = this.canPrintDiaryOwnRecords;
        data["canViewDiaryRecordsList"] = this.canViewDiaryRecordsList;
        data["canViewDiaryRecordsDetail"] = this.canViewDiaryRecordsDetail;
        data["canCreateDiaryRecord"] = this.canCreateDiaryRecord;
        data["canEditDiaryRecord"] = this.canEditDiaryRecord;
        data["canDeleteDiaryRecord"] = this.canDeleteDiaryRecord;
        data["canPrintDiaryRecord"] = this.canPrintDiaryRecord;
        data["canPrintDiaryRecordOwnRecords"] = this.canPrintDiaryRecordOwnRecords;
        data["canPrintDiaryRecordOthers"] = this.canPrintDiaryRecordOthers;
        data["subcontractorsViewOnlyTheirPage"] = this.subcontractorsViewOnlyTheirPage;
        data["canLockDailyRecords"] = this.canLockDailyRecords;
        data["canUnlockDailyRecords"] = this.canUnlockDailyRecords;
        data["seeOtherComments"] = this.seeOtherComments;
        data["writeCommonCompletedWorks"] = this.writeCommonCompletedWorks;
        data["readCommonCompletedWorks"] = this.readCommonCompletedWorks;
        data["writeOthersDiary"] = this.writeOthersDiary;
        data["attachments"] = this.attachments;
        data["directAttachments"] = this.directAttachments;
        data["deleteAttachments"] = this.deleteAttachments;
        data["investorsComments"] = this.investorsComments;
        data["canSeeChangelog"] = this.canSeeChangelog;
        data["hasSigni"] = this.hasSigni;
        data["canDeleteInsideRecords"] = this.canDeleteInsideRecords;
        return data;
    }
}

export interface IGetSubcontractorDiaryPermissionsResponse {
    canViewDiaryList?: boolean;
    canViewDiaryDetail?: boolean;
    canCreateDiary?: boolean;
    canEditDiary?: boolean;
    canDeleteDiary?: boolean;
    canPrintDiary?: boolean;
    canPrintDiaryOwnRecords?: boolean;
    canViewDiaryRecordsList?: boolean;
    canViewDiaryRecordsDetail?: boolean;
    canCreateDiaryRecord?: boolean;
    canEditDiaryRecord?: boolean;
    canDeleteDiaryRecord?: boolean;
    canPrintDiaryRecord?: boolean;
    canPrintDiaryRecordOwnRecords?: boolean;
    canPrintDiaryRecordOthers?: boolean;
    subcontractorsViewOnlyTheirPage?: boolean;
    canLockDailyRecords?: boolean;
    canUnlockDailyRecords?: boolean;
    seeOtherComments?: boolean;
    writeCommonCompletedWorks?: boolean;
    readCommonCompletedWorks?: boolean;
    writeOthersDiary?: boolean;
    attachments?: boolean;
    directAttachments?: boolean;
    deleteAttachments?: boolean;
    investorsComments?: boolean;
    canSeeChangelog?: boolean;
    hasSigni?: boolean;
    canDeleteInsideRecords?: boolean;
}

export class GetSubcontractorInfoRequest implements IGetSubcontractorInfoRequest {

    constructor(data?: IGetSubcontractorInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSubcontractorInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubcontractorInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSubcontractorInfoRequest {
}

export class GetSubcontractorInfoResponse implements IGetSubcontractorInfoResponse {
    userName?: string | undefined;
    companyName?: string | undefined;

    constructor(data?: IGetSubcontractorInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): GetSubcontractorInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubcontractorInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetSubcontractorInfoResponse {
    userName?: string | undefined;
    companyName?: string | undefined;
}

export class GetTaskDetailsResponse implements IGetTaskDetailsResponse {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: number;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeTo?: Date | undefined;
    datetimeCreated?: Date;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    wealthId?: number | undefined;
    showInGantt?: boolean;
    progress?: number;
    processingAdminUserId?: number | undefined;
    employeeIds?: number[] | undefined;
    investorIds?: number[] | undefined;
    predecessor?: string | undefined;

    constructor(data?: IGetTaskDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.datetimeStart = _data["datetimeStart"] ? new Date(_data["datetimeStart"].toString()) : <any>undefined;
            this.datetimeEnd = _data["datetimeEnd"] ? new Date(_data["datetimeEnd"].toString()) : <any>undefined;
            this.datetimeTo = _data["datetimeTo"] ? new Date(_data["datetimeTo"].toString()) : <any>undefined;
            this.datetimeCreated = _data["datetimeCreated"] ? new Date(_data["datetimeCreated"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.buildingDiaryId = _data["buildingDiaryId"];
            this.wealthId = _data["wealthId"];
            this.showInGantt = _data["showInGantt"];
            this.progress = _data["progress"];
            this.processingAdminUserId = _data["processingAdminUserId"];
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["investorIds"])) {
                this.investorIds = [] as any;
                for (let item of _data["investorIds"])
                    this.investorIds!.push(item);
            }
            this.predecessor = _data["predecessor"];
        }
    }

    static fromJS(data: any): GetTaskDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["datetimeStart"] = this.datetimeStart ? this.datetimeStart.toISOString() : <any>undefined;
        data["datetimeEnd"] = this.datetimeEnd ? this.datetimeEnd.toISOString() : <any>undefined;
        data["datetimeTo"] = this.datetimeTo ? this.datetimeTo.toISOString() : <any>undefined;
        data["datetimeCreated"] = this.datetimeCreated ? this.datetimeCreated.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["buildingDiaryId"] = this.buildingDiaryId;
        data["wealthId"] = this.wealthId;
        data["showInGantt"] = this.showInGantt;
        data["progress"] = this.progress;
        data["processingAdminUserId"] = this.processingAdminUserId;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.investorIds)) {
            data["investorIds"] = [];
            for (let item of this.investorIds)
                data["investorIds"].push(item);
        }
        data["predecessor"] = this.predecessor;
        return data;
    }
}

export interface IGetTaskDetailsResponse {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: number;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeTo?: Date | undefined;
    datetimeCreated?: Date;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    wealthId?: number | undefined;
    showInGantt?: boolean;
    progress?: number;
    processingAdminUserId?: number | undefined;
    employeeIds?: number[] | undefined;
    investorIds?: number[] | undefined;
    predecessor?: string | undefined;
}

export class GetTasksForAdminUserResponse implements IGetTasksForAdminUserResponse {
    tasks?: TaskDTO[] | undefined;

    constructor(data?: IGetTasksForAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTasksForAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksForAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTasksForAdminUserResponse {
    tasks?: TaskDTO[] | undefined;
}

export class GetTaxratesForInvoiceItemsResponse implements IGetTaxratesForInvoiceItemsResponse {
    taxrates?: TaxrateDTO[] | undefined;

    constructor(data?: IGetTaxratesForInvoiceItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taxrates"])) {
                this.taxrates = [] as any;
                for (let item of _data["taxrates"])
                    this.taxrates!.push(TaxrateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaxratesForInvoiceItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaxratesForInvoiceItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taxrates)) {
            data["taxrates"] = [];
            for (let item of this.taxrates)
                data["taxrates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTaxratesForInvoiceItemsResponse {
    taxrates?: TaxrateDTO[] | undefined;
}

export class GetTodoAllPossibleAssigneesResponse implements IGetTodoAllPossibleAssigneesResponse {
    data?: ToDoAssigneeDTO[] | undefined;

    constructor(data?: IGetTodoAllPossibleAssigneesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ToDoAssigneeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodoAllPossibleAssigneesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoAllPossibleAssigneesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodoAllPossibleAssigneesResponse {
    data?: ToDoAssigneeDTO[] | undefined;
}

export class GetTodoAllPossibleMessageAssigneesResponse implements IGetTodoAllPossibleMessageAssigneesResponse {
    data?: ToDoAssigneeDTO[] | undefined;

    constructor(data?: IGetTodoAllPossibleMessageAssigneesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ToDoAssigneeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodoAllPossibleMessageAssigneesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoAllPossibleMessageAssigneesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodoAllPossibleMessageAssigneesResponse {
    data?: ToDoAssigneeDTO[] | undefined;
}

export class GetTodoDetailResponse implements IGetTodoDetailResponse {
    data?: TodoDTO;

    constructor(data?: IGetTodoDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TodoDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTodoDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTodoDetailResponse {
    data?: TodoDTO;
}

export class GetTodoHistoryResponse implements IGetTodoHistoryResponse {
    logs?: TodoHistoryDTO[] | undefined;

    constructor(data?: IGetTodoHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(TodoHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodoHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodoHistoryResponse {
    logs?: TodoHistoryDTO[] | undefined;
}

export class GetTodoChatConversationsResponse implements IGetTodoChatConversationsResponse {
    conversation?: ConversationDto[] | undefined;

    constructor(data?: IGetTodoChatConversationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conversation"])) {
                this.conversation = [] as any;
                for (let item of _data["conversation"])
                    this.conversation!.push(ConversationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodoChatConversationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoChatConversationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversation)) {
            data["conversation"] = [];
            for (let item of this.conversation)
                data["conversation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodoChatConversationsResponse {
    conversation?: ConversationDto[] | undefined;
}

export class GetTodosAttachmentsListResponse implements IGetTodosAttachmentsListResponse {
    conversationFiles?: ConversationFileDto[] | undefined;

    constructor(data?: IGetTodosAttachmentsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conversationFiles"])) {
                this.conversationFiles = [] as any;
                for (let item of _data["conversationFiles"])
                    this.conversationFiles!.push(ConversationFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosAttachmentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosAttachmentsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversationFiles)) {
            data["conversationFiles"] = [];
            for (let item of this.conversationFiles)
                data["conversationFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosAttachmentsListResponse {
    conversationFiles?: ConversationFileDto[] | undefined;
}

export class GetTodosForDiaryDTO implements IGetTodosForDiaryDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    createdBy?: UserDTO;
    deadline?: Date | undefined;
    created?: Date | undefined;
    assignedTo?: string | undefined;
    resolvers?: UserDTO[] | undefined;

    constructor(data?: IGetTodosForDiaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"] ? UserDTO.fromJS(_data["createdBy"]) : <any>undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.assignedTo = _data["assignedTo"];
            if (Array.isArray(_data["resolvers"])) {
                this.resolvers = [] as any;
                for (let item of _data["resolvers"])
                    this.resolvers!.push(UserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosForDiaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosForDiaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["assignedTo"] = this.assignedTo;
        if (Array.isArray(this.resolvers)) {
            data["resolvers"] = [];
            for (let item of this.resolvers)
                data["resolvers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosForDiaryDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    createdBy?: UserDTO;
    deadline?: Date | undefined;
    created?: Date | undefined;
    assignedTo?: string | undefined;
    resolvers?: UserDTO[] | undefined;
}

export class GetTodosForDiaryResponse implements IGetTodosForDiaryResponse {
    todos?: GetTodosForDiaryDTO[] | undefined;

    constructor(data?: IGetTodosForDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(GetTodosForDiaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosForDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosForDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosForDiaryResponse {
    todos?: GetTodosForDiaryDTO[] | undefined;
}

export class GetTodosForGanttResponse implements IGetTodosForGanttResponse {
    todos?: TodoGanttDTO[] | undefined;

    constructor(data?: IGetTodosForGanttResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(TodoGanttDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosForGanttResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosForGanttResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosForGanttResponse {
    todos?: TodoGanttDTO[] | undefined;
}

export class GetTodosForUserAndMapResponse implements IGetTodosForUserAndMapResponse {
    todos?: TodoListDTO[] | undefined;

    constructor(data?: IGetTodosForUserAndMapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(TodoListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosForUserAndMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosForUserAndMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosForUserAndMapResponse {
    todos?: TodoListDTO[] | undefined;
}

export class GetTodosForUserResponse implements IGetTodosForUserResponse {
    todos?: TodoListDTO[] | undefined;

    constructor(data?: IGetTodosForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(TodoListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosForUserResponse {
    todos?: TodoListDTO[] | undefined;
}

export class GetTodosMapsListForProjectResponse implements IGetTodosMapsListForProjectResponse {
    imageMaps?: ImageMapDto[] | undefined;

    constructor(data?: IGetTodosMapsListForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageMaps"])) {
                this.imageMaps = [] as any;
                for (let item of _data["imageMaps"])
                    this.imageMaps!.push(ImageMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosMapsListForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosMapsListForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageMaps)) {
            data["imageMaps"] = [];
            for (let item of this.imageMaps)
                data["imageMaps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosMapsListForProjectResponse {
    imageMaps?: ImageMapDto[] | undefined;
}

export class GetTodosMapsListResponse implements IGetTodosMapsListResponse {
    imageMaps?: ImageMapDto[] | undefined;

    constructor(data?: IGetTodosMapsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageMaps"])) {
                this.imageMaps = [] as any;
                for (let item of _data["imageMaps"])
                    this.imageMaps!.push(ImageMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosMapsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosMapsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageMaps)) {
            data["imageMaps"] = [];
            for (let item of this.imageMaps)
                data["imageMaps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosMapsListResponse {
    imageMaps?: ImageMapDto[] | undefined;
}

export class GetUnreadMessagesCountResponse implements IGetUnreadMessagesCountResponse {
    newUnreadMessages?: number;
    activeUnreadMessages?: number;
    resolvedUnreadMessages?: number;

    constructor(data?: IGetUnreadMessagesCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUnreadMessages = _data["newUnreadMessages"];
            this.activeUnreadMessages = _data["activeUnreadMessages"];
            this.resolvedUnreadMessages = _data["resolvedUnreadMessages"];
        }
    }

    static fromJS(data: any): GetUnreadMessagesCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnreadMessagesCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUnreadMessages"] = this.newUnreadMessages;
        data["activeUnreadMessages"] = this.activeUnreadMessages;
        data["resolvedUnreadMessages"] = this.resolvedUnreadMessages;
        return data;
    }
}

export interface IGetUnreadMessagesCountResponse {
    newUnreadMessages?: number;
    activeUnreadMessages?: number;
    resolvedUnreadMessages?: number;
}

export class GetUserDataKrosAdminResponse implements IGetUserDataKrosAdminResponse {
    user?: AdminUsersDTO;

    constructor(data?: IGetUserDataKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? AdminUsersDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserDataKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDataKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserDataKrosAdminResponse {
    user?: AdminUsersDTO;
}

export class GetUserIdRequest implements IGetUserIdRequest {

    constructor(data?: IGetUserIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUserIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUserIdRequest {
}

export class GetUserIdResponse implements IGetUserIdResponse {
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IGetUserIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetUserIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["email"] = this.email;
        return data;
    }
}

export interface IGetUserIdResponse {
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;
}

export class GetUserRoleForSubcontractorResponse implements IGetUserRoleForSubcontractorResponse {
    roles?: UserRoleDTO[] | undefined;

    constructor(data?: IGetUserRoleForSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserRoleForSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRoleForSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserRoleForSubcontractorResponse {
    roles?: UserRoleDTO[] | undefined;
}

export class GetUsersAndEmployeesIdsAndNamesResponse implements IGetUsersAndEmployeesIdsAndNamesResponse {
    usersIdsAndNames?: UserIdAndNameDTO[] | undefined;
    employeesIdsAndNames?: EmployeeIdAndNameDTO[] | undefined;

    constructor(data?: IGetUsersAndEmployeesIdsAndNamesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["usersIdsAndNames"])) {
                this.usersIdsAndNames = [] as any;
                for (let item of _data["usersIdsAndNames"])
                    this.usersIdsAndNames!.push(UserIdAndNameDTO.fromJS(item));
            }
            if (Array.isArray(_data["employeesIdsAndNames"])) {
                this.employeesIdsAndNames = [] as any;
                for (let item of _data["employeesIdsAndNames"])
                    this.employeesIdsAndNames!.push(EmployeeIdAndNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersAndEmployeesIdsAndNamesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersAndEmployeesIdsAndNamesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.usersIdsAndNames)) {
            data["usersIdsAndNames"] = [];
            for (let item of this.usersIdsAndNames)
                data["usersIdsAndNames"].push(item.toJSON());
        }
        if (Array.isArray(this.employeesIdsAndNames)) {
            data["employeesIdsAndNames"] = [];
            for (let item of this.employeesIdsAndNames)
                data["employeesIdsAndNames"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersAndEmployeesIdsAndNamesResponse {
    usersIdsAndNames?: UserIdAndNameDTO[] | undefined;
    employeesIdsAndNames?: EmployeeIdAndNameDTO[] | undefined;
}

export class GetUsersBuildingResponse implements IGetUsersBuildingResponse {
    users?: UserResponsibleDTO[] | undefined;

    constructor(data?: IGetUsersBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserResponsibleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersBuildingResponse {
    users?: UserResponsibleDTO[] | undefined;
}

export class GetUsersForDiaryPrintResponse implements IGetUsersForDiaryPrintResponse {
    users?: UserDTO[] | undefined;

    constructor(data?: IGetUsersForDiaryPrintResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersForDiaryPrintResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersForDiaryPrintResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersForDiaryPrintResponse {
    users?: UserDTO[] | undefined;
}

export class GetUsersKrosAdminResponse implements IGetUsersKrosAdminResponse {
    users?: AdminUsersDTO[] | undefined;

    constructor(data?: IGetUsersKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AdminUsersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersKrosAdminResponse {
    users?: AdminUsersDTO[] | undefined;
}

export class GetWarehouseActionsRequest implements IGetWarehouseActionsRequest {
    warehouseId?: number;
    tabType?: WarehouseTabType;
    lang?: string | undefined;

    constructor(data?: IGetWarehouseActionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.tabType = _data["tabType"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetWarehouseActionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseActionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["tabType"] = this.tabType;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetWarehouseActionsRequest {
    warehouseId?: number;
    tabType?: WarehouseTabType;
    lang?: string | undefined;
}

export class GetWarehouseActionsResponse implements IGetWarehouseActionsResponse {
    stockInOutListSign?: boolean;
    warehouseActions?: WarehouseActionDTO[] | undefined;

    constructor(data?: IGetWarehouseActionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockInOutListSign = _data["stockInOutListSign"];
            if (Array.isArray(_data["warehouseActions"])) {
                this.warehouseActions = [] as any;
                for (let item of _data["warehouseActions"])
                    this.warehouseActions!.push(WarehouseActionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehouseActionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseActionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockInOutListSign"] = this.stockInOutListSign;
        if (Array.isArray(this.warehouseActions)) {
            data["warehouseActions"] = [];
            for (let item of this.warehouseActions)
                data["warehouseActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehouseActionsResponse {
    stockInOutListSign?: boolean;
    warehouseActions?: WarehouseActionDTO[] | undefined;
}

export class GetWarehouseDataDetailResponse implements IGetWarehouseDataDetailResponse {
    id?: number;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    name?: string | undefined;
    central?: boolean;
    inMenu?: boolean;
    isActive?: boolean;
    openActionCount?: number;
    reservationCount?: number;
    stockInOutListSign?: boolean;

    constructor(data?: IGetWarehouseDataDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.name = _data["name"];
            this.central = _data["central"];
            this.inMenu = _data["inMenu"];
            this.isActive = _data["isActive"];
            this.openActionCount = _data["openActionCount"];
            this.reservationCount = _data["reservationCount"];
            this.stockInOutListSign = _data["stockInOutListSign"];
        }
    }

    static fromJS(data: any): GetWarehouseDataDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseDataDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["name"] = this.name;
        data["central"] = this.central;
        data["inMenu"] = this.inMenu;
        data["isActive"] = this.isActive;
        data["openActionCount"] = this.openActionCount;
        data["reservationCount"] = this.reservationCount;
        data["stockInOutListSign"] = this.stockInOutListSign;
        return data;
    }
}

export interface IGetWarehouseDataDetailResponse {
    id?: number;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    name?: string | undefined;
    central?: boolean;
    inMenu?: boolean;
    isActive?: boolean;
    openActionCount?: number;
    reservationCount?: number;
    stockInOutListSign?: boolean;
}

export class GetWarehouseProductsListPageRequest implements IGetWarehouseProductsListPageRequest {
    warehouseId?: number;
    lang?: string | undefined;

    constructor(data?: IGetWarehouseProductsListPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetWarehouseProductsListPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseProductsListPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetWarehouseProductsListPageRequest {
    warehouseId?: number;
    lang?: string | undefined;
}

export class GetWarehouseProductsListPageResponse implements IGetWarehouseProductsListPageResponse {
    warehouseProductsListPage?: WarehouseProductListPageDTO[] | undefined;

    constructor(data?: IGetWarehouseProductsListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouseProductsListPage"])) {
                this.warehouseProductsListPage = [] as any;
                for (let item of _data["warehouseProductsListPage"])
                    this.warehouseProductsListPage!.push(WarehouseProductListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehouseProductsListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseProductsListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseProductsListPage)) {
            data["warehouseProductsListPage"] = [];
            for (let item of this.warehouseProductsListPage)
                data["warehouseProductsListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehouseProductsListPageResponse {
    warehouseProductsListPage?: WarehouseProductListPageDTO[] | undefined;
}

export class GetWarehouseProductsWithPriceListPageRequest implements IGetWarehouseProductsWithPriceListPageRequest {
    warehouseId?: number;
    lang?: string | undefined;

    constructor(data?: IGetWarehouseProductsWithPriceListPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetWarehouseProductsWithPriceListPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseProductsWithPriceListPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetWarehouseProductsWithPriceListPageRequest {
    warehouseId?: number;
    lang?: string | undefined;
}

export class GetWarehouseProductsWithPriceListPageResponse implements IGetWarehouseProductsWithPriceListPageResponse {
    warehouseProductsListPage?: WarehouseProductListPageDTO[] | undefined;

    constructor(data?: IGetWarehouseProductsWithPriceListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouseProductsListPage"])) {
                this.warehouseProductsListPage = [] as any;
                for (let item of _data["warehouseProductsListPage"])
                    this.warehouseProductsListPage!.push(WarehouseProductListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehouseProductsWithPriceListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseProductsWithPriceListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseProductsListPage)) {
            data["warehouseProductsListPage"] = [];
            for (let item of this.warehouseProductsListPage)
                data["warehouseProductsListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehouseProductsWithPriceListPageResponse {
    warehouseProductsListPage?: WarehouseProductListPageDTO[] | undefined;
}

export class GetWarehousesByBuildingIdResponse implements IGetWarehousesByBuildingIdResponse {
    warehouses?: WarehouseDTO[] | undefined;

    constructor(data?: IGetWarehousesByBuildingIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouses"])) {
                this.warehouses = [] as any;
                for (let item of _data["warehouses"])
                    this.warehouses!.push(WarehouseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehousesByBuildingIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehousesByBuildingIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouses)) {
            data["warehouses"] = [];
            for (let item of this.warehouses)
                data["warehouses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehousesByBuildingIdResponse {
    warehouses?: WarehouseDTO[] | undefined;
}

export class GetWarehousesForAdminUserResponse implements IGetWarehousesForAdminUserResponse {
    warehouses?: WarehouseDTO[] | undefined;

    constructor(data?: IGetWarehousesForAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouses"])) {
                this.warehouses = [] as any;
                for (let item of _data["warehouses"])
                    this.warehouses!.push(WarehouseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehousesForAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehousesForAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouses)) {
            data["warehouses"] = [];
            for (let item of this.warehouses)
                data["warehouses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehousesForAdminUserResponse {
    warehouses?: WarehouseDTO[] | undefined;
}

export class GetWarehousesListPageResponse implements IGetWarehousesListPageResponse {
    warehousesListPage?: WarehouseListPageDTO[] | undefined;

    constructor(data?: IGetWarehousesListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehousesListPage"])) {
                this.warehousesListPage = [] as any;
                for (let item of _data["warehousesListPage"])
                    this.warehousesListPage!.push(WarehouseListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehousesListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehousesListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehousesListPage)) {
            data["warehousesListPage"] = [];
            for (let item of this.warehousesListPage)
                data["warehousesListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehousesListPageResponse {
    warehousesListPage?: WarehouseListPageDTO[] | undefined;
}

export class GetWarehousesPermissionsResponse implements IGetWarehousesPermissionsResponse {
    stockListsStockPermBlock?: boolean;
    stockWarehousesList?: boolean;
    stockWarehousesDetail?: boolean;
    stockWarehousesCreate?: boolean;
    stockWarehousesEdit?: boolean;
    stockWarehousesDelete?: boolean;
    stockProductsList?: boolean;
    stockProductsDetail?: boolean;
    stockProductsCreate?: boolean;
    stockProductsEdit?: boolean;
    stockProductsDelete?: boolean;
    stockManufacturersList?: boolean;
    stockManufacturersDetail?: boolean;
    stockManufacturersCreate?: boolean;
    stockManufacturersEdit?: boolean;
    stockManufacturersDelete?: boolean;
    stockProductCategoriesList?: boolean;
    stockProductCategoriesDetail?: boolean;
    stockProductCategoriesCreate?: boolean;
    stockProductCategoriesEdit?: boolean;
    stockProductCategoriesDelete?: boolean;

    constructor(data?: IGetWarehousesPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockListsStockPermBlock = _data["stockListsStockPermBlock"];
            this.stockWarehousesList = _data["stockWarehousesList"];
            this.stockWarehousesDetail = _data["stockWarehousesDetail"];
            this.stockWarehousesCreate = _data["stockWarehousesCreate"];
            this.stockWarehousesEdit = _data["stockWarehousesEdit"];
            this.stockWarehousesDelete = _data["stockWarehousesDelete"];
            this.stockProductsList = _data["stockProductsList"];
            this.stockProductsDetail = _data["stockProductsDetail"];
            this.stockProductsCreate = _data["stockProductsCreate"];
            this.stockProductsEdit = _data["stockProductsEdit"];
            this.stockProductsDelete = _data["stockProductsDelete"];
            this.stockManufacturersList = _data["stockManufacturersList"];
            this.stockManufacturersDetail = _data["stockManufacturersDetail"];
            this.stockManufacturersCreate = _data["stockManufacturersCreate"];
            this.stockManufacturersEdit = _data["stockManufacturersEdit"];
            this.stockManufacturersDelete = _data["stockManufacturersDelete"];
            this.stockProductCategoriesList = _data["stockProductCategoriesList"];
            this.stockProductCategoriesDetail = _data["stockProductCategoriesDetail"];
            this.stockProductCategoriesCreate = _data["stockProductCategoriesCreate"];
            this.stockProductCategoriesEdit = _data["stockProductCategoriesEdit"];
            this.stockProductCategoriesDelete = _data["stockProductCategoriesDelete"];
        }
    }

    static fromJS(data: any): GetWarehousesPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehousesPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockListsStockPermBlock"] = this.stockListsStockPermBlock;
        data["stockWarehousesList"] = this.stockWarehousesList;
        data["stockWarehousesDetail"] = this.stockWarehousesDetail;
        data["stockWarehousesCreate"] = this.stockWarehousesCreate;
        data["stockWarehousesEdit"] = this.stockWarehousesEdit;
        data["stockWarehousesDelete"] = this.stockWarehousesDelete;
        data["stockProductsList"] = this.stockProductsList;
        data["stockProductsDetail"] = this.stockProductsDetail;
        data["stockProductsCreate"] = this.stockProductsCreate;
        data["stockProductsEdit"] = this.stockProductsEdit;
        data["stockProductsDelete"] = this.stockProductsDelete;
        data["stockManufacturersList"] = this.stockManufacturersList;
        data["stockManufacturersDetail"] = this.stockManufacturersDetail;
        data["stockManufacturersCreate"] = this.stockManufacturersCreate;
        data["stockManufacturersEdit"] = this.stockManufacturersEdit;
        data["stockManufacturersDelete"] = this.stockManufacturersDelete;
        data["stockProductCategoriesList"] = this.stockProductCategoriesList;
        data["stockProductCategoriesDetail"] = this.stockProductCategoriesDetail;
        data["stockProductCategoriesCreate"] = this.stockProductCategoriesCreate;
        data["stockProductCategoriesEdit"] = this.stockProductCategoriesEdit;
        data["stockProductCategoriesDelete"] = this.stockProductCategoriesDelete;
        return data;
    }
}

export interface IGetWarehousesPermissionsResponse {
    stockListsStockPermBlock?: boolean;
    stockWarehousesList?: boolean;
    stockWarehousesDetail?: boolean;
    stockWarehousesCreate?: boolean;
    stockWarehousesEdit?: boolean;
    stockWarehousesDelete?: boolean;
    stockProductsList?: boolean;
    stockProductsDetail?: boolean;
    stockProductsCreate?: boolean;
    stockProductsEdit?: boolean;
    stockProductsDelete?: boolean;
    stockManufacturersList?: boolean;
    stockManufacturersDetail?: boolean;
    stockManufacturersCreate?: boolean;
    stockManufacturersEdit?: boolean;
    stockManufacturersDelete?: boolean;
    stockProductCategoriesList?: boolean;
    stockProductCategoriesDetail?: boolean;
    stockProductCategoriesCreate?: boolean;
    stockProductCategoriesEdit?: boolean;
    stockProductCategoriesDelete?: boolean;
}

export class GetWarehousesReportListPageRequest implements IGetWarehousesReportListPageRequest {
    warehouseId?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    isBuy?: boolean;
    isIn?: boolean;
    isBlock?: boolean;
    isOut?: boolean;
    isUtility?: boolean;
    isWriteOff?: boolean;
    lang?: string | undefined;

    constructor(data?: IGetWarehousesReportListPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.isBuy = _data["isBuy"];
            this.isIn = _data["isIn"];
            this.isBlock = _data["isBlock"];
            this.isOut = _data["isOut"];
            this.isUtility = _data["isUtility"];
            this.isWriteOff = _data["isWriteOff"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetWarehousesReportListPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehousesReportListPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["isBuy"] = this.isBuy;
        data["isIn"] = this.isIn;
        data["isBlock"] = this.isBlock;
        data["isOut"] = this.isOut;
        data["isUtility"] = this.isUtility;
        data["isWriteOff"] = this.isWriteOff;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetWarehousesReportListPageRequest {
    warehouseId?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    isBuy?: boolean;
    isIn?: boolean;
    isBlock?: boolean;
    isOut?: boolean;
    isUtility?: boolean;
    isWriteOff?: boolean;
    lang?: string | undefined;
}

export class GetWarehousesReportListPageResponse implements IGetWarehousesReportListPageResponse {
    warehousesReportListPage?: WarehousesReportListPageDTO[] | undefined;

    constructor(data?: IGetWarehousesReportListPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehousesReportListPage"])) {
                this.warehousesReportListPage = [] as any;
                for (let item of _data["warehousesReportListPage"])
                    this.warehousesReportListPage!.push(WarehousesReportListPageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWarehousesReportListPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehousesReportListPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehousesReportListPage)) {
            data["warehousesReportListPage"] = [];
            for (let item of this.warehousesReportListPage)
                data["warehousesReportListPage"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWarehousesReportListPageResponse {
    warehousesReportListPage?: WarehousesReportListPageDTO[] | undefined;
}

export class GetWealthDetailByIdResponse implements IGetWealthDetailByIdResponse {
    ok?: boolean;
    message?: string | undefined;
    wealth?: MobileWealthDTO;

    constructor(data?: IGetWealthDetailByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.wealth = _data["wealth"] ? MobileWealthDTO.fromJS(_data["wealth"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthDetailByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthDetailByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["wealth"] = this.wealth ? this.wealth.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthDetailByIdResponse {
    ok?: boolean;
    message?: string | undefined;
    wealth?: MobileWealthDTO;
}

export class GetWealthDetailsResponse implements IGetWealthDetailsResponse {
    id?: number;
    isCategory?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    code?: string | undefined;
    serialNumber?: string | undefined;
    showToEmps?: boolean;
    manufacturer?: string | undefined;
    priceA?: number | undefined;
    priceB?: number | undefined;
    priceC?: number | undefined;
    priceForRent?: number | undefined;
    datetimeImage?: Date | undefined;
    gpsXImage?: number | undefined;
    gpsYImage?: number | undefined;
    employeeId?: number | undefined;
    buildingId?: number | undefined;
    warehouseId?: number | undefined;
    employeeGroups?: EmployeeGroupsDTO[] | undefined;

    constructor(data?: IGetWealthDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCategory = _data["isCategory"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.serialNumber = _data["serialNumber"];
            this.showToEmps = _data["showToEmps"];
            this.manufacturer = _data["manufacturer"];
            this.priceA = _data["priceA"];
            this.priceB = _data["priceB"];
            this.priceC = _data["priceC"];
            this.priceForRent = _data["priceForRent"];
            this.datetimeImage = _data["datetimeImage"] ? new Date(_data["datetimeImage"].toString()) : <any>undefined;
            this.gpsXImage = _data["gpsXImage"];
            this.gpsYImage = _data["gpsYImage"];
            this.employeeId = _data["employeeId"];
            this.buildingId = _data["buildingId"];
            this.warehouseId = _data["warehouseId"];
            if (Array.isArray(_data["employeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["employeeGroups"])
                    this.employeeGroups!.push(EmployeeGroupsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCategory"] = this.isCategory;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["serialNumber"] = this.serialNumber;
        data["showToEmps"] = this.showToEmps;
        data["manufacturer"] = this.manufacturer;
        data["priceA"] = this.priceA;
        data["priceB"] = this.priceB;
        data["priceC"] = this.priceC;
        data["priceForRent"] = this.priceForRent;
        data["datetimeImage"] = this.datetimeImage ? this.datetimeImage.toISOString() : <any>undefined;
        data["gpsXImage"] = this.gpsXImage;
        data["gpsYImage"] = this.gpsYImage;
        data["employeeId"] = this.employeeId;
        data["buildingId"] = this.buildingId;
        data["warehouseId"] = this.warehouseId;
        if (Array.isArray(this.employeeGroups)) {
            data["employeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["employeeGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthDetailsResponse {
    id?: number;
    isCategory?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    code?: string | undefined;
    serialNumber?: string | undefined;
    showToEmps?: boolean;
    manufacturer?: string | undefined;
    priceA?: number | undefined;
    priceB?: number | undefined;
    priceC?: number | undefined;
    priceForRent?: number | undefined;
    datetimeImage?: Date | undefined;
    gpsXImage?: number | undefined;
    gpsYImage?: number | undefined;
    employeeId?: number | undefined;
    buildingId?: number | undefined;
    warehouseId?: number | undefined;
    employeeGroups?: EmployeeGroupsDTO[] | undefined;
}

export class GetWealthExpendituresResponse implements IGetWealthExpendituresResponse {
    wealthExpenditures?: WealthExpenditureDTO[] | undefined;

    constructor(data?: IGetWealthExpendituresResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealthExpenditures"])) {
                this.wealthExpenditures = [] as any;
                for (let item of _data["wealthExpenditures"])
                    this.wealthExpenditures!.push(WealthExpenditureDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthExpendituresResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthExpendituresResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealthExpenditures)) {
            data["wealthExpenditures"] = [];
            for (let item of this.wealthExpenditures)
                data["wealthExpenditures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthExpendituresResponse {
    wealthExpenditures?: WealthExpenditureDTO[] | undefined;
}

export class GetWealthHistoryResponse implements IGetWealthHistoryResponse {
    wealthHistory?: WealthHistoryDTO[] | undefined;

    constructor(data?: IGetWealthHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealthHistory"])) {
                this.wealthHistory = [] as any;
                for (let item of _data["wealthHistory"])
                    this.wealthHistory!.push(WealthHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealthHistory)) {
            data["wealthHistory"] = [];
            for (let item of this.wealthHistory)
                data["wealthHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthHistoryResponse {
    wealthHistory?: WealthHistoryDTO[] | undefined;
}

export class GetWealthMobileDetailResponse implements IGetWealthMobileDetailResponse {
    ok?: boolean;
    message?: string | undefined;
    wealth?: MobileWealthDTO;

    constructor(data?: IGetWealthMobileDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.wealth = _data["wealth"] ? MobileWealthDTO.fromJS(_data["wealth"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMobileDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMobileDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["wealth"] = this.wealth ? this.wealth.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMobileDetailResponse {
    ok?: boolean;
    message?: string | undefined;
    wealth?: MobileWealthDTO;
}

export class GetWealthRentalResponse implements IGetWealthRentalResponse {
    wealthRental?: WealthRentalDTO;

    constructor(data?: IGetWealthRentalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wealthRental = _data["wealthRental"] ? WealthRentalDTO.fromJS(_data["wealthRental"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthRentalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthRentalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wealthRental"] = this.wealthRental ? this.wealthRental.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthRentalResponse {
    wealthRental?: WealthRentalDTO;
}

export class GetWealthsForAdminUserResponse implements IGetWealthsForAdminUserResponse {
    wealths?: WealthDTO[] | undefined;

    constructor(data?: IGetWealthsForAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealths"])) {
                this.wealths = [] as any;
                for (let item of _data["wealths"])
                    this.wealths!.push(WealthDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthsForAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthsForAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealths)) {
            data["wealths"] = [];
            for (let item of this.wealths)
                data["wealths"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthsForAdminUserResponse {
    wealths?: WealthDTO[] | undefined;
}

export class GetWealthsForDiaryDialogResponse implements IGetWealthsForDiaryDialogResponse {
    wealthsForDiaryDialog?: WealthForDiaryDialogDTO[] | undefined;

    constructor(data?: IGetWealthsForDiaryDialogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealthsForDiaryDialog"])) {
                this.wealthsForDiaryDialog = [] as any;
                for (let item of _data["wealthsForDiaryDialog"])
                    this.wealthsForDiaryDialog!.push(WealthForDiaryDialogDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthsForDiaryDialogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthsForDiaryDialogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealthsForDiaryDialog)) {
            data["wealthsForDiaryDialog"] = [];
            for (let item of this.wealthsForDiaryDialog)
                data["wealthsForDiaryDialog"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthsForDiaryDialogResponse {
    wealthsForDiaryDialog?: WealthForDiaryDialogDTO[] | undefined;
}

export class GetWealthToBorrowResponse implements IGetWealthToBorrowResponse {
    wealthToBorrow?: MobileWealthDTO[] | undefined;

    constructor(data?: IGetWealthToBorrowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealthToBorrow"])) {
                this.wealthToBorrow = [] as any;
                for (let item of _data["wealthToBorrow"])
                    this.wealthToBorrow!.push(MobileWealthDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWealthToBorrowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthToBorrowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealthToBorrow)) {
            data["wealthToBorrow"] = [];
            for (let item of this.wealthToBorrow)
                data["wealthToBorrow"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWealthToBorrowResponse {
    wealthToBorrow?: MobileWealthDTO[] | undefined;
}

export class GetWeatherForRecordDTO implements IGetWeatherForRecordDTO {
    selected?: boolean;
    id?: number;
    time?: Date;
    created?: Date;
    lastUpdate?: Date;
    authorId?: number | undefined;
    authorName?: string | undefined;
    isShared?: boolean;
    description?: string | undefined;
    temperature?: string | undefined;
    wind?: string | undefined;
    precipitation?: string | undefined;
    humidity?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IGetWeatherForRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.id = _data["id"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.authorId = _data["authorId"];
            this.authorName = _data["authorName"];
            this.isShared = _data["isShared"];
            this.description = _data["description"];
            this.temperature = _data["temperature"];
            this.wind = _data["wind"];
            this.precipitation = _data["precipitation"];
            this.humidity = _data["humidity"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GetWeatherForRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetWeatherForRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["id"] = this.id;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["authorId"] = this.authorId;
        data["authorName"] = this.authorName;
        data["isShared"] = this.isShared;
        data["description"] = this.description;
        data["temperature"] = this.temperature;
        data["wind"] = this.wind;
        data["precipitation"] = this.precipitation;
        data["humidity"] = this.humidity;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGetWeatherForRecordDTO {
    selected?: boolean;
    id?: number;
    time?: Date;
    created?: Date;
    lastUpdate?: Date;
    authorId?: number | undefined;
    authorName?: string | undefined;
    isShared?: boolean;
    description?: string | undefined;
    temperature?: string | undefined;
    wind?: string | undefined;
    precipitation?: string | undefined;
    humidity?: string | undefined;
    isDeleted?: boolean;
}

export class GetWeatherForRecordRequest implements IGetWeatherForRecordRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetWeatherForRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetWeatherForRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWeatherForRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetWeatherForRecordRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetWeatherForRecordResponse implements IGetWeatherForRecordResponse {
    weathers?: GetWeatherForRecordDTO[] | undefined;

    constructor(data?: IGetWeatherForRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weathers"])) {
                this.weathers = [] as any;
                for (let item of _data["weathers"])
                    this.weathers!.push(GetWeatherForRecordDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWeatherForRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWeatherForRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weathers)) {
            data["weathers"] = [];
            for (let item of this.weathers)
                data["weathers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWeatherForRecordResponse {
    weathers?: GetWeatherForRecordDTO[] | undefined;
}

export class GetWeatherForRecordSubcontractorRequest implements IGetWeatherForRecordSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetWeatherForRecordSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetWeatherForRecordSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWeatherForRecordSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetWeatherForRecordSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetWorkerForRecordDTO implements IGetWorkerForRecordDTO {
    selected?: boolean;
    id?: number;
    employeeId?: number | undefined;
    name?: string | undefined;
    code?: string | undefined;
    groupName?: string | undefined;
    workHours?: number;
    created?: Date;
    lastUpdate?: Date;
    authorId?: number | undefined;
    authorName?: string | undefined;
    isShared?: boolean;
    isDeleted?: boolean;

    constructor(data?: IGetWorkerForRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.groupName = _data["groupName"];
            this.workHours = _data["workHours"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.authorId = _data["authorId"];
            this.authorName = _data["authorName"];
            this.isShared = _data["isShared"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GetWorkerForRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkerForRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["groupName"] = this.groupName;
        data["workHours"] = this.workHours;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["authorId"] = this.authorId;
        data["authorName"] = this.authorName;
        data["isShared"] = this.isShared;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGetWorkerForRecordDTO {
    selected?: boolean;
    id?: number;
    employeeId?: number | undefined;
    name?: string | undefined;
    code?: string | undefined;
    groupName?: string | undefined;
    workHours?: number;
    created?: Date;
    lastUpdate?: Date;
    authorId?: number | undefined;
    authorName?: string | undefined;
    isShared?: boolean;
    isDeleted?: boolean;
}

export class GetWorkersForRecordRequest implements IGetWorkersForRecordRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetWorkersForRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetWorkersForRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkersForRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetWorkersForRecordRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GetWorkersForRecordResponse implements IGetWorkersForRecordResponse {
    workers?: GetWorkerForRecordDTO[] | undefined;

    constructor(data?: IGetWorkersForRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(GetWorkerForRecordDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorkersForRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkersForRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWorkersForRecordResponse {
    workers?: GetWorkerForRecordDTO[] | undefined;
}

export class GetWorkersForRecordSubcontractorRequest implements IGetWorkersForRecordSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;

    constructor(data?: IGetWorkersForRecordSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.onlyShared = _data["onlyShared"];
            this.onlyMine = _data["onlyMine"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): GetWorkersForRecordSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkersForRecordSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["onlyShared"] = this.onlyShared;
        data["onlyMine"] = this.onlyMine;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IGetWorkersForRecordSubcontractorRequest {
    diaryRecordId?: number;
    onlyShared?: boolean;
    onlyMine?: boolean;
    subcontractorId?: number | undefined;
}

export class GpsPoint implements IGpsPoint {
    gps_x?: number;
    gps_y?: number;
    gps_diff?: number;

    constructor(data?: IGpsPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gps_x = _data["gps_x"];
            this.gps_y = _data["gps_y"];
            this.gps_diff = _data["gps_diff"];
        }
    }

    static fromJS(data: any): GpsPoint {
        data = typeof data === 'object' ? data : {};
        let result = new GpsPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gps_x"] = this.gps_x;
        data["gps_y"] = this.gps_y;
        data["gps_diff"] = this.gps_diff;
        return data;
    }
}

export interface IGpsPoint {
    gps_x?: number;
    gps_y?: number;
    gps_diff?: number;
}

export class GroupAdminDTO implements IGroupAdminDTO {
    userId?: number;
    name?: string | undefined;
    content?: string | undefined;
    contentId?: number | undefined;
    changed?: boolean;

    constructor(data?: IGroupAdminDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.contentId = _data["contentId"];
            this.changed = _data["changed"];
        }
    }

    static fromJS(data: any): GroupAdminDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupAdminDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["content"] = this.content;
        data["contentId"] = this.contentId;
        data["changed"] = this.changed;
        return data;
    }
}

export interface IGroupAdminDTO {
    userId?: number;
    name?: string | undefined;
    content?: string | undefined;
    contentId?: number | undefined;
    changed?: boolean;
}

export class GroupDTO implements IGroupDTO {
    groupId?: number | undefined;
    groupName?: string | undefined;
    members?: GroupAdminDTO[] | undefined;

    constructor(data?: IGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(GroupAdminDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupDTO {
    groupId?: number | undefined;
    groupName?: string | undefined;
    members?: GroupAdminDTO[] | undefined;
}

export enum HealthInsuranceEnum {
    Vzp = 111,
    Vozp = 201,
    Cpzp = 205,
    Ozp = 207,
    Zps = 209,
    Zpmv = 211,
    Rbp = 213,
    Vszp = 500,
    Dovera = 501,
    Union = 502,
}

export class HintDTO implements IHintDTO {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    createdDate?: Date;

    constructor(data?: IHintDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.language = _data["language"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HintDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HintDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["language"] = this.language;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHintDTO {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    createdDate?: Date;
}

export class HttpContent implements IHttpContent {
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHttpContent {
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
}

export class HttpMethod implements IHttpMethod {
    method?: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method?: string | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version?: Version;
    versionPolicy?: HttpVersionPolicy;
    content?: HttpContent;
    method?: HttpMethod;
    requestUri?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly properties?: { [key: string]: any; } | undefined;
    readonly options?: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? Version.fromJS(_data["version"]) : <any>undefined;
            this.versionPolicy = _data["versionPolicy"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.method = _data["method"] ? HttpMethod.fromJS(_data["method"]) : <any>undefined;
            this.requestUri = _data["requestUri"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
            if (_data["options"]) {
                (<any>this).options = {} as any;
                for (let key in _data["options"]) {
                    if (_data["options"].hasOwnProperty(key))
                        (<any>(<any>this).options)![key] = _data["options"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["versionPolicy"] = this.versionPolicy;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["requestUri"] = this.requestUri;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        if (this.options) {
            data["options"] = {};
            for (let key in this.options) {
                if (this.options.hasOwnProperty(key))
                    (<any>data["options"])[key] = (<any>this.options)[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version?: Version;
    versionPolicy?: HttpVersionPolicy;
    content?: HttpContent;
    method?: HttpMethod;
    requestUri?: string | undefined;
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    properties?: { [key: string]: any; } | undefined;
    options?: { [key: string]: any; } | undefined;
}

export class HttpResponseMessage implements IHttpResponseMessage {
    version?: Version;
    content?: HttpContent;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly trailingHeaders?: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage?: HttpRequestMessage;
    readonly isSuccessStatusCode?: boolean;

    constructor(data?: IHttpResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? Version.fromJS(_data["version"]) : <any>undefined;
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            this.reasonPhrase = _data["reasonPhrase"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["trailingHeaders"])) {
                (<any>this).trailingHeaders = [] as any;
                for (let item of _data["trailingHeaders"])
                    (<any>this).trailingHeaders!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            this.requestMessage = _data["requestMessage"] ? HttpRequestMessage.fromJS(_data["requestMessage"]) : <any>undefined;
            (<any>this).isSuccessStatusCode = _data["isSuccessStatusCode"];
        }
    }

    static fromJS(data: any): HttpResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["reasonPhrase"] = this.reasonPhrase;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (Array.isArray(this.trailingHeaders)) {
            data["trailingHeaders"] = [];
            for (let item of this.trailingHeaders)
                data["trailingHeaders"].push(item.toJSON());
        }
        data["requestMessage"] = this.requestMessage ? this.requestMessage.toJSON() : <any>undefined;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        return data;
    }
}

export interface IHttpResponseMessage {
    version?: Version;
    content?: HttpContent;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    trailingHeaders?: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage?: HttpRequestMessage;
    isSuccessStatusCode?: boolean;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    UnprocessableContent = 431,
    Locked = 451,
    FailedDependency = 500,
    UpgradeRequired = 501,
    PreconditionRequired = 502,
    TooManyRequests = 503,
    RequestHeaderFieldsTooLarge = 504,
    UnavailableForLegalReasons = 505,
    InternalServerError = 506,
    NotImplemented = 507,
    BadGateway = 508,
    ServiceUnavailable = 510,
    GatewayTimeout = 511,
}

export enum HttpVersionPolicy {
    RequestVersionOrLower = 0,
    RequestVersionOrHigher = 1,
    RequestVersionExact = 2,
}

export class ChangeBuildingCustomFieldVisibilityResponse implements IChangeBuildingCustomFieldVisibilityResponse {
    ok?: boolean;

    constructor(data?: IChangeBuildingCustomFieldVisibilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ChangeBuildingCustomFieldVisibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeBuildingCustomFieldVisibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IChangeBuildingCustomFieldVisibilityResponse {
    ok?: boolean;
}

export class ChangeBuildingImageCreationDateRequest implements IChangeBuildingImageCreationDateRequest {
    imageId?: number;
    buildingId?: number;
    url?: string | undefined;
    newDate?: Date;

    constructor(data?: IChangeBuildingImageCreationDateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.buildingId = _data["buildingId"];
            this.url = _data["url"];
            this.newDate = _data["newDate"] ? new Date(_data["newDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeBuildingImageCreationDateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeBuildingImageCreationDateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["buildingId"] = this.buildingId;
        data["url"] = this.url;
        data["newDate"] = this.newDate ? this.newDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChangeBuildingImageCreationDateRequest {
    imageId?: number;
    buildingId?: number;
    url?: string | undefined;
    newDate?: Date;
}

export class ChangeBuildingImageCreationDateResponse implements IChangeBuildingImageCreationDateResponse {
    ok?: boolean;

    constructor(data?: IChangeBuildingImageCreationDateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ChangeBuildingImageCreationDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeBuildingImageCreationDateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IChangeBuildingImageCreationDateResponse {
    ok?: boolean;
}

export class ChangeLogRecord implements IChangeLogRecord {
    userName?: string | undefined;
    column?: string | undefined;
    value?: string | undefined;
    datetime?: Date;

    constructor(data?: IChangeLogRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.column = _data["column"];
            this.value = _data["value"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeLogRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["column"] = this.column;
        data["value"] = this.value;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChangeLogRecord {
    userName?: string | undefined;
    column?: string | undefined;
    value?: string | undefined;
    datetime?: Date;
}

export class ChatGroupDTO implements IChatGroupDTO {
    recordId?: number;
    groupId?: number | undefined;
    groupName?: string | undefined;
    diaryName?: string | undefined;
    shown?: boolean;
    messages?: SubcontractorsChatMessageDTO[] | undefined;

    constructor(data?: IChatGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.diaryName = _data["diaryName"];
            this.shown = _data["shown"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(SubcontractorsChatMessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["diaryName"] = this.diaryName;
        data["shown"] = this.shown;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatGroupDTO {
    recordId?: number;
    groupId?: number | undefined;
    groupName?: string | undefined;
    diaryName?: string | undefined;
    shown?: boolean;
    messages?: SubcontractorsChatMessageDTO[] | undefined;
}

export class ImageCategoryDTO implements IImageCategoryDTO {
    id?: number;
    name?: string | undefined;
    created?: Date;
    fromDiary?: boolean;

    constructor(data?: IImageCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.fromDiary = _data["fromDiary"];
        }
    }

    static fromJS(data: any): ImageCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["fromDiary"] = this.fromDiary;
        return data;
    }
}

export interface IImageCategoryDTO {
    id?: number;
    name?: string | undefined;
    created?: Date;
    fromDiary?: boolean;
}

export class ImageCategoryMobileDTO implements IImageCategoryMobileDTO {
    name?: string | undefined;
    id?: number;

    constructor(data?: IImageCategoryMobileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ImageCategoryMobileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageCategoryMobileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IImageCategoryMobileDTO {
    name?: string | undefined;
    id?: number;
}

export class ImageDiaryDTO implements IImageDiaryDTO {
    id?: number | undefined;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    fileName?: string | undefined;
    name?: string | undefined;
    base64?: string | undefined;
    isSelected?: boolean;
    showToInvestor?: boolean;
    isDirect?: boolean;
    buildingId?: number | undefined;
    categoryId?: number | undefined;
    creator?: string | undefined;
    created?: Date | undefined;

    constructor(data?: IImageDiaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.fileName = _data["fileName"];
            this.name = _data["name"];
            this.base64 = _data["base64"];
            this.isSelected = _data["isSelected"];
            this.showToInvestor = _data["showToInvestor"];
            this.isDirect = _data["isDirect"];
            this.buildingId = _data["buildingId"];
            this.categoryId = _data["categoryId"];
            this.creator = _data["creator"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageDiaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDiaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["fileName"] = this.fileName;
        data["name"] = this.name;
        data["base64"] = this.base64;
        data["isSelected"] = this.isSelected;
        data["showToInvestor"] = this.showToInvestor;
        data["isDirect"] = this.isDirect;
        data["buildingId"] = this.buildingId;
        data["categoryId"] = this.categoryId;
        data["creator"] = this.creator;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IImageDiaryDTO {
    id?: number | undefined;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    fileName?: string | undefined;
    name?: string | undefined;
    base64?: string | undefined;
    isSelected?: boolean;
    showToInvestor?: boolean;
    isDirect?: boolean;
    buildingId?: number | undefined;
    categoryId?: number | undefined;
    creator?: string | undefined;
    created?: Date | undefined;
}

export class ImageMapDto implements IImageMapDto {
    id?: number;
    blobName?: string | undefined;
    sasUri?: string | undefined;
    buildingId?: number;
    buildingName?: string | undefined;

    constructor(data?: IImageMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.blobName = _data["blobName"];
            this.sasUri = _data["sasUri"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
        }
    }

    static fromJS(data: any): ImageMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["blobName"] = this.blobName;
        data["sasUri"] = this.sasUri;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        return data;
    }
}

export interface IImageMapDto {
    id?: number;
    blobName?: string | undefined;
    sasUri?: string | undefined;
    buildingId?: number;
    buildingName?: string | undefined;
}

export class InsertBreakRequest implements IInsertBreakRequest {
    type?: string | undefined;
    gpsX?: number;
    gpsY?: number;
    accuracy?: string | undefined;

    constructor(data?: IInsertBreakRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.gpsX = _data["gpsX"];
            this.gpsY = _data["gpsY"];
            this.accuracy = _data["accuracy"];
        }
    }

    static fromJS(data: any): InsertBreakRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertBreakRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["gpsX"] = this.gpsX;
        data["gpsY"] = this.gpsY;
        data["accuracy"] = this.accuracy;
        return data;
    }
}

export interface IInsertBreakRequest {
    type?: string | undefined;
    gpsX?: number;
    gpsY?: number;
    accuracy?: string | undefined;
}

export class InsertBreakResponse implements IInsertBreakResponse {
    dateTime?: string | undefined;
    ok?: boolean;
    message?: string | undefined;

    constructor(data?: IInsertBreakResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.ok = _data["ok"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InsertBreakResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsertBreakResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["ok"] = this.ok;
        data["message"] = this.message;
        return data;
    }
}

export interface IInsertBreakResponse {
    dateTime?: string | undefined;
    ok?: boolean;
    message?: string | undefined;
}

export class InsertDoctorRequest implements IInsertDoctorRequest {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;

    constructor(data?: IInsertDoctorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
        }
    }

    static fromJS(data: any): InsertDoctorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertDoctorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        return data;
    }
}

export interface IInsertDoctorRequest {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
}

export class InsertDoctorResponse implements IInsertDoctorResponse {
    ok?: boolean;
    message?: string | undefined;

    constructor(data?: IInsertDoctorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InsertDoctorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsertDoctorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        return data;
    }
}

export interface IInsertDoctorResponse {
    ok?: boolean;
    message?: string | undefined;
}

export class InsertHolidayRequest implements IInsertHolidayRequest {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;

    constructor(data?: IInsertHolidayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
        }
    }

    static fromJS(data: any): InsertHolidayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertHolidayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        return data;
    }
}

export interface IInsertHolidayRequest {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
}

export class InsertHolidayResponse implements IInsertHolidayResponse {
    ok?: boolean;
    message?: string | undefined;

    constructor(data?: IInsertHolidayResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InsertHolidayResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsertHolidayResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        return data;
    }
}

export interface IInsertHolidayResponse {
    ok?: boolean;
    message?: string | undefined;
}

export class InsertLogRecordRequest implements IInsertLogRecordRequest {
    deviceInfo?: string | undefined;
    action?: string | undefined;

    constructor(data?: IInsertLogRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceInfo = _data["deviceInfo"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): InsertLogRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertLogRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceInfo"] = this.deviceInfo;
        data["action"] = this.action;
        return data;
    }
}

export interface IInsertLogRecordRequest {
    deviceInfo?: string | undefined;
    action?: string | undefined;
}

export class InsertLogRecordResponse implements IInsertLogRecordResponse {
    ok?: boolean;

    constructor(data?: IInsertLogRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): InsertLogRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsertLogRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IInsertLogRecordResponse {
    ok?: boolean;
}

export class InsertMessageResponseDTO implements IInsertMessageResponseDTO {
    requestId?: number;
    messageFile?: string | undefined;
    messageText?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    constructor(data?: IInsertMessageResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.messageFile = _data["messageFile"];
            this.messageText = _data["messageText"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): InsertMessageResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMessageResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["messageFile"] = this.messageFile;
        data["messageText"] = this.messageText;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IInsertMessageResponseDTO {
    requestId?: number;
    messageFile?: string | undefined;
    messageText?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export class InsertRecordRequest implements IInsertRecordRequest {
    accuracy?: string | undefined;
    buildingId?: number;
    customType?: string | undefined;
    deviceId?: string | undefined;
    deviceModel?: string | undefined;
    gpsX?: number;
    gpsY?: number;
    image?: string | undefined;
    type?: string | undefined;

    constructor(data?: IInsertRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accuracy = _data["accuracy"];
            this.buildingId = _data["buildingId"];
            this.customType = _data["customType"];
            this.deviceId = _data["deviceId"];
            this.deviceModel = _data["deviceModel"];
            this.gpsX = _data["gpsX"];
            this.gpsY = _data["gpsY"];
            this.image = _data["image"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): InsertRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accuracy"] = this.accuracy;
        data["buildingId"] = this.buildingId;
        data["customType"] = this.customType;
        data["deviceId"] = this.deviceId;
        data["deviceModel"] = this.deviceModel;
        data["gpsX"] = this.gpsX;
        data["gpsY"] = this.gpsY;
        data["image"] = this.image;
        data["type"] = this.type;
        return data;
    }
}

export interface IInsertRecordRequest {
    accuracy?: string | undefined;
    buildingId?: number;
    customType?: string | undefined;
    deviceId?: string | undefined;
    deviceModel?: string | undefined;
    gpsX?: number;
    gpsY?: number;
    image?: string | undefined;
    type?: string | undefined;
}

export class InsertRecordResponse implements IInsertRecordResponse {
    ok?: boolean;
    message?: string | undefined;

    constructor(data?: IInsertRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InsertRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        return data;
    }
}

export interface IInsertRecordResponse {
    ok?: boolean;
    message?: string | undefined;
}

export class InsertSickRequest implements IInsertSickRequest {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;

    constructor(data?: IInsertSickRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
        }
    }

    static fromJS(data: any): InsertSickRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSickRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        return data;
    }
}

export interface IInsertSickRequest {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
}

export class InsertSickResponse implements IInsertSickResponse {
    ok?: boolean;
    message?: string | undefined;

    constructor(data?: IInsertSickResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InsertSickResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSickResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        return data;
    }
}

export interface IInsertSickResponse {
    ok?: boolean;
    message?: string | undefined;
}

export enum InvalidityEnum {
    Zadna = 1,
    CastecnaPrvniDruhyStupen = 2,
    PlnaInvaliditaTretiStupen = 3,
    DrzitelPrukazuZTPP = 4,
}

export class InvestorDTO implements IInvestorDTO {
    id?: number;
    name?: string | undefined;
    isAssigned?: boolean;

    constructor(data?: IInvestorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): InvestorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAssigned"] = this.isAssigned;
        return data;
    }
}

export interface IInvestorDTO {
    id?: number;
    name?: string | undefined;
    isAssigned?: boolean;
}

export class InvestorRoleDTO implements IInvestorRoleDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IInvestorRoleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InvestorRoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorRoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IInvestorRoleDTO {
    id?: number;
    name?: string | undefined;
}

export class InvestorsChatMessageDTO implements IInvestorsChatMessageDTO {
    id?: number;
    userName?: string | undefined;
    isInvestor?: boolean;
    isMe?: boolean;
    datetime?: Date;
    text?: string | undefined;

    constructor(data?: IInvestorsChatMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.isInvestor = _data["isInvestor"];
            this.isMe = _data["isMe"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): InvestorsChatMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorsChatMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["isInvestor"] = this.isInvestor;
        data["isMe"] = this.isMe;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["text"] = this.text;
        return data;
    }
}

export interface IInvestorsChatMessageDTO {
    id?: number;
    userName?: string | undefined;
    isInvestor?: boolean;
    isMe?: boolean;
    datetime?: Date;
    text?: string | undefined;
}

export class InvoiceFileDTO implements IInvoiceFileDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    isNew?: boolean;
    isUpdated?: boolean;
    isDeleted?: boolean;
    file?: string | undefined;

    constructor(data?: IInvoiceFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.isNew = _data["isNew"];
            this.isUpdated = _data["isUpdated"];
            this.isDeleted = _data["isDeleted"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): InvoiceFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["isNew"] = this.isNew;
        data["isUpdated"] = this.isUpdated;
        data["isDeleted"] = this.isDeleted;
        data["file"] = this.file;
        return data;
    }
}

export interface IInvoiceFileDTO {
    id?: number;
    name?: string | undefined;
    url?: string | undefined;
    isNew?: boolean;
    isUpdated?: boolean;
    isDeleted?: boolean;
    file?: string | undefined;
}

export class InvoiceItem implements IInvoiceItem {
    id?: number;
    isNew?: boolean;
    isUpdated?: boolean;
    isDeleted?: boolean;
    name?: string | undefined;
    projectId?: number | undefined;
    priceWithoutVat?: number;
    taxratesId?: number | undefined;
    currency?: string | undefined;

    constructor(data?: IInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isNew = _data["isNew"];
            this.isUpdated = _data["isUpdated"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.priceWithoutVat = _data["priceWithoutVat"];
            this.taxratesId = _data["taxratesId"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): InvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isNew"] = this.isNew;
        data["isUpdated"] = this.isUpdated;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["taxratesId"] = this.taxratesId;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IInvoiceItem {
    id?: number;
    isNew?: boolean;
    isUpdated?: boolean;
    isDeleted?: boolean;
    name?: string | undefined;
    projectId?: number | undefined;
    priceWithoutVat?: number;
    taxratesId?: number | undefined;
    currency?: string | undefined;
}

export class JokeDTO implements IJokeDTO {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    createdDate?: Date;

    constructor(data?: IJokeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.language = _data["language"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JokeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new JokeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["language"] = this.language;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJokeDTO {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
    createdDate?: Date;
}

export class KrosAdminApplicationPermissionDTO implements IKrosAdminApplicationPermissionDTO {
    adminButtons_list?: boolean;
    adminButtons_detail?: boolean;
    adminRoles_list?: boolean;
    adminRoles_detail?: boolean;
    adminUserGroups_list?: boolean;
    adminUserGroups_detail?: boolean;
    adminUsers_list?: boolean;
    adminUsers_detail?: boolean;
    applications_list?: boolean;
    buildingBills_list?: boolean;
    buildingBills_detail?: boolean;
    buildingDiary_list?: boolean;
    buildingDiary_detail?: boolean;
    buildingDiaryRecords_list?: boolean;
    buildingDiaryRecords_detail?: boolean;
    buildingDocuments_list?: boolean;
    buildingDocuments_detail?: boolean;
    buildingHours_list?: boolean;
    buildings_list?: boolean;
    buildings_detail?: boolean;
    buttons_list?: boolean;
    buttons_detail?: boolean;
    dashboard_list?: boolean;
    deleteLog_list?: boolean;
    documentTemplates_list?: boolean;
    documentTemplates_detail?: boolean;
    documentTemplatesHistory_delete?: boolean;
    documentTemplatesHistory_list?: boolean;
    employeeBozps_list?: boolean;
    employeeBozps_detail?: boolean;
    employeeBozpsSettings_list?: boolean;
    employeeBozpsSettings_detail?: boolean;
    employeeDocuments_list?: boolean;
    employeeDocuments_detail?: boolean;
    employeeGroups_list?: boolean;
    employeeGroups_detail?: boolean;
    employeeHolidays_list?: boolean;
    employeeNews_list?: boolean;
    employeeNews_detail?: boolean;
    employees_list?: boolean;
    employees_detail?: boolean;
    investorRoles_list?: boolean;
    investorRoles_detail?: boolean;
    investors_list?: boolean;
    investors_detail?: boolean;
    languages_list?: boolean;
    myFiles_list?: boolean;
    myFiles_detail?: boolean;
    orders_list?: boolean;
    records_list?: boolean;
    records_detail?: boolean;
    rental_list?: boolean;
    rental_detail?: boolean;
    requests_list?: boolean;
    requests_detail?: boolean;
    requestsRepeat_list?: boolean;
    requestsRepeat_detail?: boolean;
    settings_list?: boolean;
    statistics_list?: boolean;
    stockAssemblies_list?: boolean;
    stockManufacturers_list?: boolean;
    stockManufacturers_detail?: boolean;
    stockProductCategories_list?: boolean;
    stockProductCategories_detail?: boolean;
    stockProducts_list?: boolean;
    stockProducts_detail?: boolean;
    stockWarehouses_list?: boolean;
    stockWarehouses_detail?: boolean;
    transitions_list?: boolean;
    wealth_list?: boolean;
    wealth_detail?: boolean;
    wealthDocuments_list?: boolean;
    wealthDocuments_detail?: boolean;
    workHours_list?: boolean;
    workHoursPay_list?: boolean;

    constructor(data?: IKrosAdminApplicationPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminButtons_list = _data["adminButtons_list"];
            this.adminButtons_detail = _data["adminButtons_detail"];
            this.adminRoles_list = _data["adminRoles_list"];
            this.adminRoles_detail = _data["adminRoles_detail"];
            this.adminUserGroups_list = _data["adminUserGroups_list"];
            this.adminUserGroups_detail = _data["adminUserGroups_detail"];
            this.adminUsers_list = _data["adminUsers_list"];
            this.adminUsers_detail = _data["adminUsers_detail"];
            this.applications_list = _data["applications_list"];
            this.buildingBills_list = _data["buildingBills_list"];
            this.buildingBills_detail = _data["buildingBills_detail"];
            this.buildingDiary_list = _data["buildingDiary_list"];
            this.buildingDiary_detail = _data["buildingDiary_detail"];
            this.buildingDiaryRecords_list = _data["buildingDiaryRecords_list"];
            this.buildingDiaryRecords_detail = _data["buildingDiaryRecords_detail"];
            this.buildingDocuments_list = _data["buildingDocuments_list"];
            this.buildingDocuments_detail = _data["buildingDocuments_detail"];
            this.buildingHours_list = _data["buildingHours_list"];
            this.buildings_list = _data["buildings_list"];
            this.buildings_detail = _data["buildings_detail"];
            this.buttons_list = _data["buttons_list"];
            this.buttons_detail = _data["buttons_detail"];
            this.dashboard_list = _data["dashboard_list"];
            this.deleteLog_list = _data["deleteLog_list"];
            this.documentTemplates_list = _data["documentTemplates_list"];
            this.documentTemplates_detail = _data["documentTemplates_detail"];
            this.documentTemplatesHistory_delete = _data["documentTemplatesHistory_delete"];
            this.documentTemplatesHistory_list = _data["documentTemplatesHistory_list"];
            this.employeeBozps_list = _data["employeeBozps_list"];
            this.employeeBozps_detail = _data["employeeBozps_detail"];
            this.employeeBozpsSettings_list = _data["employeeBozpsSettings_list"];
            this.employeeBozpsSettings_detail = _data["employeeBozpsSettings_detail"];
            this.employeeDocuments_list = _data["employeeDocuments_list"];
            this.employeeDocuments_detail = _data["employeeDocuments_detail"];
            this.employeeGroups_list = _data["employeeGroups_list"];
            this.employeeGroups_detail = _data["employeeGroups_detail"];
            this.employeeHolidays_list = _data["employeeHolidays_list"];
            this.employeeNews_list = _data["employeeNews_list"];
            this.employeeNews_detail = _data["employeeNews_detail"];
            this.employees_list = _data["employees_list"];
            this.employees_detail = _data["employees_detail"];
            this.investorRoles_list = _data["investorRoles_list"];
            this.investorRoles_detail = _data["investorRoles_detail"];
            this.investors_list = _data["investors_list"];
            this.investors_detail = _data["investors_detail"];
            this.languages_list = _data["languages_list"];
            this.myFiles_list = _data["myFiles_list"];
            this.myFiles_detail = _data["myFiles_detail"];
            this.orders_list = _data["orders_list"];
            this.records_list = _data["records_list"];
            this.records_detail = _data["records_detail"];
            this.rental_list = _data["rental_list"];
            this.rental_detail = _data["rental_detail"];
            this.requests_list = _data["requests_list"];
            this.requests_detail = _data["requests_detail"];
            this.requestsRepeat_list = _data["requestsRepeat_list"];
            this.requestsRepeat_detail = _data["requestsRepeat_detail"];
            this.settings_list = _data["settings_list"];
            this.statistics_list = _data["statistics_list"];
            this.stockAssemblies_list = _data["stockAssemblies_list"];
            this.stockManufacturers_list = _data["stockManufacturers_list"];
            this.stockManufacturers_detail = _data["stockManufacturers_detail"];
            this.stockProductCategories_list = _data["stockProductCategories_list"];
            this.stockProductCategories_detail = _data["stockProductCategories_detail"];
            this.stockProducts_list = _data["stockProducts_list"];
            this.stockProducts_detail = _data["stockProducts_detail"];
            this.stockWarehouses_list = _data["stockWarehouses_list"];
            this.stockWarehouses_detail = _data["stockWarehouses_detail"];
            this.transitions_list = _data["transitions_list"];
            this.wealth_list = _data["wealth_list"];
            this.wealth_detail = _data["wealth_detail"];
            this.wealthDocuments_list = _data["wealthDocuments_list"];
            this.wealthDocuments_detail = _data["wealthDocuments_detail"];
            this.workHours_list = _data["workHours_list"];
            this.workHoursPay_list = _data["workHoursPay_list"];
        }
    }

    static fromJS(data: any): KrosAdminApplicationPermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KrosAdminApplicationPermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminButtons_list"] = this.adminButtons_list;
        data["adminButtons_detail"] = this.adminButtons_detail;
        data["adminRoles_list"] = this.adminRoles_list;
        data["adminRoles_detail"] = this.adminRoles_detail;
        data["adminUserGroups_list"] = this.adminUserGroups_list;
        data["adminUserGroups_detail"] = this.adminUserGroups_detail;
        data["adminUsers_list"] = this.adminUsers_list;
        data["adminUsers_detail"] = this.adminUsers_detail;
        data["applications_list"] = this.applications_list;
        data["buildingBills_list"] = this.buildingBills_list;
        data["buildingBills_detail"] = this.buildingBills_detail;
        data["buildingDiary_list"] = this.buildingDiary_list;
        data["buildingDiary_detail"] = this.buildingDiary_detail;
        data["buildingDiaryRecords_list"] = this.buildingDiaryRecords_list;
        data["buildingDiaryRecords_detail"] = this.buildingDiaryRecords_detail;
        data["buildingDocuments_list"] = this.buildingDocuments_list;
        data["buildingDocuments_detail"] = this.buildingDocuments_detail;
        data["buildingHours_list"] = this.buildingHours_list;
        data["buildings_list"] = this.buildings_list;
        data["buildings_detail"] = this.buildings_detail;
        data["buttons_list"] = this.buttons_list;
        data["buttons_detail"] = this.buttons_detail;
        data["dashboard_list"] = this.dashboard_list;
        data["deleteLog_list"] = this.deleteLog_list;
        data["documentTemplates_list"] = this.documentTemplates_list;
        data["documentTemplates_detail"] = this.documentTemplates_detail;
        data["documentTemplatesHistory_delete"] = this.documentTemplatesHistory_delete;
        data["documentTemplatesHistory_list"] = this.documentTemplatesHistory_list;
        data["employeeBozps_list"] = this.employeeBozps_list;
        data["employeeBozps_detail"] = this.employeeBozps_detail;
        data["employeeBozpsSettings_list"] = this.employeeBozpsSettings_list;
        data["employeeBozpsSettings_detail"] = this.employeeBozpsSettings_detail;
        data["employeeDocuments_list"] = this.employeeDocuments_list;
        data["employeeDocuments_detail"] = this.employeeDocuments_detail;
        data["employeeGroups_list"] = this.employeeGroups_list;
        data["employeeGroups_detail"] = this.employeeGroups_detail;
        data["employeeHolidays_list"] = this.employeeHolidays_list;
        data["employeeNews_list"] = this.employeeNews_list;
        data["employeeNews_detail"] = this.employeeNews_detail;
        data["employees_list"] = this.employees_list;
        data["employees_detail"] = this.employees_detail;
        data["investorRoles_list"] = this.investorRoles_list;
        data["investorRoles_detail"] = this.investorRoles_detail;
        data["investors_list"] = this.investors_list;
        data["investors_detail"] = this.investors_detail;
        data["languages_list"] = this.languages_list;
        data["myFiles_list"] = this.myFiles_list;
        data["myFiles_detail"] = this.myFiles_detail;
        data["orders_list"] = this.orders_list;
        data["records_list"] = this.records_list;
        data["records_detail"] = this.records_detail;
        data["rental_list"] = this.rental_list;
        data["rental_detail"] = this.rental_detail;
        data["requests_list"] = this.requests_list;
        data["requests_detail"] = this.requests_detail;
        data["requestsRepeat_list"] = this.requestsRepeat_list;
        data["requestsRepeat_detail"] = this.requestsRepeat_detail;
        data["settings_list"] = this.settings_list;
        data["statistics_list"] = this.statistics_list;
        data["stockAssemblies_list"] = this.stockAssemblies_list;
        data["stockManufacturers_list"] = this.stockManufacturers_list;
        data["stockManufacturers_detail"] = this.stockManufacturers_detail;
        data["stockProductCategories_list"] = this.stockProductCategories_list;
        data["stockProductCategories_detail"] = this.stockProductCategories_detail;
        data["stockProducts_list"] = this.stockProducts_list;
        data["stockProducts_detail"] = this.stockProducts_detail;
        data["stockWarehouses_list"] = this.stockWarehouses_list;
        data["stockWarehouses_detail"] = this.stockWarehouses_detail;
        data["transitions_list"] = this.transitions_list;
        data["wealth_list"] = this.wealth_list;
        data["wealth_detail"] = this.wealth_detail;
        data["wealthDocuments_list"] = this.wealthDocuments_list;
        data["wealthDocuments_detail"] = this.wealthDocuments_detail;
        data["workHours_list"] = this.workHours_list;
        data["workHoursPay_list"] = this.workHoursPay_list;
        return data;
    }
}

export interface IKrosAdminApplicationPermissionDTO {
    adminButtons_list?: boolean;
    adminButtons_detail?: boolean;
    adminRoles_list?: boolean;
    adminRoles_detail?: boolean;
    adminUserGroups_list?: boolean;
    adminUserGroups_detail?: boolean;
    adminUsers_list?: boolean;
    adminUsers_detail?: boolean;
    applications_list?: boolean;
    buildingBills_list?: boolean;
    buildingBills_detail?: boolean;
    buildingDiary_list?: boolean;
    buildingDiary_detail?: boolean;
    buildingDiaryRecords_list?: boolean;
    buildingDiaryRecords_detail?: boolean;
    buildingDocuments_list?: boolean;
    buildingDocuments_detail?: boolean;
    buildingHours_list?: boolean;
    buildings_list?: boolean;
    buildings_detail?: boolean;
    buttons_list?: boolean;
    buttons_detail?: boolean;
    dashboard_list?: boolean;
    deleteLog_list?: boolean;
    documentTemplates_list?: boolean;
    documentTemplates_detail?: boolean;
    documentTemplatesHistory_delete?: boolean;
    documentTemplatesHistory_list?: boolean;
    employeeBozps_list?: boolean;
    employeeBozps_detail?: boolean;
    employeeBozpsSettings_list?: boolean;
    employeeBozpsSettings_detail?: boolean;
    employeeDocuments_list?: boolean;
    employeeDocuments_detail?: boolean;
    employeeGroups_list?: boolean;
    employeeGroups_detail?: boolean;
    employeeHolidays_list?: boolean;
    employeeNews_list?: boolean;
    employeeNews_detail?: boolean;
    employees_list?: boolean;
    employees_detail?: boolean;
    investorRoles_list?: boolean;
    investorRoles_detail?: boolean;
    investors_list?: boolean;
    investors_detail?: boolean;
    languages_list?: boolean;
    myFiles_list?: boolean;
    myFiles_detail?: boolean;
    orders_list?: boolean;
    records_list?: boolean;
    records_detail?: boolean;
    rental_list?: boolean;
    rental_detail?: boolean;
    requests_list?: boolean;
    requests_detail?: boolean;
    requestsRepeat_list?: boolean;
    requestsRepeat_detail?: boolean;
    settings_list?: boolean;
    statistics_list?: boolean;
    stockAssemblies_list?: boolean;
    stockManufacturers_list?: boolean;
    stockManufacturers_detail?: boolean;
    stockProductCategories_list?: boolean;
    stockProductCategories_detail?: boolean;
    stockProducts_list?: boolean;
    stockProducts_detail?: boolean;
    stockWarehouses_list?: boolean;
    stockWarehouses_detail?: boolean;
    transitions_list?: boolean;
    wealth_list?: boolean;
    wealth_detail?: boolean;
    wealthDocuments_list?: boolean;
    wealthDocuments_detail?: boolean;
    workHours_list?: boolean;
    workHoursPay_list?: boolean;
}

export class LockDiaryRecordRequest implements ILockDiaryRecordRequest {
    diaryRecordId?: number;
    lock?: boolean;

    constructor(data?: ILockDiaryRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.lock = _data["lock"];
        }
    }

    static fromJS(data: any): LockDiaryRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LockDiaryRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["lock"] = this.lock;
        return data;
    }
}

export interface ILockDiaryRecordRequest {
    diaryRecordId?: number;
    lock?: boolean;
}

export class LockDiaryRecordResponse implements ILockDiaryRecordResponse {
    ok?: boolean;

    constructor(data?: ILockDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): LockDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LockDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ILockDiaryRecordResponse {
    ok?: boolean;
}

export class LockSubcontractorDiaryRecordRequest implements ILockSubcontractorDiaryRecordRequest {
    diaryRecordId?: number;
    lock?: boolean;

    constructor(data?: ILockSubcontractorDiaryRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.lock = _data["lock"];
        }
    }

    static fromJS(data: any): LockSubcontractorDiaryRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LockSubcontractorDiaryRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["lock"] = this.lock;
        return data;
    }
}

export interface ILockSubcontractorDiaryRecordRequest {
    diaryRecordId?: number;
    lock?: boolean;
}

export enum LoginPhotoEnum {
    NO = 0,
    YES = 1,
    UNDETERMINED = 2,
}

export class ManufacturerListPageDTO implements IManufacturerListPageDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IManufacturerListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ManufacturerListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturerListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IManufacturerListPageDTO {
    id?: number;
    name?: string | undefined;
}

export enum MaritalStatusEnum {
    Single = 1,
    Married = 2,
    Divorced = 3,
    Widowed = 4,
}

export class MarkConversationAsReadRequest implements IMarkConversationAsReadRequest {
    taskId?: number;

    constructor(data?: IMarkConversationAsReadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): MarkConversationAsReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkConversationAsReadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface IMarkConversationAsReadRequest {
    taskId?: number;
}

export class MarkConversationAsReadResponse implements IMarkConversationAsReadResponse {
    ok?: boolean;

    constructor(data?: IMarkConversationAsReadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MarkConversationAsReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkConversationAsReadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMarkConversationAsReadResponse {
    ok?: boolean;
}

export class MarkerWithPositionDto implements IMarkerWithPositionDto {
    id?: number;
    mapTop?: number;
    mapLeft?: number;
    buildingTodoMapId?: number;
    mapTagColor?: string | undefined;

    constructor(data?: IMarkerWithPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapTop = _data["mapTop"];
            this.mapLeft = _data["mapLeft"];
            this.buildingTodoMapId = _data["buildingTodoMapId"];
            this.mapTagColor = _data["mapTagColor"];
        }
    }

    static fromJS(data: any): MarkerWithPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkerWithPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapTop"] = this.mapTop;
        data["mapLeft"] = this.mapLeft;
        data["buildingTodoMapId"] = this.buildingTodoMapId;
        data["mapTagColor"] = this.mapTagColor;
        return data;
    }
}

export interface IMarkerWithPositionDto {
    id?: number;
    mapTop?: number;
    mapLeft?: number;
    buildingTodoMapId?: number;
    mapTagColor?: string | undefined;
}

export class MeasureUnitListPageDTO implements IMeasureUnitListPageDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IMeasureUnitListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MeasureUnitListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MeasureUnitListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMeasureUnitListPageDTO {
    id?: number;
    name?: string | undefined;
}

export class MeEmployeeResponse implements IMeEmployeeResponse {
    initials?: string | undefined;
    fullName?: string | undefined;
    takeLoginPhoto?: boolean;
    workTimeNotifyFrom?: Date | undefined;
    workTimeNotifyTo?: Date | undefined;
    adminUserId?: number | undefined;
    adminAccessToken?: string | undefined;
    adminRefreshToken?: string | undefined;

    constructor(data?: IMeEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initials = _data["initials"];
            this.fullName = _data["fullName"];
            this.takeLoginPhoto = _data["takeLoginPhoto"];
            this.workTimeNotifyFrom = _data["workTimeNotifyFrom"] ? new Date(_data["workTimeNotifyFrom"].toString()) : <any>undefined;
            this.workTimeNotifyTo = _data["workTimeNotifyTo"] ? new Date(_data["workTimeNotifyTo"].toString()) : <any>undefined;
            this.adminUserId = _data["adminUserId"];
            this.adminAccessToken = _data["adminAccessToken"];
            this.adminRefreshToken = _data["adminRefreshToken"];
        }
    }

    static fromJS(data: any): MeEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeEmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initials"] = this.initials;
        data["fullName"] = this.fullName;
        data["takeLoginPhoto"] = this.takeLoginPhoto;
        data["workTimeNotifyFrom"] = this.workTimeNotifyFrom ? this.workTimeNotifyFrom.toISOString() : <any>undefined;
        data["workTimeNotifyTo"] = this.workTimeNotifyTo ? this.workTimeNotifyTo.toISOString() : <any>undefined;
        data["adminUserId"] = this.adminUserId;
        data["adminAccessToken"] = this.adminAccessToken;
        data["adminRefreshToken"] = this.adminRefreshToken;
        return data;
    }
}

export interface IMeEmployeeResponse {
    initials?: string | undefined;
    fullName?: string | undefined;
    takeLoginPhoto?: boolean;
    workTimeNotifyFrom?: Date | undefined;
    workTimeNotifyTo?: Date | undefined;
    adminUserId?: number | undefined;
    adminAccessToken?: string | undefined;
    adminRefreshToken?: string | undefined;
}

export enum MessageDTOSenderType {
    Admin = 0,
    Investor = 1,
    Employee = 2,
}

export class MessageWithDateDTO implements IMessageWithDateDTO {
    id?: number;
    type?: string | undefined;
    senderName?: string | undefined;
    senderType?: MessageDTOSenderType;
    senderId?: number;
    messageText?: string | undefined;
    fileUrl?: string | undefined;
    imageUrl?: string | undefined;
    datetime?: string | undefined;
    read?: boolean;
    additionalProperties?: { [key: string]: any; } | undefined;
    datetimeDate?: Date;
    fileName?: string | undefined;

    constructor(data?: IMessageWithDateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.senderName = _data["senderName"];
            this.senderType = _data["senderType"];
            this.senderId = _data["senderId"];
            this.messageText = _data["messageText"];
            this.fileUrl = _data["fileUrl"];
            this.imageUrl = _data["imageUrl"];
            this.datetime = _data["datetime"];
            this.read = _data["read"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
            this.datetimeDate = _data["datetimeDate"] ? new Date(_data["datetimeDate"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): MessageWithDateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MessageWithDateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["senderName"] = this.senderName;
        data["senderType"] = this.senderType;
        data["senderId"] = this.senderId;
        data["messageText"] = this.messageText;
        data["fileUrl"] = this.fileUrl;
        data["imageUrl"] = this.imageUrl;
        data["datetime"] = this.datetime;
        data["read"] = this.read;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        data["datetimeDate"] = this.datetimeDate ? this.datetimeDate.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IMessageWithDateDTO {
    id?: number;
    type?: string | undefined;
    senderName?: string | undefined;
    senderType?: MessageDTOSenderType;
    senderId?: number;
    messageText?: string | undefined;
    fileUrl?: string | undefined;
    imageUrl?: string | undefined;
    datetime?: string | undefined;
    read?: boolean;
    additionalProperties?: { [key: string]: any; } | undefined;
    datetimeDate?: Date;
    fileName?: string | undefined;
}

export class MobileBuildingDTO implements IMobileBuildingDTO {
    buildingId?: number;
    name?: string | undefined;
    code?: string | undefined;
    city?: string | undefined;
    admin?: boolean;
    gps_point_1?: GpsPoint;
    gps_point_2?: GpsPoint;
    gps_point_3?: GpsPoint;
    gps_point_4?: GpsPoint;

    constructor(data?: IMobileBuildingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.city = _data["city"];
            this.admin = _data["admin"];
            this.gps_point_1 = _data["gps_point_1"] ? GpsPoint.fromJS(_data["gps_point_1"]) : <any>undefined;
            this.gps_point_2 = _data["gps_point_2"] ? GpsPoint.fromJS(_data["gps_point_2"]) : <any>undefined;
            this.gps_point_3 = _data["gps_point_3"] ? GpsPoint.fromJS(_data["gps_point_3"]) : <any>undefined;
            this.gps_point_4 = _data["gps_point_4"] ? GpsPoint.fromJS(_data["gps_point_4"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileBuildingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MobileBuildingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["city"] = this.city;
        data["admin"] = this.admin;
        data["gps_point_1"] = this.gps_point_1 ? this.gps_point_1.toJSON() : <any>undefined;
        data["gps_point_2"] = this.gps_point_2 ? this.gps_point_2.toJSON() : <any>undefined;
        data["gps_point_3"] = this.gps_point_3 ? this.gps_point_3.toJSON() : <any>undefined;
        data["gps_point_4"] = this.gps_point_4 ? this.gps_point_4.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMobileBuildingDTO {
    buildingId?: number;
    name?: string | undefined;
    code?: string | undefined;
    city?: string | undefined;
    admin?: boolean;
    gps_point_1?: GpsPoint;
    gps_point_2?: GpsPoint;
    gps_point_3?: GpsPoint;
    gps_point_4?: GpsPoint;
}

export class MobileDiaryRecordDTO implements IMobileDiaryRecordDTO {
    id?: number;
    isReadOnly?: boolean;
    isLocked?: boolean;
    completedWorks?: string | undefined;
    isSharedCompletedWorks?: boolean;
    weathers?: GetWeatherForRecordDTO[] | undefined;
    workers?: GetWorkerForRecordDTO[] | undefined;
    materials?: GetMaterialsForRecordTableDTO[] | undefined;
    machines?: GetMachinesForRecordTableDTO[] | undefined;

    constructor(data?: IMobileDiaryRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isReadOnly = _data["isReadOnly"];
            this.isLocked = _data["isLocked"];
            this.completedWorks = _data["completedWorks"];
            this.isSharedCompletedWorks = _data["isSharedCompletedWorks"];
            if (Array.isArray(_data["weathers"])) {
                this.weathers = [] as any;
                for (let item of _data["weathers"])
                    this.weathers!.push(GetWeatherForRecordDTO.fromJS(item));
            }
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(GetWorkerForRecordDTO.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(GetMaterialsForRecordTableDTO.fromJS(item));
            }
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(GetMachinesForRecordTableDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MobileDiaryRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MobileDiaryRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isReadOnly"] = this.isReadOnly;
        data["isLocked"] = this.isLocked;
        data["completedWorks"] = this.completedWorks;
        data["isSharedCompletedWorks"] = this.isSharedCompletedWorks;
        if (Array.isArray(this.weathers)) {
            data["weathers"] = [];
            for (let item of this.weathers)
                data["weathers"].push(item.toJSON());
        }
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMobileDiaryRecordDTO {
    id?: number;
    isReadOnly?: boolean;
    isLocked?: boolean;
    completedWorks?: string | undefined;
    isSharedCompletedWorks?: boolean;
    weathers?: GetWeatherForRecordDTO[] | undefined;
    workers?: GetWorkerForRecordDTO[] | undefined;
    materials?: GetMaterialsForRecordTableDTO[] | undefined;
    machines?: GetMachinesForRecordTableDTO[] | undefined;
}

export class MobileWealthDTO implements IMobileWealthDTO {
    wealthId?: number;
    name?: string | undefined;
    code?: string | undefined;
    imagePreview?: string | undefined;
    employeeCodeAndName?: string | undefined;
    borrowedByCurrentEmployee?: boolean;
    buildingCodeAndName?: string | undefined;
    rentDateFrom?: Date | undefined;
    rentDateTo?: Date | undefined;

    constructor(data?: IMobileWealthDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wealthId = _data["wealthId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.imagePreview = _data["imagePreview"];
            this.employeeCodeAndName = _data["employeeCodeAndName"];
            this.borrowedByCurrentEmployee = _data["borrowedByCurrentEmployee"];
            this.buildingCodeAndName = _data["buildingCodeAndName"];
            this.rentDateFrom = _data["rentDateFrom"] ? new Date(_data["rentDateFrom"].toString()) : <any>undefined;
            this.rentDateTo = _data["rentDateTo"] ? new Date(_data["rentDateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileWealthDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MobileWealthDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wealthId"] = this.wealthId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["imagePreview"] = this.imagePreview;
        data["employeeCodeAndName"] = this.employeeCodeAndName;
        data["borrowedByCurrentEmployee"] = this.borrowedByCurrentEmployee;
        data["buildingCodeAndName"] = this.buildingCodeAndName;
        data["rentDateFrom"] = this.rentDateFrom ? this.rentDateFrom.toISOString() : <any>undefined;
        data["rentDateTo"] = this.rentDateTo ? this.rentDateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMobileWealthDTO {
    wealthId?: number;
    name?: string | undefined;
    code?: string | undefined;
    imagePreview?: string | undefined;
    employeeCodeAndName?: string | undefined;
    borrowedByCurrentEmployee?: boolean;
    buildingCodeAndName?: string | undefined;
    rentDateFrom?: Date | undefined;
    rentDateTo?: Date | undefined;
}

export class MoveBuildingsFromTrashRequest implements IMoveBuildingsFromTrashRequest {
    deletedBuildingsIds?: number[] | undefined;

    constructor(data?: IMoveBuildingsFromTrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedBuildingsIds"])) {
                this.deletedBuildingsIds = [] as any;
                for (let item of _data["deletedBuildingsIds"])
                    this.deletedBuildingsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveBuildingsFromTrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveBuildingsFromTrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedBuildingsIds)) {
            data["deletedBuildingsIds"] = [];
            for (let item of this.deletedBuildingsIds)
                data["deletedBuildingsIds"].push(item);
        }
        return data;
    }
}

export interface IMoveBuildingsFromTrashRequest {
    deletedBuildingsIds?: number[] | undefined;
}

export class MoveBuildingsFromTrashResponse implements IMoveBuildingsFromTrashResponse {
    ok?: boolean;

    constructor(data?: IMoveBuildingsFromTrashResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MoveBuildingsFromTrashResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveBuildingsFromTrashResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMoveBuildingsFromTrashResponse {
    ok?: boolean;
}

export class MoveDialyRecordsFromTrashRequest implements IMoveDialyRecordsFromTrashRequest {
    deletedDailyRecordsIds?: number[] | undefined;

    constructor(data?: IMoveDialyRecordsFromTrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedDailyRecordsIds"])) {
                this.deletedDailyRecordsIds = [] as any;
                for (let item of _data["deletedDailyRecordsIds"])
                    this.deletedDailyRecordsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveDialyRecordsFromTrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDialyRecordsFromTrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedDailyRecordsIds)) {
            data["deletedDailyRecordsIds"] = [];
            for (let item of this.deletedDailyRecordsIds)
                data["deletedDailyRecordsIds"].push(item);
        }
        return data;
    }
}

export interface IMoveDialyRecordsFromTrashRequest {
    deletedDailyRecordsIds?: number[] | undefined;
}

export class MoveDialyRecordsFromTrashResponse implements IMoveDialyRecordsFromTrashResponse {
    ok?: boolean;

    constructor(data?: IMoveDialyRecordsFromTrashResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MoveDialyRecordsFromTrashResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDialyRecordsFromTrashResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMoveDialyRecordsFromTrashResponse {
    ok?: boolean;
}

export class MoveDialyRecordsFromTrashSubcontractorRequest implements IMoveDialyRecordsFromTrashSubcontractorRequest {
    deletedDailyRecordsIds?: number[] | undefined;

    constructor(data?: IMoveDialyRecordsFromTrashSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedDailyRecordsIds"])) {
                this.deletedDailyRecordsIds = [] as any;
                for (let item of _data["deletedDailyRecordsIds"])
                    this.deletedDailyRecordsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveDialyRecordsFromTrashSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDialyRecordsFromTrashSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedDailyRecordsIds)) {
            data["deletedDailyRecordsIds"] = [];
            for (let item of this.deletedDailyRecordsIds)
                data["deletedDailyRecordsIds"].push(item);
        }
        return data;
    }
}

export interface IMoveDialyRecordsFromTrashSubcontractorRequest {
    deletedDailyRecordsIds?: number[] | undefined;
}

export class MoveDiariesFromTrashRequest implements IMoveDiariesFromTrashRequest {
    deletedDiariesIds?: number[] | undefined;

    constructor(data?: IMoveDiariesFromTrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedDiariesIds"])) {
                this.deletedDiariesIds = [] as any;
                for (let item of _data["deletedDiariesIds"])
                    this.deletedDiariesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveDiariesFromTrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDiariesFromTrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedDiariesIds)) {
            data["deletedDiariesIds"] = [];
            for (let item of this.deletedDiariesIds)
                data["deletedDiariesIds"].push(item);
        }
        return data;
    }
}

export interface IMoveDiariesFromTrashRequest {
    deletedDiariesIds?: number[] | undefined;
}

export class MoveDiariesFromTrashResponse implements IMoveDiariesFromTrashResponse {
    ok?: boolean;

    constructor(data?: IMoveDiariesFromTrashResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MoveDiariesFromTrashResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDiariesFromTrashResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMoveDiariesFromTrashResponse {
    ok?: boolean;
}

export class MoveEmployeesFromTrashRequest implements IMoveEmployeesFromTrashRequest {
    deletedEmployeeIds?: number[] | undefined;

    constructor(data?: IMoveEmployeesFromTrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedEmployeeIds"])) {
                this.deletedEmployeeIds = [] as any;
                for (let item of _data["deletedEmployeeIds"])
                    this.deletedEmployeeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveEmployeesFromTrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveEmployeesFromTrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedEmployeeIds)) {
            data["deletedEmployeeIds"] = [];
            for (let item of this.deletedEmployeeIds)
                data["deletedEmployeeIds"].push(item);
        }
        return data;
    }
}

export interface IMoveEmployeesFromTrashRequest {
    deletedEmployeeIds?: number[] | undefined;
}

export class MoveEmployeesFromTrashResponse implements IMoveEmployeesFromTrashResponse {
    ok?: boolean;

    constructor(data?: IMoveEmployeesFromTrashResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MoveEmployeesFromTrashResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveEmployeesFromTrashResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMoveEmployeesFromTrashResponse {
    ok?: boolean;
}

export class MoveInvoicesFromTrashRequest implements IMoveInvoicesFromTrashRequest {
    deletedInvoicesIds?: number[] | undefined;

    constructor(data?: IMoveInvoicesFromTrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedInvoicesIds"])) {
                this.deletedInvoicesIds = [] as any;
                for (let item of _data["deletedInvoicesIds"])
                    this.deletedInvoicesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveInvoicesFromTrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveInvoicesFromTrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedInvoicesIds)) {
            data["deletedInvoicesIds"] = [];
            for (let item of this.deletedInvoicesIds)
                data["deletedInvoicesIds"].push(item);
        }
        return data;
    }
}

export interface IMoveInvoicesFromTrashRequest {
    deletedInvoicesIds?: number[] | undefined;
}

export class MoveInvoicesFromTrashResponse implements IMoveInvoicesFromTrashResponse {
    ok?: boolean;

    constructor(data?: IMoveInvoicesFromTrashResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MoveInvoicesFromTrashResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveInvoicesFromTrashResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMoveInvoicesFromTrashResponse {
    ok?: boolean;
}

export class MoveTodosFromThrashRequest implements IMoveTodosFromThrashRequest {
    deletedTodoIds?: number[] | undefined;

    constructor(data?: IMoveTodosFromThrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedTodoIds"])) {
                this.deletedTodoIds = [] as any;
                for (let item of _data["deletedTodoIds"])
                    this.deletedTodoIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveTodosFromThrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTodosFromThrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedTodoIds)) {
            data["deletedTodoIds"] = [];
            for (let item of this.deletedTodoIds)
                data["deletedTodoIds"].push(item);
        }
        return data;
    }
}

export interface IMoveTodosFromThrashRequest {
    deletedTodoIds?: number[] | undefined;
}

export class MoveTodosFromThrashResponse implements IMoveTodosFromThrashResponse {
    ok?: boolean;

    constructor(data?: IMoveTodosFromThrashResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MoveTodosFromThrashResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTodosFromThrashResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMoveTodosFromThrashResponse {
    ok?: boolean;
}

export class MoveWealthsFromTrashRequest implements IMoveWealthsFromTrashRequest {
    deletedWealthsIds?: number[] | undefined;

    constructor(data?: IMoveWealthsFromTrashRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedWealthsIds"])) {
                this.deletedWealthsIds = [] as any;
                for (let item of _data["deletedWealthsIds"])
                    this.deletedWealthsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveWealthsFromTrashRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveWealthsFromTrashRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedWealthsIds)) {
            data["deletedWealthsIds"] = [];
            for (let item of this.deletedWealthsIds)
                data["deletedWealthsIds"].push(item);
        }
        return data;
    }
}

export interface IMoveWealthsFromTrashRequest {
    deletedWealthsIds?: number[] | undefined;
}

export class MoveWealthsFromTrashResponse implements IMoveWealthsFromTrashResponse {
    ok?: boolean;

    constructor(data?: IMoveWealthsFromTrashResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): MoveWealthsFromTrashResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveWealthsFromTrashResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IMoveWealthsFromTrashResponse {
    ok?: boolean;
}

export class OpenActionDTO implements IOpenActionDTO {
    stockListId?: number;
    datetime?: Date;
    state?: string | undefined;

    constructor(data?: IOpenActionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockListId = _data["stockListId"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): OpenActionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OpenActionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockListId"] = this.stockListId;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IOpenActionDTO {
    stockListId?: number;
    datetime?: Date;
    state?: string | undefined;
}

export class PartialRegistrationRequest implements IPartialRegistrationRequest {
    companyName?: string | undefined;
    email?: string | undefined;
    source?: string | undefined;
    language?: string | undefined;

    constructor(data?: IPartialRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.source = _data["source"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): PartialRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartialRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["source"] = this.source;
        data["language"] = this.language;
        return data;
    }
}

export interface IPartialRegistrationRequest {
    companyName?: string | undefined;
    email?: string | undefined;
    source?: string | undefined;
    language?: string | undefined;
}

export class PartialRegistrationResponse implements IPartialRegistrationResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number | undefined;

    constructor(data?: IPartialRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PartialRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartialRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface IPartialRegistrationResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number | undefined;
}

export class PostDiaryChatMessageInvestorsRequest implements IPostDiaryChatMessageInvestorsRequest {
    diaryRecordId?: number;
    text?: string | undefined;

    constructor(data?: IPostDiaryChatMessageInvestorsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): PostDiaryChatMessageInvestorsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostDiaryChatMessageInvestorsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["text"] = this.text;
        return data;
    }
}

export interface IPostDiaryChatMessageInvestorsRequest {
    diaryRecordId?: number;
    text?: string | undefined;
}

export class PostDiaryChatMessageInvestorsResponse implements IPostDiaryChatMessageInvestorsResponse {
    ok?: boolean;

    constructor(data?: IPostDiaryChatMessageInvestorsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PostDiaryChatMessageInvestorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostDiaryChatMessageInvestorsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPostDiaryChatMessageInvestorsResponse {
    ok?: boolean;
}

export class PostDiaryChatMessageInvestorsSubcontractorRequest implements IPostDiaryChatMessageInvestorsSubcontractorRequest {
    diaryRecordId?: number;
    text?: string | undefined;

    constructor(data?: IPostDiaryChatMessageInvestorsSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): PostDiaryChatMessageInvestorsSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostDiaryChatMessageInvestorsSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["text"] = this.text;
        return data;
    }
}

export interface IPostDiaryChatMessageInvestorsSubcontractorRequest {
    diaryRecordId?: number;
    text?: string | undefined;
}

export class PostDiaryChatMessageSubcontractorsAsSubcontractorsRequest implements IPostDiaryChatMessageSubcontractorsAsSubcontractorsRequest {
    diaryRecordId?: number;
    text?: string | undefined;

    constructor(data?: IPostDiaryChatMessageSubcontractorsAsSubcontractorsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): PostDiaryChatMessageSubcontractorsAsSubcontractorsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostDiaryChatMessageSubcontractorsAsSubcontractorsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["text"] = this.text;
        return data;
    }
}

export interface IPostDiaryChatMessageSubcontractorsAsSubcontractorsRequest {
    diaryRecordId?: number;
    text?: string | undefined;
}

export class PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse implements IPostDiaryChatMessageSubcontractorsAsSubcontractorsResponse {
    ok?: boolean;

    constructor(data?: IPostDiaryChatMessageSubcontractorsAsSubcontractorsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostDiaryChatMessageSubcontractorsAsSubcontractorsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPostDiaryChatMessageSubcontractorsAsSubcontractorsResponse {
    ok?: boolean;
}

export class PostDiaryChatMessageSubcontractorsRequest implements IPostDiaryChatMessageSubcontractorsRequest {
    diaryRecordId?: number;
    text?: string | undefined;

    constructor(data?: IPostDiaryChatMessageSubcontractorsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): PostDiaryChatMessageSubcontractorsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostDiaryChatMessageSubcontractorsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["text"] = this.text;
        return data;
    }
}

export interface IPostDiaryChatMessageSubcontractorsRequest {
    diaryRecordId?: number;
    text?: string | undefined;
}

export class PostDiaryChatMessageSubcontractorsResponse implements IPostDiaryChatMessageSubcontractorsResponse {
    ok?: boolean;

    constructor(data?: IPostDiaryChatMessageSubcontractorsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PostDiaryChatMessageSubcontractorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostDiaryChatMessageSubcontractorsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPostDiaryChatMessageSubcontractorsResponse {
    ok?: boolean;
}

export class PreviousMessagesDTO implements IPreviousMessagesDTO {
    role?: string | undefined;
    content?: string | undefined;

    constructor(data?: IPreviousMessagesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): PreviousMessagesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreviousMessagesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["content"] = this.content;
        return data;
    }
}

export interface IPreviousMessagesDTO {
    role?: string | undefined;
    content?: string | undefined;
}

export class PrintDiaryBackgroundRequest implements IPrintDiaryBackgroundRequest {
    printType?: DiaryPrintType;
    diaryId?: number;
    onlyMyNotes?: boolean;
    hasDigitalSignatureField?: boolean;
    hasAttachments?: boolean;
    hasPhotos?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    apiAdress?: string | undefined;

    constructor(data?: IPrintDiaryBackgroundRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.printType = _data["printType"];
            this.diaryId = _data["diaryId"];
            this.onlyMyNotes = _data["onlyMyNotes"];
            this.hasDigitalSignatureField = _data["hasDigitalSignatureField"];
            this.hasAttachments = _data["hasAttachments"];
            this.hasPhotos = _data["hasPhotos"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.apiAdress = _data["apiAdress"];
        }
    }

    static fromJS(data: any): PrintDiaryBackgroundRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintDiaryBackgroundRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["printType"] = this.printType;
        data["diaryId"] = this.diaryId;
        data["onlyMyNotes"] = this.onlyMyNotes;
        data["hasDigitalSignatureField"] = this.hasDigitalSignatureField;
        data["hasAttachments"] = this.hasAttachments;
        data["hasPhotos"] = this.hasPhotos;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["apiAdress"] = this.apiAdress;
        return data;
    }
}

export interface IPrintDiaryBackgroundRequest {
    printType?: DiaryPrintType;
    diaryId?: number;
    onlyMyNotes?: boolean;
    hasDigitalSignatureField?: boolean;
    hasAttachments?: boolean;
    hasPhotos?: boolean;
    dateFrom?: Date;
    dateTo?: Date;
    apiAdress?: string | undefined;
}

export class PrintSignedDiaryRecordsZIPRequest implements IPrintSignedDiaryRecordsZIPRequest {
    diaryId?: number;
    apiAdress?: string | undefined;

    constructor(data?: IPrintSignedDiaryRecordsZIPRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.apiAdress = _data["apiAdress"];
        }
    }

    static fromJS(data: any): PrintSignedDiaryRecordsZIPRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintSignedDiaryRecordsZIPRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["apiAdress"] = this.apiAdress;
        return data;
    }
}

export interface IPrintSignedDiaryRecordsZIPRequest {
    diaryId?: number;
    apiAdress?: string | undefined;
}

export class PrintWholeDiaryInvestorResponse implements IPrintWholeDiaryInvestorResponse {
    downloadUri?: string | undefined;

    constructor(data?: IPrintWholeDiaryInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUri = _data["downloadUri"];
        }
    }

    static fromJS(data: any): PrintWholeDiaryInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrintWholeDiaryInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUri"] = this.downloadUri;
        return data;
    }
}

export interface IPrintWholeDiaryInvestorResponse {
    downloadUri?: string | undefined;
}

export class ProductCategoryListPageDTO implements IProductCategoryListPageDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IProductCategoryListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProductCategoryListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProductCategoryListPageDTO {
    id?: number;
    name?: string | undefined;
}

export class ProductForDiaryDialogDTO implements IProductForDiaryDialogDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    stockManufacturerName?: string | undefined;
    stockProductCategoryName?: string | undefined;
    measureUnitName?: string | undefined;
    measureUnitAbbr?: string | undefined;

    constructor(data?: IProductForDiaryDialogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.stockManufacturerName = _data["stockManufacturerName"];
            this.stockProductCategoryName = _data["stockProductCategoryName"];
            this.measureUnitName = _data["measureUnitName"];
            this.measureUnitAbbr = _data["measureUnitAbbr"];
        }
    }

    static fromJS(data: any): ProductForDiaryDialogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductForDiaryDialogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["stockManufacturerName"] = this.stockManufacturerName;
        data["stockProductCategoryName"] = this.stockProductCategoryName;
        data["measureUnitName"] = this.measureUnitName;
        data["measureUnitAbbr"] = this.measureUnitAbbr;
        return data;
    }
}

export interface IProductForDiaryDialogDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    stockManufacturerName?: string | undefined;
    stockProductCategoryName?: string | undefined;
    measureUnitName?: string | undefined;
    measureUnitAbbr?: string | undefined;
}

export class ProductListPageDTO implements IProductListPageDTO {
    id?: number;
    code?: string | undefined;
    eanCode?: string | undefined;
    name?: string | undefined;
    stockManufacturerName?: string | undefined;
    stockProductCategoryName?: string | undefined;
    measureUnitName?: string | undefined;
    measureUnitAbbr?: string | undefined;
    rentPrice1?: number | undefined;
    unitWeight?: number | undefined;
    isActive?: boolean | undefined;
    isCode?: boolean;
    totalUnitsCount?: number;
    productSupplyInWarehouses?: ProductSupplyInWarehouseDTO[] | undefined;

    constructor(data?: IProductListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.eanCode = _data["eanCode"];
            this.name = _data["name"];
            this.stockManufacturerName = _data["stockManufacturerName"];
            this.stockProductCategoryName = _data["stockProductCategoryName"];
            this.measureUnitName = _data["measureUnitName"];
            this.measureUnitAbbr = _data["measureUnitAbbr"];
            this.rentPrice1 = _data["rentPrice1"];
            this.unitWeight = _data["unitWeight"];
            this.isActive = _data["isActive"];
            this.isCode = _data["isCode"];
            this.totalUnitsCount = _data["totalUnitsCount"];
            if (Array.isArray(_data["productSupplyInWarehouses"])) {
                this.productSupplyInWarehouses = [] as any;
                for (let item of _data["productSupplyInWarehouses"])
                    this.productSupplyInWarehouses!.push(ProductSupplyInWarehouseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["eanCode"] = this.eanCode;
        data["name"] = this.name;
        data["stockManufacturerName"] = this.stockManufacturerName;
        data["stockProductCategoryName"] = this.stockProductCategoryName;
        data["measureUnitName"] = this.measureUnitName;
        data["measureUnitAbbr"] = this.measureUnitAbbr;
        data["rentPrice1"] = this.rentPrice1;
        data["unitWeight"] = this.unitWeight;
        data["isActive"] = this.isActive;
        data["isCode"] = this.isCode;
        data["totalUnitsCount"] = this.totalUnitsCount;
        if (Array.isArray(this.productSupplyInWarehouses)) {
            data["productSupplyInWarehouses"] = [];
            for (let item of this.productSupplyInWarehouses)
                data["productSupplyInWarehouses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductListPageDTO {
    id?: number;
    code?: string | undefined;
    eanCode?: string | undefined;
    name?: string | undefined;
    stockManufacturerName?: string | undefined;
    stockProductCategoryName?: string | undefined;
    measureUnitName?: string | undefined;
    measureUnitAbbr?: string | undefined;
    rentPrice1?: number | undefined;
    unitWeight?: number | undefined;
    isActive?: boolean | undefined;
    isCode?: boolean;
    totalUnitsCount?: number;
    productSupplyInWarehouses?: ProductSupplyInWarehouseDTO[] | undefined;
}

export class ProductMovementListPageDTO implements IProductMovementListPageDTO {
    id?: number;
    datetime?: Date;
    state?: string | undefined;
    number?: string | undefined;
    warehouseName?: string | undefined;
    userName?: string | undefined;
    note?: string | undefined;
    totalUnitsCount?: number;
    totalPrice?: number;
    measureUnitAbbr?: string | undefined;

    constructor(data?: IProductMovementListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.number = _data["number"];
            this.warehouseName = _data["warehouseName"];
            this.userName = _data["userName"];
            this.note = _data["note"];
            this.totalUnitsCount = _data["totalUnitsCount"];
            this.totalPrice = _data["totalPrice"];
            this.measureUnitAbbr = _data["measureUnitAbbr"];
        }
    }

    static fromJS(data: any): ProductMovementListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMovementListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["number"] = this.number;
        data["warehouseName"] = this.warehouseName;
        data["userName"] = this.userName;
        data["note"] = this.note;
        data["totalUnitsCount"] = this.totalUnitsCount;
        data["totalPrice"] = this.totalPrice;
        data["measureUnitAbbr"] = this.measureUnitAbbr;
        return data;
    }
}

export interface IProductMovementListPageDTO {
    id?: number;
    datetime?: Date;
    state?: string | undefined;
    number?: string | undefined;
    warehouseName?: string | undefined;
    userName?: string | undefined;
    note?: string | undefined;
    totalUnitsCount?: number;
    totalPrice?: number;
    measureUnitAbbr?: string | undefined;
}

export class ProductSupplyInWarehouseDTO implements IProductSupplyInWarehouseDTO {
    warehouseId?: number;
    warehouseName?: string | undefined;
    totalUnitsCount?: number;
    measureUnitAbbr?: string | undefined;

    constructor(data?: IProductSupplyInWarehouseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.totalUnitsCount = _data["totalUnitsCount"];
            this.measureUnitAbbr = _data["measureUnitAbbr"];
        }
    }

    static fromJS(data: any): ProductSupplyInWarehouseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSupplyInWarehouseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["totalUnitsCount"] = this.totalUnitsCount;
        data["measureUnitAbbr"] = this.measureUnitAbbr;
        return data;
    }
}

export interface IProductSupplyInWarehouseDTO {
    warehouseId?: number;
    warehouseName?: string | undefined;
    totalUnitsCount?: number;
    measureUnitAbbr?: string | undefined;
}

export class PromptDTO implements IPromptDTO {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;

    constructor(data?: IPromptDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): PromptDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PromptDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["text"] = this.text;
        return data;
    }
}

export interface IPromptDTO {
    id?: number;
    name?: string | undefined;
    text?: string | undefined;
}

export enum PromptType {
    Unknown = 0,
    DiaryPhotoPrompt = 1,
}

export class ReauthRequest implements IReauthRequest {

    constructor(data?: IReauthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReauthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReauthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IReauthRequest {
}

export class ReauthResponse implements IReauthResponse {
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;

    constructor(data?: IReauthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.initials = _data["initials"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): ReauthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReauthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["initials"] = this.initials;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IReauthResponse {
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;
}

export class RecordSearchDTO implements IRecordSearchDTO {
    id?: number;
    name?: string | undefined;
    amount?: string | undefined;
    unit?: string | undefined;
    groupName?: string | undefined;
    type?: SEARCH_TYPE;

    constructor(data?: IRecordSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.groupName = _data["groupName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RecordSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["groupName"] = this.groupName;
        data["type"] = this.type;
        return data;
    }
}

export interface IRecordSearchDTO {
    id?: number;
    name?: string | undefined;
    amount?: string | undefined;
    unit?: string | undefined;
    groupName?: string | undefined;
    type?: SEARCH_TYPE;
}

export class RefreshEmployeeTokenRequest implements IRefreshEmployeeTokenRequest {
    accessToken?: string | undefined;
    refreshEmployeeToken?: string | undefined;

    constructor(data?: IRefreshEmployeeTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshEmployeeToken = _data["refreshEmployeeToken"];
        }
    }

    static fromJS(data: any): RefreshEmployeeTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshEmployeeTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshEmployeeToken"] = this.refreshEmployeeToken;
        return data;
    }
}

export interface IRefreshEmployeeTokenRequest {
    accessToken?: string | undefined;
    refreshEmployeeToken?: string | undefined;
}

export class RefreshEmployeeTokenResponse implements IRefreshEmployeeTokenResponse {
    accessToken?: string | undefined;
    accessTokenMobile?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshEmployeeTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenMobile = _data["accessTokenMobile"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshEmployeeTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshEmployeeTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenMobile"] = this.accessTokenMobile;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRefreshEmployeeTokenResponse {
    accessToken?: string | undefined;
    accessTokenMobile?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RefreshInvestorTokenRequest implements IRefreshInvestorTokenRequest {
    accessToken?: string | undefined;
    refreshInvestorToken?: string | undefined;

    constructor(data?: IRefreshInvestorTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshInvestorToken = _data["refreshInvestorToken"];
        }
    }

    static fromJS(data: any): RefreshInvestorTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshInvestorTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshInvestorToken"] = this.refreshInvestorToken;
        return data;
    }
}

export interface IRefreshInvestorTokenRequest {
    accessToken?: string | undefined;
    refreshInvestorToken?: string | undefined;
}

export class RefreshInvestorTokenResponse implements IRefreshInvestorTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshInvestorTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshInvestorTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshInvestorTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRefreshInvestorTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RefreshTokenSubcontractorRequest implements IRefreshTokenSubcontractorRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenSubcontractorRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenSubcontractorResponse implements IRefreshTokenSubcontractorResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshTokenSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTokenSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRefreshTokenSubcontractorResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RemoveTaskFromMapResponse implements IRemoveTaskFromMapResponse {
    ok?: boolean;

    constructor(data?: IRemoveTaskFromMapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RemoveTaskFromMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveTaskFromMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRemoveTaskFromMapResponse {
    ok?: boolean;
}

export class RenameCategoryBuildingRequest implements IRenameCategoryBuildingRequest {
    categoryId?: number;
    oldName?: string | undefined;
    newName?: string | undefined;

    constructor(data?: IRenameCategoryBuildingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.oldName = _data["oldName"];
            this.newName = _data["newName"];
        }
    }

    static fromJS(data: any): RenameCategoryBuildingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameCategoryBuildingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["oldName"] = this.oldName;
        data["newName"] = this.newName;
        return data;
    }
}

export interface IRenameCategoryBuildingRequest {
    categoryId?: number;
    oldName?: string | undefined;
    newName?: string | undefined;
}

export class RenameCategoryBuildingResponse implements IRenameCategoryBuildingResponse {
    ok?: boolean;

    constructor(data?: IRenameCategoryBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RenameCategoryBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameCategoryBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRenameCategoryBuildingResponse {
    ok?: boolean;
}

export class RenameDocumentOrFileRequest implements IRenameDocumentOrFileRequest {
    id?: number;
    name?: string | undefined;
    isFile?: boolean;

    constructor(data?: IRenameDocumentOrFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFile = _data["isFile"];
        }
    }

    static fromJS(data: any): RenameDocumentOrFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameDocumentOrFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFile"] = this.isFile;
        return data;
    }
}

export interface IRenameDocumentOrFileRequest {
    id?: number;
    name?: string | undefined;
    isFile?: boolean;
}

export class RenameDocumentOrFileResponse implements IRenameDocumentOrFileResponse {
    ok?: boolean;

    constructor(data?: IRenameDocumentOrFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RenameDocumentOrFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameDocumentOrFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRenameDocumentOrFileResponse {
    ok?: boolean;
}

export class RenameImagesBuildingRequest implements IRenameImagesBuildingRequest {
    imageId?: number;
    newName?: string | undefined;

    constructor(data?: IRenameImagesBuildingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.newName = _data["newName"];
        }
    }

    static fromJS(data: any): RenameImagesBuildingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameImagesBuildingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["newName"] = this.newName;
        return data;
    }
}

export interface IRenameImagesBuildingRequest {
    imageId?: number;
    newName?: string | undefined;
}

export class RenameImagesBuildingResponse implements IRenameImagesBuildingResponse {
    ok?: boolean;

    constructor(data?: IRenameImagesBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RenameImagesBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameImagesBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRenameImagesBuildingResponse {
    ok?: boolean;
}

export class RequestConversationDTO implements IRequestConversationDTO {
    id?: number;
    employeeId?: number | undefined;
    adminUserId?: number | undefined;
    investorId?: number | undefined;
    name?: string | undefined;
    text?: string | undefined;
    datetime?: Date;
    fileUrl?: string | undefined;
    fileThumbnailUrl?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IRequestConversationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.adminUserId = _data["adminUserId"];
            this.investorId = _data["investorId"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.fileUrl = _data["fileUrl"];
            this.fileThumbnailUrl = _data["fileThumbnailUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): RequestConversationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestConversationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["adminUserId"] = this.adminUserId;
        data["investorId"] = this.investorId;
        data["name"] = this.name;
        data["text"] = this.text;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["fileUrl"] = this.fileUrl;
        data["fileThumbnailUrl"] = this.fileThumbnailUrl;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IRequestConversationDTO {
    id?: number;
    employeeId?: number | undefined;
    adminUserId?: number | undefined;
    investorId?: number | undefined;
    name?: string | undefined;
    text?: string | undefined;
    datetime?: Date;
    fileUrl?: string | undefined;
    fileThumbnailUrl?: string | undefined;
    fileName?: string | undefined;
}

export class RequestEyetowerData implements IRequestEyetowerData {
    buildingId?: number;
    eyetowerType?: EyetowerType;
    installation?: boolean;
    deinstallation?: boolean;
    email?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    contactInfo?: string | undefined;
    gpsx?: number;
    gpsy?: number;
    electricity?: boolean;
    from?: Date;
    to?: Date;

    constructor(data?: IRequestEyetowerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            this.eyetowerType = _data["eyetowerType"];
            this.installation = _data["installation"];
            this.deinstallation = _data["deinstallation"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.contactInfo = _data["contactInfo"];
            this.gpsx = _data["gpsx"];
            this.gpsy = _data["gpsy"];
            this.electricity = _data["electricity"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestEyetowerData {
        data = typeof data === 'object' ? data : {};
        let result = new RequestEyetowerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        data["eyetowerType"] = this.eyetowerType;
        data["installation"] = this.installation;
        data["deinstallation"] = this.deinstallation;
        data["email"] = this.email;
        data["name"] = this.name;
        data["address"] = this.address;
        data["contactInfo"] = this.contactInfo;
        data["gpsx"] = this.gpsx;
        data["gpsy"] = this.gpsy;
        data["electricity"] = this.electricity;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRequestEyetowerData {
    buildingId?: number;
    eyetowerType?: EyetowerType;
    installation?: boolean;
    deinstallation?: boolean;
    email?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    contactInfo?: string | undefined;
    gpsx?: number;
    gpsy?: number;
    electricity?: boolean;
    from?: Date;
    to?: Date;
}

export class RequestEyetowerRequest implements IRequestEyetowerRequest {
    data?: RequestEyetowerData;

    constructor(data?: IRequestEyetowerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RequestEyetowerData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestEyetowerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestEyetowerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestEyetowerRequest {
    data?: RequestEyetowerData;
}

export class RequestEyetowerResponse implements IRequestEyetowerResponse {
    ok?: boolean;

    constructor(data?: IRequestEyetowerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RequestEyetowerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestEyetowerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRequestEyetowerResponse {
    ok?: boolean;
}

export enum RequestOriginType {
    AdminUser = 0,
    Employee = 1,
    Investor = 2,
}

export class RequestResponseDTO implements IRequestResponseDTO {
    requestId?: number;
    text?: string | undefined;
    description?: string | undefined;
    datetime?: string | undefined;
    datetimeTo?: string | undefined;
    buildingId?: number;
    wealthId?: number | undefined;
    state?: RequestResponseDTOState;
    adminUser?: string | undefined;
    creator?: string | undefined;
    assignee?: AssigneeResponseDTO;
    flow?: string | undefined;
    images?: string[] | undefined;
    unreadMessages?: number;
    additionalProperties?: { [key: string]: any; } | undefined;

    constructor(data?: IRequestResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.text = _data["text"];
            this.description = _data["description"];
            this.datetime = _data["datetime"];
            this.datetimeTo = _data["datetimeTo"];
            this.buildingId = _data["buildingId"];
            this.wealthId = _data["wealthId"];
            this.state = _data["state"];
            this.adminUser = _data["adminUser"];
            this.creator = _data["creator"];
            this.assignee = _data["assignee"] ? AssigneeResponseDTO.fromJS(_data["assignee"]) : <any>undefined;
            this.flow = _data["flow"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.unreadMessages = _data["unreadMessages"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): RequestResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["text"] = this.text;
        data["description"] = this.description;
        data["datetime"] = this.datetime;
        data["datetimeTo"] = this.datetimeTo;
        data["buildingId"] = this.buildingId;
        data["wealthId"] = this.wealthId;
        data["state"] = this.state;
        data["adminUser"] = this.adminUser;
        data["creator"] = this.creator;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["flow"] = this.flow;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["unreadMessages"] = this.unreadMessages;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IRequestResponseDTO {
    requestId?: number;
    text?: string | undefined;
    description?: string | undefined;
    datetime?: string | undefined;
    datetimeTo?: string | undefined;
    buildingId?: number;
    wealthId?: number | undefined;
    state?: RequestResponseDTOState;
    adminUser?: string | undefined;
    creator?: string | undefined;
    assignee?: AssigneeResponseDTO;
    flow?: string | undefined;
    images?: string[] | undefined;
    unreadMessages?: number;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export enum RequestResponseDTOState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RequestResponseWithBuildingDTO implements IRequestResponseWithBuildingDTO {
    id?: number;
    text?: string | undefined;
    description?: string | undefined;
    datetime?: Date;
    datetimeTo?: Date | undefined;
    buildingId?: number;
    wealthId?: number | undefined;
    state?: TodoState;
    adminUser?: string | undefined;
    creator?: string | undefined;
    assignee?: AssigneeDto;
    flow?: string | undefined;
    images?: string[] | undefined;
    unreadMessages?: number;
    buildingName?: string | undefined;

    constructor(data?: IRequestResponseWithBuildingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.description = _data["description"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.datetimeTo = _data["datetimeTo"] ? new Date(_data["datetimeTo"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.wealthId = _data["wealthId"];
            this.state = _data["state"];
            this.adminUser = _data["adminUser"];
            this.creator = _data["creator"];
            this.assignee = _data["assignee"] ? AssigneeDto.fromJS(_data["assignee"]) : <any>undefined;
            this.flow = _data["flow"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.unreadMessages = _data["unreadMessages"];
            this.buildingName = _data["buildingName"];
        }
    }

    static fromJS(data: any): RequestResponseWithBuildingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResponseWithBuildingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["description"] = this.description;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["datetimeTo"] = this.datetimeTo ? this.datetimeTo.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["wealthId"] = this.wealthId;
        data["state"] = this.state;
        data["adminUser"] = this.adminUser;
        data["creator"] = this.creator;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["flow"] = this.flow;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["unreadMessages"] = this.unreadMessages;
        data["buildingName"] = this.buildingName;
        return data;
    }
}

export interface IRequestResponseWithBuildingDTO {
    id?: number;
    text?: string | undefined;
    description?: string | undefined;
    datetime?: Date;
    datetimeTo?: Date | undefined;
    buildingId?: number;
    wealthId?: number | undefined;
    state?: TodoState;
    adminUser?: string | undefined;
    creator?: string | undefined;
    assignee?: AssigneeDto;
    flow?: string | undefined;
    images?: string[] | undefined;
    unreadMessages?: number;
    buildingName?: string | undefined;
}

export class RequestsDTO implements IRequestsDTO {
    id?: number;
    appId?: number;
    name?: string | undefined;
    description?: string | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    progress?: number;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    employeeId?: number | undefined;
    investorId?: number | undefined;
    processingAdminId?: number | undefined;
    building?: string | undefined;
    investor?: string | undefined;
    employee?: string | undefined;
    date?: Date;
    dateTo?: Date | undefined;
    color?: string | undefined;
    stateString?: string | undefined;
    stateLocalizedString?: string | undefined;
    rowVersion?: string | undefined;
    hasUnreadConversation?: boolean;
    isDone?: number;
    isDoneString?: string | undefined;
    adminUsers?: AdminUserDTO[] | undefined;

    constructor(data?: IRequestsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appId = _data["appId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.progress = _data["progress"];
            this.buildingId = _data["buildingId"];
            this.buildingDiaryId = _data["buildingDiaryId"];
            this.employeeId = _data["employeeId"];
            this.investorId = _data["investorId"];
            this.processingAdminId = _data["processingAdminId"];
            this.building = _data["building"];
            this.investor = _data["investor"];
            this.employee = _data["employee"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.stateString = _data["stateString"];
            this.stateLocalizedString = _data["stateLocalizedString"];
            this.rowVersion = _data["rowVersion"];
            this.hasUnreadConversation = _data["hasUnreadConversation"];
            this.isDone = _data["isDone"];
            this.isDoneString = _data["isDoneString"];
            if (Array.isArray(_data["adminUsers"])) {
                this.adminUsers = [] as any;
                for (let item of _data["adminUsers"])
                    this.adminUsers!.push(AdminUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appId"] = this.appId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["progress"] = this.progress;
        data["buildingId"] = this.buildingId;
        data["buildingDiaryId"] = this.buildingDiaryId;
        data["employeeId"] = this.employeeId;
        data["investorId"] = this.investorId;
        data["processingAdminId"] = this.processingAdminId;
        data["building"] = this.building;
        data["investor"] = this.investor;
        data["employee"] = this.employee;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["stateString"] = this.stateString;
        data["stateLocalizedString"] = this.stateLocalizedString;
        data["rowVersion"] = this.rowVersion;
        data["hasUnreadConversation"] = this.hasUnreadConversation;
        data["isDone"] = this.isDone;
        data["isDoneString"] = this.isDoneString;
        if (Array.isArray(this.adminUsers)) {
            data["adminUsers"] = [];
            for (let item of this.adminUsers)
                data["adminUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestsDTO {
    id?: number;
    appId?: number;
    name?: string | undefined;
    description?: string | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    progress?: number;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    employeeId?: number | undefined;
    investorId?: number | undefined;
    processingAdminId?: number | undefined;
    building?: string | undefined;
    investor?: string | undefined;
    employee?: string | undefined;
    date?: Date;
    dateTo?: Date | undefined;
    color?: string | undefined;
    stateString?: string | undefined;
    stateLocalizedString?: string | undefined;
    rowVersion?: string | undefined;
    hasUnreadConversation?: boolean;
    isDone?: number;
    isDoneString?: string | undefined;
    adminUsers?: AdminUserDTO[] | undefined;
}

export class ResetInvestorPasswordRequest implements IResetInvestorPasswordRequest {
    email?: string | undefined;
    domain?: string | undefined;

    constructor(data?: IResetInvestorPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): ResetInvestorPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetInvestorPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["domain"] = this.domain;
        return data;
    }
}

export interface IResetInvestorPasswordRequest {
    email?: string | undefined;
    domain?: string | undefined;
}

export class ResetInvestorPasswordResponse implements IResetInvestorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IResetInvestorPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ResetInvestorPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetInvestorPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IResetInvestorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class ResetPasswordKrosAdminRequest implements IResetPasswordKrosAdminRequest {
    userId?: number;

    constructor(data?: IResetPasswordKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ResetPasswordKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IResetPasswordKrosAdminRequest {
    userId?: number;
}

export class ResetPasswordKrosAdminResponse implements IResetPasswordKrosAdminResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IResetPasswordKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ResetPasswordKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IResetPasswordKrosAdminResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    email?: string | undefined;
    domain?: string | undefined;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["domain"] = this.domain;
        return data;
    }
}

export interface IResetPasswordRequest {
    email?: string | undefined;
    domain?: string | undefined;
}

export class ResetPasswordResponse implements IResetPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IResetPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class ResetSubcontractorPasswordRequest implements IResetSubcontractorPasswordRequest {
    email?: string | undefined;
    domain?: string | undefined;

    constructor(data?: IResetSubcontractorPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): ResetSubcontractorPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetSubcontractorPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["domain"] = this.domain;
        return data;
    }
}

export interface IResetSubcontractorPasswordRequest {
    email?: string | undefined;
    domain?: string | undefined;
}

export class ResetSubcontractorPasswordResponse implements IResetSubcontractorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IResetSubcontractorPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ResetSubcontractorPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetSubcontractorPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IResetSubcontractorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class RestoreDeletedEmployeeDocumentFilesRequest implements IRestoreDeletedEmployeeDocumentFilesRequest {
    documentId?: number;
    filesIds?: number[] | undefined;

    constructor(data?: IRestoreDeletedEmployeeDocumentFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["filesIds"])) {
                this.filesIds = [] as any;
                for (let item of _data["filesIds"])
                    this.filesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RestoreDeletedEmployeeDocumentFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDeletedEmployeeDocumentFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        if (Array.isArray(this.filesIds)) {
            data["filesIds"] = [];
            for (let item of this.filesIds)
                data["filesIds"].push(item);
        }
        return data;
    }
}

export interface IRestoreDeletedEmployeeDocumentFilesRequest {
    documentId?: number;
    filesIds?: number[] | undefined;
}

export class RestoreDeletedEmployeeDocumentFilesResponse implements IRestoreDeletedEmployeeDocumentFilesResponse {
    ok?: boolean;

    constructor(data?: IRestoreDeletedEmployeeDocumentFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RestoreDeletedEmployeeDocumentFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDeletedEmployeeDocumentFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRestoreDeletedEmployeeDocumentFilesResponse {
    ok?: boolean;
}

export class RestoreDeletedProjectDocumentFilesRequest implements IRestoreDeletedProjectDocumentFilesRequest {
    documentId?: number;
    filesIds?: number[] | undefined;

    constructor(data?: IRestoreDeletedProjectDocumentFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["filesIds"])) {
                this.filesIds = [] as any;
                for (let item of _data["filesIds"])
                    this.filesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RestoreDeletedProjectDocumentFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDeletedProjectDocumentFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        if (Array.isArray(this.filesIds)) {
            data["filesIds"] = [];
            for (let item of this.filesIds)
                data["filesIds"].push(item);
        }
        return data;
    }
}

export interface IRestoreDeletedProjectDocumentFilesRequest {
    documentId?: number;
    filesIds?: number[] | undefined;
}

export class RestoreDeletedProjectDocumentFilesResponse implements IRestoreDeletedProjectDocumentFilesResponse {
    ok?: boolean;

    constructor(data?: IRestoreDeletedProjectDocumentFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RestoreDeletedProjectDocumentFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDeletedProjectDocumentFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRestoreDeletedProjectDocumentFilesResponse {
    ok?: boolean;
}

export class RestoreDeletedProjectFilesRequest implements IRestoreDeletedProjectFilesRequest {
    projectId?: number;
    filesIds?: number[] | undefined;

    constructor(data?: IRestoreDeletedProjectFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["filesIds"])) {
                this.filesIds = [] as any;
                for (let item of _data["filesIds"])
                    this.filesIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RestoreDeletedProjectFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDeletedProjectFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.filesIds)) {
            data["filesIds"] = [];
            for (let item of this.filesIds)
                data["filesIds"].push(item);
        }
        return data;
    }
}

export interface IRestoreDeletedProjectFilesRequest {
    projectId?: number;
    filesIds?: number[] | undefined;
}

export class RestoreDeletedProjectFilesResponse implements IRestoreDeletedProjectFilesResponse {
    ok?: boolean;

    constructor(data?: IRestoreDeletedProjectFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RestoreDeletedProjectFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreDeletedProjectFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRestoreDeletedProjectFilesResponse {
    ok?: boolean;
}

export class SaveApplicationDataKrosAdminRequest implements ISaveApplicationDataKrosAdminRequest {
    app?: AdminApplicationDataDTO;

    constructor(data?: ISaveApplicationDataKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.app = _data["app"] ? AdminApplicationDataDTO.fromJS(_data["app"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveApplicationDataKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveApplicationDataKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["app"] = this.app ? this.app.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveApplicationDataKrosAdminRequest {
    app?: AdminApplicationDataDTO;
}

export class SaveApplicationDataKrosAdminResponse implements ISaveApplicationDataKrosAdminResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number;

    constructor(data?: ISaveApplicationDataKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveApplicationDataKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveApplicationDataKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveApplicationDataKrosAdminResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number;
}

export class SaveBuildingCustomFieldValuesRequest implements ISaveBuildingCustomFieldValuesRequest {
    buildingId?: number;
    customFieldValues?: CustomFieldWithValueDto[] | undefined;

    constructor(data?: ISaveBuildingCustomFieldValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingId = _data["buildingId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldWithValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveBuildingCustomFieldValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBuildingCustomFieldValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingId"] = this.buildingId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveBuildingCustomFieldValuesRequest {
    buildingId?: number;
    customFieldValues?: CustomFieldWithValueDto[] | undefined;
}

export class SaveBuildingCustomFieldValuesResponse implements ISaveBuildingCustomFieldValuesResponse {
    ok?: boolean;

    constructor(data?: ISaveBuildingCustomFieldValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveBuildingCustomFieldValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBuildingCustomFieldValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveBuildingCustomFieldValuesResponse {
    ok?: boolean;
}

export class SaveBuildingRequest implements ISaveBuildingRequest {
    id?: number | undefined;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    contractNumber?: string | undefined;
    gpsX1?: number;
    gpsY1?: number;
    gpsDiff1?: number;
    address1?: string | undefined;
    parcelNumber1?: string | undefined;
    gpsX2?: number;
    gpsY2?: number;
    gpsDiff2?: number;
    address2?: string | undefined;
    parcelNumber2?: string | undefined;
    gpsActive2?: boolean;
    gpsX3?: number;
    gpsY3?: number;
    gpsDiff3?: number;
    address3?: string | undefined;
    parcelNumber3?: string | undefined;
    gpsActive3?: boolean;
    gpsX4?: number;
    gpsY4?: number;
    gpsDiff4?: number;
    address4?: string | undefined;
    parcelNumber4?: string | undefined;
    gpsActive4?: boolean;
    city?: string | undefined;
    client?: string | undefined;
    architect?: string | undefined;
    houseType?: string | undefined;
    notes?: string | undefined;
    hourlyRate?: number | undefined;
    state?: BuildingStateEnum;
    assignedUsers?: AssignedUserDTO[] | undefined;
    assignedEmployees?: AssignedEmployeeDTO[] | undefined;
    assignedInvestor?: InvestorDTO[] | undefined;
    noteList?: BuildingNoteDTO[] | undefined;
    createDiary?: boolean | undefined;
    createWarehouse?: boolean | undefined;

    constructor(data?: ISaveBuildingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isActive = _data["isActive"];
            this.showToEmployees = _data["showToEmployees"];
            this.contractNumber = _data["contractNumber"];
            this.gpsX1 = _data["gpsX1"];
            this.gpsY1 = _data["gpsY1"];
            this.gpsDiff1 = _data["gpsDiff1"];
            this.address1 = _data["address1"];
            this.parcelNumber1 = _data["parcelNumber1"];
            this.gpsX2 = _data["gpsX2"];
            this.gpsY2 = _data["gpsY2"];
            this.gpsDiff2 = _data["gpsDiff2"];
            this.address2 = _data["address2"];
            this.parcelNumber2 = _data["parcelNumber2"];
            this.gpsActive2 = _data["gpsActive2"];
            this.gpsX3 = _data["gpsX3"];
            this.gpsY3 = _data["gpsY3"];
            this.gpsDiff3 = _data["gpsDiff3"];
            this.address3 = _data["address3"];
            this.parcelNumber3 = _data["parcelNumber3"];
            this.gpsActive3 = _data["gpsActive3"];
            this.gpsX4 = _data["gpsX4"];
            this.gpsY4 = _data["gpsY4"];
            this.gpsDiff4 = _data["gpsDiff4"];
            this.address4 = _data["address4"];
            this.parcelNumber4 = _data["parcelNumber4"];
            this.gpsActive4 = _data["gpsActive4"];
            this.city = _data["city"];
            this.client = _data["client"];
            this.architect = _data["architect"];
            this.houseType = _data["houseType"];
            this.notes = _data["notes"];
            this.hourlyRate = _data["hourlyRate"];
            this.state = _data["state"];
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(AssignedUserDTO.fromJS(item));
            }
            if (Array.isArray(_data["assignedEmployees"])) {
                this.assignedEmployees = [] as any;
                for (let item of _data["assignedEmployees"])
                    this.assignedEmployees!.push(AssignedEmployeeDTO.fromJS(item));
            }
            if (Array.isArray(_data["assignedInvestor"])) {
                this.assignedInvestor = [] as any;
                for (let item of _data["assignedInvestor"])
                    this.assignedInvestor!.push(InvestorDTO.fromJS(item));
            }
            if (Array.isArray(_data["noteList"])) {
                this.noteList = [] as any;
                for (let item of _data["noteList"])
                    this.noteList!.push(BuildingNoteDTO.fromJS(item));
            }
            this.createDiary = _data["createDiary"];
            this.createWarehouse = _data["createWarehouse"];
        }
    }

    static fromJS(data: any): SaveBuildingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBuildingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["showToEmployees"] = this.showToEmployees;
        data["contractNumber"] = this.contractNumber;
        data["gpsX1"] = this.gpsX1;
        data["gpsY1"] = this.gpsY1;
        data["gpsDiff1"] = this.gpsDiff1;
        data["address1"] = this.address1;
        data["parcelNumber1"] = this.parcelNumber1;
        data["gpsX2"] = this.gpsX2;
        data["gpsY2"] = this.gpsY2;
        data["gpsDiff2"] = this.gpsDiff2;
        data["address2"] = this.address2;
        data["parcelNumber2"] = this.parcelNumber2;
        data["gpsActive2"] = this.gpsActive2;
        data["gpsX3"] = this.gpsX3;
        data["gpsY3"] = this.gpsY3;
        data["gpsDiff3"] = this.gpsDiff3;
        data["address3"] = this.address3;
        data["parcelNumber3"] = this.parcelNumber3;
        data["gpsActive3"] = this.gpsActive3;
        data["gpsX4"] = this.gpsX4;
        data["gpsY4"] = this.gpsY4;
        data["gpsDiff4"] = this.gpsDiff4;
        data["address4"] = this.address4;
        data["parcelNumber4"] = this.parcelNumber4;
        data["gpsActive4"] = this.gpsActive4;
        data["city"] = this.city;
        data["client"] = this.client;
        data["architect"] = this.architect;
        data["houseType"] = this.houseType;
        data["notes"] = this.notes;
        data["hourlyRate"] = this.hourlyRate;
        data["state"] = this.state;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedEmployees)) {
            data["assignedEmployees"] = [];
            for (let item of this.assignedEmployees)
                data["assignedEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedInvestor)) {
            data["assignedInvestor"] = [];
            for (let item of this.assignedInvestor)
                data["assignedInvestor"].push(item.toJSON());
        }
        if (Array.isArray(this.noteList)) {
            data["noteList"] = [];
            for (let item of this.noteList)
                data["noteList"].push(item.toJSON());
        }
        data["createDiary"] = this.createDiary;
        data["createWarehouse"] = this.createWarehouse;
        return data;
    }
}

export interface ISaveBuildingRequest {
    id?: number | undefined;
    name?: string | undefined;
    code?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    contractNumber?: string | undefined;
    gpsX1?: number;
    gpsY1?: number;
    gpsDiff1?: number;
    address1?: string | undefined;
    parcelNumber1?: string | undefined;
    gpsX2?: number;
    gpsY2?: number;
    gpsDiff2?: number;
    address2?: string | undefined;
    parcelNumber2?: string | undefined;
    gpsActive2?: boolean;
    gpsX3?: number;
    gpsY3?: number;
    gpsDiff3?: number;
    address3?: string | undefined;
    parcelNumber3?: string | undefined;
    gpsActive3?: boolean;
    gpsX4?: number;
    gpsY4?: number;
    gpsDiff4?: number;
    address4?: string | undefined;
    parcelNumber4?: string | undefined;
    gpsActive4?: boolean;
    city?: string | undefined;
    client?: string | undefined;
    architect?: string | undefined;
    houseType?: string | undefined;
    notes?: string | undefined;
    hourlyRate?: number | undefined;
    state?: BuildingStateEnum;
    assignedUsers?: AssignedUserDTO[] | undefined;
    assignedEmployees?: AssignedEmployeeDTO[] | undefined;
    assignedInvestor?: InvestorDTO[] | undefined;
    noteList?: BuildingNoteDTO[] | undefined;
    createDiary?: boolean | undefined;
    createWarehouse?: boolean | undefined;
}

export class SaveBuildingResponse implements ISaveBuildingResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;

    constructor(data?: ISaveBuildingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): SaveBuildingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBuildingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISaveBuildingResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;
}

export class SaveBuildingWeatherToDiaryDiaryByIdRequest implements ISaveBuildingWeatherToDiaryDiaryByIdRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;

    constructor(data?: ISaveBuildingWeatherToDiaryDiaryByIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dairyRecordId = _data["dairyRecordId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.hour = _data["hour"];
        }
    }

    static fromJS(data: any): SaveBuildingWeatherToDiaryDiaryByIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBuildingWeatherToDiaryDiaryByIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dairyRecordId"] = this.dairyRecordId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["hour"] = this.hour;
        return data;
    }
}

export interface ISaveBuildingWeatherToDiaryDiaryByIdRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;
}

export class SaveBuildingWeatherToDiaryDiaryByIdResponse implements ISaveBuildingWeatherToDiaryDiaryByIdResponse {
    ok?: boolean;

    constructor(data?: ISaveBuildingWeatherToDiaryDiaryByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveBuildingWeatherToDiaryDiaryByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBuildingWeatherToDiaryDiaryByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveBuildingWeatherToDiaryDiaryByIdResponse {
    ok?: boolean;
}

export class SaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest implements ISaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;

    constructor(data?: ISaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dairyRecordId = _data["dairyRecordId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.hour = _data["hour"];
        }
    }

    static fromJS(data: any): SaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dairyRecordId"] = this.dairyRecordId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["hour"] = this.hour;
        return data;
    }
}

export interface ISaveBuildingWeatherToDiaryDiaryByIdSubcontractorRequest {
    dairyRecordId?: number;
    date?: Date;
    hour?: number;
}

export class SaveDiaryContentsRequest implements ISaveDiaryContentsRequest {
    diaryId?: number;
    completedWorks?: string | undefined;
    materials?: string | undefined;
    machines?: string | undefined;
    additionalNotes?: string | undefined;
    completedWorksLastUpdate?: number;
    contents?: GroupAdminDTO[] | undefined;

    constructor(data?: ISaveDiaryContentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.completedWorks = _data["completedWorks"];
            this.materials = _data["materials"];
            this.machines = _data["machines"];
            this.additionalNotes = _data["additionalNotes"];
            this.completedWorksLastUpdate = _data["completedWorksLastUpdate"];
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(GroupAdminDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveDiaryContentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDiaryContentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["completedWorks"] = this.completedWorks;
        data["materials"] = this.materials;
        data["machines"] = this.machines;
        data["additionalNotes"] = this.additionalNotes;
        data["completedWorksLastUpdate"] = this.completedWorksLastUpdate;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveDiaryContentsRequest {
    diaryId?: number;
    completedWorks?: string | undefined;
    materials?: string | undefined;
    machines?: string | undefined;
    additionalNotes?: string | undefined;
    completedWorksLastUpdate?: number;
    contents?: GroupAdminDTO[] | undefined;
}

export class SaveDiaryContentsResponse implements ISaveDiaryContentsResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    errors?: string | undefined;
    actualCompletedWorks?: string | undefined;
    actualNotes?: string | undefined;
    actualTimeStamp?: number | undefined;

    constructor(data?: ISaveDiaryContentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.isConcurrency = _data["isConcurrency"];
            this.errors = _data["errors"];
            this.actualCompletedWorks = _data["actualCompletedWorks"];
            this.actualNotes = _data["actualNotes"];
            this.actualTimeStamp = _data["actualTimeStamp"];
        }
    }

    static fromJS(data: any): SaveDiaryContentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDiaryContentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["isConcurrency"] = this.isConcurrency;
        data["errors"] = this.errors;
        data["actualCompletedWorks"] = this.actualCompletedWorks;
        data["actualNotes"] = this.actualNotes;
        data["actualTimeStamp"] = this.actualTimeStamp;
        return data;
    }
}

export interface ISaveDiaryContentsResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    errors?: string | undefined;
    actualCompletedWorks?: string | undefined;
    actualNotes?: string | undefined;
    actualTimeStamp?: number | undefined;
}

export class SaveDiaryContentsSubcontractorRequest implements ISaveDiaryContentsSubcontractorRequest {
    diaryId?: number;
    completedWorks?: string | undefined;
    materials?: string | undefined;
    machines?: string | undefined;
    additionalNotes?: string | undefined;
    completedWorksLastUpdate?: number;
    contents?: GroupAdminDTO[] | undefined;

    constructor(data?: ISaveDiaryContentsSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.completedWorks = _data["completedWorks"];
            this.materials = _data["materials"];
            this.machines = _data["machines"];
            this.additionalNotes = _data["additionalNotes"];
            this.completedWorksLastUpdate = _data["completedWorksLastUpdate"];
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(GroupAdminDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveDiaryContentsSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDiaryContentsSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["completedWorks"] = this.completedWorks;
        data["materials"] = this.materials;
        data["machines"] = this.machines;
        data["additionalNotes"] = this.additionalNotes;
        data["completedWorksLastUpdate"] = this.completedWorksLastUpdate;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveDiaryContentsSubcontractorRequest {
    diaryId?: number;
    completedWorks?: string | undefined;
    materials?: string | undefined;
    machines?: string | undefined;
    additionalNotes?: string | undefined;
    completedWorksLastUpdate?: number;
    contents?: GroupAdminDTO[] | undefined;
}

export class SaveDiaryContentsSubcontractorResponse implements ISaveDiaryContentsSubcontractorResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    errors?: string | undefined;
    actualCompletedWorks?: string | undefined;
    actualNotes?: string | undefined;
    actualTimeStamp?: number | undefined;

    constructor(data?: ISaveDiaryContentsSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.isConcurrency = _data["isConcurrency"];
            this.errors = _data["errors"];
            this.actualCompletedWorks = _data["actualCompletedWorks"];
            this.actualNotes = _data["actualNotes"];
            this.actualTimeStamp = _data["actualTimeStamp"];
        }
    }

    static fromJS(data: any): SaveDiaryContentsSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDiaryContentsSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["isConcurrency"] = this.isConcurrency;
        data["errors"] = this.errors;
        data["actualCompletedWorks"] = this.actualCompletedWorks;
        data["actualNotes"] = this.actualNotes;
        data["actualTimeStamp"] = this.actualTimeStamp;
        return data;
    }
}

export interface ISaveDiaryContentsSubcontractorResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    errors?: string | undefined;
    actualCompletedWorks?: string | undefined;
    actualNotes?: string | undefined;
    actualTimeStamp?: number | undefined;
}

export class SaveDiaryRequest implements ISaveDiaryRequest {
    id?: number;
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    users?: UsersGroupDiaryDTO[] | undefined;
    authorizedPerson?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISaveDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.diaryName = _data["diaryName"];
            this.responsibleCompany = _data["responsibleCompany"];
            this.section = _data["section"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.place = _data["place"];
            this.investor = _data["investor"];
            this.tdsPermament = _data["tdsPermament"];
            this.tdsTemporary = _data["tdsTemporary"];
            this.authorWatch = _data["authorWatch"];
            this.generalContractor = _data["generalContractor"];
            this.constructionContractor = _data["constructionContractor"];
            this.technologicallContractor = _data["technologicallContractor"];
            this.subcontractors = _data["subcontractors"];
            this.projectManager = _data["projectManager"];
            this.constructionManager = _data["constructionManager"];
            this.generalArchitect = _data["generalArchitect"];
            this.responsibleArchitect = _data["responsibleArchitect"];
            this.groupId = _data["groupId"];
            this.parentDiaryId = _data["parentDiaryId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersGroupDiaryDTO.fromJS(item));
            }
            this.authorizedPerson = _data["authorizedPerson"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SaveDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["diaryName"] = this.diaryName;
        data["responsibleCompany"] = this.responsibleCompany;
        data["section"] = this.section;
        data["district"] = this.district;
        data["city"] = this.city;
        data["place"] = this.place;
        data["investor"] = this.investor;
        data["tdsPermament"] = this.tdsPermament;
        data["tdsTemporary"] = this.tdsTemporary;
        data["authorWatch"] = this.authorWatch;
        data["generalContractor"] = this.generalContractor;
        data["constructionContractor"] = this.constructionContractor;
        data["technologicallContractor"] = this.technologicallContractor;
        data["subcontractors"] = this.subcontractors;
        data["projectManager"] = this.projectManager;
        data["constructionManager"] = this.constructionManager;
        data["generalArchitect"] = this.generalArchitect;
        data["responsibleArchitect"] = this.responsibleArchitect;
        data["groupId"] = this.groupId;
        data["parentDiaryId"] = this.parentDiaryId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["authorizedPerson"] = this.authorizedPerson;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISaveDiaryRequest {
    id?: number;
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    users?: UsersGroupDiaryDTO[] | undefined;
    authorizedPerson?: string | undefined;
    isActive?: boolean;
}

export class SaveDiaryResponse implements ISaveDiaryResponse {
    ok?: boolean;

    constructor(data?: ISaveDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveDiaryResponse {
    ok?: boolean;
}

export class SaveDiarySignatureAdminUserResponse implements ISaveDiarySignatureAdminUserResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;

    constructor(data?: ISaveDiarySignatureAdminUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SaveDiarySignatureAdminUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDiarySignatureAdminUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["url"] = this.url;
        return data;
    }
}

export interface ISaveDiarySignatureAdminUserResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;
}

export class SaveEmployeeFileDataRequest implements ISaveEmployeeFileDataRequest {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    signatureImage?: string | undefined;
    employeeId?: number | undefined;
    isRead?: boolean;
    isRejected?: boolean;
    dateRead?: Date | undefined;
    dateChanged?: Date | undefined;
    employeeIdTo?: number | undefined;
    showToEmployee?: boolean;
    text?: string | undefined;

    constructor(data?: ISaveEmployeeFileDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.isDone = _data["isDone"];
            this.isCategory = _data["isCategory"];
            this.adminUserFromId = _data["adminUserFromId"];
            this.adminUserToId = _data["adminUserToId"];
            this.signatureImage = _data["signatureImage"];
            this.employeeId = _data["employeeId"];
            this.isRead = _data["isRead"];
            this.isRejected = _data["isRejected"];
            this.dateRead = _data["dateRead"] ? new Date(_data["dateRead"].toString()) : <any>undefined;
            this.dateChanged = _data["dateChanged"] ? new Date(_data["dateChanged"].toString()) : <any>undefined;
            this.employeeIdTo = _data["employeeIdTo"];
            this.showToEmployee = _data["showToEmployee"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SaveEmployeeFileDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEmployeeFileDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isDone"] = this.isDone;
        data["isCategory"] = this.isCategory;
        data["adminUserFromId"] = this.adminUserFromId;
        data["adminUserToId"] = this.adminUserToId;
        data["signatureImage"] = this.signatureImage;
        data["employeeId"] = this.employeeId;
        data["isRead"] = this.isRead;
        data["isRejected"] = this.isRejected;
        data["dateRead"] = this.dateRead ? this.dateRead.toISOString() : <any>undefined;
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toISOString() : <any>undefined;
        data["employeeIdTo"] = this.employeeIdTo;
        data["showToEmployee"] = this.showToEmployee;
        data["text"] = this.text;
        return data;
    }
}

export interface ISaveEmployeeFileDataRequest {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    signatureImage?: string | undefined;
    employeeId?: number | undefined;
    isRead?: boolean;
    isRejected?: boolean;
    dateRead?: Date | undefined;
    dateChanged?: Date | undefined;
    employeeIdTo?: number | undefined;
    showToEmployee?: boolean;
    text?: string | undefined;
}

export class SaveEmployeeFileDataResponse implements ISaveEmployeeFileDataResponse {
    ok?: boolean;

    constructor(data?: ISaveEmployeeFileDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveEmployeeFileDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEmployeeFileDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveEmployeeFileDataResponse {
    ok?: boolean;
}

export class SaveEmployeeRequest implements ISaveEmployeeRequest {
    employee?: EmployeeDetailDTO;

    constructor(data?: ISaveEmployeeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeDetailDTO.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveEmployeeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEmployeeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveEmployeeRequest {
    employee?: EmployeeDetailDTO;
}

export class SaveEmployeeResponse implements ISaveEmployeeResponse {
    ok?: boolean;

    constructor(data?: ISaveEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveEmployeeResponse {
    ok?: boolean;
}

export class SaveEmployeeSignatureResponse implements ISaveEmployeeSignatureResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;

    constructor(data?: ISaveEmployeeSignatureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SaveEmployeeSignatureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEmployeeSignatureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["url"] = this.url;
        return data;
    }
}

export interface ISaveEmployeeSignatureResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;
}

export class SaveImageMapTodoDetailRequest implements ISaveImageMapTodoDetailRequest {
    id?: number | undefined;
    name?: string | undefined;
    mapTagColor?: string | undefined;
    mapId?: number;
    responsibleId?: number | undefined;
    status?: TodoState;
    mapTop?: number;
    mapLeft?: number;
    description?: string | undefined;

    constructor(data?: ISaveImageMapTodoDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.mapTagColor = _data["mapTagColor"];
            this.mapId = _data["mapId"];
            this.responsibleId = _data["responsibleId"];
            this.status = _data["status"];
            this.mapTop = _data["mapTop"];
            this.mapLeft = _data["mapLeft"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SaveImageMapTodoDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageMapTodoDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mapTagColor"] = this.mapTagColor;
        data["mapId"] = this.mapId;
        data["responsibleId"] = this.responsibleId;
        data["status"] = this.status;
        data["mapTop"] = this.mapTop;
        data["mapLeft"] = this.mapLeft;
        data["description"] = this.description;
        return data;
    }
}

export interface ISaveImageMapTodoDetailRequest {
    id?: number | undefined;
    name?: string | undefined;
    mapTagColor?: string | undefined;
    mapId?: number;
    responsibleId?: number | undefined;
    status?: TodoState;
    mapTop?: number;
    mapLeft?: number;
    description?: string | undefined;
}

export class SaveImageMapTodoDetailResponse implements ISaveImageMapTodoDetailResponse {
    id?: number;

    constructor(data?: ISaveImageMapTodoDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveImageMapTodoDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageMapTodoDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveImageMapTodoDetailResponse {
    id?: number;
}

export class SaveInvoiceFilesRequest implements ISaveInvoiceFilesRequest {
    invoiceId?: number;
    files?: InvoiceFileDTO[] | undefined;

    constructor(data?: ISaveInvoiceFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(InvoiceFileDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveInvoiceFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInvoiceFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveInvoiceFilesRequest {
    invoiceId?: number;
    files?: InvoiceFileDTO[] | undefined;
}

export class SaveInvoiceItemsRequest implements ISaveInvoiceItemsRequest {
    invoiceId?: number;
    invoiceItems?: InvoiceItem[] | undefined;

    constructor(data?: ISaveInvoiceItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveInvoiceItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInvoiceItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveInvoiceItemsRequest {
    invoiceId?: number;
    invoiceItems?: InvoiceItem[] | undefined;
}

export class SaveInvoiceRequest implements ISaveInvoiceRequest {
    id?: number;
    name?: string | undefined;
    isDone?: boolean;
    isApproved?: boolean;
    isPostponed?: boolean;
    isPosted?: boolean;
    dateTaxable?: Date;
    dateExpire?: Date;
    adminUserFrom?: number | undefined;
    adminUserTo?: number | undefined;
    supplier?: string | undefined;
    dateReceive?: Date | undefined;
    variableSymbol?: string | undefined;
    subject?: string | undefined;
    paymentPayerBankNumber?: string | undefined;
    paymentPayerBankCode?: string | undefined;
    paymentRecipientBankNumber?: string | undefined;
    paymentRecipientBankCode?: string | undefined;
    paymentDueDate?: Date;
    paymentRecipientName?: string | undefined;
    paymentMessage?: string | undefined;
    paymentVariableSymbol?: string | undefined;
    paymentConstantSymbol?: string | undefined;
    paymentSpecificSymbol?: string | undefined;
    commentAdd?: string | undefined;

    constructor(data?: ISaveInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDone = _data["isDone"];
            this.isApproved = _data["isApproved"];
            this.isPostponed = _data["isPostponed"];
            this.isPosted = _data["isPosted"];
            this.dateTaxable = _data["dateTaxable"] ? new Date(_data["dateTaxable"].toString()) : <any>undefined;
            this.dateExpire = _data["dateExpire"] ? new Date(_data["dateExpire"].toString()) : <any>undefined;
            this.adminUserFrom = _data["adminUserFrom"];
            this.adminUserTo = _data["adminUserTo"];
            this.supplier = _data["supplier"];
            this.dateReceive = _data["dateReceive"] ? new Date(_data["dateReceive"].toString()) : <any>undefined;
            this.variableSymbol = _data["variableSymbol"];
            this.subject = _data["subject"];
            this.paymentPayerBankNumber = _data["paymentPayerBankNumber"];
            this.paymentPayerBankCode = _data["paymentPayerBankCode"];
            this.paymentRecipientBankNumber = _data["paymentRecipientBankNumber"];
            this.paymentRecipientBankCode = _data["paymentRecipientBankCode"];
            this.paymentDueDate = _data["paymentDueDate"] ? new Date(_data["paymentDueDate"].toString()) : <any>undefined;
            this.paymentRecipientName = _data["paymentRecipientName"];
            this.paymentMessage = _data["paymentMessage"];
            this.paymentVariableSymbol = _data["paymentVariableSymbol"];
            this.paymentConstantSymbol = _data["paymentConstantSymbol"];
            this.paymentSpecificSymbol = _data["paymentSpecificSymbol"];
            this.commentAdd = _data["commentAdd"];
        }
    }

    static fromJS(data: any): SaveInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDone"] = this.isDone;
        data["isApproved"] = this.isApproved;
        data["isPostponed"] = this.isPostponed;
        data["isPosted"] = this.isPosted;
        data["dateTaxable"] = this.dateTaxable ? this.dateTaxable.toISOString() : <any>undefined;
        data["dateExpire"] = this.dateExpire ? this.dateExpire.toISOString() : <any>undefined;
        data["adminUserFrom"] = this.adminUserFrom;
        data["adminUserTo"] = this.adminUserTo;
        data["supplier"] = this.supplier;
        data["dateReceive"] = this.dateReceive ? this.dateReceive.toISOString() : <any>undefined;
        data["variableSymbol"] = this.variableSymbol;
        data["subject"] = this.subject;
        data["paymentPayerBankNumber"] = this.paymentPayerBankNumber;
        data["paymentPayerBankCode"] = this.paymentPayerBankCode;
        data["paymentRecipientBankNumber"] = this.paymentRecipientBankNumber;
        data["paymentRecipientBankCode"] = this.paymentRecipientBankCode;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : <any>undefined;
        data["paymentRecipientName"] = this.paymentRecipientName;
        data["paymentMessage"] = this.paymentMessage;
        data["paymentVariableSymbol"] = this.paymentVariableSymbol;
        data["paymentConstantSymbol"] = this.paymentConstantSymbol;
        data["paymentSpecificSymbol"] = this.paymentSpecificSymbol;
        data["commentAdd"] = this.commentAdd;
        return data;
    }
}

export interface ISaveInvoiceRequest {
    id?: number;
    name?: string | undefined;
    isDone?: boolean;
    isApproved?: boolean;
    isPostponed?: boolean;
    isPosted?: boolean;
    dateTaxable?: Date;
    dateExpire?: Date;
    adminUserFrom?: number | undefined;
    adminUserTo?: number | undefined;
    supplier?: string | undefined;
    dateReceive?: Date | undefined;
    variableSymbol?: string | undefined;
    subject?: string | undefined;
    paymentPayerBankNumber?: string | undefined;
    paymentPayerBankCode?: string | undefined;
    paymentRecipientBankNumber?: string | undefined;
    paymentRecipientBankCode?: string | undefined;
    paymentDueDate?: Date;
    paymentRecipientName?: string | undefined;
    paymentMessage?: string | undefined;
    paymentVariableSymbol?: string | undefined;
    paymentConstantSymbol?: string | undefined;
    paymentSpecificSymbol?: string | undefined;
    commentAdd?: string | undefined;
}

export class SaveListWithItemsRequest implements ISaveListWithItemsRequest {
    warehouseId?: number;
    toWarehouseId?: number | undefined;
    stockListId?: number | undefined;
    state?: string | undefined;
    note?: string | undefined;
    datetime?: Date;
    products?: StockItemDTO[] | undefined;
    withPrice?: boolean;

    constructor(data?: ISaveListWithItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.toWarehouseId = _data["toWarehouseId"];
            this.stockListId = _data["stockListId"];
            this.state = _data["state"];
            this.note = _data["note"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(StockItemDTO.fromJS(item));
            }
            this.withPrice = _data["withPrice"];
        }
    }

    static fromJS(data: any): SaveListWithItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveListWithItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["toWarehouseId"] = this.toWarehouseId;
        data["stockListId"] = this.stockListId;
        data["state"] = this.state;
        data["note"] = this.note;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["withPrice"] = this.withPrice;
        return data;
    }
}

export interface ISaveListWithItemsRequest {
    warehouseId?: number;
    toWarehouseId?: number | undefined;
    stockListId?: number | undefined;
    state?: string | undefined;
    note?: string | undefined;
    datetime?: Date;
    products?: StockItemDTO[] | undefined;
    withPrice?: boolean;
}

export class SaveListWithItemsResponse implements ISaveListWithItemsResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;

    constructor(data?: ISaveListWithItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): SaveListWithItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveListWithItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISaveListWithItemsResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;
}

export class SaveMachinesIsSharedTableRequest implements ISaveMachinesIsSharedTableRequest {
    mechanisms?: number[] | undefined;
    isShared?: boolean;

    constructor(data?: ISaveMachinesIsSharedTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mechanisms"])) {
                this.mechanisms = [] as any;
                for (let item of _data["mechanisms"])
                    this.mechanisms!.push(item);
            }
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveMachinesIsSharedTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMachinesIsSharedTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mechanisms)) {
            data["mechanisms"] = [];
            for (let item of this.mechanisms)
                data["mechanisms"].push(item);
        }
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveMachinesIsSharedTableRequest {
    mechanisms?: number[] | undefined;
    isShared?: boolean;
}

export class SaveMachinesIsSharedTableResponse implements ISaveMachinesIsSharedTableResponse {
    ok?: boolean;

    constructor(data?: ISaveMachinesIsSharedTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveMachinesIsSharedTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMachinesIsSharedTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveMachinesIsSharedTableResponse {
    ok?: boolean;
}

export class SaveMachinesTableReqDTO implements ISaveMachinesTableReqDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isShared?: boolean;

    constructor(data?: ISaveMachinesTableReqDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveMachinesTableReqDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMachinesTableReqDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveMachinesTableReqDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isShared?: boolean;
}

export class SaveMachinesTableRequest implements ISaveMachinesTableRequest {
    diaryId?: number;
    machines?: SaveMachinesTableReqDTO[] | undefined;

    constructor(data?: ISaveMachinesTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(SaveMachinesTableReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMachinesTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMachinesTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveMachinesTableRequest {
    diaryId?: number;
    machines?: SaveMachinesTableReqDTO[] | undefined;
}

export class SaveMachinesTableResponse implements ISaveMachinesTableResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;

    constructor(data?: ISaveMachinesTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["concurrencyRecords"])) {
                this.concurrencyRecords = [] as any;
                for (let item of _data["concurrencyRecords"])
                    this.concurrencyRecords!.push(item);
            }
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): SaveMachinesTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMachinesTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.concurrencyRecords)) {
            data["concurrencyRecords"] = [];
            for (let item of this.concurrencyRecords)
                data["concurrencyRecords"].push(item);
        }
        data["errors"] = this.errors;
        return data;
    }
}

export interface ISaveMachinesTableResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;
}

export class SaveMachinesTableSubcontractorRequest implements ISaveMachinesTableSubcontractorRequest {
    diaryId?: number;
    machines?: SaveMachinesTableReqDTO[] | undefined;

    constructor(data?: ISaveMachinesTableSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(SaveMachinesTableReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMachinesTableSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMachinesTableSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveMachinesTableSubcontractorRequest {
    diaryId?: number;
    machines?: SaveMachinesTableReqDTO[] | undefined;
}

export class SaveManufacturerRequest implements ISaveManufacturerRequest {
    id?: number;
    name?: string | undefined;

    constructor(data?: ISaveManufacturerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SaveManufacturerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveManufacturerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISaveManufacturerRequest {
    id?: number;
    name?: string | undefined;
}

export class SaveManufacturerResponse implements ISaveManufacturerResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;

    constructor(data?: ISaveManufacturerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): SaveManufacturerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveManufacturerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISaveManufacturerResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;
}

export class SaveMaterialsIsSharedTableRequest implements ISaveMaterialsIsSharedTableRequest {
    materials?: number[] | undefined;
    isShared?: boolean;

    constructor(data?: ISaveMaterialsIsSharedTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(item);
            }
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveMaterialsIsSharedTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMaterialsIsSharedTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item);
        }
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveMaterialsIsSharedTableRequest {
    materials?: number[] | undefined;
    isShared?: boolean;
}

export class SaveMaterialsIsSharedTableResponse implements ISaveMaterialsIsSharedTableResponse {
    ok?: boolean;

    constructor(data?: ISaveMaterialsIsSharedTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveMaterialsIsSharedTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMaterialsIsSharedTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveMaterialsIsSharedTableResponse {
    ok?: boolean;
}

export class SaveMaterialsTableReqDTO implements ISaveMaterialsTableReqDTO {
    id?: number;
    name?: string | undefined;
    unit?: string | undefined;
    amount?: number;
    isShared?: boolean;

    constructor(data?: ISaveMaterialsTableReqDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.amount = _data["amount"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveMaterialsTableReqDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMaterialsTableReqDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["amount"] = this.amount;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveMaterialsTableReqDTO {
    id?: number;
    name?: string | undefined;
    unit?: string | undefined;
    amount?: number;
    isShared?: boolean;
}

export class SaveMaterialsTableRequest implements ISaveMaterialsTableRequest {
    diaryId?: number;
    materials?: SaveMaterialsTableReqDTO[] | undefined;

    constructor(data?: ISaveMaterialsTableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(SaveMaterialsTableReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMaterialsTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMaterialsTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveMaterialsTableRequest {
    diaryId?: number;
    materials?: SaveMaterialsTableReqDTO[] | undefined;
}

export class SaveMaterialsTableResponse implements ISaveMaterialsTableResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;

    constructor(data?: ISaveMaterialsTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["concurrencyRecords"])) {
                this.concurrencyRecords = [] as any;
                for (let item of _data["concurrencyRecords"])
                    this.concurrencyRecords!.push(item);
            }
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): SaveMaterialsTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMaterialsTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.concurrencyRecords)) {
            data["concurrencyRecords"] = [];
            for (let item of this.concurrencyRecords)
                data["concurrencyRecords"].push(item);
        }
        data["errors"] = this.errors;
        return data;
    }
}

export interface ISaveMaterialsTableResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;
}

export class SaveMaterialsTableSubcontractorRequest implements ISaveMaterialsTableSubcontractorRequest {
    diaryId?: number;
    materials?: SaveMaterialsTableReqDTO[] | undefined;

    constructor(data?: ISaveMaterialsTableSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(SaveMaterialsTableReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMaterialsTableSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMaterialsTableSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveMaterialsTableSubcontractorRequest {
    diaryId?: number;
    materials?: SaveMaterialsTableReqDTO[] | undefined;
}

export class SaveMobileDiaryRecordRequest implements ISaveMobileDiaryRecordRequest {
    diaryRecord?: MobileDiaryRecordDTO;

    constructor(data?: ISaveMobileDiaryRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecord = _data["diaryRecord"] ? MobileDiaryRecordDTO.fromJS(_data["diaryRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveMobileDiaryRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMobileDiaryRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecord"] = this.diaryRecord ? this.diaryRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveMobileDiaryRecordRequest {
    diaryRecord?: MobileDiaryRecordDTO;
}

export class SaveMobileDiaryRecordResponse implements ISaveMobileDiaryRecordResponse {
    ok?: boolean;

    constructor(data?: ISaveMobileDiaryRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveMobileDiaryRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMobileDiaryRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveMobileDiaryRecordResponse {
    ok?: boolean;
}

export class SaveProductCategoryRequest implements ISaveProductCategoryRequest {
    id?: number;
    name?: string | undefined;

    constructor(data?: ISaveProductCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SaveProductCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISaveProductCategoryRequest {
    id?: number;
    name?: string | undefined;
}

export class SaveProductCategoryResponse implements ISaveProductCategoryResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;

    constructor(data?: ISaveProductCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): SaveProductCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISaveProductCategoryResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;
}

export class SaveProductRequest implements ISaveProductRequest {
    id?: number;
    stockManufacturerId?: number | undefined;
    stockProductCategoryId?: number | undefined;
    measureUnitId?: number | undefined;
    code?: string | undefined;
    eanCode?: string | undefined;
    name?: string | undefined;
    text?: string | undefined;
    rentPrice1?: number | undefined;
    unitWeight?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ISaveProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockManufacturerId = _data["stockManufacturerId"];
            this.stockProductCategoryId = _data["stockProductCategoryId"];
            this.measureUnitId = _data["measureUnitId"];
            this.code = _data["code"];
            this.eanCode = _data["eanCode"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.rentPrice1 = _data["rentPrice1"];
            this.unitWeight = _data["unitWeight"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SaveProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockManufacturerId"] = this.stockManufacturerId;
        data["stockProductCategoryId"] = this.stockProductCategoryId;
        data["measureUnitId"] = this.measureUnitId;
        data["code"] = this.code;
        data["eanCode"] = this.eanCode;
        data["name"] = this.name;
        data["text"] = this.text;
        data["rentPrice1"] = this.rentPrice1;
        data["unitWeight"] = this.unitWeight;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISaveProductRequest {
    id?: number;
    stockManufacturerId?: number | undefined;
    stockProductCategoryId?: number | undefined;
    measureUnitId?: number | undefined;
    code?: string | undefined;
    eanCode?: string | undefined;
    name?: string | undefined;
    text?: string | undefined;
    rentPrice1?: number | undefined;
    unitWeight?: number | undefined;
    isActive?: boolean | undefined;
}

export class SaveProductResponse implements ISaveProductResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;

    constructor(data?: ISaveProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): SaveProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISaveProductResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;
}

export class SaveProjectFileDetailRequest implements ISaveProjectFileDetailRequest {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    investorId?: number | undefined;
    showToClient?: boolean;
    signatureImage?: string | undefined;
    emailTemplateId?: number | undefined;
    canOrderSolution?: boolean;
    parentId?: number | undefined;

    constructor(data?: ISaveProjectFileDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.isDone = _data["isDone"];
            this.isCategory = _data["isCategory"];
            this.adminUserFromId = _data["adminUserFromId"];
            this.adminUserToId = _data["adminUserToId"];
            this.investorId = _data["investorId"];
            this.showToClient = _data["showToClient"];
            this.signatureImage = _data["signatureImage"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.canOrderSolution = _data["canOrderSolution"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): SaveProjectFileDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProjectFileDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isDone"] = this.isDone;
        data["isCategory"] = this.isCategory;
        data["adminUserFromId"] = this.adminUserFromId;
        data["adminUserToId"] = this.adminUserToId;
        data["investorId"] = this.investorId;
        data["showToClient"] = this.showToClient;
        data["signatureImage"] = this.signatureImage;
        data["emailTemplateId"] = this.emailTemplateId;
        data["canOrderSolution"] = this.canOrderSolution;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface ISaveProjectFileDetailRequest {
    id?: number;
    name?: string | undefined;
    expirationDate?: Date;
    isDone?: boolean;
    isCategory?: boolean;
    adminUserFromId?: number | undefined;
    adminUserToId?: number | undefined;
    investorId?: number | undefined;
    showToClient?: boolean;
    signatureImage?: string | undefined;
    emailTemplateId?: number | undefined;
    canOrderSolution?: boolean;
    parentId?: number | undefined;
}

export class SaveProjectFileDetailResponse implements ISaveProjectFileDetailResponse {
    ok?: boolean;

    constructor(data?: ISaveProjectFileDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveProjectFileDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProjectFileDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveProjectFileDetailResponse {
    ok?: boolean;
}

export class SaveRequestCommentResponse implements ISaveRequestCommentResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ISaveRequestCommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SaveRequestCommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRequestCommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISaveRequestCommentResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class SaveRequestCommentTextRequest implements ISaveRequestCommentTextRequest {
    requestId?: number;
    text?: string | undefined;
    file?: string | undefined;

    constructor(data?: ISaveRequestCommentTextRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.text = _data["text"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): SaveRequestCommentTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRequestCommentTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["text"] = this.text;
        data["file"] = this.file;
        return data;
    }
}

export interface ISaveRequestCommentTextRequest {
    requestId?: number;
    text?: string | undefined;
    file?: string | undefined;
}

export class SaveRequestCommentTextResponse implements ISaveRequestCommentTextResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ISaveRequestCommentTextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SaveRequestCommentTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRequestCommentTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISaveRequestCommentTextResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class SaveRequestRequest implements ISaveRequestRequest {
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    dateTo?: Date | undefined;
    imageUrl?: string | undefined;

    constructor(data?: ISaveRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.buildingId = _data["buildingId"];
            this.buildingDiaryId = _data["buildingDiaryId"];
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): SaveRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["buildingId"] = this.buildingId;
        data["buildingDiaryId"] = this.buildingDiaryId;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface ISaveRequestRequest {
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    dateTo?: Date | undefined;
    imageUrl?: string | undefined;
}

export class SaveRequestResponse implements ISaveRequestResponse {
    ok?: boolean;
    id?: number;
    errorMessage?: string | undefined;

    constructor(data?: ISaveRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SaveRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISaveRequestResponse {
    ok?: boolean;
    id?: number;
    errorMessage?: string | undefined;
}

export class SaveRotatedImageRequest implements ISaveRotatedImageRequest {
    uri?: string | undefined;
    rotation?: number;
    buildingDiaryRecordId?: number | undefined;
    buildingId?: number | undefined;

    constructor(data?: ISaveRotatedImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.rotation = _data["rotation"];
            this.buildingDiaryRecordId = _data["buildingDiaryRecordId"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): SaveRotatedImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRotatedImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["rotation"] = this.rotation;
        data["buildingDiaryRecordId"] = this.buildingDiaryRecordId;
        data["buildingId"] = this.buildingId;
        return data;
    }
}

export interface ISaveRotatedImageRequest {
    uri?: string | undefined;
    rotation?: number;
    buildingDiaryRecordId?: number | undefined;
    buildingId?: number | undefined;
}

export class SaveRotatedImageResponse implements ISaveRotatedImageResponse {
    newUri?: string | undefined;
    newThumbnailUri?: string | undefined;

    constructor(data?: ISaveRotatedImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUri = _data["newUri"];
            this.newThumbnailUri = _data["newThumbnailUri"];
        }
    }

    static fromJS(data: any): SaveRotatedImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRotatedImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUri"] = this.newUri;
        data["newThumbnailUri"] = this.newThumbnailUri;
        return data;
    }
}

export interface ISaveRotatedImageResponse {
    newUri?: string | undefined;
    newThumbnailUri?: string | undefined;
}

export class SaveRotatedImageSubcontractorRequest implements ISaveRotatedImageSubcontractorRequest {
    uri?: string | undefined;
    rotation?: number;
    buildingDiaryRecordId?: number | undefined;
    buildingId?: number | undefined;

    constructor(data?: ISaveRotatedImageSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.rotation = _data["rotation"];
            this.buildingDiaryRecordId = _data["buildingDiaryRecordId"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): SaveRotatedImageSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRotatedImageSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["rotation"] = this.rotation;
        data["buildingDiaryRecordId"] = this.buildingDiaryRecordId;
        data["buildingId"] = this.buildingId;
        return data;
    }
}

export interface ISaveRotatedImageSubcontractorRequest {
    uri?: string | undefined;
    rotation?: number;
    buildingDiaryRecordId?: number | undefined;
    buildingId?: number | undefined;
}

export class SaveRotatedImageSubcontractorResponse implements ISaveRotatedImageSubcontractorResponse {
    newUri?: string | undefined;
    newThumbnailUri?: string | undefined;

    constructor(data?: ISaveRotatedImageSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUri = _data["newUri"];
            this.newThumbnailUri = _data["newThumbnailUri"];
        }
    }

    static fromJS(data: any): SaveRotatedImageSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRotatedImageSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUri"] = this.newUri;
        data["newThumbnailUri"] = this.newThumbnailUri;
        return data;
    }
}

export interface ISaveRotatedImageSubcontractorResponse {
    newUri?: string | undefined;
    newThumbnailUri?: string | undefined;
}

export class SaveShownChatResponse implements ISaveShownChatResponse {
    ok?: boolean;

    constructor(data?: ISaveShownChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveShownChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveShownChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveShownChatResponse {
    ok?: boolean;
}

export class SaveSubcontractorDiaryRequest implements ISaveSubcontractorDiaryRequest {
    id?: number;
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    users?: UsersGroupDiaryDTO[] | undefined;
    authorizedPerson?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISaveSubcontractorDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.diaryName = _data["diaryName"];
            this.responsibleCompany = _data["responsibleCompany"];
            this.section = _data["section"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.place = _data["place"];
            this.investor = _data["investor"];
            this.tdsPermament = _data["tdsPermament"];
            this.tdsTemporary = _data["tdsTemporary"];
            this.authorWatch = _data["authorWatch"];
            this.generalContractor = _data["generalContractor"];
            this.constructionContractor = _data["constructionContractor"];
            this.technologicallContractor = _data["technologicallContractor"];
            this.subcontractors = _data["subcontractors"];
            this.projectManager = _data["projectManager"];
            this.constructionManager = _data["constructionManager"];
            this.generalArchitect = _data["generalArchitect"];
            this.responsibleArchitect = _data["responsibleArchitect"];
            this.groupId = _data["groupId"];
            this.parentDiaryId = _data["parentDiaryId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersGroupDiaryDTO.fromJS(item));
            }
            this.authorizedPerson = _data["authorizedPerson"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SaveSubcontractorDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSubcontractorDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["diaryName"] = this.diaryName;
        data["responsibleCompany"] = this.responsibleCompany;
        data["section"] = this.section;
        data["district"] = this.district;
        data["city"] = this.city;
        data["place"] = this.place;
        data["investor"] = this.investor;
        data["tdsPermament"] = this.tdsPermament;
        data["tdsTemporary"] = this.tdsTemporary;
        data["authorWatch"] = this.authorWatch;
        data["generalContractor"] = this.generalContractor;
        data["constructionContractor"] = this.constructionContractor;
        data["technologicallContractor"] = this.technologicallContractor;
        data["subcontractors"] = this.subcontractors;
        data["projectManager"] = this.projectManager;
        data["constructionManager"] = this.constructionManager;
        data["generalArchitect"] = this.generalArchitect;
        data["responsibleArchitect"] = this.responsibleArchitect;
        data["groupId"] = this.groupId;
        data["parentDiaryId"] = this.parentDiaryId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["authorizedPerson"] = this.authorizedPerson;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISaveSubcontractorDiaryRequest {
    id?: number;
    buildingId?: number;
    diaryName?: string | undefined;
    responsibleCompany?: string | undefined;
    section?: string | undefined;
    district?: string | undefined;
    city?: string | undefined;
    place?: string | undefined;
    investor?: string | undefined;
    tdsPermament?: string | undefined;
    tdsTemporary?: string | undefined;
    authorWatch?: string | undefined;
    generalContractor?: string | undefined;
    constructionContractor?: string | undefined;
    technologicallContractor?: string | undefined;
    subcontractors?: string | undefined;
    projectManager?: string | undefined;
    constructionManager?: string | undefined;
    generalArchitect?: string | undefined;
    responsibleArchitect?: string | undefined;
    groupId?: number | undefined;
    parentDiaryId?: number | undefined;
    users?: UsersGroupDiaryDTO[] | undefined;
    authorizedPerson?: string | undefined;
    isActive?: boolean;
}

export class SaveSubcontractorDiaryResponse implements ISaveSubcontractorDiaryResponse {
    ok?: boolean;

    constructor(data?: ISaveSubcontractorDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveSubcontractorDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSubcontractorDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveSubcontractorDiaryResponse {
    ok?: boolean;
}

export class SaveTaskDetailsRequest implements ISaveTaskDetailsRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: number;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeTo?: Date | undefined;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    wealthId?: number | undefined;
    showInGantt?: boolean;
    progress?: number;
    processingAdminUserId?: number | undefined;
    employeesIds?: number[] | undefined;
    investorsIds?: number[] | undefined;
    predecessor?: string | undefined;

    constructor(data?: ISaveTaskDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.datetimeStart = _data["datetimeStart"] ? new Date(_data["datetimeStart"].toString()) : <any>undefined;
            this.datetimeEnd = _data["datetimeEnd"] ? new Date(_data["datetimeEnd"].toString()) : <any>undefined;
            this.datetimeTo = _data["datetimeTo"] ? new Date(_data["datetimeTo"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.buildingDiaryId = _data["buildingDiaryId"];
            this.wealthId = _data["wealthId"];
            this.showInGantt = _data["showInGantt"];
            this.progress = _data["progress"];
            this.processingAdminUserId = _data["processingAdminUserId"];
            if (Array.isArray(_data["employeesIds"])) {
                this.employeesIds = [] as any;
                for (let item of _data["employeesIds"])
                    this.employeesIds!.push(item);
            }
            if (Array.isArray(_data["investorsIds"])) {
                this.investorsIds = [] as any;
                for (let item of _data["investorsIds"])
                    this.investorsIds!.push(item);
            }
            this.predecessor = _data["predecessor"];
        }
    }

    static fromJS(data: any): SaveTaskDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTaskDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["datetimeStart"] = this.datetimeStart ? this.datetimeStart.toISOString() : <any>undefined;
        data["datetimeEnd"] = this.datetimeEnd ? this.datetimeEnd.toISOString() : <any>undefined;
        data["datetimeTo"] = this.datetimeTo ? this.datetimeTo.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["buildingDiaryId"] = this.buildingDiaryId;
        data["wealthId"] = this.wealthId;
        data["showInGantt"] = this.showInGantt;
        data["progress"] = this.progress;
        data["processingAdminUserId"] = this.processingAdminUserId;
        if (Array.isArray(this.employeesIds)) {
            data["employeesIds"] = [];
            for (let item of this.employeesIds)
                data["employeesIds"].push(item);
        }
        if (Array.isArray(this.investorsIds)) {
            data["investorsIds"] = [];
            for (let item of this.investorsIds)
                data["investorsIds"].push(item);
        }
        data["predecessor"] = this.predecessor;
        return data;
    }
}

export interface ISaveTaskDetailsRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: number;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeTo?: Date | undefined;
    buildingId?: number | undefined;
    buildingDiaryId?: number | undefined;
    wealthId?: number | undefined;
    showInGantt?: boolean;
    progress?: number;
    processingAdminUserId?: number | undefined;
    employeesIds?: number[] | undefined;
    investorsIds?: number[] | undefined;
    predecessor?: string | undefined;
}

export class SaveTaskDetailsResponse implements ISaveTaskDetailsResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ISaveTaskDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SaveTaskDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTaskDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISaveTaskDetailsResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class SaveUserDataKrosAdminRequest implements ISaveUserDataKrosAdminRequest {
    user?: AdminUsersDTO;

    constructor(data?: ISaveUserDataKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? AdminUsersDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveUserDataKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveUserDataKrosAdminRequest {
    user?: AdminUsersDTO;
}

export class SaveUserDataKrosAdminResponse implements ISaveUserDataKrosAdminResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number;

    constructor(data?: ISaveUserDataKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveUserDataKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveUserDataKrosAdminResponse {
    ok?: boolean;
    message?: string | undefined;
    id?: number;
}

export class SaveWarehouseRequest implements ISaveWarehouseRequest {
    id?: number;
    buildingId?: number | undefined;
    name?: string | undefined;
    central?: boolean;
    inMenu?: boolean;
    isActive?: boolean;

    constructor(data?: ISaveWarehouseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.name = _data["name"];
            this.central = _data["central"];
            this.inMenu = _data["inMenu"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SaveWarehouseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWarehouseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["name"] = this.name;
        data["central"] = this.central;
        data["inMenu"] = this.inMenu;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISaveWarehouseRequest {
    id?: number;
    buildingId?: number | undefined;
    name?: string | undefined;
    central?: boolean;
    inMenu?: boolean;
    isActive?: boolean;
}

export class SaveWarehouseResponse implements ISaveWarehouseResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;

    constructor(data?: ISaveWarehouseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): SaveWarehouseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWarehouseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISaveWarehouseResponse {
    ok?: boolean;
    id?: number;
    errorCode?: number;
}

export class SaveWealthDetailsRequest implements ISaveWealthDetailsRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    code?: string | undefined;
    serialNumber?: string | undefined;
    showToEmps?: boolean;
    manufacturer?: string | undefined;
    priceA?: number | undefined;
    priceB?: number | undefined;
    priceC?: number | undefined;
    priceForRent?: number | undefined;
    datetimeImage?: Date | undefined;
    gpsXImage?: number | undefined;
    gpsYImage?: number | undefined;
    employeeId?: number | undefined;
    buildingId?: number | undefined;
    warehouseId?: number | undefined;
    employeeGroups?: EmployeeGroupsDTO[] | undefined;

    constructor(data?: ISaveWealthDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.serialNumber = _data["serialNumber"];
            this.showToEmps = _data["showToEmps"];
            this.manufacturer = _data["manufacturer"];
            this.priceA = _data["priceA"];
            this.priceB = _data["priceB"];
            this.priceC = _data["priceC"];
            this.priceForRent = _data["priceForRent"];
            this.datetimeImage = _data["datetimeImage"] ? new Date(_data["datetimeImage"].toString()) : <any>undefined;
            this.gpsXImage = _data["gpsXImage"];
            this.gpsYImage = _data["gpsYImage"];
            this.employeeId = _data["employeeId"];
            this.buildingId = _data["buildingId"];
            this.warehouseId = _data["warehouseId"];
            if (Array.isArray(_data["employeeGroups"])) {
                this.employeeGroups = [] as any;
                for (let item of _data["employeeGroups"])
                    this.employeeGroups!.push(EmployeeGroupsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveWealthDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWealthDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["serialNumber"] = this.serialNumber;
        data["showToEmps"] = this.showToEmps;
        data["manufacturer"] = this.manufacturer;
        data["priceA"] = this.priceA;
        data["priceB"] = this.priceB;
        data["priceC"] = this.priceC;
        data["priceForRent"] = this.priceForRent;
        data["datetimeImage"] = this.datetimeImage ? this.datetimeImage.toISOString() : <any>undefined;
        data["gpsXImage"] = this.gpsXImage;
        data["gpsYImage"] = this.gpsYImage;
        data["employeeId"] = this.employeeId;
        data["buildingId"] = this.buildingId;
        data["warehouseId"] = this.warehouseId;
        if (Array.isArray(this.employeeGroups)) {
            data["employeeGroups"] = [];
            for (let item of this.employeeGroups)
                data["employeeGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveWealthDetailsRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    code?: string | undefined;
    serialNumber?: string | undefined;
    showToEmps?: boolean;
    manufacturer?: string | undefined;
    priceA?: number | undefined;
    priceB?: number | undefined;
    priceC?: number | undefined;
    priceForRent?: number | undefined;
    datetimeImage?: Date | undefined;
    gpsXImage?: number | undefined;
    gpsYImage?: number | undefined;
    employeeId?: number | undefined;
    buildingId?: number | undefined;
    warehouseId?: number | undefined;
    employeeGroups?: EmployeeGroupsDTO[] | undefined;
}

export class SaveWealthDetailsResponse implements ISaveWealthDetailsResponse {
    ok?: boolean;
    id?: number | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ISaveWealthDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SaveWealthDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWealthDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISaveWealthDetailsResponse {
    ok?: boolean;
    id?: number | undefined;
    errorMessage?: string | undefined;
}

export class SaveWealthExpendituresRequest implements ISaveWealthExpendituresRequest {
    wealthId?: number;
    wealthExpenditures?: WealthExpenditureDTO[] | undefined;

    constructor(data?: ISaveWealthExpendituresRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wealthId = _data["wealthId"];
            if (Array.isArray(_data["wealthExpenditures"])) {
                this.wealthExpenditures = [] as any;
                for (let item of _data["wealthExpenditures"])
                    this.wealthExpenditures!.push(WealthExpenditureDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveWealthExpendituresRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWealthExpendituresRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wealthId"] = this.wealthId;
        if (Array.isArray(this.wealthExpenditures)) {
            data["wealthExpenditures"] = [];
            for (let item of this.wealthExpenditures)
                data["wealthExpenditures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveWealthExpendituresRequest {
    wealthId?: number;
    wealthExpenditures?: WealthExpenditureDTO[] | undefined;
}

export class SaveWealthExpendituresResponse implements ISaveWealthExpendituresResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ISaveWealthExpendituresResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SaveWealthExpendituresResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWealthExpendituresResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISaveWealthExpendituresResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class SaveWealthRentalRequest implements ISaveWealthRentalRequest {
    wealthRental?: WealthRentalDTO;

    constructor(data?: ISaveWealthRentalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wealthRental = _data["wealthRental"] ? WealthRentalDTO.fromJS(_data["wealthRental"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveWealthRentalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWealthRentalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wealthRental"] = this.wealthRental ? this.wealthRental.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveWealthRentalRequest {
    wealthRental?: WealthRentalDTO;
}

export class SaveWealthRentalResponse implements ISaveWealthRentalResponse {
    ok?: boolean;
    id?: number | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ISaveWealthRentalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SaveWealthRentalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWealthRentalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ISaveWealthRentalResponse {
    ok?: boolean;
    id?: number | undefined;
    errorMessage?: string | undefined;
}

export class SaveWealthRentalSignatureResponse implements ISaveWealthRentalSignatureResponse {
    ok?: boolean;
    signature?: string | undefined;

    constructor(data?: ISaveWealthRentalSignatureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SaveWealthRentalSignatureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWealthRentalSignatureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISaveWealthRentalSignatureResponse {
    ok?: boolean;
    signature?: string | undefined;
}

export class SaveWeatherReqDTO implements ISaveWeatherReqDTO {
    id?: number;
    time?: string | undefined;
    description?: string | undefined;
    temperature?: string | undefined;
    humidity?: string | undefined;
    wind?: string | undefined;
    precipitation?: string | undefined;
    hours?: number | undefined;
    isShared?: boolean;

    constructor(data?: ISaveWeatherReqDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"];
            this.description = _data["description"];
            this.temperature = _data["temperature"];
            this.humidity = _data["humidity"];
            this.wind = _data["wind"];
            this.precipitation = _data["precipitation"];
            this.hours = _data["hours"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveWeatherReqDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWeatherReqDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time;
        data["description"] = this.description;
        data["temperature"] = this.temperature;
        data["humidity"] = this.humidity;
        data["wind"] = this.wind;
        data["precipitation"] = this.precipitation;
        data["hours"] = this.hours;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveWeatherReqDTO {
    id?: number;
    time?: string | undefined;
    description?: string | undefined;
    temperature?: string | undefined;
    humidity?: string | undefined;
    wind?: string | undefined;
    precipitation?: string | undefined;
    hours?: number | undefined;
    isShared?: boolean;
}

export class SaveWeathersIsSharedRequest implements ISaveWeathersIsSharedRequest {
    weathers?: number[] | undefined;
    isShared?: boolean;

    constructor(data?: ISaveWeathersIsSharedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weathers"])) {
                this.weathers = [] as any;
                for (let item of _data["weathers"])
                    this.weathers!.push(item);
            }
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveWeathersIsSharedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWeathersIsSharedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weathers)) {
            data["weathers"] = [];
            for (let item of this.weathers)
                data["weathers"].push(item);
        }
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveWeathersIsSharedRequest {
    weathers?: number[] | undefined;
    isShared?: boolean;
}

export class SaveWeathersIsSharedResponse implements ISaveWeathersIsSharedResponse {
    ok?: boolean;

    constructor(data?: ISaveWeathersIsSharedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveWeathersIsSharedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWeathersIsSharedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveWeathersIsSharedResponse {
    ok?: boolean;
}

export class SaveWeathersRequest implements ISaveWeathersRequest {
    diaryId?: number;
    weathers?: SaveWeatherReqDTO[] | undefined;

    constructor(data?: ISaveWeathersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["weathers"])) {
                this.weathers = [] as any;
                for (let item of _data["weathers"])
                    this.weathers!.push(SaveWeatherReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveWeathersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWeathersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.weathers)) {
            data["weathers"] = [];
            for (let item of this.weathers)
                data["weathers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveWeathersRequest {
    diaryId?: number;
    weathers?: SaveWeatherReqDTO[] | undefined;
}

export class SaveWeathersResponse implements ISaveWeathersResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;

    constructor(data?: ISaveWeathersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["concurrencyRecords"])) {
                this.concurrencyRecords = [] as any;
                for (let item of _data["concurrencyRecords"])
                    this.concurrencyRecords!.push(item);
            }
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): SaveWeathersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWeathersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.concurrencyRecords)) {
            data["concurrencyRecords"] = [];
            for (let item of this.concurrencyRecords)
                data["concurrencyRecords"].push(item);
        }
        data["errors"] = this.errors;
        return data;
    }
}

export interface ISaveWeathersResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;
}

export class SaveWeathersSubcontractorRequest implements ISaveWeathersSubcontractorRequest {
    diaryId?: number;
    weathers?: SaveWeatherReqDTO[] | undefined;

    constructor(data?: ISaveWeathersSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["weathers"])) {
                this.weathers = [] as any;
                for (let item of _data["weathers"])
                    this.weathers!.push(SaveWeatherReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveWeathersSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWeathersSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.weathers)) {
            data["weathers"] = [];
            for (let item of this.weathers)
                data["weathers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveWeathersSubcontractorRequest {
    diaryId?: number;
    weathers?: SaveWeatherReqDTO[] | undefined;
}

export class SaveWholeInvoiceRequest implements ISaveWholeInvoiceRequest {
    saveInvoiceRequest?: SaveInvoiceRequest;
    saveInvoiceItemsRequest?: SaveInvoiceItemsRequest;
    saveInvoiceFilesRequest?: SaveInvoiceFilesRequest;

    constructor(data?: ISaveWholeInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saveInvoiceRequest = _data["saveInvoiceRequest"] ? SaveInvoiceRequest.fromJS(_data["saveInvoiceRequest"]) : <any>undefined;
            this.saveInvoiceItemsRequest = _data["saveInvoiceItemsRequest"] ? SaveInvoiceItemsRequest.fromJS(_data["saveInvoiceItemsRequest"]) : <any>undefined;
            this.saveInvoiceFilesRequest = _data["saveInvoiceFilesRequest"] ? SaveInvoiceFilesRequest.fromJS(_data["saveInvoiceFilesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveWholeInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWholeInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveInvoiceRequest"] = this.saveInvoiceRequest ? this.saveInvoiceRequest.toJSON() : <any>undefined;
        data["saveInvoiceItemsRequest"] = this.saveInvoiceItemsRequest ? this.saveInvoiceItemsRequest.toJSON() : <any>undefined;
        data["saveInvoiceFilesRequest"] = this.saveInvoiceFilesRequest ? this.saveInvoiceFilesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveWholeInvoiceRequest {
    saveInvoiceRequest?: SaveInvoiceRequest;
    saveInvoiceItemsRequest?: SaveInvoiceItemsRequest;
    saveInvoiceFilesRequest?: SaveInvoiceFilesRequest;
}

export class SaveWholeInvoiceResponse implements ISaveWholeInvoiceResponse {
    ok?: boolean;
    id?: number;

    constructor(data?: ISaveWholeInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveWholeInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWholeInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveWholeInvoiceResponse {
    ok?: boolean;
    id?: number;
}

export class SaveWorkerReqDTO implements ISaveWorkerReqDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    groupName?: string | undefined;
    hours?: number | undefined;
    isShared?: boolean;

    constructor(data?: ISaveWorkerReqDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.groupName = _data["groupName"];
            this.hours = _data["hours"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveWorkerReqDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkerReqDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["groupName"] = this.groupName;
        data["hours"] = this.hours;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveWorkerReqDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    groupName?: string | undefined;
    hours?: number | undefined;
    isShared?: boolean;
}

export class SaveWorkersIsSharedRequest implements ISaveWorkersIsSharedRequest {
    workers?: number[] | undefined;
    isShared?: boolean;

    constructor(data?: ISaveWorkersIsSharedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(item);
            }
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveWorkersIsSharedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkersIsSharedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item);
        }
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveWorkersIsSharedRequest {
    workers?: number[] | undefined;
    isShared?: boolean;
}

export class SaveWorkersIsSharedResponse implements ISaveWorkersIsSharedResponse {
    ok?: boolean;

    constructor(data?: ISaveWorkersIsSharedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveWorkersIsSharedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkersIsSharedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveWorkersIsSharedResponse {
    ok?: boolean;
}

export class SaveWorkersRequest implements ISaveWorkersRequest {
    diaryId?: number;
    workers?: SaveWorkerReqDTO[] | undefined;

    constructor(data?: ISaveWorkersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(SaveWorkerReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveWorkersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveWorkersRequest {
    diaryId?: number;
    workers?: SaveWorkerReqDTO[] | undefined;
}

export class SaveWorkersResponse implements ISaveWorkersResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;

    constructor(data?: ISaveWorkersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["concurrencyRecords"])) {
                this.concurrencyRecords = [] as any;
                for (let item of _data["concurrencyRecords"])
                    this.concurrencyRecords!.push(item);
            }
            this.errors = _data["errors"];
        }
    }

    static fromJS(data: any): SaveWorkersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.concurrencyRecords)) {
            data["concurrencyRecords"] = [];
            for (let item of this.concurrencyRecords)
                data["concurrencyRecords"].push(item);
        }
        data["errors"] = this.errors;
        return data;
    }
}

export interface ISaveWorkersResponse {
    ok?: boolean;
    concurrencyRecords?: number[] | undefined;
    errors?: string | undefined;
}

export class SaveWorkersSubcontractorRequest implements ISaveWorkersSubcontractorRequest {
    diaryId?: number;
    workers?: SaveWorkerReqDTO[] | undefined;

    constructor(data?: ISaveWorkersSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(SaveWorkerReqDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveWorkersSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkersSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveWorkersSubcontractorRequest {
    diaryId?: number;
    workers?: SaveWorkerReqDTO[] | undefined;
}

export enum SEARCH_TYPE {
    MACHINE = 0,
    EMPLOYEE = 1,
    MATERIAL = 2,
    WORK = 3,
    OTHER_NOTES = 4,
}

export class SearchDocumentFilesRequest implements ISearchDocumentFilesRequest {
    id?: number;
    searchString?: string | undefined;

    constructor(data?: ISearchDocumentFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchString = _data["searchString"];
        }
    }

    static fromJS(data: any): SearchDocumentFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchString"] = this.searchString;
        return data;
    }
}

export interface ISearchDocumentFilesRequest {
    id?: number;
    searchString?: string | undefined;
}

export class SearchDocumentFilesResponse implements ISearchDocumentFilesResponse {
    results?: DocumentSearchResultDTO[] | undefined;

    constructor(data?: ISearchDocumentFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DocumentSearchResultDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchDocumentFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchDocumentFilesResponse {
    results?: DocumentSearchResultDTO[] | undefined;
}

export class SendGptImageMessageRequest implements ISendGptImageMessageRequest {
    message?: string | undefined;
    imageUrls?: string[] | undefined;
    previousMessages?: PreviousMessagesDTO[] | undefined;
    diaryRecordId?: number;

    constructor(data?: ISendGptImageMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            if (Array.isArray(_data["previousMessages"])) {
                this.previousMessages = [] as any;
                for (let item of _data["previousMessages"])
                    this.previousMessages!.push(PreviousMessagesDTO.fromJS(item));
            }
            this.diaryRecordId = _data["diaryRecordId"];
        }
    }

    static fromJS(data: any): SendGptImageMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendGptImageMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        if (Array.isArray(this.previousMessages)) {
            data["previousMessages"] = [];
            for (let item of this.previousMessages)
                data["previousMessages"].push(item.toJSON());
        }
        data["diaryRecordId"] = this.diaryRecordId;
        return data;
    }
}

export interface ISendGptImageMessageRequest {
    message?: string | undefined;
    imageUrls?: string[] | undefined;
    previousMessages?: PreviousMessagesDTO[] | undefined;
    diaryRecordId?: number;
}

export class SendGptImageMessageResponse implements ISendGptImageMessageResponse {
    message?: string | undefined;

    constructor(data?: ISendGptImageMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendGptImageMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendGptImageMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ISendGptImageMessageResponse {
    message?: string | undefined;
}

export class SendGptMessageRequest implements ISendGptMessageRequest {
    message?: string | undefined;
    previousMessages?: PreviousMessagesDTO[] | undefined;

    constructor(data?: ISendGptMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["previousMessages"])) {
                this.previousMessages = [] as any;
                for (let item of _data["previousMessages"])
                    this.previousMessages!.push(PreviousMessagesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendGptMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendGptMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.previousMessages)) {
            data["previousMessages"] = [];
            for (let item of this.previousMessages)
                data["previousMessages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendGptMessageRequest {
    message?: string | undefined;
    previousMessages?: PreviousMessagesDTO[] | undefined;
}

export class SendGptMessageResponse implements ISendGptMessageResponse {
    message?: string | undefined;

    constructor(data?: ISendGptMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendGptMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendGptMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ISendGptMessageResponse {
    message?: string | undefined;
}

export class SendMessageDiaryRequest implements ISendMessageDiaryRequest {
    diaryRecordId?: number;

    constructor(data?: ISendMessageDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
        }
    }

    static fromJS(data: any): SendMessageDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        return data;
    }
}

export interface ISendMessageDiaryRequest {
    diaryRecordId?: number;
}

export class SendMessageDiaryResponse implements ISendMessageDiaryResponse {
    ok?: boolean;

    constructor(data?: ISendMessageDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SendMessageDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISendMessageDiaryResponse {
    ok?: boolean;
}

export class SendMessageSubcontractorDiaryRequest implements ISendMessageSubcontractorDiaryRequest {
    diaryRecordId?: number;

    constructor(data?: ISendMessageSubcontractorDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
        }
    }

    static fromJS(data: any): SendMessageSubcontractorDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageSubcontractorDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        return data;
    }
}

export interface ISendMessageSubcontractorDiaryRequest {
    diaryRecordId?: number;
}

export class SetAllImagesShowToInvestorRequest implements ISetAllImagesShowToInvestorRequest {
    categoryId?: number | undefined;
    showToInvestor?: boolean;
    buildingId?: number;

    constructor(data?: ISetAllImagesShowToInvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.showToInvestor = _data["showToInvestor"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): SetAllImagesShowToInvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAllImagesShowToInvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["showToInvestor"] = this.showToInvestor;
        data["buildingId"] = this.buildingId;
        return data;
    }
}

export interface ISetAllImagesShowToInvestorRequest {
    categoryId?: number | undefined;
    showToInvestor?: boolean;
    buildingId?: number;
}

export class SetAllImagesShowToInvestorResponse implements ISetAllImagesShowToInvestorResponse {
    ok?: boolean;

    constructor(data?: ISetAllImagesShowToInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetAllImagesShowToInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetAllImagesShowToInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetAllImagesShowToInvestorResponse {
    ok?: boolean;
}

export class SetApplicationPermissionsKrosAdminRequest implements ISetApplicationPermissionsKrosAdminRequest {
    applicationId?: number;
    permissions?: KrosAdminApplicationPermissionDTO;

    constructor(data?: ISetApplicationPermissionsKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.permissions = _data["permissions"] ? KrosAdminApplicationPermissionDTO.fromJS(_data["permissions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SetApplicationPermissionsKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetApplicationPermissionsKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetApplicationPermissionsKrosAdminRequest {
    applicationId?: number;
    permissions?: KrosAdminApplicationPermissionDTO;
}

export class SetApplicationPermissionsKrosAdminResponse implements ISetApplicationPermissionsKrosAdminResponse {

    constructor(data?: ISetApplicationPermissionsKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SetApplicationPermissionsKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetApplicationPermissionsKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISetApplicationPermissionsKrosAdminResponse {
}

export class SetBozpAsReadEmployeeMobileRequest implements ISetBozpAsReadEmployeeMobileRequest {
    bozpId?: number;
    signature?: string | undefined;

    constructor(data?: ISetBozpAsReadEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bozpId = _data["bozpId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetBozpAsReadEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetBozpAsReadEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bozpId"] = this.bozpId;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetBozpAsReadEmployeeMobileRequest {
    bozpId?: number;
    signature?: string | undefined;
}

export class SetBozpAsReadEmployeeMobileResponse implements ISetBozpAsReadEmployeeMobileResponse {
    ok?: boolean;

    constructor(data?: ISetBozpAsReadEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetBozpAsReadEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetBozpAsReadEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetBozpAsReadEmployeeMobileResponse {
    ok?: boolean;
}

export class SetBuildingIsActiveRequest implements ISetBuildingIsActiveRequest {
    id?: number | undefined;
    isActive?: boolean;

    constructor(data?: ISetBuildingIsActiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SetBuildingIsActiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetBuildingIsActiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISetBuildingIsActiveRequest {
    id?: number | undefined;
    isActive?: boolean;
}

export class SetBuildingIsActiveResponse implements ISetBuildingIsActiveResponse {
    ok?: boolean;

    constructor(data?: ISetBuildingIsActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetBuildingIsActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetBuildingIsActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetBuildingIsActiveResponse {
    ok?: boolean;
}

export class SetBuildingShowToEmployeesRequest implements ISetBuildingShowToEmployeesRequest {
    id?: number | undefined;
    showToEmployees?: boolean;

    constructor(data?: ISetBuildingShowToEmployeesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showToEmployees = _data["showToEmployees"];
        }
    }

    static fromJS(data: any): SetBuildingShowToEmployeesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetBuildingShowToEmployeesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showToEmployees"] = this.showToEmployees;
        return data;
    }
}

export interface ISetBuildingShowToEmployeesRequest {
    id?: number | undefined;
    showToEmployees?: boolean;
}

export class SetBuildingShowToEmployeesResponse implements ISetBuildingShowToEmployeesResponse {
    ok?: boolean;

    constructor(data?: ISetBuildingShowToEmployeesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetBuildingShowToEmployeesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetBuildingShowToEmployeesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetBuildingShowToEmployeesResponse {
    ok?: boolean;
}

export class SetDocumentAsReadEmployeeMobileRequest implements ISetDocumentAsReadEmployeeMobileRequest {
    documentId?: number;
    documentType?: string | undefined;
    signature?: string | undefined;

    constructor(data?: ISetDocumentAsReadEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetDocumentAsReadEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsReadEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetDocumentAsReadEmployeeMobileRequest {
    documentId?: number;
    documentType?: string | undefined;
    signature?: string | undefined;
}

export class SetDocumentAsReadEmployeeMobileResponse implements ISetDocumentAsReadEmployeeMobileResponse {
    ok?: boolean;

    constructor(data?: ISetDocumentAsReadEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetDocumentAsReadEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsReadEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetDocumentAsReadEmployeeMobileResponse {
    ok?: boolean;
}

export class SetDocumentAsRejectedEmployeeMobileRequest implements ISetDocumentAsRejectedEmployeeMobileRequest {
    documentId?: number;
    documentType?: string | undefined;

    constructor(data?: ISetDocumentAsRejectedEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): SetDocumentAsRejectedEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsRejectedEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface ISetDocumentAsRejectedEmployeeMobileRequest {
    documentId?: number;
    documentType?: string | undefined;
}

export class SetDocumentAsRejectedEmployeeMobileResponse implements ISetDocumentAsRejectedEmployeeMobileResponse {
    ok?: boolean;

    constructor(data?: ISetDocumentAsRejectedEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetDocumentAsRejectedEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsRejectedEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetDocumentAsRejectedEmployeeMobileResponse {
    ok?: boolean;
}

export class SetImagesCategoryRequest implements ISetImagesCategoryRequest {
    imageIds?: number[] | undefined;
    categoryId?: number;

    constructor(data?: ISetImagesCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): SetImagesCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetImagesCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface ISetImagesCategoryRequest {
    imageIds?: number[] | undefined;
    categoryId?: number;
}

export class SetImagesCategoryResponse implements ISetImagesCategoryResponse {
    ok?: boolean;

    constructor(data?: ISetImagesCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetImagesCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetImagesCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetImagesCategoryResponse {
    ok?: boolean;
}

export class SetImagesShowToInvestorRequest implements ISetImagesShowToInvestorRequest {
    imagesId?: number[] | undefined;
    showToInvestor?: boolean;

    constructor(data?: ISetImagesShowToInvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imagesId"])) {
                this.imagesId = [] as any;
                for (let item of _data["imagesId"])
                    this.imagesId!.push(item);
            }
            this.showToInvestor = _data["showToInvestor"];
        }
    }

    static fromJS(data: any): SetImagesShowToInvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetImagesShowToInvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imagesId)) {
            data["imagesId"] = [];
            for (let item of this.imagesId)
                data["imagesId"].push(item);
        }
        data["showToInvestor"] = this.showToInvestor;
        return data;
    }
}

export interface ISetImagesShowToInvestorRequest {
    imagesId?: number[] | undefined;
    showToInvestor?: boolean;
}

export class SetImagesShowToInvestorResponse implements ISetImagesShowToInvestorResponse {
    ok?: boolean;

    constructor(data?: ISetImagesShowToInvestorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetImagesShowToInvestorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetImagesShowToInvestorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetImagesShowToInvestorResponse {
    ok?: boolean;
}

export class SetIsActiveDiaryRequest implements ISetIsActiveDiaryRequest {
    diaryId?: number;
    active?: boolean;

    constructor(data?: ISetIsActiveDiaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SetIsActiveDiaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsActiveDiaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["active"] = this.active;
        return data;
    }
}

export interface ISetIsActiveDiaryRequest {
    diaryId?: number;
    active?: boolean;
}

export class SetIsActiveDiaryResponse implements ISetIsActiveDiaryResponse {
    ok?: boolean;

    constructor(data?: ISetIsActiveDiaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetIsActiveDiaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsActiveDiaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetIsActiveDiaryResponse {
    ok?: boolean;
}

export class SetIsAppActiveKrosAdminRequest implements ISetIsAppActiveKrosAdminRequest {
    appId?: number;
    active?: boolean;

    constructor(data?: ISetIsAppActiveKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SetIsAppActiveKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsAppActiveKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["active"] = this.active;
        return data;
    }
}

export interface ISetIsAppActiveKrosAdminRequest {
    appId?: number;
    active?: boolean;
}

export class SetIsAppActiveKrosAdminResponse implements ISetIsAppActiveKrosAdminResponse {
    ok?: boolean;

    constructor(data?: ISetIsAppActiveKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetIsAppActiveKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsAppActiveKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetIsAppActiveKrosAdminResponse {
    ok?: boolean;
}

export class SetIsAppPayingKrosAdminRequest implements ISetIsAppPayingKrosAdminRequest {
    appId?: number;
    paying?: boolean;

    constructor(data?: ISetIsAppPayingKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.paying = _data["paying"];
        }
    }

    static fromJS(data: any): SetIsAppPayingKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsAppPayingKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["paying"] = this.paying;
        return data;
    }
}

export interface ISetIsAppPayingKrosAdminRequest {
    appId?: number;
    paying?: boolean;
}

export class SetIsAppPayingKrosAdminResponse implements ISetIsAppPayingKrosAdminResponse {
    ok?: boolean;

    constructor(data?: ISetIsAppPayingKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetIsAppPayingKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsAppPayingKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetIsAppPayingKrosAdminResponse {
    ok?: boolean;
}

export class SetIsEmployeeActiveRequest implements ISetIsEmployeeActiveRequest {
    employeeId?: number;
    active?: boolean;

    constructor(data?: ISetIsEmployeeActiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SetIsEmployeeActiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsEmployeeActiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["active"] = this.active;
        return data;
    }
}

export interface ISetIsEmployeeActiveRequest {
    employeeId?: number;
    active?: boolean;
}

export class SetIsEmployeeActiveResponse implements ISetIsEmployeeActiveResponse {
    ok?: boolean;

    constructor(data?: ISetIsEmployeeActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetIsEmployeeActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetIsEmployeeActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetIsEmployeeActiveResponse {
    ok?: boolean;
}

export class SetMessagesAsReadDTO implements ISetMessagesAsReadDTO {
    datetime!: string;
    requestId?: number;
    additionalProperties?: { [key: string]: any; } | undefined;

    constructor(data?: ISetMessagesAsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datetime = _data["datetime"];
            this.requestId = _data["requestId"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): SetMessagesAsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetMessagesAsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datetime"] = this.datetime;
        data["requestId"] = this.requestId;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface ISetMessagesAsReadDTO {
    datetime: string;
    requestId?: number;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export class SetMessagesAsReadEmployeeMobileRequest implements ISetMessagesAsReadEmployeeMobileRequest {
    message?: SetMessagesAsReadDTO;

    constructor(data?: ISetMessagesAsReadEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] ? SetMessagesAsReadDTO.fromJS(_data["message"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SetMessagesAsReadEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMessagesAsReadEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetMessagesAsReadEmployeeMobileRequest {
    message?: SetMessagesAsReadDTO;
}

export class SetMessagesAsReadEmployeeMobileResponse implements ISetMessagesAsReadEmployeeMobileResponse {
    message?: SetMessagesAsReadDTO;

    constructor(data?: ISetMessagesAsReadEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] ? SetMessagesAsReadDTO.fromJS(_data["message"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SetMessagesAsReadEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMessagesAsReadEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetMessagesAsReadEmployeeMobileResponse {
    message?: SetMessagesAsReadDTO;
}

export class SetNewsAsReadEmployeeMobileRequest implements ISetNewsAsReadEmployeeMobileRequest {
    newId?: number;
    signature?: string | undefined;

    constructor(data?: ISetNewsAsReadEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newId = _data["newId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetNewsAsReadEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetNewsAsReadEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newId"] = this.newId;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetNewsAsReadEmployeeMobileRequest {
    newId?: number;
    signature?: string | undefined;
}

export class SetNewsAsReadEmployeeMobileResponse implements ISetNewsAsReadEmployeeMobileResponse {
    ok?: boolean;

    constructor(data?: ISetNewsAsReadEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetNewsAsReadEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetNewsAsReadEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetNewsAsReadEmployeeMobileResponse {
    ok?: boolean;
}

export class SetProductIsActiveRequest implements ISetProductIsActiveRequest {
    id?: number | undefined;
    isActive?: boolean;

    constructor(data?: ISetProductIsActiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SetProductIsActiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductIsActiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISetProductIsActiveRequest {
    id?: number | undefined;
    isActive?: boolean;
}

export class SetProductIsActiveResponse implements ISetProductIsActiveResponse {
    ok?: boolean;

    constructor(data?: ISetProductIsActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetProductIsActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductIsActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetProductIsActiveResponse {
    ok?: boolean;
}

export class SetRequestStateEmployeeMobileRequest implements ISetRequestStateEmployeeMobileRequest {
    requestId?: number;
    state?: TodoState;

    constructor(data?: ISetRequestStateEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): SetRequestStateEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRequestStateEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["state"] = this.state;
        return data;
    }
}

export interface ISetRequestStateEmployeeMobileRequest {
    requestId?: number;
    state?: TodoState;
}

export class SetRequestStateEmployeeMobileResponse implements ISetRequestStateEmployeeMobileResponse {
    state?: TodoState;
    success?: boolean;

    constructor(data?: ISetRequestStateEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SetRequestStateEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetRequestStateEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["success"] = this.success;
        return data;
    }
}

export interface ISetRequestStateEmployeeMobileResponse {
    state?: TodoState;
    success?: boolean;
}

export class SetShowPayingKrosAdminRequest implements ISetShowPayingKrosAdminRequest {
    appId?: number;
    paying?: boolean;

    constructor(data?: ISetShowPayingKrosAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.paying = _data["paying"];
        }
    }

    static fromJS(data: any): SetShowPayingKrosAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetShowPayingKrosAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["paying"] = this.paying;
        return data;
    }
}

export interface ISetShowPayingKrosAdminRequest {
    appId?: number;
    paying?: boolean;
}

export class SetShowPayingKrosAdminResponse implements ISetShowPayingKrosAdminResponse {
    ok?: boolean;

    constructor(data?: ISetShowPayingKrosAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetShowPayingKrosAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetShowPayingKrosAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetShowPayingKrosAdminResponse {
    ok?: boolean;
}

export class SetWarehouseIsActiveRequest implements ISetWarehouseIsActiveRequest {
    id?: number | undefined;
    isActive?: boolean;

    constructor(data?: ISetWarehouseIsActiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SetWarehouseIsActiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetWarehouseIsActiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISetWarehouseIsActiveRequest {
    id?: number | undefined;
    isActive?: boolean;
}

export class SetWarehouseIsActiveResponse implements ISetWarehouseIsActiveResponse {
    ok?: boolean;

    constructor(data?: ISetWarehouseIsActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SetWarehouseIsActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetWarehouseIsActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISetWarehouseIsActiveResponse {
    ok?: boolean;
}

export class SetWealthToEmployeeRequest implements ISetWealthToEmployeeRequest {
    wealths?: MobileWealthDTO[] | undefined;
    buildingId?: number | undefined;
    rentDateOrientationFrom?: Date | undefined;
    signature?: string | undefined;

    constructor(data?: ISetWealthToEmployeeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealths"])) {
                this.wealths = [] as any;
                for (let item of _data["wealths"])
                    this.wealths!.push(MobileWealthDTO.fromJS(item));
            }
            this.buildingId = _data["buildingId"];
            this.rentDateOrientationFrom = _data["rentDateOrientationFrom"] ? new Date(_data["rentDateOrientationFrom"].toString()) : <any>undefined;
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetWealthToEmployeeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetWealthToEmployeeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealths)) {
            data["wealths"] = [];
            for (let item of this.wealths)
                data["wealths"].push(item.toJSON());
        }
        data["buildingId"] = this.buildingId;
        data["rentDateOrientationFrom"] = this.rentDateOrientationFrom ? this.rentDateOrientationFrom.toISOString() : <any>undefined;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetWealthToEmployeeRequest {
    wealths?: MobileWealthDTO[] | undefined;
    buildingId?: number | undefined;
    rentDateOrientationFrom?: Date | undefined;
    signature?: string | undefined;
}

export class SetWealthToEmployeeResponse implements ISetWealthToEmployeeResponse {
    wealths?: string[] | undefined;

    constructor(data?: ISetWealthToEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wealths"])) {
                this.wealths = [] as any;
                for (let item of _data["wealths"])
                    this.wealths!.push(item);
            }
        }
    }

    static fromJS(data: any): SetWealthToEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetWealthToEmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wealths)) {
            data["wealths"] = [];
            for (let item of this.wealths)
                data["wealths"].push(item);
        }
        return data;
    }
}

export interface ISetWealthToEmployeeResponse {
    wealths?: string[] | undefined;
}

export class SignatueListDTO implements ISignatueListDTO {
    id?: number;
    name?: string | undefined;
    isInvestor?: boolean;
    isSubcontractor?: boolean;

    constructor(data?: ISignatueListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isInvestor = _data["isInvestor"];
            this.isSubcontractor = _data["isSubcontractor"];
        }
    }

    static fromJS(data: any): SignatueListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SignatueListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isInvestor"] = this.isInvestor;
        data["isSubcontractor"] = this.isSubcontractor;
        return data;
    }
}

export interface ISignatueListDTO {
    id?: number;
    name?: string | undefined;
    isInvestor?: boolean;
    isSubcontractor?: boolean;
}

export class SignatureDTO implements ISignatureDTO {
    userName?: string | undefined;
    dateTime?: Date | undefined;
    isInvestor?: boolean;
    isUser?: boolean;
    url?: string | undefined;
    base64?: string | undefined;
    isMySignature?: boolean;

    constructor(data?: ISignatureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.isInvestor = _data["isInvestor"];
            this.isUser = _data["isUser"];
            this.url = _data["url"];
            this.base64 = _data["base64"];
            this.isMySignature = _data["isMySignature"];
        }
    }

    static fromJS(data: any): SignatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["isInvestor"] = this.isInvestor;
        data["isUser"] = this.isUser;
        data["url"] = this.url;
        data["base64"] = this.base64;
        data["isMySignature"] = this.isMySignature;
        return data;
    }
}

export interface ISignatureDTO {
    userName?: string | undefined;
    dateTime?: Date | undefined;
    isInvestor?: boolean;
    isUser?: boolean;
    url?: string | undefined;
    base64?: string | undefined;
    isMySignature?: boolean;
}

export class SignatureEmployeeDTO implements ISignatureEmployeeDTO {
    url?: string | undefined;

    constructor(data?: ISignatureEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SignatureEmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureEmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface ISignatureEmployeeDTO {
    url?: string | undefined;
}

export class SignPeopleDTO implements ISignPeopleDTO {
    name?: string | undefined;
    isOkForSignWorkflow?: boolean;
    isInvestor?: boolean;

    constructor(data?: ISignPeopleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isOkForSignWorkflow = _data["isOkForSignWorkflow"];
            this.isInvestor = _data["isInvestor"];
        }
    }

    static fromJS(data: any): SignPeopleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SignPeopleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isOkForSignWorkflow"] = this.isOkForSignWorkflow;
        data["isInvestor"] = this.isInvestor;
        return data;
    }
}

export interface ISignPeopleDTO {
    name?: string | undefined;
    isOkForSignWorkflow?: boolean;
    isInvestor?: boolean;
}

export class StartSigniInteractiveRequest implements IStartSigniInteractiveRequest {
    diaryRecordId?: number;
    lang?: string | undefined;

    constructor(data?: IStartSigniInteractiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): StartSigniInteractiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartSigniInteractiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IStartSigniInteractiveRequest {
    diaryRecordId?: number;
    lang?: string | undefined;
}

export class StatisticsKrosAdminDTO implements IStatisticsKrosAdminDTO {
    dataAmount?: number;
    demosCount?: number;
    payingApps?: number;
    activeApps?: number;
    apps?: number;
    activeProjects?: number;
    projects?: number;
    activeWealth?: number;
    wealth?: number;
    activeRequests?: number;
    requests?: number;
    diaries?: number;
    investors?: number;
    users?: number;
    activeEmployees?: number;
    employees?: number;
    activeUsersAndEmployees?: number;
    employeesAtWork?: number;
    invoices?: number;

    constructor(data?: IStatisticsKrosAdminDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataAmount = _data["dataAmount"];
            this.demosCount = _data["demosCount"];
            this.payingApps = _data["payingApps"];
            this.activeApps = _data["activeApps"];
            this.apps = _data["apps"];
            this.activeProjects = _data["activeProjects"];
            this.projects = _data["projects"];
            this.activeWealth = _data["activeWealth"];
            this.wealth = _data["wealth"];
            this.activeRequests = _data["activeRequests"];
            this.requests = _data["requests"];
            this.diaries = _data["diaries"];
            this.investors = _data["investors"];
            this.users = _data["users"];
            this.activeEmployees = _data["activeEmployees"];
            this.employees = _data["employees"];
            this.activeUsersAndEmployees = _data["activeUsersAndEmployees"];
            this.employeesAtWork = _data["employeesAtWork"];
            this.invoices = _data["invoices"];
        }
    }

    static fromJS(data: any): StatisticsKrosAdminDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsKrosAdminDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataAmount"] = this.dataAmount;
        data["demosCount"] = this.demosCount;
        data["payingApps"] = this.payingApps;
        data["activeApps"] = this.activeApps;
        data["apps"] = this.apps;
        data["activeProjects"] = this.activeProjects;
        data["projects"] = this.projects;
        data["activeWealth"] = this.activeWealth;
        data["wealth"] = this.wealth;
        data["activeRequests"] = this.activeRequests;
        data["requests"] = this.requests;
        data["diaries"] = this.diaries;
        data["investors"] = this.investors;
        data["users"] = this.users;
        data["activeEmployees"] = this.activeEmployees;
        data["employees"] = this.employees;
        data["activeUsersAndEmployees"] = this.activeUsersAndEmployees;
        data["employeesAtWork"] = this.employeesAtWork;
        data["invoices"] = this.invoices;
        return data;
    }
}

export interface IStatisticsKrosAdminDTO {
    dataAmount?: number;
    demosCount?: number;
    payingApps?: number;
    activeApps?: number;
    apps?: number;
    activeProjects?: number;
    projects?: number;
    activeWealth?: number;
    wealth?: number;
    activeRequests?: number;
    requests?: number;
    diaries?: number;
    investors?: number;
    users?: number;
    activeEmployees?: number;
    employees?: number;
    activeUsersAndEmployees?: number;
    employeesAtWork?: number;
    invoices?: number;
}

export class StockItemDTO implements IStockItemDTO {
    id?: number;
    productId?: number;
    code?: string | undefined;
    name?: string | undefined;
    unitsCount?: number;
    unitsPrice?: number;
    unitsWeight?: number | undefined;
    totalUnitsCount?: number;
    measureUnitAbbr?: string | undefined;

    constructor(data?: IStockItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.unitsCount = _data["unitsCount"];
            this.unitsPrice = _data["unitsPrice"];
            this.unitsWeight = _data["unitsWeight"];
            this.totalUnitsCount = _data["totalUnitsCount"];
            this.measureUnitAbbr = _data["measureUnitAbbr"];
        }
    }

    static fromJS(data: any): StockItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["unitsCount"] = this.unitsCount;
        data["unitsPrice"] = this.unitsPrice;
        data["unitsWeight"] = this.unitsWeight;
        data["totalUnitsCount"] = this.totalUnitsCount;
        data["measureUnitAbbr"] = this.measureUnitAbbr;
        return data;
    }
}

export interface IStockItemDTO {
    id?: number;
    productId?: number;
    code?: string | undefined;
    name?: string | undefined;
    unitsCount?: number;
    unitsPrice?: number;
    unitsWeight?: number | undefined;
    totalUnitsCount?: number;
    measureUnitAbbr?: string | undefined;
}

export class StringStringIEnumerableKeyValuePair implements IStringStringIEnumerableKeyValuePair {
    key?: string | undefined;
    value?: string[] | undefined;

    constructor(data?: IStringStringIEnumerableKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringStringIEnumerableKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringIEnumerableKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IStringStringIEnumerableKeyValuePair {
    key?: string | undefined;
    value?: string[] | undefined;
}

export class SubcontractorGroupResponse implements ISubcontractorGroupResponse {
    groups?: UserGroupDTO[] | undefined;

    constructor(data?: ISubcontractorGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(UserGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubcontractorGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubcontractorGroupResponse {
    groups?: UserGroupDTO[] | undefined;
}

export class SubcontractorsChatMessageDTO implements ISubcontractorsChatMessageDTO {
    id?: number;
    userName?: string | undefined;
    isMe?: boolean;
    datetime?: Date;
    text?: string | undefined;

    constructor(data?: ISubcontractorsChatMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.isMe = _data["isMe"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SubcontractorsChatMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorsChatMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["isMe"] = this.isMe;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["text"] = this.text;
        return data;
    }
}

export interface ISubcontractorsChatMessageDTO {
    id?: number;
    userName?: string | undefined;
    isMe?: boolean;
    datetime?: Date;
    text?: string | undefined;
}

export class SubDiaryDTO implements ISubDiaryDTO {
    diaryId?: number | undefined;
    diaryName?: string | undefined;
    content?: string | undefined;
    changed?: boolean;

    constructor(data?: ISubDiaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryId = _data["diaryId"];
            this.diaryName = _data["diaryName"];
            this.content = _data["content"];
            this.changed = _data["changed"];
        }
    }

    static fromJS(data: any): SubDiaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubDiaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryId"] = this.diaryId;
        data["diaryName"] = this.diaryName;
        data["content"] = this.content;
        data["changed"] = this.changed;
        return data;
    }
}

export interface ISubDiaryDTO {
    diaryId?: number | undefined;
    diaryName?: string | undefined;
    content?: string | undefined;
    changed?: boolean;
}

export class TaskDTO implements ITaskDTO {
    id?: number;
    name?: string | undefined;
    status?: number;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeTo?: Date | undefined;
    datetimeCreated?: Date;
    buildingId?: number | undefined;
    wealthId?: number | undefined;
    authorId?: number | undefined;
    processingAdminUserId?: number | undefined;
    employeeIds?: number[] | undefined;

    constructor(data?: ITaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.datetimeStart = _data["datetimeStart"] ? new Date(_data["datetimeStart"].toString()) : <any>undefined;
            this.datetimeEnd = _data["datetimeEnd"] ? new Date(_data["datetimeEnd"].toString()) : <any>undefined;
            this.datetimeTo = _data["datetimeTo"] ? new Date(_data["datetimeTo"].toString()) : <any>undefined;
            this.datetimeCreated = _data["datetimeCreated"] ? new Date(_data["datetimeCreated"].toString()) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.wealthId = _data["wealthId"];
            this.authorId = _data["authorId"];
            this.processingAdminUserId = _data["processingAdminUserId"];
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["datetimeStart"] = this.datetimeStart ? this.datetimeStart.toISOString() : <any>undefined;
        data["datetimeEnd"] = this.datetimeEnd ? this.datetimeEnd.toISOString() : <any>undefined;
        data["datetimeTo"] = this.datetimeTo ? this.datetimeTo.toISOString() : <any>undefined;
        data["datetimeCreated"] = this.datetimeCreated ? this.datetimeCreated.toISOString() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["wealthId"] = this.wealthId;
        data["authorId"] = this.authorId;
        data["processingAdminUserId"] = this.processingAdminUserId;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        return data;
    }
}

export interface ITaskDTO {
    id?: number;
    name?: string | undefined;
    status?: number;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeTo?: Date | undefined;
    datetimeCreated?: Date;
    buildingId?: number | undefined;
    wealthId?: number | undefined;
    authorId?: number | undefined;
    processingAdminUserId?: number | undefined;
    employeeIds?: number[] | undefined;
}

export class TaxrateDTO implements ITaxrateDTO {
    id?: number;
    value?: number;

    constructor(data?: ITaxrateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TaxrateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TaxrateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface ITaxrateDTO {
    id?: number;
    value?: number;
}

export class TestPrintRequest implements ITestPrintRequest {

    constructor(data?: ITestPrintRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TestPrintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestPrintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITestPrintRequest {
}

export class TestSigniDownloadRequest implements ITestSigniDownloadRequest {
    apiKey?: string | undefined;
    contractId?: number;

    constructor(data?: ITestSigniDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.contractId = _data["contractId"];
        }
    }

    static fromJS(data: any): TestSigniDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestSigniDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["contractId"] = this.contractId;
        return data;
    }
}

export interface ITestSigniDownloadRequest {
    apiKey?: string | undefined;
    contractId?: number;
}

export class ToDoAssigneeDTO implements IToDoAssigneeDTO {
    id?: number;
    name?: string | undefined;
    type?: UserType;

    constructor(data?: IToDoAssigneeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ToDoAssigneeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ToDoAssigneeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IToDoAssigneeDTO {
    id?: number;
    name?: string | undefined;
    type?: UserType;
}

export class TodoDTO implements ITodoDTO {
    id?: number;
    state?: TodoState;
    name?: string | undefined;
    responsiblePersonId?: number | undefined;
    assignees?: ToDoAssigneeDTO[] | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    buildingDiaryId?: number | undefined;
    wealthId?: number | undefined;
    showInGantt?: boolean;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeCreated?: Date;
    datetimeDeadline?: Date | undefined;
    mapTagColor?: string | undefined;
    mapLeft?: number | undefined;
    mapTop?: number | undefined;
    buildingTodoMapId?: number | undefined;
    buildingTodoMapName?: string | undefined;
    progress?: number;
    origin?: RequestOriginType;
    creator?: string | undefined;

    constructor(data?: ITodoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.name = _data["name"];
            this.responsiblePersonId = _data["responsiblePersonId"];
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(ToDoAssigneeDTO.fromJS(item));
            }
            this.description = _data["description"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.buildingDiaryId = _data["buildingDiaryId"];
            this.wealthId = _data["wealthId"];
            this.showInGantt = _data["showInGantt"];
            this.datetimeStart = _data["datetimeStart"] ? new Date(_data["datetimeStart"].toString()) : <any>undefined;
            this.datetimeEnd = _data["datetimeEnd"] ? new Date(_data["datetimeEnd"].toString()) : <any>undefined;
            this.datetimeCreated = _data["datetimeCreated"] ? new Date(_data["datetimeCreated"].toString()) : <any>undefined;
            this.datetimeDeadline = _data["datetimeDeadline"] ? new Date(_data["datetimeDeadline"].toString()) : <any>undefined;
            this.mapTagColor = _data["mapTagColor"];
            this.mapLeft = _data["mapLeft"];
            this.mapTop = _data["mapTop"];
            this.buildingTodoMapId = _data["buildingTodoMapId"];
            this.buildingTodoMapName = _data["buildingTodoMapName"];
            this.progress = _data["progress"];
            this.origin = _data["origin"];
            this.creator = _data["creator"];
        }
    }

    static fromJS(data: any): TodoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["name"] = this.name;
        data["responsiblePersonId"] = this.responsiblePersonId;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["buildingDiaryId"] = this.buildingDiaryId;
        data["wealthId"] = this.wealthId;
        data["showInGantt"] = this.showInGantt;
        data["datetimeStart"] = this.datetimeStart ? this.datetimeStart.toISOString() : <any>undefined;
        data["datetimeEnd"] = this.datetimeEnd ? this.datetimeEnd.toISOString() : <any>undefined;
        data["datetimeCreated"] = this.datetimeCreated ? this.datetimeCreated.toISOString() : <any>undefined;
        data["datetimeDeadline"] = this.datetimeDeadline ? this.datetimeDeadline.toISOString() : <any>undefined;
        data["mapTagColor"] = this.mapTagColor;
        data["mapLeft"] = this.mapLeft;
        data["mapTop"] = this.mapTop;
        data["buildingTodoMapId"] = this.buildingTodoMapId;
        data["buildingTodoMapName"] = this.buildingTodoMapName;
        data["progress"] = this.progress;
        data["origin"] = this.origin;
        data["creator"] = this.creator;
        return data;
    }
}

export interface ITodoDTO {
    id?: number;
    state?: TodoState;
    name?: string | undefined;
    responsiblePersonId?: number | undefined;
    assignees?: ToDoAssigneeDTO[] | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    buildingDiaryId?: number | undefined;
    wealthId?: number | undefined;
    showInGantt?: boolean;
    datetimeStart?: Date | undefined;
    datetimeEnd?: Date | undefined;
    datetimeCreated?: Date;
    datetimeDeadline?: Date | undefined;
    mapTagColor?: string | undefined;
    mapLeft?: number | undefined;
    mapTop?: number | undefined;
    buildingTodoMapId?: number | undefined;
    buildingTodoMapName?: string | undefined;
    progress?: number;
    origin?: RequestOriginType;
    creator?: string | undefined;
}

export class TodoGanttDTO implements ITodoGanttDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    investorId?: number | undefined;
    investorName?: string | undefined;
    userIdFrom?: number | undefined;
    userIdFromName?: string | undefined;
    createdTime?: Date;
    datetimeStart?: Date;
    datetimeEnd?: Date | undefined;
    deadline?: Date | undefined;
    duration?: number | undefined;
    progress?: number;
    state?: TodoState;
    level?: number;
    subtasks?: TodoGanttDTO[] | undefined;
    isBuilding?: boolean;
    predecessor?: string | undefined;

    constructor(data?: ITodoGanttDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.investorId = _data["investorId"];
            this.investorName = _data["investorName"];
            this.userIdFrom = _data["userIdFrom"];
            this.userIdFromName = _data["userIdFromName"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.datetimeStart = _data["datetimeStart"] ? new Date(_data["datetimeStart"].toString()) : <any>undefined;
            this.datetimeEnd = _data["datetimeEnd"] ? new Date(_data["datetimeEnd"].toString()) : <any>undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.progress = _data["progress"];
            this.state = _data["state"];
            this.level = _data["level"];
            if (Array.isArray(_data["subtasks"])) {
                this.subtasks = [] as any;
                for (let item of _data["subtasks"])
                    this.subtasks!.push(TodoGanttDTO.fromJS(item));
            }
            this.isBuilding = _data["isBuilding"];
            this.predecessor = _data["predecessor"];
        }
    }

    static fromJS(data: any): TodoGanttDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoGanttDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["investorId"] = this.investorId;
        data["investorName"] = this.investorName;
        data["userIdFrom"] = this.userIdFrom;
        data["userIdFromName"] = this.userIdFromName;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["datetimeStart"] = this.datetimeStart ? this.datetimeStart.toISOString() : <any>undefined;
        data["datetimeEnd"] = this.datetimeEnd ? this.datetimeEnd.toISOString() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["progress"] = this.progress;
        data["state"] = this.state;
        data["level"] = this.level;
        if (Array.isArray(this.subtasks)) {
            data["subtasks"] = [];
            for (let item of this.subtasks)
                data["subtasks"].push(item.toJSON());
        }
        data["isBuilding"] = this.isBuilding;
        data["predecessor"] = this.predecessor;
        return data;
    }
}

export interface ITodoGanttDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    investorId?: number | undefined;
    investorName?: string | undefined;
    userIdFrom?: number | undefined;
    userIdFromName?: string | undefined;
    createdTime?: Date;
    datetimeStart?: Date;
    datetimeEnd?: Date | undefined;
    deadline?: Date | undefined;
    duration?: number | undefined;
    progress?: number;
    state?: TodoState;
    level?: number;
    subtasks?: TodoGanttDTO[] | undefined;
    isBuilding?: boolean;
    predecessor?: string | undefined;
}

export class TodoHistoryDTO implements ITodoHistoryDTO {
    id?: number;
    requestsId?: number;
    columnName?: string | undefined;
    value?: string | undefined;
    datetime?: Date;
    adminUser?: string | undefined;
    employee?: string | undefined;
    investor?: string | undefined;

    constructor(data?: ITodoHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestsId = _data["requestsId"];
            this.columnName = _data["columnName"];
            this.value = _data["value"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.adminUser = _data["adminUser"];
            this.employee = _data["employee"];
            this.investor = _data["investor"];
        }
    }

    static fromJS(data: any): TodoHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestsId"] = this.requestsId;
        data["columnName"] = this.columnName;
        data["value"] = this.value;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["adminUser"] = this.adminUser;
        data["employee"] = this.employee;
        data["investor"] = this.investor;
        return data;
    }
}

export interface ITodoHistoryDTO {
    id?: number;
    requestsId?: number;
    columnName?: string | undefined;
    value?: string | undefined;
    datetime?: Date;
    adminUser?: string | undefined;
    employee?: string | undefined;
    investor?: string | undefined;
}

export class TodoListDTO implements ITodoListDTO {
    id?: number;
    name?: string | undefined;
    buildingName?: string | undefined;
    buildingId?: number | undefined;
    assignees?: string | undefined;
    creatorName?: string | undefined;
    responsiblePersonId?: number | undefined;
    responsiblePerson?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeDeadline?: Date | undefined;
    state?: number;
    buildingTodoMapId?: number | undefined;
    mapTagColor?: string | undefined;
    mapLeft?: number | undefined;
    mapTop?: number | undefined;
    temporaryMarker?: boolean;
    rowVersion?: Date;
    unread?: boolean;
    description?: string | undefined;

    constructor(data?: ITodoListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.buildingName = _data["buildingName"];
            this.buildingId = _data["buildingId"];
            this.assignees = _data["assignees"];
            this.creatorName = _data["creatorName"];
            this.responsiblePersonId = _data["responsiblePersonId"];
            this.responsiblePerson = _data["responsiblePerson"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeDeadline = _data["dateTimeDeadline"] ? new Date(_data["dateTimeDeadline"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.buildingTodoMapId = _data["buildingTodoMapId"];
            this.mapTagColor = _data["mapTagColor"];
            this.mapLeft = _data["mapLeft"];
            this.mapTop = _data["mapTop"];
            this.temporaryMarker = _data["temporaryMarker"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : <any>undefined;
            this.unread = _data["unread"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TodoListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["buildingName"] = this.buildingName;
        data["buildingId"] = this.buildingId;
        data["assignees"] = this.assignees;
        data["creatorName"] = this.creatorName;
        data["responsiblePersonId"] = this.responsiblePersonId;
        data["responsiblePerson"] = this.responsiblePerson;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeDeadline"] = this.dateTimeDeadline ? this.dateTimeDeadline.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["buildingTodoMapId"] = this.buildingTodoMapId;
        data["mapTagColor"] = this.mapTagColor;
        data["mapLeft"] = this.mapLeft;
        data["mapTop"] = this.mapTop;
        data["temporaryMarker"] = this.temporaryMarker;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : <any>undefined;
        data["unread"] = this.unread;
        data["description"] = this.description;
        return data;
    }
}

export interface ITodoListDTO {
    id?: number;
    name?: string | undefined;
    buildingName?: string | undefined;
    buildingId?: number | undefined;
    assignees?: string | undefined;
    creatorName?: string | undefined;
    responsiblePersonId?: number | undefined;
    responsiblePerson?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeDeadline?: Date | undefined;
    state?: number;
    buildingTodoMapId?: number | undefined;
    mapTagColor?: string | undefined;
    mapLeft?: number | undefined;
    mapTop?: number | undefined;
    temporaryMarker?: boolean;
    rowVersion?: Date;
    unread?: boolean;
    description?: string | undefined;
}

export enum TodoState {
    NEW = 0,
    ACTIVE = 1,
    RESOLVED = 2,
    CLOSED = 3,
    Unknown = 99,
}

export class TransferPhotosFromProjectRequest implements ITransferPhotosFromProjectRequest {
    diaryRecordId?: number;
    filenames?: FileToTransferDTO[] | undefined;

    constructor(data?: ITransferPhotosFromProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            if (Array.isArray(_data["filenames"])) {
                this.filenames = [] as any;
                for (let item of _data["filenames"])
                    this.filenames!.push(FileToTransferDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferPhotosFromProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransferPhotosFromProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        if (Array.isArray(this.filenames)) {
            data["filenames"] = [];
            for (let item of this.filenames)
                data["filenames"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransferPhotosFromProjectRequest {
    diaryRecordId?: number;
    filenames?: FileToTransferDTO[] | undefined;
}

export class TransferPhotosFromProjectResponse implements ITransferPhotosFromProjectResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;

    constructor(data?: ITransferPhotosFromProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TransferPhotosFromProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransferPhotosFromProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["url"] = this.url;
        return data;
    }
}

export interface ITransferPhotosFromProjectResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;
}

export class TransferPhotosFromProjectSubcontractorRequest implements ITransferPhotosFromProjectSubcontractorRequest {
    diaryRecordId?: number;
    filenames?: FileToTransferDTO[] | undefined;

    constructor(data?: ITransferPhotosFromProjectSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diaryRecordId = _data["diaryRecordId"];
            if (Array.isArray(_data["filenames"])) {
                this.filenames = [] as any;
                for (let item of _data["filenames"])
                    this.filenames!.push(FileToTransferDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferPhotosFromProjectSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransferPhotosFromProjectSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diaryRecordId"] = this.diaryRecordId;
        if (Array.isArray(this.filenames)) {
            data["filenames"] = [];
            for (let item of this.filenames)
                data["filenames"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransferPhotosFromProjectSubcontractorRequest {
    diaryRecordId?: number;
    filenames?: FileToTransferDTO[] | undefined;
}

export class UpdateBlockToDraftOutResponse implements IUpdateBlockToDraftOutResponse {
    ok?: boolean;

    constructor(data?: IUpdateBlockToDraftOutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateBlockToDraftOutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBlockToDraftOutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateBlockToDraftOutResponse {
    ok?: boolean;
}

export class UpdateCategoryTemplateRequest implements IUpdateCategoryTemplateRequest {
    template?: CategoryTemplateDTO;

    constructor(data?: IUpdateCategoryTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? CategoryTemplateDTO.fromJS(_data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCategoryTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCategoryTemplateRequest {
    template?: CategoryTemplateDTO;
}

export class UpdateCategoryTemplateResponse implements IUpdateCategoryTemplateResponse {
    ok?: boolean;

    constructor(data?: IUpdateCategoryTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateCategoryTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateCategoryTemplateResponse {
    ok?: boolean;
}

export class UpdateCustomFieldForApplicationRequest implements IUpdateCustomFieldForApplicationRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: CustomFieldDataType;
    newEnumOptions?: string[] | undefined;
    deletedEnumOptions?: number[] | undefined;
    updatedEnumOptions?: CustomFieldOptionDto[] | undefined;

    constructor(data?: IUpdateCustomFieldForApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.dataType = _data["dataType"];
            if (Array.isArray(_data["newEnumOptions"])) {
                this.newEnumOptions = [] as any;
                for (let item of _data["newEnumOptions"])
                    this.newEnumOptions!.push(item);
            }
            if (Array.isArray(_data["deletedEnumOptions"])) {
                this.deletedEnumOptions = [] as any;
                for (let item of _data["deletedEnumOptions"])
                    this.deletedEnumOptions!.push(item);
            }
            if (Array.isArray(_data["updatedEnumOptions"])) {
                this.updatedEnumOptions = [] as any;
                for (let item of _data["updatedEnumOptions"])
                    this.updatedEnumOptions!.push(CustomFieldOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCustomFieldForApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomFieldForApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["dataType"] = this.dataType;
        if (Array.isArray(this.newEnumOptions)) {
            data["newEnumOptions"] = [];
            for (let item of this.newEnumOptions)
                data["newEnumOptions"].push(item);
        }
        if (Array.isArray(this.deletedEnumOptions)) {
            data["deletedEnumOptions"] = [];
            for (let item of this.deletedEnumOptions)
                data["deletedEnumOptions"].push(item);
        }
        if (Array.isArray(this.updatedEnumOptions)) {
            data["updatedEnumOptions"] = [];
            for (let item of this.updatedEnumOptions)
                data["updatedEnumOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateCustomFieldForApplicationRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: CustomFieldDataType;
    newEnumOptions?: string[] | undefined;
    deletedEnumOptions?: number[] | undefined;
    updatedEnumOptions?: CustomFieldOptionDto[] | undefined;
}

export class UpdateCustomFieldForApplicationResponse implements IUpdateCustomFieldForApplicationResponse {
    customField?: CustomFieldDto;

    constructor(data?: IUpdateCustomFieldForApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customField = _data["customField"] ? CustomFieldDto.fromJS(_data["customField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomFieldForApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomFieldForApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customField"] = this.customField ? this.customField.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCustomFieldForApplicationResponse {
    customField?: CustomFieldDto;
}

export class UpdateHintRequest implements IUpdateHintRequest {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;

    constructor(data?: IUpdateHintRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UpdateHintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["language"] = this.language;
        return data;
    }
}

export interface IUpdateHintRequest {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
}

export class UpdateHintResponse implements IUpdateHintResponse {
    ok?: boolean;

    constructor(data?: IUpdateHintResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateHintResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHintResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateHintResponse {
    ok?: boolean;
}

export class UpdateInvestorCredentialsRequest implements IUpdateInvestorCredentialsRequest {
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUpdateInvestorCredentialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateInvestorCredentialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorCredentialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateInvestorCredentialsRequest {
    name?: string | undefined;
    email?: string | undefined;
}

export class UpdateInvestorCredentialsResponse implements IUpdateInvestorCredentialsResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateInvestorCredentialsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateInvestorCredentialsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorCredentialsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpdateInvestorCredentialsResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class UpdateInvestorPasswordRequest implements IUpdateInvestorPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IUpdateInvestorPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateInvestorPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdateInvestorPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class UpdateInvestorPasswordResponse implements IUpdateInvestorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateInvestorPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateInvestorPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestorPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpdateInvestorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class UpdateInvoiceFromListRequest implements IUpdateInvoiceFromListRequest {
    invoiceId?: number;
    property?: string | undefined;
    value?: boolean;

    constructor(data?: IUpdateInvoiceFromListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.property = _data["property"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateInvoiceFromListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceFromListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["property"] = this.property;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateInvoiceFromListRequest {
    invoiceId?: number;
    property?: string | undefined;
    value?: boolean;
}

export class UpdateInvoiceFromListResponse implements IUpdateInvoiceFromListResponse {
    ok?: boolean;

    constructor(data?: IUpdateInvoiceFromListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateInvoiceFromListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceFromListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateInvoiceFromListResponse {
    ok?: boolean;
}

export class UpdateInWaitingForSignatureToInResponse implements IUpdateInWaitingForSignatureToInResponse {
    ok?: boolean;

    constructor(data?: IUpdateInWaitingForSignatureToInResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateInWaitingForSignatureToInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInWaitingForSignatureToInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateInWaitingForSignatureToInResponse {
    ok?: boolean;
}

export class UpdateJokeRequest implements IUpdateJokeRequest {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;

    constructor(data?: IUpdateJokeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.heading = _data["heading"];
            this.content = _data["content"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UpdateJokeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJokeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["heading"] = this.heading;
        data["content"] = this.content;
        data["language"] = this.language;
        return data;
    }
}

export interface IUpdateJokeRequest {
    id?: number;
    heading?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
}

export class UpdateJokeResponse implements IUpdateJokeResponse {
    ok?: boolean;

    constructor(data?: IUpdateJokeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateJokeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJokeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateJokeResponse {
    ok?: boolean;
}

export class UpdateMarkersPositionsRequest implements IUpdateMarkersPositionsRequest {
    markers?: MarkerWithPositionDto[] | undefined;

    constructor(data?: IUpdateMarkersPositionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["markers"])) {
                this.markers = [] as any;
                for (let item of _data["markers"])
                    this.markers!.push(MarkerWithPositionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMarkersPositionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarkersPositionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.markers)) {
            data["markers"] = [];
            for (let item of this.markers)
                data["markers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMarkersPositionsRequest {
    markers?: MarkerWithPositionDto[] | undefined;
}

export class UpdateMarkersPositionsResponse implements IUpdateMarkersPositionsResponse {
    ok?: boolean;

    constructor(data?: IUpdateMarkersPositionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMarkersPositionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarkersPositionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMarkersPositionsResponse {
    ok?: boolean;
}

export class UpdateRequestEmployeeMobileRequest implements IUpdateRequestEmployeeMobileRequest {
    requestId?: number;
    assigneeId?: number;
    datetimeTo?: Date;

    constructor(data?: IUpdateRequestEmployeeMobileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.assigneeId = _data["assigneeId"];
            this.datetimeTo = _data["datetimeTo"] ? new Date(_data["datetimeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRequestEmployeeMobileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestEmployeeMobileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["assigneeId"] = this.assigneeId;
        data["datetimeTo"] = this.datetimeTo ? this.datetimeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateRequestEmployeeMobileRequest {
    requestId?: number;
    assigneeId?: number;
    datetimeTo?: Date;
}

export class UpdateRequestEmployeeMobileResponse implements IUpdateRequestEmployeeMobileResponse {
    ok?: boolean;

    constructor(data?: IUpdateRequestEmployeeMobileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateRequestEmployeeMobileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestEmployeeMobileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateRequestEmployeeMobileResponse {
    ok?: boolean;
}

export class UpdateRequestRequest implements IUpdateRequestRequest {
    requestId?: number;
    description?: string | undefined;
    progres?: number;
    isDone?: number;
    buildingId?: number | undefined;
    dateTo?: Date | undefined;

    constructor(data?: IUpdateRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.description = _data["description"];
            this.progres = _data["progres"];
            this.isDone = _data["isDone"];
            this.buildingId = _data["buildingId"];
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["description"] = this.description;
        data["progres"] = this.progres;
        data["isDone"] = this.isDone;
        data["buildingId"] = this.buildingId;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateRequestRequest {
    requestId?: number;
    description?: string | undefined;
    progres?: number;
    isDone?: number;
    buildingId?: number | undefined;
    dateTo?: Date | undefined;
}

export class UpdateRequestResponse implements IUpdateRequestResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpdateRequestResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class UpdateStockListSignatureResponse implements IUpdateStockListSignatureResponse {
    ok?: boolean;

    constructor(data?: IUpdateStockListSignatureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateStockListSignatureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStockListSignatureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateStockListSignatureResponse {
    ok?: boolean;
}

export class UpdateSubcontractorPasswordRequest implements IUpdateSubcontractorPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IUpdateSubcontractorPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateSubcontractorPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubcontractorPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdateSubcontractorPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class UpdateSubcontractorPasswordResponse implements IUpdateSubcontractorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateSubcontractorPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateSubcontractorPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubcontractorPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpdateSubcontractorPasswordResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
}

export class UpdateTodoConversationRequest implements IUpdateTodoConversationRequest {
    id?: number;
    text?: string | undefined;
    toEmployee?: boolean;
    toInvestor?: boolean;

    constructor(data?: IUpdateTodoConversationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.toEmployee = _data["toEmployee"];
            this.toInvestor = _data["toInvestor"];
        }
    }

    static fromJS(data: any): UpdateTodoConversationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoConversationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["toEmployee"] = this.toEmployee;
        data["toInvestor"] = this.toInvestor;
        return data;
    }
}

export interface IUpdateTodoConversationRequest {
    id?: number;
    text?: string | undefined;
    toEmployee?: boolean;
    toInvestor?: boolean;
}

export class UpdateTodoConversationResponse implements IUpdateTodoConversationResponse {
    ok?: boolean;

    constructor(data?: IUpdateTodoConversationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateTodoConversationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoConversationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateTodoConversationResponse {
    ok?: boolean;
}

export class UpdateTodoGanttRequest implements IUpdateTodoGanttRequest {
    data?: TodoGanttDTO;

    constructor(data?: IUpdateTodoGanttRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TodoGanttDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTodoGanttRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoGanttRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateTodoGanttRequest {
    data?: TodoGanttDTO;
}

export class UpdateTodoGanttResponse implements IUpdateTodoGanttResponse {
    id?: number;

    constructor(data?: IUpdateTodoGanttResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTodoGanttResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoGanttResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTodoGanttResponse {
    id?: number;
}

export class UpdateTodoKanbanDto implements IUpdateTodoKanbanDto {
    id?: number;
    responsiblePersonId?: number | undefined;
    state?: TodoState;
    buildingId?: number | undefined;

    constructor(data?: IUpdateTodoKanbanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsiblePersonId = _data["responsiblePersonId"];
            this.state = _data["state"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): UpdateTodoKanbanDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoKanbanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsiblePersonId"] = this.responsiblePersonId;
        data["state"] = this.state;
        data["buildingId"] = this.buildingId;
        return data;
    }
}

export interface IUpdateTodoKanbanDto {
    id?: number;
    responsiblePersonId?: number | undefined;
    state?: TodoState;
    buildingId?: number | undefined;
}

export class UpdateTodoKanbanReponse implements IUpdateTodoKanbanReponse {
    ok?: boolean;
    concurrencyEditedTodo?: boolean;

    constructor(data?: IUpdateTodoKanbanReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.concurrencyEditedTodo = _data["concurrencyEditedTodo"];
        }
    }

    static fromJS(data: any): UpdateTodoKanbanReponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoKanbanReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["concurrencyEditedTodo"] = this.concurrencyEditedTodo;
        return data;
    }
}

export interface IUpdateTodoKanbanReponse {
    ok?: boolean;
    concurrencyEditedTodo?: boolean;
}

export class UpdateTodoKanbanRequest implements IUpdateTodoKanbanRequest {
    updates?: UpdateTodoKanbanDto[] | undefined;

    constructor(data?: IUpdateTodoKanbanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(UpdateTodoKanbanDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTodoKanbanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoKanbanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTodoKanbanRequest {
    updates?: UpdateTodoKanbanDto[] | undefined;
}

export class UpdateTodoRequest implements IUpdateTodoRequest {
    data?: TodoDTO;

    constructor(data?: IUpdateTodoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TodoDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTodoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateTodoRequest {
    data?: TodoDTO;
}

export class UpdateTodoResponse implements IUpdateTodoResponse {
    id?: number;

    constructor(data?: IUpdateTodoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTodoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTodoResponse {
    id?: number;
}

export class UpdateTodoStateRequest implements IUpdateTodoStateRequest {
    id?: number;
    state?: TodoState;

    constructor(data?: IUpdateTodoStateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateTodoStateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoStateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateTodoStateRequest {
    id?: number;
    state?: TodoState;
}

export class UpdateTodoStateResponse implements IUpdateTodoStateResponse {
    id?: number;

    constructor(data?: IUpdateTodoStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTodoStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTodoStateResponse {
    id?: number;
}

export class UploadDigitalSignedPDFResponse implements IUploadDigitalSignedPDFResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;

    constructor(data?: IUploadDigitalSignedPDFResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadDigitalSignedPDFResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDigitalSignedPDFResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["url"] = this.url;
        return data;
    }
}

export interface IUploadDigitalSignedPDFResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;
}

export class UploadEmployeeDocumentChunkResponse implements IUploadEmployeeDocumentChunkResponse {
    ok?: boolean;

    constructor(data?: IUploadEmployeeDocumentChunkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UploadEmployeeDocumentChunkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadEmployeeDocumentChunkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUploadEmployeeDocumentChunkResponse {
    ok?: boolean;
}

export class UploadFileToDiaryDirectResponse implements IUploadFileToDiaryDirectResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;

    constructor(data?: IUploadFileToDiaryDirectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadFileToDiaryDirectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileToDiaryDirectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["url"] = this.url;
        return data;
    }
}

export interface IUploadFileToDiaryDirectResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    url?: string | undefined;
}

export class UploadImageToProjectTodosMapResponse implements IUploadImageToProjectTodosMapResponse {
    imageMapId?: number;

    constructor(data?: IUploadImageToProjectTodosMapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageMapId = _data["imageMapId"];
        }
    }

    static fromJS(data: any): UploadImageToProjectTodosMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageToProjectTodosMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageMapId"] = this.imageMapId;
        return data;
    }
}

export interface IUploadImageToProjectTodosMapResponse {
    imageMapId?: number;
}

export class UploadProjectDocumentChunkResponse implements IUploadProjectDocumentChunkResponse {
    ok?: boolean;

    constructor(data?: IUploadProjectDocumentChunkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UploadProjectDocumentChunkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadProjectDocumentChunkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUploadProjectDocumentChunkResponse {
    ok?: boolean;
}

export class UserDTO implements IUserDTO {
    id?: number;
    name?: string | undefined;
    type?: UserType;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IUserDTO {
    id?: number;
    name?: string | undefined;
    type?: UserType;
}

export class UserGroupDTO implements IUserGroupDTO {
    name?: string | undefined;
    id?: number;

    constructor(data?: IUserGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserGroupDTO {
    name?: string | undefined;
    id?: number;
}

export class UserGroupsResponse implements IUserGroupsResponse {
    groups?: UserGroupDTO[] | undefined;

    constructor(data?: IUserGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(UserGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserGroupsResponse {
    groups?: UserGroupDTO[] | undefined;
}

export class UserIdAndNameDTO implements IUserIdAndNameDTO {
    id?: number;
    name?: string | undefined;
    groupId?: number | undefined;
    group?: string | undefined;

    constructor(data?: IUserIdAndNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
        }
    }

    static fromJS(data: any): UserIdAndNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdAndNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        return data;
    }
}

export interface IUserIdAndNameDTO {
    id?: number;
    name?: string | undefined;
    groupId?: number | undefined;
    group?: string | undefined;
}

export class UserResponsibleDTO implements IUserResponsibleDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUserResponsibleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserResponsibleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponsibleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserResponsibleDTO {
    id?: number;
    name?: string | undefined;
}

export class UserRoleDTO implements IUserRoleDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUserRoleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserRoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserRoleDTO {
    id?: number;
    name?: string | undefined;
}

export class UsersGroupDiaryDTO implements IUsersGroupDiaryDTO {
    userId?: number;
    groupId?: number;
    userName?: string | undefined;
    hasRight?: boolean;

    constructor(data?: IUsersGroupDiaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.groupId = _data["groupId"];
            this.userName = _data["userName"];
            this.hasRight = _data["hasRight"];
        }
    }

    static fromJS(data: any): UsersGroupDiaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UsersGroupDiaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["groupId"] = this.groupId;
        data["userName"] = this.userName;
        data["hasRight"] = this.hasRight;
        return data;
    }
}

export interface IUsersGroupDiaryDTO {
    userId?: number;
    groupId?: number;
    userName?: string | undefined;
    hasRight?: boolean;
}

export class UserTenantDTO implements IUserTenantDTO {
    tenantName?: string | undefined;
    tenantId?: number;
    url?: string | undefined;
    userId?: number;
    isActive?: boolean;
    isPaying?: boolean;
    isValidLogin?: boolean;

    constructor(data?: IUserTenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.tenantId = _data["tenantId"];
            this.url = _data["url"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.isPaying = _data["isPaying"];
            this.isValidLogin = _data["isValidLogin"];
        }
    }

    static fromJS(data: any): UserTenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["tenantId"] = this.tenantId;
        data["url"] = this.url;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["isPaying"] = this.isPaying;
        data["isValidLogin"] = this.isValidLogin;
        return data;
    }
}

export interface IUserTenantDTO {
    tenantName?: string | undefined;
    tenantId?: number;
    url?: string | undefined;
    userId?: number;
    isActive?: boolean;
    isPaying?: boolean;
    isValidLogin?: boolean;
}

export enum UserType {
    Admin = 0,
    Employee = 1,
    Investor = 2,
}

export class Version implements IVersion {
    major?: number;
    minor?: number;
    build?: number;
    revision?: number;
    readonly majorRevision?: number;
    readonly minorRevision?: number;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.build = _data["build"];
            this.revision = _data["revision"];
            (<any>this).majorRevision = _data["majorRevision"];
            (<any>this).minorRevision = _data["minorRevision"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["build"] = this.build;
        data["revision"] = this.revision;
        data["majorRevision"] = this.majorRevision;
        data["minorRevision"] = this.minorRevision;
        return data;
    }
}

export interface IVersion {
    major?: number;
    minor?: number;
    build?: number;
    revision?: number;
    majorRevision?: number;
    minorRevision?: number;
}

export class WarehouseActionDTO implements IWarehouseActionDTO {
    id?: number;
    state?: string | undefined;
    datetime?: Date;
    number?: string | undefined;
    note?: string | undefined;
    userName?: string | undefined;
    toWarehouseName?: string | undefined;
    fromWarehouseName?: string | undefined;
    stockItems?: StockItemDTO[] | undefined;

    constructor(data?: IWarehouseActionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.number = _data["number"];
            this.note = _data["note"];
            this.userName = _data["userName"];
            this.toWarehouseName = _data["toWarehouseName"];
            this.fromWarehouseName = _data["fromWarehouseName"];
            if (Array.isArray(_data["stockItems"])) {
                this.stockItems = [] as any;
                for (let item of _data["stockItems"])
                    this.stockItems!.push(StockItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseActionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseActionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["number"] = this.number;
        data["note"] = this.note;
        data["userName"] = this.userName;
        data["toWarehouseName"] = this.toWarehouseName;
        data["fromWarehouseName"] = this.fromWarehouseName;
        if (Array.isArray(this.stockItems)) {
            data["stockItems"] = [];
            for (let item of this.stockItems)
                data["stockItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWarehouseActionDTO {
    id?: number;
    state?: string | undefined;
    datetime?: Date;
    number?: string | undefined;
    note?: string | undefined;
    userName?: string | undefined;
    toWarehouseName?: string | undefined;
    fromWarehouseName?: string | undefined;
    stockItems?: StockItemDTO[] | undefined;
}

export class WarehouseDTO implements IWarehouseDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IWarehouseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WarehouseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWarehouseDTO {
    id?: number;
    name?: string | undefined;
}

export class WarehouseListPageDTO implements IWarehouseListPageDTO {
    id?: number;
    name?: string | undefined;
    buildingName?: string | undefined;
    isActive?: boolean;
    openActions?: OpenActionDTO[] | undefined;

    constructor(data?: IWarehouseListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.buildingName = _data["buildingName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["openActions"])) {
                this.openActions = [] as any;
                for (let item of _data["openActions"])
                    this.openActions!.push(OpenActionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["buildingName"] = this.buildingName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.openActions)) {
            data["openActions"] = [];
            for (let item of this.openActions)
                data["openActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWarehouseListPageDTO {
    id?: number;
    name?: string | undefined;
    buildingName?: string | undefined;
    isActive?: boolean;
    openActions?: OpenActionDTO[] | undefined;
}

export class WarehouseProductListPageDTO implements IWarehouseProductListPageDTO {
    id?: number;
    stockProductId?: number;
    code?: string | undefined;
    name?: string | undefined;
    stockManufacturerName?: string | undefined;
    stockProductCategoryName?: string | undefined;
    totalUnitsCount?: number;
    price?: number;
    totalPrice?: number;
    measureUnitName?: string | undefined;
    measureUnitAbbr?: string | undefined;

    constructor(data?: IWarehouseProductListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockProductId = _data["stockProductId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.stockManufacturerName = _data["stockManufacturerName"];
            this.stockProductCategoryName = _data["stockProductCategoryName"];
            this.totalUnitsCount = _data["totalUnitsCount"];
            this.price = _data["price"];
            this.totalPrice = _data["totalPrice"];
            this.measureUnitName = _data["measureUnitName"];
            this.measureUnitAbbr = _data["measureUnitAbbr"];
        }
    }

    static fromJS(data: any): WarehouseProductListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseProductListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockProductId"] = this.stockProductId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["stockManufacturerName"] = this.stockManufacturerName;
        data["stockProductCategoryName"] = this.stockProductCategoryName;
        data["totalUnitsCount"] = this.totalUnitsCount;
        data["price"] = this.price;
        data["totalPrice"] = this.totalPrice;
        data["measureUnitName"] = this.measureUnitName;
        data["measureUnitAbbr"] = this.measureUnitAbbr;
        return data;
    }
}

export interface IWarehouseProductListPageDTO {
    id?: number;
    stockProductId?: number;
    code?: string | undefined;
    name?: string | undefined;
    stockManufacturerName?: string | undefined;
    stockProductCategoryName?: string | undefined;
    totalUnitsCount?: number;
    price?: number;
    totalPrice?: number;
    measureUnitName?: string | undefined;
    measureUnitAbbr?: string | undefined;
}

export class WarehousesReportListPageDTO implements IWarehousesReportListPageDTO {
    id?: number;
    stockProductId?: number;
    code?: string | undefined;
    name?: string | undefined;
    totalUnitsCount?: number;
    price?: number;
    totalPrice?: number;
    weight?: number;
    totalWeight?: number;
    measureUnitAbbr?: string | undefined;

    constructor(data?: IWarehousesReportListPageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockProductId = _data["stockProductId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.totalUnitsCount = _data["totalUnitsCount"];
            this.price = _data["price"];
            this.totalPrice = _data["totalPrice"];
            this.weight = _data["weight"];
            this.totalWeight = _data["totalWeight"];
            this.measureUnitAbbr = _data["measureUnitAbbr"];
        }
    }

    static fromJS(data: any): WarehousesReportListPageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousesReportListPageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockProductId"] = this.stockProductId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["totalUnitsCount"] = this.totalUnitsCount;
        data["price"] = this.price;
        data["totalPrice"] = this.totalPrice;
        data["weight"] = this.weight;
        data["totalWeight"] = this.totalWeight;
        data["measureUnitAbbr"] = this.measureUnitAbbr;
        return data;
    }
}

export interface IWarehousesReportListPageDTO {
    id?: number;
    stockProductId?: number;
    code?: string | undefined;
    name?: string | undefined;
    totalUnitsCount?: number;
    price?: number;
    totalPrice?: number;
    weight?: number;
    totalWeight?: number;
    measureUnitAbbr?: string | undefined;
}

export enum WarehouseTabType {
    OpenActions = 1,
    MovementsInStock = 2,
    Reservations = 3,
}

export class WealthDTO implements IWealthDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    wealthRentalType?: number;
    wealthState?: string | undefined;
    serialNumber?: string | undefined;
    responsibleEmployee?: string | undefined;
    buildingName?: string | undefined;
    stockName?: string | undefined;
    isActive?: boolean;
    showToEmployee?: boolean;

    constructor(data?: IWealthDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.wealthRentalType = _data["wealthRentalType"];
            this.wealthState = _data["wealthState"];
            this.serialNumber = _data["serialNumber"];
            this.responsibleEmployee = _data["responsibleEmployee"];
            this.buildingName = _data["buildingName"];
            this.stockName = _data["stockName"];
            this.isActive = _data["isActive"];
            this.showToEmployee = _data["showToEmployee"];
        }
    }

    static fromJS(data: any): WealthDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["wealthRentalType"] = this.wealthRentalType;
        data["wealthState"] = this.wealthState;
        data["serialNumber"] = this.serialNumber;
        data["responsibleEmployee"] = this.responsibleEmployee;
        data["buildingName"] = this.buildingName;
        data["stockName"] = this.stockName;
        data["isActive"] = this.isActive;
        data["showToEmployee"] = this.showToEmployee;
        return data;
    }
}

export interface IWealthDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    wealthRentalType?: number;
    wealthState?: string | undefined;
    serialNumber?: string | undefined;
    responsibleEmployee?: string | undefined;
    buildingName?: string | undefined;
    stockName?: string | undefined;
    isActive?: boolean;
    showToEmployee?: boolean;
}

export class WealthExpenditureDTO implements IWealthExpenditureDTO {
    id?: number;
    date?: Date;
    name?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    description?: string | undefined;
    price?: number;
    isDeleted?: boolean;

    constructor(data?: IWealthExpenditureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): WealthExpenditureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthExpenditureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["description"] = this.description;
        data["price"] = this.price;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IWealthExpenditureDTO {
    id?: number;
    date?: Date;
    name?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    description?: string | undefined;
    price?: number;
    isDeleted?: boolean;
}

export class WealthForDiaryDialogDTO implements IWealthForDiaryDialogDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    serialNumber?: string | undefined;
    employeeFullName?: string | undefined;
    isActive?: boolean;

    constructor(data?: IWealthForDiaryDialogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.serialNumber = _data["serialNumber"];
            this.employeeFullName = _data["employeeFullName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WealthForDiaryDialogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthForDiaryDialogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["serialNumber"] = this.serialNumber;
        data["employeeFullName"] = this.employeeFullName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWealthForDiaryDialogDTO {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    serialNumber?: string | undefined;
    employeeFullName?: string | undefined;
    isActive?: boolean;
}

export class WealthHistoryDTO implements IWealthHistoryDTO {
    responsibleEmployee?: string | undefined;
    building?: string | undefined;
    warehouse?: string | undefined;
    from?: Date;
    to?: Date;
    deviation?: string | undefined;

    constructor(data?: IWealthHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsibleEmployee = _data["responsibleEmployee"];
            this.building = _data["building"];
            this.warehouse = _data["warehouse"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.deviation = _data["deviation"];
        }
    }

    static fromJS(data: any): WealthHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsibleEmployee"] = this.responsibleEmployee;
        data["building"] = this.building;
        data["warehouse"] = this.warehouse;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["deviation"] = this.deviation;
        return data;
    }
}

export interface IWealthHistoryDTO {
    responsibleEmployee?: string | undefined;
    building?: string | undefined;
    warehouse?: string | undefined;
    from?: Date;
    to?: Date;
    deviation?: string | undefined;
}

export class WealthRentalDTO implements IWealthRentalDTO {
    id?: number;
    type?: number;
    name?: string | undefined;
    buildingId?: number | undefined;
    employeeId?: number | undefined;
    advance?: number;
    isDeleted?: boolean;
    datetimeFrom?: Date;
    signatureImage?: string | undefined;
    items?: WealthRentalItemDTO[] | undefined;

    constructor(data?: IWealthRentalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
            this.employeeId = _data["employeeId"];
            this.advance = _data["advance"];
            this.isDeleted = _data["isDeleted"];
            this.datetimeFrom = _data["datetimeFrom"] ? new Date(_data["datetimeFrom"].toString()) : <any>undefined;
            this.signatureImage = _data["signatureImage"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WealthRentalItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WealthRentalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthRentalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        data["employeeId"] = this.employeeId;
        data["advance"] = this.advance;
        data["isDeleted"] = this.isDeleted;
        data["datetimeFrom"] = this.datetimeFrom ? this.datetimeFrom.toISOString() : <any>undefined;
        data["signatureImage"] = this.signatureImage;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWealthRentalDTO {
    id?: number;
    type?: number;
    name?: string | undefined;
    buildingId?: number | undefined;
    employeeId?: number | undefined;
    advance?: number;
    isDeleted?: boolean;
    datetimeFrom?: Date;
    signatureImage?: string | undefined;
    items?: WealthRentalItemDTO[] | undefined;
}

export class WealthRentalItemDTO implements IWealthRentalItemDTO {
    id?: number;
    wealthId?: number;
    datetimeTo?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IWealthRentalItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wealthId = _data["wealthId"];
            this.datetimeTo = _data["datetimeTo"] ? new Date(_data["datetimeTo"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): WealthRentalItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthRentalItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wealthId"] = this.wealthId;
        data["datetimeTo"] = this.datetimeTo ? this.datetimeTo.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IWealthRentalItemDTO {
    id?: number;
    wealthId?: number;
    datetimeTo?: Date | undefined;
    isDeleted?: boolean;
}

export class WeatherInfoDTO implements IWeatherInfoDTO {
    temp?: number;
    image?: string | undefined;
    title?: string | undefined;
    city?: string | undefined;
    time?: string | undefined;
    date?: string | undefined;
    wind?: number;
    humidity?: number;
    rain1h?: number;
    rain3h?: number;

    constructor(data?: IWeatherInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temp = _data["temp"];
            this.image = _data["image"];
            this.title = _data["title"];
            this.city = _data["city"];
            this.time = _data["time"];
            this.date = _data["date"];
            this.wind = _data["wind"];
            this.humidity = _data["humidity"];
            this.rain1h = _data["rain1h"];
            this.rain3h = _data["rain3h"];
        }
    }

    static fromJS(data: any): WeatherInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temp"] = this.temp;
        data["image"] = this.image;
        data["title"] = this.title;
        data["city"] = this.city;
        data["time"] = this.time;
        data["date"] = this.date;
        data["wind"] = this.wind;
        data["humidity"] = this.humidity;
        data["rain1h"] = this.rain1h;
        data["rain3h"] = this.rain3h;
        return data;
    }
}

export interface IWeatherInfoDTO {
    temp?: number;
    image?: string | undefined;
    title?: string | undefined;
    city?: string | undefined;
    time?: string | undefined;
    date?: string | undefined;
    wind?: number;
    humidity?: number;
    rain1h?: number;
    rain3h?: number;
}

export enum WorkTimeEnum {
    Polovicni = 1,
    PruznaPracovniDoba = 2,
    SdilenePracovniMisto = 3,
    PraceZDomova = 4,
    KontoPracovniDoby = 5,
    StlacenyPracovniTyden = 6,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}